/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 01: Namespace + Utilities
   ═══════════════════════════════════════════════ */

(function(){
'use strict';

/* ─ NAMESPACE ─ */
window.ANI = {
  cfg: { blogUrl: '', pageType: '', googleClientId: '340079800476-npm0tip4k48d9a0d5rf102p57o7ladqb.apps.googleusercontent.com' },
  cache: {}, router: null, player: null
};

/* ─ UTILS ─ */
ANI.util = {
  /* Escape HTML untuk mencegah XSS di attribute dan content */
  esc: function(str){
    if(!str) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  },
  /* Konversi Google Drive file ID ke thumbnail URL */
  driveThumb: function(id, width){
    if(!id) return '';
    // Jika sudah URL lengkap, return apa adanya
    if(id.indexOf('http') === 0) return id;
    return 'https://drive.google.com/thumbnail?id=' + id + '&sz=w' + (width || 400);
  },
  /* Format genre slug D1 → label display. slice_of_life→Slice of Life, sci-fi→Sci-Fi */
  fmtGenre: function(g) {
    if (!g) return g;
    return g.replace(/_/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  },
  /* TMDB banner: w780 disimpan di D1. Desktop ≥1024px → coba w1280, onerror fallback ke w780 */
  tmdbBanner: function(url) {
    if (!url) return '';
    if (url.indexOf('image.tmdb.org') === -1) return url;
    var isDesktop = (typeof window !== 'undefined' && window.innerWidth >= 1024);
    if (isDesktop) return url.replace(/\/t\/p\/[^\/]+\//, '/t/p/w1280/');
    return url.replace(/\/t\/p\/[^\/]+\//, '/t/p/w780/');
  },
  /* TMDB original: ganti /t/p/w342/, /w500/, /w780/, /w1280/ → /original/ untuk lightbox HD */
  tmdbOriginal: function(url) {
    if (!url) return '';
    if (url.indexOf('image.tmdb.org') === -1) return url;
    return url.replace(/\/t\/p\/[^\/]+\//, '/t/p/original/');
  },
  /* Safe sessionStorage */
  ssGet: function(k){
    try { return sessionStorage.getItem(k); } catch(e) { return null; }
  },
  ssSet: function(k, v){
    try { sessionStorage.setItem(k, v); } catch(e) {}
  },
  /* Upgrade TMDB ep_thumb dari w300 → w780 untuk poster Artplayer.
     Hanya berlaku untuk URL image.tmdb.org dengan format /t/p/w300/... */
  tmdbThumbHD: function(url){
    if(!url) return '';
    if(url.indexOf('image.tmdb.org') === -1) return url;
    return url.replace('/t/p/w300/', '/t/p/w780/');
  },
  /* Format seconds → mm:ss */
  fmtTime: function(s){
    if(s === null || s === undefined || isNaN(s)) return '0:00';
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }
,

  /* ── Player status box — render konsisten antar server (loading/error/warn/info/empty) ──
     Usage: ANI.util.playerStatus(box, 'loading', 'Mempersiapkan stream...');
            ANI.util.playerStatus(box, 'error', 'Stream sign gagal', errMsg);
     type: 'loading' | 'error' | 'warn' | 'info' | 'empty' */
  playerStatus: function(box, type, title, detail){
    if (typeof box === 'string') box = document.getElementById(box);
    if (!box) return;
    type = type || 'info';
    var icon = '';
    if (type === 'loading') {
      icon = '<div class="ply-status__spinner"></div>';
    } else if (type === 'error') {
      icon = '<div class="ply-status__icon">!</div>';
    } else if (type === 'warn') {
      icon = '<div class="ply-status__icon">!</div>';
    } else if (type === 'empty') {
      icon = '<div class="ply-status__icon">\u2205</div>';
    } else {
      icon = '<div class="ply-status__icon">i</div>';
    }
    var html = '<div class="ply-status ply-status--' + ANI.util.esc(type) + '">'
      + icon
      + '<div class="ply-status__title">' + ANI.util.esc(title || '') + '</div>'
      + (detail ? '<div class="ply-status__detail">' + ANI.util.esc(detail) + '</div>' : '')
      + '</div>';
    box.innerHTML = html;
  }};

/* ── Download helper — trigger download tanpa meninggalkan SPA ── */
ANI.dl = {
  /* ── Hidden iframe target — page tidak navigasi saat download ── */
  _ensureFrame: function(){
    var f = document.getElementById('ani-dl-frame');
    if(!f){
      f = document.createElement('iframe');
      f.id = 'ani-dl-frame';
      f.name = 'ani-dl-frame';
      f.style.cssText = 'position:absolute;width:0;height:0;border:none;opacity:0;pointer-events:none';
      f.setAttribute('aria-hidden','true');
      document.body.appendChild(f);
    }
    return f;
  },

  /* ── Fire actual download (no SPA navigation) ── */
  _fire: function(url){
    try {
      this._ensureFrame();
      var a = document.createElement('a');
      a.href = url;
      a.target = 'ani-dl-frame';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch(e){
      try { window.open(url, '_blank'); } catch(e2){}
    }
  },

  /* ── High-level: orchestrate sign → connect → start dengan state-aware modal ──
     opts: { signUrl, displayName, meta }
     Flow: preparing (sign request) → connecting (HEAD pre-flight) → started (iframe fire)
     Toast HANYA tertutup otomatis saat download benar-benar dimulai (bukan timer). */
  start: function(opts){
    var self = this;
    if(!opts || !opts.signUrl){ return; }
    self._lastOpts = opts;
    if(self._closeTimer){ clearTimeout(self._closeTimer); self._closeTimer = null; }

    var meta = opts.meta || '';
    var displayName = opts.displayName || '';

    self._show('preparing', { displayName: displayName, meta: meta });

    fetch(opts.signUrl, { cache: 'no-store' })
      .then(function(r){
        if(!r.ok){ throw new Error('Server tidak merespons (HTTP ' + r.status + ')'); }
        return r.json();
      })
      .then(function(d){
        if(!d || !d.url){ throw new Error((d && d.error) || 'Link unduhan tidak tersedia'); }
        var fn = d.filename || displayName;
        self._show('connecting', { displayName: fn, meta: meta });
        /* HEAD pre-flight: tunggu sampai upstream Worker selesai resolve & TTFB tercapai.
           no-cors agar tidak butuh CORS header dari dl.aneetaku.cloud.
           Timeout 12 detik sebagai safety — tetap fire download walau HEAD lama. */
        return new Promise(function(resolve){
          var done = false;
          var finalize = function(){ if(!done){ done = true; resolve(d); } };
          var timer = setTimeout(finalize, 12000);
          fetch(d.url, { method: 'HEAD', mode: 'no-cors', cache: 'no-store' })
            .then(function(){ clearTimeout(timer); finalize(); })
            .catch(function(){ clearTimeout(timer); finalize(); });
        });
      })
      .then(function(d){
        var fn = d.filename || displayName;
        self._show('started', { displayName: fn, meta: meta });
        self._fire(d.url);
        self._closeTimer = setTimeout(function(){ self._hide(); }, 2400);
      })
      .catch(function(e){
        try { console.error('[Aneetaku] download error:', e); } catch(ee){}
        self._show('error', { displayName: displayName, meta: meta, errorMsg: (e && e.message) || 'Terjadi kesalahan' });
      });
  },

  /* ── Render state-aware modal toast (centered) ── */
  _show: function(state, ctx){
    var self = this;
    /* Hapus modal lama jika ada (state transition) */
    var existing = document.getElementById('ani-dl-modal');
    if(existing){ try{ existing.parentNode.removeChild(existing); }catch(e){} }

    var iconHtml = '', title = '', sub = '', showBar = false;
    var stateCls = ' ani-dl-modal--' + state;

    if(state === 'preparing'){
      iconHtml = '<div class="ani-dl-modal__spinner"></div>';
      title = 'Mempersiapkan unduhan';
      sub = 'Membuat tautan aman...';
      showBar = true;
    } else if(state === 'connecting'){
      iconHtml = '<div class="ani-dl-modal__spinner"></div>';
      title = 'Menghubungkan ke server';
      sub = 'Beberapa detik lagi, server sedang menyiapkan file...';
      showBar = true;
    } else if(state === 'started'){
      iconHtml = '<svg class="ani-dl-modal__check" viewBox="0 0 52 52" width="44" height="44">'
        + '<circle class="ani-dl-modal__check-c" cx="26" cy="26" r="23" fill="none" stroke-width="2.5"/>'
        + '<path class="ani-dl-modal__check-p" fill="none" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" d="M14 27 L23 36 L39 18"/>'
        + '</svg>';
      title = 'Unduhan dimulai!';
      sub = 'Cek folder unduhan browser kamu';
      showBar = false;
    } else if(state === 'error'){
      iconHtml = '<svg class="ani-dl-modal__x" viewBox="0 0 52 52" width="44" height="44">'
        + '<circle class="ani-dl-modal__x-c" cx="26" cy="26" r="23" fill="none" stroke-width="2.5"/>'
        + '<path class="ani-dl-modal__x-p" fill="none" stroke-width="3.5" stroke-linecap="round" d="M18 18 L34 34 M34 18 L18 34"/>'
        + '</svg>';
      title = 'Unduhan gagal';
      sub = ctx.errorMsg || 'Coba lagi atau pilih server lain';
      showBar = false;
    }

    var dn = ANI.util.esc(ctx.displayName || '');
    var mt = ANI.util.esc(ctx.meta || '');
    var btnLabel = (state === 'started' || state === 'error') ? 'Tutup' : 'Batal';

    var modal = document.createElement('div');
    modal.id = 'ani-dl-modal';
    modal.className = 'ani-dl-modal' + stateCls;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-live', 'polite');
    modal.innerHTML = '<div class="ani-dl-modal__backdrop" data-act="backdrop"></div>'
      + '<div class="ani-dl-modal__card" role="document">'
        + '<div class="ani-dl-modal__icon">' + iconHtml + '</div>'
        + '<div class="ani-dl-modal__title">' + ANI.util.esc(title) + '</div>'
        + '<div class="ani-dl-modal__sub">' + ANI.util.esc(sub) + '</div>'
        + (dn ? '<div class="ani-dl-modal__file"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg><span>' + dn + '</span></div>' : '')
        + (mt ? '<div class="ani-dl-modal__meta">' + mt + '</div>' : '')
        + (showBar ? '<div class="ani-dl-modal__bar"><div class="ani-dl-modal__bar-fill"></div></div>' : '')
        + '<div class="ani-dl-modal__actions">'
          + (state === 'error' ? '<button class="ani-dl-modal__btn ani-dl-modal__btn--retry" data-act="retry">Coba Lagi</button>' : '')
          + '<button class="ani-dl-modal__btn ani-dl-modal__btn--close" data-act="close">' + btnLabel + '</button>'
        + '</div>'
      + '</div>';
    document.body.appendChild(modal);

    /* Animasi enter */
    requestAnimationFrame(function(){ modal.classList.add('is-show'); });

    /* Event delegation: backdrop, close, retry */
    modal.addEventListener('click', function(e){
      var actEl = e.target.closest('[data-act]');
      if(!actEl) return;
      var act = actEl.dataset.act;
      if(act === 'backdrop'){
        /* Backdrop click: hanya boleh close kalau state terminal */
        if(state === 'started' || state === 'error'){ self._hide(); }
        return;
      }
      if(act === 'close'){ self._hide(); }
      else if(act === 'retry'){
        if(self._lastOpts){ self.start(self._lastOpts); }
      }
    });
  },

  _hide: function(){
    var self = this;
    if(self._closeTimer){ clearTimeout(self._closeTimer); self._closeTimer = null; }
    var modal = document.getElementById('ani-dl-modal');
    if(!modal) return;
    modal.classList.remove('is-show');
    setTimeout(function(){
      try { if(modal.parentNode) modal.parentNode.removeChild(modal); } catch(e){}
    }, 280);
  },

  /* ── Legacy API: simple trigger (back-compat for old callers) ── */
  trigger: function(url, filename){
    var self = this;
    self._fire(url);
    self._show('started', { displayName: filename || '', meta: '' });
    self._closeTimer = setTimeout(function(){ self._hide(); }, 2400);
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 02: API (Worker API v2)
   
   PERUBAHAN dari Blogger:
   - Semua endpoint mengarah ke api.aneetaku.cloud
   - Response shape: D1 rows, bukan Blogger Feed entries
   - Tidak ada lagi byLabel(), byPath(), recent() format Feed
   - Method baru: all(), bySlug(), featured(), ongoing(), 
     search(), byGenre(), schedule()
   ═══════════════════════════════════════════════ */

ANI.api = {
  _BASE: 'https://api.aneetaku.cloud',

  /* ── Internal fetch helper ── */
  _get: function(path){
    return fetch(this._BASE + path, { cache: 'default' })
      .then(function(r){
        if(!r.ok) throw new Error('API ' + r.status);
        return r.json();
      });
  },

  /* ── Public methods ── 
     Semua return Promise yang resolve ke JSON dari Worker API.
     Shape response:
       GET /api/anime       → { data: [anime_row, ...] }
       GET /api/anime/:slug → { data: { ...anime_row, episodes: [...] } }
       GET /api/schedule    → { data: { jumat: [...], senin: [...], ... } }
  */

  /**
   * List anime dengan filter opsional
   * @param {Object} params - { status, featured, genre, q, limit, schedule }
   * @returns {Promise<{data: Array}>}
   */
  all: function(params){
    var qs = [];
    if(params){
      if(params.status)   qs.push('status='   + encodeURIComponent(params.status));
      if(params.featured) qs.push('featured=1');
      if(params.genre)    qs.push('genre='    + encodeURIComponent(params.genre));
      if(params.q)        qs.push('q='        + encodeURIComponent(params.q));
      if(params.limit)    qs.push('limit='    + params.limit);
      if(params.schedule) qs.push('schedule=' + encodeURIComponent(params.schedule));
      /* Fase 1: pagination + extended filters */
      if(params.page)     qs.push('page='     + params.page);
      if(params.per_page) qs.push('per_page=' + params.per_page);
      if(params.sort)     qs.push('sort='     + encodeURIComponent(params.sort));
      if(params.type)     qs.push('type='     + encodeURIComponent(params.type));
      if(params.season)   qs.push('season='   + encodeURIComponent(params.season));
      if(params.year)     qs.push('year='     + params.year);
      if(params.studio)   qs.push('studio='   + encodeURIComponent(params.studio));
      if(params.genre_inc) qs.push('genre_inc=' + encodeURIComponent(params.genre_inc));
      if(params.genre_exc) qs.push('genre_exc=' + encodeURIComponent(params.genre_exc));
    }
    /* NSFW: explicit _nsfw override takes priority over pref auto-add */
    if(params && params._nsfw !== undefined){
      if(params._nsfw === '1') qs.push('nsfw=1');
      else if(params._nsfw === 'only') qs.push('nsfw=only');
      /* _nsfw='0' = explicitly hide, send nothing */
    } else {
      try { if(ANI.pref.getNsfw()) qs.push('nsfw=1'); } catch(e){}
    }
   try { if(ANI.pref.getExperimental()) qs.push('experimental=1'); } catch(e){}
    var query = qs.length ? '?' + qs.join('&') : '';
    return this._get('/api/anime' + query);
  },

  /**
   * Detail anime + episodes berdasarkan slug
   * @param {string} slug
   * @returns {Promise<{data: Object}>}
   */
  bySlug: function(slug){
    return this._get('/api/anime/' + encodeURIComponent(slug));
  },

  /**
   * Anime featured (is_featured = 1)
   * @param {number} n - max results
   */
  featured: function(n){
    return this.all({ featured: 1, limit: n || 5 });
  },

  /**
   * Anime ongoing
   * @param {number} n - max results
   */
  ongoing: function(n){
    return this.all({ status: 'ongoing', limit: n || 10 });
  },

  /**
   * Anime terbaru (default sort by updated_at desc)
   * @param {number} n - max results
   */
  recent: function(n){
    return this.all({ limit: n || 20 });
  },

  /**
   * Search by query string
   * @param {string} q - search query
   * @param {number} n - max results
   */
  search: function(q, n){
    return this.all({ q: q, limit: n || 12 });
  },

  /**
   * Filter by genre
   * @param {string} genre - genre name (lowercase)
   * @param {number} n - max results
   */
  byGenre: function(genre, n){
    return this.all({ genre: genre, limit: n || 50 });
  },

  /**
   * Jadwal tayang per hari
   * @returns {Promise<{data: Object}>} - keyed by day name
   */
  schedule: function(){
    return this._get('/api/schedule');
  },

/**
   * Search index — lightweight data untuk typeahead dropdown
   * @returns {Promise<{data: Array, ts: number}>}
   */
  index: function(){
    var qs = [];
    try { if(ANI.pref.getNsfw()) qs.push('nsfw=1'); } catch(e){}
    try { if(ANI.pref.getExperimental()) qs.push('experimental=1'); } catch(e){}
    var q = qs.length ? '?' + qs.join('&') : '';
    return this._get('/api/anime/index' + q);
  },

  /**
   * Facets — available genres, years, studios for catalog filters
   * @returns {Promise<{genres: Object, years: Object, studios: Object}>}
   */
  facets: function(){
    var qs = [];
    try { if(ANI.pref.getNsfw()) qs.push('nsfw=1'); } catch(e){}
    try { if(ANI.pref.getExperimental()) qs.push('experimental=1'); } catch(e){}
    var q = qs.length ? '?' + qs.join('&') : '';
    return this._get('/api/anime/facets' + q);
  },

  // ── Pemeran (Sprint 2) ──
  pemeranList: function(opts){
    opts = opts || {};
    var qs = [];
    if (opts.q)      qs.push('q=' + encodeURIComponent(opts.q));
    if (opts.limit)  qs.push('limit=' + (opts.limit | 0));
    if (opts.offset) qs.push('offset=' + (opts.offset | 0));
    var q = qs.length ? '?' + qs.join('&') : '';
    return this._get('/api/pemeran' + q);
  },
  pemeranBySlug: function(slug){
    return this._get('/api/pemeran/' + encodeURIComponent(slug));
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 02b: Search Index

   Preload ringan (~200 byte/anime) untuk instant search
   dropdown. Support alt_titles + auto-abbreviation.
   ═══════════════════════════════════════════════ */

ANI.searchIndex = {
  _data: null,    /* array of index items */
  _ready: false,
  _loading: false,
  _SS_KEY: 'ani_idx_v1',

  /* ── Abbreviation generator ──
     "Shingeki no Kyojin" → "snk"
     "Attack on Titan"    → "aot"
     Skip kata penghubung umum */
  _makeAbbr: function(title){
    if(!title) return '';
    var skip = ['no','na','ni','wa','wo','ga','de','to','the','of','a','an','and','in','on','at','for'];
    var words = title.split(/[\s\-:!.~,]+/);
    var abbr = '';
    for(var i = 0; i < words.length; i++){
      var w = words[i].toLowerCase();
      if(skip.indexOf(w) === -1 && words[i].length > 0){
        abbr += words[i].charAt(0);
      }
    }
    return abbr.length >= 2 ? abbr.toLowerCase() : '';
  },

  /* ── Build search-ready string for an item ──
     Gabung: title + alt_titles + abbreviations → satu lowercase string */
  _buildSearchStr: function(item){
    var parts = [(item.title || '').toLowerCase()];

    /* Alt titles */
    var alts = [];
    if(typeof item.alt_titles === 'string'){
      try { alts = JSON.parse(item.alt_titles); } catch(e){
        /* Mungkin comma-separated plain text */
        if(item.alt_titles) alts = item.alt_titles.split(',');
      }
    } else if(Array.isArray(item.alt_titles)){
      alts = item.alt_titles;
    }
    for(var i = 0; i < alts.length; i++){
      var a = (alts[i] || '').trim();
      if(a) parts.push(a.toLowerCase());
    }

    /* Abbreviations dari title + setiap alt title */
    var abbrMain = this._makeAbbr(item.title);
    if(abbrMain) parts.push(abbrMain);
    for(var j = 0; j < alts.length; j++){
      var abbrAlt = this._makeAbbr((alts[j] || '').trim());
      if(abbrAlt) parts.push(abbrAlt);
    }

    return parts.join(' || ');
  },

  /* ── Preload: fetch index lalu cache ── */
  preload: function(){
    var self = this;
    if(self._loading || self._ready) return;

    /* Cek sessionStorage cache */
    try{
      var nsfwSuffix = ANI.pref.getNsfw() ? 'n' : '';
      var raw = sessionStorage.getItem(self._SS_KEY + nsfwSuffix);
      if(raw){
        var cached = JSON.parse(raw);
        /* Cache valid 10 menit */
        if(Date.now() - cached.ts < 600000){
          self._data = cached.d;
          self._ready = true;
          return;
        }
      }
    }catch(e){}

    self._loading = true;
    ANI.api.index().then(function(res){
      var rows = res.data || [];
      /* Build search-ready items */
      self._data = rows.map(function(row){
        return {
          slug:   row.slug,
          title:  row.title || '',
          cover:  row.cover || '',
          type:   row.type || 'TV',
          status: row.status || '',
          year:   String(row.year || ''),
          isNsfw: !!(row.is_nsfw),
          /* Pre-computed search string */
          _s: self._buildSearchStr(row),
          /* URL & thumb for dropdown render */
          url:   '/anime/' + (row.slug || ''),
          thumb: ANI.util.driveThumb(row.cover, 200)
        };
      });
      self._ready = true;
      self._loading = false;

      /* Cache ke sessionStorage */
      try{
        var nsfwSuffix = ANI.pref.getNsfw() ? 'n' : '';
        sessionStorage.setItem(self._SS_KEY + nsfwSuffix, JSON.stringify({
          ts: Date.now(),
          d: self._data
        }));
      }catch(e){}
    }).catch(function(){
      self._loading = false;
    });
  },

  /* ── Search: client-side fuzzy match ── */
  search: function(q){
    if(!this._ready || !this._data) return null;
    var lq = q.toLowerCase().trim();
    if(!lq) return [];

    var results = [];
    for(var i = 0; i < this._data.length; i++){
      var item = this._data[i];
      if(item._s.indexOf(lq) !== -1){
        results.push(item);
      }
    }
    return results;
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 02c: Pagination

   Reusable pagination untuk search, genre, catalog.
   Responsive: full buttons desktop, compact mobile.
   ═══════════════════════════════════════════════ */

ANI.pagination = {
  /**
   * Generate array of page indicators
   * @param {number} current - halaman aktif (1-based)
   * @param {number} total   - total halaman
   * @returns {Array} e.g. [1, 2, 3, '...', 20]
   */
  _getPages: function(current, total){
    if(total <= 7){
      var all = [];
      for(var i = 1; i <= total; i++) all.push(i);
      return all;
    }
    var pages = [];
    pages.push(1);

    var start = Math.max(2, current - 1);
    var end   = Math.min(total - 1, current + 1);
    /* Pastikan minimal 3 angka terlihat di window */
    if(current <= 3) end = Math.min(total - 1, 4);
    if(current >= total - 2) start = Math.max(2, total - 3);

    if(start > 2) pages.push('...');
    for(var j = start; j <= end; j++) pages.push(j);
    if(end < total - 1) pages.push('...');

    pages.push(total);
    return pages;
  },

  /**
   * Render pagination HTML
   * @param {number} current  - halaman aktif
   * @param {number} total    - total halaman
   * @param {string} containerId - ID element container
   * @returns {string} HTML string
   */
  render: function(current, total, containerId){
    if(total <= 1) return '';
    var pages = this._getPages(current, total);
    var prevDisabled = current <= 1 ? ' is-disabled' : '';
    var nextDisabled = current >= total ? ' is-disabled' : '';

    var html = '<nav class="pagination" id="' + (containerId || 'pg-nav') + '" aria-label="Navigasi halaman">';

    /* Prev button */
    html += '<button class="pg-btn' + prevDisabled + '" data-pg="' + (current - 1) + '" aria-label="Halaman sebelumnya">' +
      '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="15,18 9,12 15,6"/></svg>' +
    '</button>';

    /* Page numbers (desktop/tablet) */
    html += '<div class="pg-pages">';
    for(var i = 0; i < pages.length; i++){
      if(pages[i] === '...'){
        html += '<span class="pg-ellipsis">…</span>';
      } else {
        var isActive = pages[i] === current ? ' is-active' : '';
        html += '<button class="pg-btn' + isActive + '" data-pg="' + pages[i] + '" aria-label="Halaman ' + pages[i] + '">' + pages[i] + '</button>';
      }
    }
    html += '</div>';

    /* Compact indicator (mobile) */
    html += '<div class="pg-compact"><strong>' + current + '</strong> / ' + total + '</div>';

    /* Next button */
    html += '<button class="pg-btn' + nextDisabled + '" data-pg="' + (current + 1) + '" aria-label="Halaman berikutnya">' +
      '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="9,18 15,12 9,6"/></svg>' +
    '</button>';

    html += '</nav>';
    return html;
  },

  /**
   * Bind click events pada pagination container
   * @param {string}   containerId - ID nav element
   * @param {function} callback    - fn(pageNumber)
   */
  bind: function(containerId, callback){
    var nav = document.getElementById(containerId);
    if(!nav) return;
    nav.addEventListener('click', function(e){
      var btn = e.target.closest('.pg-btn');
      if(!btn || btn.classList.contains('is-active') || btn.classList.contains('is-disabled')) return;
      var pg = parseInt(btn.dataset.pg);
      if(!isNaN(pg) && pg >= 1) callback(pg);
    });
  },

  /**
   * Update URL query param tanpa reload
   * @param {string} key   - param name (e.g. 'page')
   * @param {string} value - param value
   */
  _updateURL: function(key, value){
    try{
      var url = new URL(window.location.href);
      if(value && String(value) !== '1'){
        url.searchParams.set(key, value);
      } else {
        url.searchParams.delete(key);
      }
      history.replaceState(null, '', url.toString());
    }catch(e){}
  },

  /**
   * Smooth scroll ke atas grid/container
   * @param {string} selector - CSS selector target
   */
  scrollToTop: function(selector){
    try{
      var el = document.querySelector(selector);
      if(!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }catch(e){}
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 03: Parse
   
   PERUBAHAN dari Blogger v27:
   - Tambah fromDB(row, episodes) → aniData format
   - Tambah fromDBEntry(row) → fake Blogger entry (adapter)
   - Tambah fromDBSlim(row) → slim object untuk catalog
   - aniData() masih ada tapi di CF Pages jarang dipakai
   - Method DOM (aniDataFromDOM dll) di-strip karena 
     tidak ada Blog1 widget di CF Pages
   ═══════════════════════════════════════════════ */

ANI.parse = {
  _dbg: function(msg){ if(window.console) console.log('[ANI.parse]', msg); },

  /* ── Safe JSON parse ── */
  _safeParse: function(str, fallback){
    if(!str) return fallback;
    try { return JSON.parse(str); } catch(e) { return fallback; }
  },

  /* ══════════════════════════════════════════════
     BRIDGE: D1 row → internal format
     
     Ini adalah jantung migrasi. Semua render module
     expect format (entry, aniData) dari Blogger.
     fromDB* methods mengkonversi D1 rows ke format 
     yang sama persis.
     ══════════════════════════════════════════════ */

  /**
   * Konversi D1 anime row → format aniData internal
   * Shape output identik dengan yang dihasilkan aniData(entry) di v27
   * 
   * @param {Object} row - D1 anime row (dari GET /api/anime/:slug)
   * @param {Array}  episodes - array of episode rows (dari row.episodes atau terpisah)
   * @returns {Object} aniData format: { series, season, schedule, episodes }
   */
  fromDB: function(row, episodes){
    if(!row) return null;
    var info = this._safeParse(row.info, {});
    var altTitles = this._safeParse(row.alt_titles, []);

    /* Pastikan genres ada di info (bisa dari D1 info JSON) */
    if(!info.genres) info.genres = [];

    /* Normalisasi episodes dari D1 rows */
    var eps = (episodes || []).map(function(ep){
      return {
        ep:        ep.ep,
        title:     ep.title || '',
        thumb:     ep.thumb || '',
        airDate:   ep.air_date || '',
        oped:      ep.oped || '',
        servers:   ANI.parse._safeParse(ep.servers, []),
        downloads: ANI.parse._safeParse(ep.downloads, []),
        subtitles: ANI.parse._safeParse(ep.subtitles, [])
      };
    });

    /* Sort episodes by ep number */
    eps.sort(function(a,b){ return a.ep - b.ep; });

    return {
      series: {
        title:    row.title || '',
        slug:     row.slug || '',
        cover:    row.cover || '',
        banner:   row.banner || '',
        synopsis: row.synopsis || '',
        trailer:  row.trailer || '',
        alt:      altTitles,
        info:     info
      },
      season: {
        number: row.season_number || 1,
        title:  row.season_title || 'Season 1'
      },
      schedule: {
        day:  row.schedule_day || '',
        time: row.schedule_time || ''
      },
      episodes: eps
    };
  },

  /**
   * Konversi D1 anime row → fake Blogger entry object
   * Supaya ANI.render.animeCard(entry, aniData), heroSlide(entry, aniData), dll
   * bisa dipakai tanpa modifikasi
   * 
   * PENTING: _cachedAniData di-set otomatis supaya
   * ANI.parse.aniData(entry) return data yang benar
   * 
   * @param {Object} row - D1 anime row
   * @param {Array}  episodes - optional episode rows
   * @returns {Object} fake entry dengan shape mirip Blogger Feed entry
   */
  fromDBEntry: function(row, episodes){
    if(!row) return {};
    var info = this._safeParse(row.info, {});
    var genres = (info.genres || []).map(function(g){
      return { term: 'g:' + g };
    });

    /* Rebuild label-style categories */
    var cats = genres.slice(); /* clone */
    if(info.status)  cats.push({ term: 'status:' + info.status.toLowerCase() });
    if(info.type)    cats.push({ term: 'type:' + info.type.toLowerCase() });
    if(row.is_new)   cats.push({ term: 'new' });

    var entry = {
      title: { $t: row.title || '' },
      link:  [{ rel: 'alternate', href: '/anime/' + (row.slug || '') }],
      category: cats,
      /* published.$t dipakai oleh year() fallback */
      published: { $t: row.created_at || '' }
    };

    /* Auto-cache aniData supaya aniData(entry) langsung return data */
    var aniData = this.fromDB(row, episodes || []);
    /* Jika API return latest_ep (dari list query), inject fake episode supaya latestEp() work */
    if(row.latest_ep && (!aniData.episodes || !aniData.episodes.length)){
      aniData.episodes = [{ ep: row.latest_ep }];
    }
    aniData._raw = row;
    entry._cachedAniData = aniData;

    return entry;
  },

  /**
   * Konversi D1 anime row → slim object untuk catalog + search
   * Shape identik dengan slim object di ANI.catalog v27
   * Dipakai oleh ANI.render.catalogCard(slim)
   * 
   * @param {Object} row - D1 anime row
   * @returns {Object} slim catalog object
   */
  fromDBSlim: function(row){
    if(!row) return null;
    var info = this._safeParse(row.info, {});
    var genres = (info.genres || []).map(function(g){ return g.toLowerCase(); });
    var nsfwG = (info.nsfw_genres || []).map(function(g){ return g.toLowerCase().replace(/ /g,'_'); });
    genres = genres.concat(nsfwG);

    return {
      /* Render fields (untuk catalogCard, animeCard) */
      url:    '/anime/' + (row.slug || ''),
      thumb:  ANI.util.driveThumb(row.cover, 400),
      title:  row.title || 'Untitled',
      score:  info.score || 0,
      status: info.status || '',
      type:   info.type || 'TV',
      year:   String(info.year || ''),
      latEp:  row.latest_ep || null,
      isNew:  !!(row.is_new),
      isNsfw: !!(row.is_nsfw),

      /* Filter fields (untuk catalog filter/sort) */
      _type:    (info.type || '').toLowerCase(),
      _status:  (info.status || '').toLowerCase(),
      _genres:  genres,
      _season:  (info.season || '').toLowerCase(),
      _year:    String(info.year || ''),
      _title:   (row.title || '').toLowerCase(),
      _score:   info.score || 0,
      _studio:  (info.studio || '').trim()
    };
  },

  /**
   * Konversi sibling row (dari API siblings array) → fake entry
   * Sibling row hanya punya: slug, title, cover, season_number, season_title, info
   * Dipakai oleh series.js untuk allSeasons tabs/nav
   */
  fromDBSibling: function(row){
    if(!row) return {};
    var info = this._safeParse(row.info, {});

    var entry = {
      title: { $t: row.title || '' },
      link:  [{ rel: 'alternate', href: '/anime/' + (row.slug || '') }],
      category: [],
      published: { $t: '' }
    };

    /* Cache aniData minimal (tanpa episodes — hanya untuk season info) */
    entry._cachedAniData = {
      series: {
        title:    row.title || '',
        slug:     row.slug || '',
        cover:    row.cover || '',
        banner:   '',
        synopsis: '',
        trailer:  '',
        alt:      [],
        info:     info
      },
      season: {
        number: row.season_number || 1,
        title:  row.season_title || 'Season 1'
      },
      schedule: { day: '', time: '' },
      episodes: [],
      _ep_count: row.ep_count || 0
    };

    return entry;
  },

  /* ══════════════════════════════════════════════
     LEGACY METHODS — untuk kompatibilitas
     Render modules memanggil ini dengan (entry, aniData)
     di mana entry bisa jadi fake entry dari fromDBEntry()
     ══════════════════════════════════════════════ */

  /* Decode HTML entities */
  _decodeEntities: function(str){
    if(!str) return '';
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  },

  /* Try parse JSON string, return null if fail */
  _tryParse: function(str){
    if(!str) return null;
    var s = str.trim();
    s = s.replace(/<br\s*\/?>/gi, '\n').replace(/<\/?p>/gi, '').trim();
    if(s.indexOf('&') !== -1) s = this._decodeEntities(s);
    try { var obj = JSON.parse(s); return (obj && obj.series) ? obj : null; }
    catch(e) { return null; }
  },

  /* aniData() — smart resolver: works with D1 fake entries AND legacy Blogger entries
     Priority:
     1. _cachedAniData (set oleh fromDBEntry, paling umum di CF Pages)
     2. entry.series (jika entry sudah berupa aniData langsung)
     3. entry.content.$t (legacy Blogger format, fallback)
  */
  aniData: function(entry){
    /* D1 fake entry: aniData di-cache di property */
    if(entry && entry._cachedAniData) return entry._cachedAniData;
    /* Jika entry sudah berupa aniData (punya .series), return langsung */
    if(entry && entry.series) return entry;
    /* Legacy Blogger: parse dari content HTML */
    if(entry && entry.content && entry.content.$t){
      return this._extractJsonFromHtml(entry.content.$t);
    }
    return null;
  },

  /* Regex extract dari HTML string — legacy, untuk edge cases */
  _extractJsonFromHtml: function(html){
    if(!html) return null;
    var patterns = [
      /(<textarea[^>]*>)([\s\S]*?)(<\/textarea>)/i,
      /(<script[^>]*type=['"]application\/json['"][^>]*>)([\s\S]*?)(<\/script>)/i
    ];
    for(var i = 0; i < patterns.length; i++){
      var m = html.match(patterns[i]);
      if(m && m[2]){
        var result = this._tryParse(m[2]);
        if(result) return result;
      }
    }
    var jsonMatch = html.match(/\{[\s\S]*?"series"\s*:\s*\{[\s\S]*?"title"[\s\S]*?\}\s*\}/);
    if(jsonMatch) return this._tryParse(jsonMatch[0]);
    return null;
  },

  /* ── Field extractors — bekerja dengan entry asli maupun fake entry ── */

  labels: function(entry){
    if(!entry) return [];
    var cats = entry.category || [];
    return cats.map(function(c){ return c.term; });
  },

  thumb: function(entry, aniData){
    if(aniData && aniData.series && aniData.series.cover){
      return ANI.util.driveThumb(aniData.series.cover, 400);
    }
    if(entry){
      var mt = entry.media$thumbnail;
      if(mt && mt[0]) return mt[0].url.replace('/s72-c/', '/s400-c/');
    }
    return 'https://via.placeholder.com/200x300/10101c/6c63ff?text=No+Cover';
  },

  banner: function(aniData){
    if(aniData && aniData.series && aniData.series.banner){
      return ANI.util.tmdbBanner(aniData.series.banner);
    }
    return null;
  },

  url: function(entry){
    if(!entry) return '#';
    var links = entry.link || [];
    for(var i = 0; i < links.length; i++){
      if(links[i].rel === 'alternate') return links[i].href;
    }
    return '#';
  },

  score: function(aniData){
    return aniData && aniData.series && aniData.series.info ? aniData.series.info.score : null;
  },

  status: function(entry, aniData){
    if(aniData && aniData.series && aniData.series.info && aniData.series.info.status){
      return aniData.series.info.status;
    }
    var labels = this.labels(entry);
    for(var i = 0; i < labels.length; i++){
      if(labels[i].indexOf('status:') === 0) return labels[i].replace('status:', '');
    }
    return '';
  },

  type: function(entry, aniData){
    if(aniData && aniData.series && aniData.series.info && aniData.series.info.type){
      return aniData.series.info.type;
    }
    return 'TV';
  },

  year: function(entry, aniData){
    if(aniData && aniData.series && aniData.series.info && aniData.series.info.year){
      return aniData.series.info.year;
    }
    var pub = entry && entry.published && entry.published.$t;
    return pub ? pub.substring(0, 4) : '';
  },

  genres: function(entry){
    var labels = this.labels(entry);
    return labels.filter(function(l){ return l.indexOf('g:') === 0; })
                 .map(function(l){ return l.replace('g:', ''); });
  },

  getEpisodes: function(aniData){
    if(!aniData) return [];
    if(aniData.episodes && aniData.episodes.length) return aniData.episodes;
    if(aniData.seasons && aniData.seasons.length){
      var lastS = aniData.seasons[aniData.seasons.length - 1];
      if(lastS && lastS.episodes) return lastS.episodes;
    }
    return [];
  },

  latestEp: function(aniData){
    var eps = this.getEpisodes(aniData);
    return eps.length ? eps[eps.length - 1] : null;
  },

  schedule: function(aniData){
    if(aniData && aniData.schedule) return aniData.schedule;
    return null;
  },

  seasonTag: function(entry){ return ''; },
  yearTag: function(entry){ return ''; }
};
/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 04: Render
   
   TIDAK ADA PERUBAHAN dari v27.
   Semua method menerima (entry, aniData) atau (slim).
   Bridge pattern di parse.fromDBEntry() memastikan
   D1 data compatible dengan semua method ini.
   ═══════════════════════════════════════════════ */

ANI.render = {
  svgPlay: '<svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21" fill="#fff"/></svg>',
  svgStar: '<svg width="9" height="9" viewBox="0 0 24 24" fill="var(--c-yellow)"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>',

  statusBadge: function(status){
    var s = (status || '').toLowerCase();
    if(s === 'ongoing')   return '<span class="badge badge-ongoing"><span class="status-dot status-dot--ongoing"></span>Ongoing</span>';
    if(s === 'completed') return '<span class="badge badge-completed"><span class="status-dot status-dot--completed"></span>Completed</span>';
    if(s === 'upcoming')  return '<span class="badge badge-upcoming"><span class="status-dot status-dot--upcoming"></span>Upcoming</span>';
    return '';
  },

  typeClass: function(type){
    var t = (type || '').toLowerCase();
    if(t === 'tv') return 'card-type card-type--tv';
    if(t === 'movie') return 'card-type card-type--movie';
    if(t === 'ova' || t === 'ona') return 'card-type card-type--ova';
    if(t === 'special') return 'card-type card-type--special';
    return 'card-type card-type--tv';
  },

  animeCard: function(entry, aniData, idx){
    var url    = ANI.parse.url(entry);
    var thumb  = ANI.parse.thumb(entry, aniData);
    var title  = ANI.util.esc((aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled');
    var score  = ANI.parse.score(aniData);
    var status = ANI.parse.status(entry, aniData);
    var type   = ANI.parse.type(entry, aniData);
    var year   = ANI.parse.year(entry, aniData);
    var latEp  = ANI.parse.latestEp(aniData);
    var delay  = idx < 6 ? (' anim-d' + (idx + 1)) : '';

    var statusBadge = this.statusBadge(status);
    var isMovieType = (type || '').toLowerCase() === 'movie';
    var epBadge  = (!isMovieType && latEp) ? ('<span class="badge badge-ep">Ep. ' + latEp.ep + '</span>') : '';
    var isNsfw = false;
    try { isNsfw = entry._cachedAniData && entry._cachedAniData._raw && entry._cachedAniData._raw.is_nsfw; } catch(e){}
    var isRaw = false;
    try { isRaw = entry._cachedAniData && entry._cachedAniData._raw && entry._cachedAniData._raw.is_new; } catch(e){}
    var rawBadge  = isRaw  ? '<div class="badge-raw" title="Belum ada subtitle Indonesia">RAW</div>' : '';
    var nsfwBadge = isNsfw ? '<div class="badge-nsfw">NSFW</div>' : '';
    var scoreBadge = score ? ('<div class="badge-score card-score-badge">' + this.svgStar + score + '</div>') : '';

    return '<a href="' + url + '" class="anime-card anim-slide-up' + delay + '" aria-label="' + title + '">' +
      '<div class="poster-wrap">' +
        '<img class="card-poster" src="' + thumb + '" alt="' + title + '" loading="lazy" width="200" height="300"/>' +
        '<div class="card-overlay"><div class="play-circle">' + this.svgPlay + '</div></div>' +
        '<div class="card-badges">' + statusBadge + epBadge + '</div>' +
        '<div class="card-bottom-badges">' + rawBadge + nsfwBadge + scoreBadge + '</div>' +
      '</div>' +
      '<div class="card-body">' +
        '<div class="card-title">' + title + '</div>' +
        '<div class="card-meta"><span class="' + this.typeClass(type) + '">' + type + '</span><span class="dot"></span><span>' + year + '</span></div>' +
      '</div>' +
    '</a>';
  },

  catalogCard: function(slim, idx){
    var title = ANI.util.esc(slim.title || 'Untitled');
    var delay = idx < 6 ? (' anim-d' + (idx + 1)) : '';
    var statusBadge = this.statusBadge(slim.status);
    var isMovieType = (slim.type || '').toLowerCase() === 'movie';
    var epBadge   = (!isMovieType && slim.latEp)  ? '<span class="badge badge-ep">Ep. ' + slim.latEp + '</span>' : '';
    var rawBadge  = slim.isNew  ? '<div class="badge-raw" title="Belum ada subtitle Indonesia">RAW</div>' : '';
    var nsfwBadge = slim.isNsfw ? '<div class="badge-nsfw">NSFW</div>' : '';
    var scoreBadge = slim.score ? '<div class="badge-score card-score-badge">' + this.svgStar + slim.score + '</div>' : '';
    return '<a href="' + slim.url + '" class="anime-card anim-slide-up' + delay + '" aria-label="' + title + '">' +
      '<div class="poster-wrap">' +
        '<img class="card-poster" src="' + slim.thumb + '" alt="' + title + '" loading="lazy" width="200" height="300"/>' +
        '<div class="card-overlay"><div class="play-circle">' + this.svgPlay + '</div></div>' +
        '<div class="card-badges">' + statusBadge + epBadge + '</div>' +
        '<div class="card-bottom-badges">' + rawBadge + nsfwBadge + scoreBadge + '</div>' +
      '</div>' +
      '<div class="card-body">' +
        '<div class="card-title">' + title + '</div>' +
        '<div class="card-meta"><span class="' + this.typeClass(slim.type) + '">' + slim.type + '</span><span class="dot"></span><span>' + slim.year + '</span></div>' +
      '</div>' +
    '</a>';
  },

  catalogListItem: function(slim, idx){
    var title = ANI.util.esc(slim.title || 'Untitled');
    var s = (slim.status || '').toLowerCase();
    var dotCls = s === 'ongoing' ? 'status-dot--ongoing' : s === 'completed' ? 'status-dot--completed' : 'status-dot--upcoming';
    var isMovieType = (slim.type || '').toLowerCase() === 'movie';
    var epText = (!isMovieType && slim.latEp) ? 'Ep ' + slim.latEp : '';
    var nsfwBadge = slim.isNsfw ? '<span class="cli-nsfw">18+</span>' : '';
    var rawBadge = slim.isNew ? '<span class="cli-raw">RAW</span>' : '';
    var scoreBadge = slim.score ? '<span class="cli-score">'+this.svgStar+slim.score+'</span>' : '';
    /* Meta line parts (filter empty) */
    var metaParts = [];
    if(slim.type)  metaParts.push('<span class="cli-type '+this.typeClass(slim.type)+'">'+slim.type+'</span>');
    if(slim.year)  metaParts.push('<span class="cli-year">'+slim.year+'</span>');
    if(epText)     metaParts.push('<span class="cli-ep">'+epText+'</span>');
    if(s)          metaParts.push('<span class="cli-status cli-status--'+s+'">'+(s.charAt(0).toUpperCase()+s.slice(1))+'</span>');
    return '<a href="'+slim.url+'" class="anime-list-item" aria-label="'+title+'">' +
      '<span class="cli-dot"><span class="status-dot '+dotCls+'"></span></span>' +
      '<div class="cli-main">' +
        '<div class="cli-title-row">' +
          '<span class="cli-title">'+title+'</span>' +
          rawBadge + nsfwBadge +
        '</div>' +
        '<div class="cli-meta">' + metaParts.join('<span class="cli-sep">·</span>') + '</div>' +
      '</div>' +
      scoreBadge +
    '</a>';
  },

  ongoingCard: function(entry, aniData){
    var url    = ANI.parse.url(entry);
    var thumb  = ANI.parse.thumb(entry, aniData);
    var title  = ANI.util.esc((aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled');
    var latEp  = ANI.parse.latestEp(aniData);
    var isNew  = ANI.parse.labels(entry).indexOf('new') !== -1;
    var epText = latEp ? ('Episode ' + latEp.ep) : 'Episode ?';
    var newBadge = isNew ? '<span class="oc-new">NEW</span>' : '';
    /* Arahkan langsung ke episode terbaru jika tersedia */
    var epUrl  = (latEp && latEp.ep) ? (url + '?ep=' + latEp.ep) : url;
    return '<a href="' + epUrl + '" class="oc-card">' +
      '<div class="oc-poster"><img src="' + thumb + '" alt="' + title + '" loading="lazy"/></div>' +
      '<div class="oc-info">' +
        '<div class="oc-title">' + title + '</div>' +
        '<div class="oc-ep">' + epText + '</div>' +
        newBadge +
      '</div>' +
    '</a>';
  },

  /* ── Popular widget: 3-tier Spotlight layout ── */
  popSpotlight: function(entry, aniData){
    var url    = ANI.parse.url(entry);
    var thumb  = ANI.parse.thumb(entry, aniData);
    var title  = ANI.util.esc((aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled');
    var score  = ANI.parse.score(aniData);
    var genres = ANI.parse.genres(entry).slice(0, 2);
    var tags   = genres.map(function(g){ return '<span class="pop-tag">' + ANI.util.fmtGenre(g) + '</span>'; }).join('');
    var pct    = score ? Math.round(score * 10) : 0;
    return '<a href="' + url + '" class="pop-spotlight">' +
      '<div class="pop-spotlight__poster">' +
        '<img src="' + thumb + '" alt="' + title + '" loading="lazy"/>' +
        '<div class="pop-spotlight__rank">1</div>' +
      '</div>' +
      '<div class="pop-spotlight__info">' +
        '<div class="pop-spotlight__title">' + title + '</div>' +
        '<div class="pop-spotlight__tags">' + tags + '</div>' +
        '<div class="pop-spotlight__bar">' +
          '<div class="pop-spotlight__track"><div class="pop-spotlight__fill" style="width:' + pct + '%"></div></div>' +
          '<span class="pop-spotlight__score">' + (score || '') + '</span>' +
        '</div>' +
      '</div>' +
    '</a>';
  },
  popMidCard: function(entry, aniData, rank){
    var url    = ANI.parse.url(entry);
    var title  = ANI.util.esc((aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled');
    var score  = ANI.parse.score(aniData);
    var cls    = rank === 2 ? 'rank-silver' : 'rank-bronze';
    return '<a href="' + url + '" class="pop-mid-card">' +
      '<div class="pop-mid__head">' +
        '<div class="pop-mid__rank ' + cls + '">' + rank + '</div>' +
        '<div class="pop-mid__score ' + cls + '">' + (score || '') + '</div>' +
      '</div>' +
      '<div class="pop-mid__title">' + title + '</div>' +
    '</a>';
  },
  popCompact: function(entry, aniData, rank){
    var url    = ANI.parse.url(entry);
    var thumb  = ANI.parse.thumb(entry, aniData);
    var title  = ANI.util.esc((aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled');
    var score  = ANI.parse.score(aniData);
    return '<a href="' + url + '" class="pop-compact">' +
      '<div class="pop-compact__rank">' + rank + '</div>' +
      '<div class="pop-compact__thumb"><img src="' + thumb + '" alt="' + title + '" loading="lazy"/></div>' +
      '<div class="pop-compact__title">' + title + '</div>' +
      '<div class="pop-compact__score">' + (score || '') + '</div>' +
    '</a>';
  },
  /* Legacy popularItem — used by series page Season Lain */
  popularItem: function(entry, aniData, rank){
    var url    = ANI.parse.url(entry);
    var thumb  = ANI.parse.thumb(entry, aniData);
    var title  = ANI.util.esc((aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled');
    var genres = ANI.parse.genres(entry).slice(0, 2);
    var tags   = genres.map(function(g){ return '<span class="pop-tag">' + ANI.util.fmtGenre(g) + '</span>'; }).join('');
    return '<a href="' + url + '" class="popular-item">' +
      '<div class="pop-thumb"><img src="' + thumb + '" alt="' + title + '" loading="lazy"/></div>' +
      '<div class="pop-info">' +
        '<div class="pop-title">' + title + '</div>' +
        '<div class="pop-tags">' + tags + '</div>' +
      '</div>' +
    '</a>';
  },

  skeletonCards: function(n, type){
    var html = '', i;
    if(type === 'ongoing'){
      for(i = 0; i < n; i++){
        html += '<div class="skel-strip-card">' +
          '<div class="skel skel-strip-thumb"></div>' +
          '<div style="flex:1">' +
            '<div class="skel skel-line skel-line--lg"></div>' +
            '<div class="skel skel-line skel-line--sm"></div>' +
          '</div></div>';
      }
    } else {
      for(i = 0; i < n; i++){
        html += '<div class="skel-card">' +
          '<div class="skel skel-poster"></div>' +
          '<div class="skel skel-line skel-line--lg"></div>' +
          '<div class="skel skel-line skel-line--sm"></div>' +
        '</div>';
      }
    }
    return html;
  },

  heroSlide: function(entry, aniData){
    var url     = ANI.parse.url(entry);
    var title   = (aniData && aniData.series && aniData.series.title) || (entry.title && entry.title.$t) || 'Untitled';
    var altTitle = aniData && aniData.series && aniData.series.alt && aniData.series.alt[0] ? aniData.series.alt[0] : '';
    var banner  = ANI.parse.banner(aniData) || ANI.parse.thumb(entry, aniData);
    var score   = ANI.parse.score(aniData);
    var status  = ANI.parse.status(entry, aniData);
    var info    = aniData && aniData.series && aniData.series.info || {};
    var synopsis = aniData && aniData.series && aniData.series.synopsis || '';
    var latEp   = ANI.parse.latestEp(aniData);
    var epLabel = latEp ? ('Ep ' + latEp.ep) : ' ';

    return {
      banner: banner, title: title, altTitle: altTitle, score: score,
      status: status, info: info, synopsis: synopsis, url: url, epLabel: epLabel
    };
  }
};
/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 05: Home + SearchLabel + SearchResult
   
   PERUBAHAN dari v27:
   - home.init(): tidak ada __searchLabel/__searchQuery 
     (routing di-handle oleh init() global)
   - loadAll(): semua calls ganti ke ANI.api.featured/ongoing/recent
   - Response D1 rows → convert via fromDBEntry() sebelum render
   - searchLabel: parse label dari URL, map ke API params
   - searchResult: parse q dari URL, pakai ANI.api.search()
   ═══════════════════════════════════════════════ */

/* ── Helper: konversi D1 rows → fake entries untuk render ── */
function _rowsToEntries(rows){
  return (rows || []).map(function(row){
    return ANI.parse.fromDBEntry(row);
  });
}

/* ─ HOME MODULE ─ */
ANI.home = {
  slides: [], currentSlide: 0, slideTimer: null,

  init: function(){
    /* Di CF Pages, routing ke searchLabel/searchResult 
       sudah di-handle oleh init() global via URL pattern.
       home.init() HANYA untuk halaman beranda. */
    this.buildLayout();
    this.loadAll();
  },

  buildLayout: function(){
    document.getElementById('app-content').innerHTML =
      '<section id="home-hero" class="hero" aria-label="Featured anime">' +
        '<img id="hero-bg" class="hero-bg-img" src="" alt="" aria-hidden="true"/>' +
        '<div class="hero-gradient"></div>' +
        '<div class="hero-vignette"></div>' +
        '<div class="hero-content" id="hero-content">' +
          '<div class="spinner" style="margin:40px 0"></div>' +
        '</div>' +
        '<div class="hero-indicators" id="hero-indicators"></div>' +
      '</section>' +

      '<section class="section" aria-label="Sedang tayang">' +
        '<div class="section-header">' +
          '<h2 class="section-title">Update Terbaru</h2>' +
          '<a href="/status/ongoing" class="section-link">Lihat semua &#8594;</a>' +
        '</div>' +
        '<div id="ongoing-strip" class="ongoing-strip">' + this.skels('ongoing', 10) + '</div>' +
      '</section>' +

      '<section class="genre-nav-wrap" aria-label="Navigasi genre">' +
        '<div class="genre-nav-inner">' +
        '<button class="genre-nav-btn genre-nav-btn--prev" id="genre-prev" aria-label="Sebelumnya"><svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="15,18 9,12 15,6"/></svg></button>' +
        '<div class="genre-nav" id="genre-nav" role="list">' +
          ['Semua','Action','Romance','Isekai','Mecha','Horror','Slice of Life','Sports','Supernatural','Comedy','Drama','Mystery','Sci-Fi'].map(function(g, i){
            var slug = g.toLowerCase().replace(/ /g, '_');
            var href = i === 0 ? '/' : ('/genre/' + slug);
            return '<a href="' + href + '" class="genre-tag' + (i === 0 ? ' is-active' : '') + '" role="listitem">' + g + '</a>';
          }).join('') +
        '</div>' +
        '<button class="genre-nav-btn genre-nav-btn--next" id="genre-next" aria-label="Berikutnya"><svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="9,18 15,12 9,6"/></svg></button>' +
        '</div>' +
      '</section>' +

      '<div class="home-grid">' +
        '<div class="home-main">' +
          '<div class="section-header">' +
            '<h2 class="section-title">Baru Ditambahkan</h2>' +
            '<a href="/status/completed" class="section-link">Lihat semua &#8594;</a>' +
          '</div>' +
          '<div id="recent-grid" class="anime-grid">' + this.skels('card', 20) + '</div>' +
        '</div>' +
        '<aside class="home-sidebar" aria-label="Sidebar">' +
          '<div class="anee-greet" role="complementary" aria-label="Sapaan Anee-chan">' +
            '<div class="anee-greet__avatar"><img src="/assets/mascot/anee-chan.png" alt="" aria-hidden="true" loading="lazy" decoding="async"/></div>' +
            '<div class="anee-greet__body">' +
              '<div class="anee-greet__eyebrow">Halo, Otaku-san!</div>' +
              '<div class="anee-greet__title">Aku <b>Anee-chan</b>~</div>' +
              '<div class="anee-greet__tip">Hari ini ada beberapa episode baru menunggumu. Selamat menonton!</div>' +
            '</div>' +
          '</div>' +
          '<div class="widget-box">' +
            '<div class="widget-title">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>' +
              'Populer Minggu Ini' +
            '</div>' +
            '<div id="popular-list" class="popular-list">' + this.skelsPop(5) + '</div>' +
          '</div>' +
          '<div class="widget-box">' +
            '<div class="widget-title">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' +
              'Jadwal Tayang' +
              '<a href="/jadwal" class="widget-more">Semua &#8594;</a>' +
            '</div>' +
            '<div id="schedule-list" class="schedule-list">' + this.skelsSchedule() + '</div>' +
          '</div>' +
        '</aside>' +
      '</div>';
    /* Genre nav arrows */
    var gnav = document.getElementById('genre-nav');
    var gprev = document.getElementById('genre-prev');
    var gnext = document.getElementById('genre-next');
    if(gnav && gprev && gnext){
      gprev.addEventListener('click', function(){ gnav.scrollLeft -= 280; });
      gnext.addEventListener('click', function(){ gnav.scrollLeft += 280; });
    }
  },

  skels: function(type, n){ return ANI.render.skeletonCards(n, type); },
  skelsPop: function(n){
    var h = '';
    /* Spotlight skeleton */
    h += '<div class="pop-spotlight" style="pointer-events:none"><div class="pop-spotlight__poster"><div class="skel" style="width:72px;height:102px;border-radius:10px"></div></div><div class="pop-spotlight__info" style="gap:8px"><div class="skel skel-line skel-line--lg"></div><div class="skel skel-line skel-line--sm"></div><div class="skel" style="height:4px;border-radius:2px;width:100%"></div></div></div>';
    /* Mid-grid skeleton */
    h += '<div class="pop-mid-grid">';
    for(var i = 0; i < 2; i++){
      h += '<div class="pop-mid-card" style="pointer-events:none"><div style="display:flex;gap:6px;align-items:center"><div class="skel" style="width:20px;height:20px;border-radius:50%"></div><div class="skel" style="width:30px;height:12px;border-radius:4px"></div></div><div class="skel skel-line" style="margin-top:6px"></div></div>';
    }
    h += '</div>';
    /* Compact skeletons */
    for(var j = 0; j < 2; j++){
      h += '<div class="pop-compact" style="pointer-events:none"><div class="skel" style="width:14px;height:12px;border-radius:3px"></div><div class="skel" style="width:28px;height:40px;border-radius:4px;flex-shrink:0"></div><div class="skel skel-line" style="flex:1"></div></div>';
    }
    return h;
  },
  skelsSchedule: function(){
    var h = '';
    for(var i = 0; i < 5; i++){
      h += '<div class="sched-item"><div class="skel sched-day"></div><div style="flex:1"><div class="skel skel-line"></div><div class="skel skel-line skel-line--sm"></div></div></div>';
    }
    return h;
  },

  /* ══════════════════════════════════════════════
     loadAll() — PERUBAHAN UTAMA
     v27: ANI.api.byLabel('featured', 5) → Blogger Feed entries
     CF:  ANI.api.featured(5) → { data: [D1 rows] }
          → _rowsToEntries() → fake entries → render
     ══════════════════════════════════════════════ */
  loadAll: function(){
    var self = this;

    /* Hero: featured anime */
    ANI.api.featured(5).then(function(res){
      self.renderHero(_rowsToEntries(res.data));
    }).catch(function(){
      document.getElementById('hero-content').innerHTML = '<h2 style="font-family:var(--font-display)">Selamat datang di Aneetaku</h2><p style="color:var(--c-muted);margin-top:8px">Konten featured belum tersedia.</p>';
    });

    /* Ongoing strip */
    ANI.api.ongoing(10).then(function(res){
      self.renderOngoing(_rowsToEntries(res.data));
    }).catch(function(){
      document.getElementById('ongoing-strip').innerHTML = '<p style="color:var(--c-muted);grid-column:1/-1;padding:8px">Belum ada anime ongoing.</p>';
    });

    /* Recent grid */
    ANI.api.recent(20).then(function(res){
      self.renderRecent(_rowsToEntries(res.data));
    }).catch(function(){
      document.getElementById('recent-grid').innerHTML = '<p style="color:var(--c-muted);grid-column:1/-1">Gagal memuat konten.</p>';
    });

    /* Popular — sort by score dari recent */
    ANI.api.recent(20).then(function(res){
      self.renderPopular(_rowsToEntries(res.data));
    }).catch(function(){
      document.getElementById('popular-list').innerHTML = '';
    });

    /* Schedule — dynamic from API */
    ANI.api.schedule().then(function(res){
      self.renderSchedule(res.data || {});
    }).catch(function(){
      var el = document.getElementById('schedule-list');
      if(el) el.innerHTML = '<p style="color:var(--c-muted);font-size:.75rem;padding:var(--s2) 0">Gagal memuat jadwal.</p>';
    });

    /* Preload search index di background (ringan, ~60KB gzipped) */
    setTimeout(function(){
      try { ANI.searchIndex.preload(); } catch(e) {}
    }, 1500);
  },

  /* ── Render functions — TIDAK BERUBAH dari v27 ── */
  /* Semua terima entries (real atau fake), render ke DOM */

  renderHero: function(entries){
    var self = this;
    if(!entries.length){
      document.getElementById('hero-content').innerHTML = '<h2 style="font-family:var(--font-display)">Selamat datang di Aneetaku</h2>';
      return;
    }
    this.slides = entries.map(function(e){
      return ANI.render.heroSlide(e, ANI.parse.aniData(e));
    });
    this.showSlide(0);
    var indHtml = entries.slice(0, 4).map(function(e, i){
      return '<button class="hi-item' + (i === 0 ? ' is-active' : '') + '" data-idx="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>';
    }).join('');
    document.getElementById('hero-indicators').innerHTML = indHtml;
    document.querySelectorAll('.hi-item').forEach(function(btn){
      btn.addEventListener('click', function(){
        self.showSlide(parseInt(this.dataset.idx));
        if(self.slideTimer){ clearInterval(self.slideTimer); }
        self.slideTimer = setInterval(function(){
          self.showSlide((self.currentSlide + 1) % Math.min(self.slides.length, 4));
        }, 6000);
      });
    });
    this.slideTimer = setInterval(function(){
      self.showSlide((self.currentSlide + 1) % Math.min(self.slides.length, 4));
    }, 6000);
  },

  showSlide: function(idx){
    var slide = this.slides[idx];
    if(!slide) return;
    this.currentSlide = idx;
    var bgEl = document.getElementById('hero-bg');
    if(bgEl){
      bgEl.onerror = function(){ this.onerror=null; this.src=this.src.replace('/t/p/w1280/','/t/p/w780/'); };
      bgEl.src = slide.banner; bgEl.alt = slide.title;
    }
    var scoreBit = slide.score ? ('<div class="badge-score">' + ANI.render.svgStar + slide.score + '</div>') : '';
    var studio = slide.info.studio || '';
    var eps = slide.info.total_ep || '';
    var year = slide.info.year || '';
    var statusDot = slide.status.toLowerCase() === 'ongoing' ? '<span class="dot-live"></span>' : '';
    var heroContent = document.getElementById('hero-content');
    if(heroContent){
      heroContent.innerHTML =
        '<div class="hero-badge">' + statusDot + ' Featured</div>' +
        '<h1 class="hero-title">' + ANI.util.esc(slide.title) + '</h1>' +
        '<div class="hero-meta">' + scoreBit + (scoreBit ? '<span class="sep"></span>' : '') + '<span>' + (slide.info.type || 'TV') + '</span>' + (year ? '<span class="sep"></span><span>' + year + '</span>' : '') + (studio ? '<span class="sep"></span><span>' + studio + '</span>' : '') + (eps ? '<span class="sep"></span><span>' + eps + ' Eps</span>' : '') + '<span class="sep"></span><span style="color:var(--c-green)">' + slide.status + '</span></div>' +
        (slide.synopsis ? '<p class="hero-synopsis">' + slide.synopsis + '</p>' : '') +
        '<div class="hero-actions"><a href="' + slide.url + '?ep=1" class="btn-primary"><svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>Tonton Anime</a><a href="' + slide.url + '" class="btn-secondary"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>Detail Series</a></div>';
    }
    document.querySelectorAll('.hi-item').forEach(function(btn, i){
      btn.classList.toggle('is-active', i === idx);
    });
  },

  renderOngoing: function(entries){
    var html = entries.map(function(e){ return ANI.render.ongoingCard(e, ANI.parse.aniData(e)); }).join('');
    var el = document.getElementById('ongoing-strip');
    if(el) el.innerHTML = html || '<p style="color:var(--c-muted);grid-column:1/-1;padding:8px">Belum ada anime ongoing.</p>';
  },

  renderRecent: function(entries){
    var html = entries.map(function(e, i){ return ANI.render.animeCard(e, ANI.parse.aniData(e), i); }).join('');
    var el = document.getElementById('recent-grid');
    if(el) el.innerHTML = html || '<p style="color:var(--c-muted);grid-column:1/-1;padding:8px">Belum ada konten.</p>';
  },

  renderPopular: function(entries){
    var scored = entries.filter(function(e){
      var a = ANI.parse.aniData(e);
      return ANI.parse.score(a) !== null;
    }).sort(function(a, b){
      return (ANI.parse.score(ANI.parse.aniData(b)) || 0) - (ANI.parse.score(ANI.parse.aniData(a)) || 0);
    }).slice(0, 5);
    var html = '';
    /* Tier 1: Spotlight #1 */
    if(scored[0]) html += ANI.render.popSpotlight(scored[0], ANI.parse.aniData(scored[0]));
    /* Tier 2: Mid-grid #2-#3 */
    var midHtml = '';
    if(scored[1]) midHtml += ANI.render.popMidCard(scored[1], ANI.parse.aniData(scored[1]), 2);
    if(scored[2]) midHtml += ANI.render.popMidCard(scored[2], ANI.parse.aniData(scored[2]), 3);
    if(midHtml) html += '<div class="pop-mid-grid">' + midHtml + '</div>';
    /* Tier 3: Compact #4-#5 */
    for(var i = 3; i < scored.length; i++){
      html += ANI.render.popCompact(scored[i], ANI.parse.aniData(scored[i]), i + 1);
    }
    var el = document.getElementById('popular-list');
    if(el) el.innerHTML = html || '<p style="color:var(--c-muted);padding:8px;font-size:.8rem">Belum ada data populer.</p>';
  },

  /* Schedule — dynamic sidebar widget, max 5 items */
  renderSchedule: function(data){
    var DAY_KEY = {0:'minggu',1:'senin',2:'selasa',3:'rabu',4:'kamis',5:'jumat',6:'sabtu'};
    var DAY_LABEL = {senin:'Sen',selasa:'Sel',rabu:'Rab',kamis:'Kam',jumat:'Jum',sabtu:'Sab',minggu:'Min'};
    var DAY_ORDER = ['senin','selasa','rabu','kamis','jumat','sabtu','minggu'];
    var todayKey = DAY_KEY[new Date().getDay()];
    var idx = DAY_ORDER.indexOf(todayKey);
    var ordered = DAY_ORDER.slice(idx).concat(DAY_ORDER.slice(0, idx));
    var todayItems = data[todayKey] || [];
    var esc = ANI.util.esc;
    var h = '';
    var count = 0;
    var MAX = 5;
    /* Today zone — cards with cover */
    if(todayItems.length){
      h += '<div class="sw-today-head"><div class="sw-badge">HARI INI</div></div>';
      for(var t = 0; t < todayItems.length && count < MAX; t++){
        var a = todayItems[t];
        var epText = a.latest_ep ? 'Episode ' + a.latest_ep : (a.ep_count ? a.ep_count + ' episode' : '');
        h += '<a href="/anime/' + esc(a.slug) + '" class="sw-today-card">' +
          (a.cover ? '<img class="sw-cover" src="' + esc(a.cover) + '" alt="" loading="lazy">' : '<div class="sw-cover sw-cover--empty"></div>') +
          '<div class="sw-info"><div class="sw-title">' + esc(a.title) + '</div>' +
          (epText ? '<div class="sw-ep">' + epText + '</div>' : '') +
          '</div>' +
          '<div class="sw-time-accent">' + esc(a.schedule_time || '') + '</div>' +
          '</a>';
        count++;
      }
    }
    /* Upcoming days — compact rows */
    if(count < MAX){
      var hasCompact = false;
      for(var d = 1; d < ordered.length && count < MAX; d++){
        var day = ordered[d];
        var items = data[day] || [];
        for(var j = 0; j < items.length && count < MAX; j++){
          if(!hasCompact){ h += '<div class="sw-divider"></div>'; hasCompact = true; }
          var b = items[j];
          h += '<a href="/anime/' + esc(b.slug) + '" class="sw-compact">' +
            '<div class="sw-compact-day">' + DAY_LABEL[day] + '</div>' +
            '<div class="sw-compact-title">' + esc(b.title) + '</div>' +
            '<div class="sw-compact-time">' + esc(b.schedule_time || '') + '</div>' +
            '</a>';
          count++;
        }
      }
    }
    if(!count) h = '<p style="color:var(--c-muted);font-size:.75rem;padding:var(--s2) 0">Belum ada jadwal tayang.</p>';
    var el = document.getElementById('schedule-list');
    if(el) el.innerHTML = h;
  }
};

/* ═══════════════════════════════════════════════
   SEARCH LABEL MODULE
   
   PERUBAHAN dari v27:
   - Label diparsing dari URL path /search/label/:label
   - API calls diganti ke Worker API params
   - g:action → ANI.api.byGenre('action')
   - status:ongoing → ANI.api.all({status:'ongoing'})
   - Lainnya → ANI.api.search(label)
   ═══════════════════════════════════════════════ */

ANI.searchLabel = {
  _label: '',
  _page: 1,
  _perPage: 20,

  init: function(label){
    var self = this;
    self._label = label;

    /* Parse page dari URL query string */
    try{
      var urlParams = new URLSearchParams(window.location.search);
      self._page = Math.max(parseInt(urlParams.get('page')) || 1, 1);
    }catch(e){ self._page = 1; }

    var displayLabel = label.replace(/^(g|status):/, '').replace(/[_]/g, ' ');
    displayLabel = displayLabel.charAt(0).toUpperCase() + displayLabel.slice(1);
    var prefix = '';
    if(label.indexOf('g:') === 0) prefix = 'Genre: ';
    else if(label.indexOf('status:') === 0) prefix = 'Status: ';

    var _bcLabel = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([
          { label:'Beranda', href:'/' },
          { label:'Daftar Anime', href:'/daftar-anime' },
          { label: prefix + displayLabel }
        ])
      : '';

    document.getElementById('app-content').innerHTML = _bcLabel +
      '<div class="search-label-page">' +
        '<div class="search-label-header">' +
          '<h1>' + prefix + displayLabel + '</h1>' +
          '<p>Menampilkan anime ' + (prefix ? prefix.toLowerCase().replace(': ', ' ') : 'dengan label ') + '<strong>' + ANI.util.esc(displayLabel) + '</strong></p>' +
        '</div>' +
        '<div id="search-result-count" class="search-result-count"></div>' +
        '<div id="search-grid" class="anime-grid">' + ANI.render.skeletonCards(self._perPage, 'card') + '</div>' +
        '<div id="search-pagination"></div>' +
      '</div>';

    self._loadPage(self._page);
  },

  _buildApiParams: function(page){
    var self = this;
    var label = self._label;
    var p = { page: page, per_page: self._perPage };

    if(label.indexOf('g:') === 0){
      p.genre = label.replace('g:', '');
    } else if(label.indexOf('status:') === 0){
      p.status = label.replace('status:', '');
    } else {
      p.q = label;
    }
    return p;
  },

  _loadPage: function(page){
    var self = this;
    self._page = page;

    /* Update URL tanpa reload */
    ANI.pagination._updateURL('page', page);

    /* Tampilkan skeleton di grid */
    var grid = document.getElementById('search-grid');
    if(grid) grid.innerHTML = ANI.render.skeletonCards(self._perPage, 'card');

    /* Scroll ke atas */
    if(page > 1) ANI.pagination.scrollToTop('.search-label-header');

    var apiParams = self._buildApiParams(page);

    ANI.api.all(apiParams).then(function(res){
      var data = res.data || [];
      var total = res.total || data.length;
      var totalPages = Math.ceil(total / self._perPage);

      /* Update count */
      var countEl = document.getElementById('search-result-count');
      if(countEl) countEl.textContent = total + ' anime ditemukan';

      /* Render grid */
      var entries = _rowsToEntries(data);
      var html = entries.map(function(e, i){ return ANI.render.animeCard(e, ANI.parse.aniData(e), i); }).join('');
      if(grid) grid.innerHTML = html || '<p style="color:var(--c-muted);grid-column:1/-1">Tidak ada anime ditemukan untuk label ini.</p>';

      /* Render pagination */
      var pgContainer = document.getElementById('search-pagination');
      if(pgContainer){
        pgContainer.innerHTML = ANI.pagination.render(page, totalPages, 'sl-pg');
        ANI.pagination.bind('sl-pg', function(pg){ self._loadPage(pg); });
      }
    }).catch(function(){
      if(grid) grid.innerHTML = '<p style="color:var(--c-muted);grid-column:1/-1">Gagal memuat data. Coba refresh halaman.</p>';
    });
  }
};

/* ═══════════════════════════════════════════════
   SEARCH RESULT MODULE
   
   PERUBAHAN dari v27:
   - Query diparsing dari URL ?q=xxx
   - API: ANI.api.search() → Worker API
   ═══════════════════════════════════════════════ */

ANI.searchResult = {
  _query: '',
  _page: 1,
  _perPage: 20,

  init: function(query){
    var self = this;
    self._query = query;

    /* Parse page dari URL */
    try{
      var urlParams = new URLSearchParams(window.location.search);
      self._page = Math.max(parseInt(urlParams.get('page')) || 1, 1);
    }catch(e){ self._page = 1; }

    var _bcSearch = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([
          { label:'Beranda', href:'/' },
          { label:'Pencarian: "' + query + '"' }
        ])
      : '';

    document.getElementById('app-content').innerHTML = _bcSearch +
      '<div class="search-label-page">' +
        '<div class="search-label-header">' +
          '<h1>Hasil Pencarian</h1>' +
          '<p>Menampilkan hasil untuk <strong>"' + ANI.util.esc(query) + '"</strong></p>' +
        '</div>' +
        '<div id="search-result-count" class="search-result-count"></div>' +
        '<div id="search-grid" class="anime-grid">' + ANI.render.skeletonCards(self._perPage, 'card') + '</div>' +
        '<div id="search-pagination"></div>' +
      '</div>';

    self._loadPage(self._page);
  },

  _loadPage: function(page){
    var self = this;
    self._page = page;

    /* Update URL: /search?q=xxx&page=2 */
    try{
      var url = new URL(window.location.href);
      url.searchParams.set('q', self._query);
      if(page > 1) url.searchParams.set('page', page);
      else url.searchParams.delete('page');
      history.replaceState(null, '', url.toString());
    }catch(e){}

    /* Skeleton */
    var grid = document.getElementById('search-grid');
    if(grid) grid.innerHTML = ANI.render.skeletonCards(self._perPage, 'card');

    /* Scroll */
    if(page > 1) ANI.pagination.scrollToTop('.search-label-header');

    ANI.api.all({ q: self._query, page: page, per_page: self._perPage }).then(function(res){
      var data = res.data || [];
      var total = res.total || data.length;
      var totalPages = Math.ceil(total / self._perPage);

      /* Count */
      var countEl = document.getElementById('search-result-count');
      if(countEl) countEl.textContent = total + ' hasil ditemukan';

      /* Grid */
      var entries = _rowsToEntries(data);
      var html = entries.map(function(e, i){ return ANI.render.animeCard(e, ANI.parse.aniData(e), i); }).join('');
      if(grid) grid.innerHTML = html || '<p style="color:var(--c-muted);grid-column:1/-1">Tidak ditemukan anime dengan kata kunci tersebut.</p>';

      /* Pagination */
      var pgContainer = document.getElementById('search-pagination');
      if(pgContainer){
        pgContainer.innerHTML = ANI.pagination.render(page, totalPages, 'sr-pg');
        ANI.pagination.bind('sr-pg', function(pg){ self._loadPage(pg); });
      }
    }).catch(function(){
      if(grid) grid.innerHTML = '<p style="color:var(--c-muted);grid-column:1/-1">Gagal mencari. Coba lagi.</p>';
    });
  }
};
/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 06: Series (series page + player)
   
   PERUBAHAN dari v27:
   - init(): slug dari URL /anime/:slug, fetch via ANI.api.bySlug()
   - _bootstrap(): multi-season via series_group siblings dari API
   - Semua render & player logic: TIDAK BERUBAH
   ═══════════════════════════════════════════════ */

ANI.series = {
  data: null,
  allSeasons: [],
  currentEp: null,
  artInstance: null,
  epGridHtml: '',

  /* ══════════════════════════════════════════════
     init() — PERUBAHAN UTAMA
     v27: pageType === 'item' → Feed byPath → parse aniData dari HTML
     CF:  URL /anime/:slug → API bySlug → D1 row → fromDB() → aniData
     ══════════════════════════════════════════════ */
  init: function(){
    var self = this;
    var path = window.location.pathname;

    /* Extract slug dari URL /anime/:slug */
    var match = path.match(/^\/anime\/([^\/\?]+)/);
    if(!match){
      self.renderError('URL anime tidak valid.<br><small>' + ANI.util.esc(path) + '</small>');
      return;
    }
    var slug = decodeURIComponent(match[1]);

    /* Skeleton placeholder while bySlug() pending — gunakan skeleton yang cocok */
    try {
      if(ANI.polish){
        var _hasEp = !!(new URLSearchParams(window.location.search)).get('ep');
        if(_hasEp && ANI.polish.renderPlayerSkeleton) ANI.polish.renderPlayerSkeleton();
        else if(ANI.polish.renderDetailSkeleton) ANI.polish.renderDetailSkeleton(slug);
      }
    } catch(_){}

    ANI.api.bySlug(slug)
      .then(function(res){
        try {
        if(res.data.is_nsfw && !ANI.pref.getNsfw()){
          window.location.replace('/');
          return;
        }
      } catch(e){}
        var row = res.data;
        if(!row || !row.slug){
          self.renderError('Anime tidak ditemukan.<br><small>' + ANI.util.esc(slug) + '</small>');
          return;
        }
        /* Convert D1 row → aniData + fake entry */
        var episodes = row.episodes || [];
        var aniData = ANI.parse.fromDB(row, episodes);
        aniData._raw = row;
        var entry = ANI.parse.fromDBEntry(row, episodes);

        self._bootstrap(aniData, entry, row.siblings || []);
      })
      .catch(function(e){
        console.error('[ANI.series] API error:', e);
        self.renderError('Gagal memuat data. Periksa koneksi internet.');
      });
  },

  /* ── Bootstrap: build allSeasons dari siblings (multi-season) ── 
     API mengembalikan siblings[] jika series_group terisi.
     allSeasons = [sibling entries...sorted by season_number].
     Current anime di-insert pada posisi yang benar. */
  _bootstrap: function(aniData, entry, siblings){
    var self = this;
    self.data = { entry: entry, ani: aniData };

    /* Build allSeasons: current + siblings, sorted by season_number */
    if(siblings && siblings.length){
      var all = [];
      /* Add siblings as fake entries */
      for(var i = 0; i < siblings.length; i++){
        all.push(ANI.parse.fromDBSibling(siblings[i]));
      }
      /* Add current entry */
      all.push(entry);
      /* Sort by season number */
      all.sort(function(a, b){
        var sa = ANI.parse.aniData(a);
        var sb = ANI.parse.aniData(b);
        var na = sa && sa.season ? sa.season.number : 1;
        var nb = sb && sb.season ? sb.season.number : 1;
        return na - nb;
      });
      self.allSeasons = all;
    } else {
      self.allSeasons = [entry];
    }

    self.decide();
  },

  decide: function(){
    var p = new URLSearchParams(window.location.search);
    var ep = p.get('ep');
    if(ep){ this.renderPlayer(parseInt(ep)); return; }
    this.renderSeriesPage();
  },

  renderSeriesPage: function(){
    var self = this;
    var ani  = this.data.ani;
    var s    = ani.series;
    var info = s.info || {};
    var currentSeason = ani.season || { number: 1, title: 'Season 1' };
    var episodes = ANI.parse.getEpisodes(ani);

    var firstEpUrl = window.location.pathname + '?ep=1';
    var genres = ANI.parse.genres(this.data.entry).sort(function(a,b){ return a.toLowerCase().localeCompare(b.toLowerCase()); });

    var GENRE_HARDCODED = [
      'action','adventure','comedy','drama','fantasy','horror',
      'isekai','josei','mecha','mystery','reincarnation','romance',
      'school','sci-fi','seinen','shoujo','shounen',
      'slice_of_life','sports','supernatural','thriller'
    ];
    var nsfwGenres = [];
    try { var _inf = (self.data && self.data.ani && self.data.ani.series) ? self.data.ani.series.info || {} : {}; nsfwGenres = (_inf.nsfw_genres || []).map(function(g){ return g.toLowerCase().replace(/ /g,'_'); }); } catch(e){}
    var genreHtml = genres.map(function(g){
      var key = g.toLowerCase().replace(/ /g,'_');
      var label = g.replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();});
      if(GENRE_HARDCODED.indexOf(key) !== -1){
        return '<a href="/genre/'+key+'" class="genre-pill">'+label+'</a>';
      } else {
        return '<a href="/genre/'+key+'" class="tag-pill">'+label+'</a>';
      }
    }).join('');

    if(nsfwGenres.length > 0){
      genreHtml += nsfwGenres.map(function(g){
        var label = g.replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();});
        return '<a href="/genre/'+g+'" class="genre-pill genre-pill--nsfw">'+label+'</a>';
      }).join('');
    }

    var statusColor = (info.status||'').toLowerCase() === 'ongoing' ? 'var(--c-green)' :
                      (info.status||'').toLowerCase() === 'upcoming' ? 'var(--c-yellow)' : 'var(--c-text-2)';

    var rawSyn = s.synopsis || '';
    var _synToHtml = function(str){
      if(!str) return '';
      var escaped = ANI.util.esc(str);
      var paras = escaped.split(/\n\s*\n/);
      if(paras.length > 1) return paras.map(function(p){ return p.replace(/\n/g,'<br>'); }).join('</p><p class="series-synopsis-text" style="margin-top:var(--s2)">');
      return escaped.replace(/\n/g,'<br>');
    };
    var plainSyn = rawSyn.replace(/\n/g,' ').replace(/\s+/g,' ');
    var shortSynText = plainSyn.length > 280 ? plainSyn.substring(0, 280) + '...' : plainSyn;
    var fullSynRendered = _synToHtml(rawSyn);
    var synHtml = plainSyn.length > 280
      ? '<p class="series-synopsis-text" id="syn-text">' + shortSynText + '</p><button class="synopsis-toggle" id="syn-toggle">Baca selengkapnya &#9660;</button>'
      : '<p class="series-synopsis-text">' + fullSynRendered + '</p>';

    var coverUrl = ANI.util.driveThumb(s.cover, 400);
    var bannerUrl = ANI.parse.banner(ani) || coverUrl;

    var epHtml = self.buildEpGrid(episodes);
    self.epGridHtml = epHtml;

    /* ── Batch Download section (two versions: sidebar + mobile) ── */
    var batchSidebarHtml = '';
    var batchMobileHtml = '';
    try {
      var rawBatch = (ani._raw && ani._raw.batch_downloads) ? ani._raw.batch_downloads : '{}';
      var batchData = typeof rawBatch === 'string' ? JSON.parse(rawBatch) : rawBatch;
      var batchKeys = [];
      var bk;
      for (bk in batchData) {
        /* URL di-sanitize jadi '' di public response — pakai presence object sebagai indikator availability */
        if (batchData.hasOwnProperty(bk) && batchData[bk] && typeof batchData[bk] === 'object') {
          batchKeys.push(bk);
        }
      }
      batchKeys.sort(function(a, b) {
        var order = { '1080p': 1, '720p': 2, '480p': 3 };
        return (order[a] || 9) - (order[b] || 9);
      });
      if (batchKeys.length > 0) {
        /* ── Sidebar version (desktop) ── */
        var sidebarRows = batchKeys.map(function(q) {
          var bd = batchData[q];
          var sizeStr = bd.size_mb ? (bd.size_mb >= 1000 ? (bd.size_mb / 1000).toFixed(1) + ' GB' : bd.size_mb + ' MB') : '';
          return '<button class="batch-sb-row" data-q="' + q + '">'
            + '<span class="batch-sb-res">' + q + '</span>'
            + '<span class="batch-sb-size">' + sizeStr + '</span>'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
          + '</button>';
        }).join('');
        var totalEp = batchData[batchKeys[0]].ep_count || '?';
        batchSidebarHtml = '<div class="widget-box" id="batch-sidebar">'
          + '<div class="widget-title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>Download Batch</div>'
          + '<div class="batch-sb-meta">' + totalEp + ' Episode &bull; RAR Archive</div>'
          + '<div class="batch-sb-list">' + sidebarRows + '</div>'
        + '</div>';

        /* ── Mobile version (pills) ── */
        var mobilePills = batchKeys.map(function(q) {
          var bd = batchData[q];
          var sizeStr = bd.size_mb ? (bd.size_mb >= 1000 ? (bd.size_mb / 1000).toFixed(1) + 'GB' : bd.size_mb + 'MB') : '';
          return '<button class="batch-pill" data-q="' + q + '">'
            + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
            + '<span class="batch-pill__q">' + q + '</span>'
            + '<span class="batch-pill__size">' + sizeStr + '</span>'
          + '</button>';
        }).join('');
        batchMobileHtml = '<div class="batch-mobile" id="batch-mobile">'
          + '<div class="batch-mobile-card">'
            + '<div class="batch-mobile__label"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>Download Batch</div>'
            + '<div class="batch-mobile__pills">' + mobilePills + '</div>'
          + '</div>'
        + '</div>';
      }
    } catch (e) { batchSidebarHtml = ''; batchMobileHtml = ''; }

    var infoRows = [
      { l: 'Studio',   v: info.studio    || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 21h18M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7H3l2-4h14l2 4"/></svg>' },
      { l: 'Tipe',     v: info.type      || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/></svg>' },
      { l: 'Kualitas', v: info.source_type || '', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>' },
      { l: 'Musim',    v: info.season    || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' },
      { l: 'Durasi',   v: info.duration  || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' },
      { l: 'Tayang',   v: info.aired     || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>' },
      { l: 'Rating',   v: info.rating    || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' },
      { l: 'Kredit',   v: info.credit    || '-', ico: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>' },
    ].filter(function(r){return r.v && r.v !== '-'});

    var prodChips = '';
    if(info.producers && info.producers !== '-'){
      var prodList = info.producers.split(',').map(function(p){ return p.trim(); }).filter(Boolean);
      prodList.sort(function(a,b){ return a.length - b.length; });
      prodChips = '<div class="info-row info-row--chips">'
        + '<span class="info-row__lbl"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>Produser</span>'
        + '<div class="info-chips">'
        + prodList.map(function(p){ return '<span class="info-chip">' + p + '</span>'; }).join('')
        + '</div></div>';
    }

    var infoTableHtml = infoRows.map(function(r){
      var valCls = r.cls ? ' info-row__val' + r.cls : '';
      var rowCls = r.block ? ' info-row--block' : '';
      return '<div class="info-row' + rowCls + '"><span class="info-row__lbl">' + r.ico + r.l + '</span><span class="info-row__val' + valCls + '">' + r.v + '</span></div>';
    }).join('') + prodChips;

    var trailerBtn = s.trailer && s.trailer !== 'YOUTUBE_ID'
      ? '<a href="https://www.youtube.com/watch?v=' + s.trailer + '" target="_blank" rel="noopener" class="trailer-btn"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98" fill="var(--c-card)"/></svg>Tonton Trailer</a>'
      : '';

    /* ── Season Nav: unified parent-child hierarchy ──
       season_number bulat (1, 2, ...) = parent
       season_number desimal (1.1, 2.1, ...) = child dari Math.floor
       Orphan child (tidak ada parent di group) → tampil standalone */
    var seasonNavHtml = '';
    if(this.allSeasons.length > 1){
      /* 1. Build groups keyed by Math.floor(season_number) */
      var _snavGroups = {};
      var _snavKeys = [];
      this.allSeasons.forEach(function(e){
        var a = ANI.parse.aniData(e);
        var sn = a && a.season ? a.season : { number: 1, title: 'Season 1' };
        var num = sn.number || 1;
        var key = Math.floor(num);
        if(!_snavGroups[key]){ _snavGroups[key] = []; _snavKeys.push(key); }
        _snavGroups[key].push({ entry: e, a: a, sn: sn, num: num });
      });
      _snavKeys.sort(function(a, b){ return a - b; });

      /* 2. Render each group as .snav-group column */
      var _snavGroupsHtml = _snavKeys.map(function(key){
        var members = _snavGroups[key];
        members.sort(function(a, b){ return a.num - b.num; });

        /* Pisah parent (bilangan bulat) vs children (desimal) */
        var _par = null;
        var _chi = [];
        members.forEach(function(m){
          if(m.num % 1 === 0){ _par = m; }
          else { _chi.push(m); }
        });
        /* Orphan: tidak ada parent → anggap member pertama sebagai parent */
        if(!_par){ _par = members[0]; _chi = members.slice(1); }

        /* Cek apakah current ada di group ini (untuk parent-glow) */
        var _grpHasCur = members.some(function(m){ return m.sn.number === currentSeason.number; });
        var _pIsCur = _par.sn.number === currentSeason.number;
        var _pHasCur = !_pIsCur && _grpHasCur;

        var pThumb = ANI.parse.thumb(_par.entry, _par.a);
        var pUrl   = ANI.parse.url(_par.entry);
        var pEpCnt = ANI.parse.getEpisodes(_par.a).length
          || (_par.a && _par.a._ep_count)
          || (_par.a && _par.a.series && _par.a.series.info && _par.a.series.info.total_ep)
          || '?';
        var pClass = 'snav-card'
          + (_pIsCur  ? ' snav-card--active'      : '')
          + (_pHasCur ? ' snav-card--parent-glow' : '');
        var pChev = _pIsCur ? '' : '<svg class="snav-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';

        var pAnimeTitle = (_par.a && _par.a.series && _par.a.series.title) ? _par.a.series.title : '';
        var gHtml = '<a href="' + pUrl + '" class="' + pClass + '">'
          + '<div class="snav-poster"><img src="' + pThumb + '" alt="" loading="lazy"/></div>'
          + '<div class="snav-info">'
            + '<div class="snav-title">' + ANI.util.esc(_par.sn.title) + '</div>'
            + (pAnimeTitle ? '<div class="snav-anime-name">' + ANI.util.esc(pAnimeTitle) + '</div>' : '')
            + '<span class="snav-ep-chip">' + pEpCnt + ' Ep</span>'
          + '</div>'
          + pChev
        + '</a>';

        /* Children */
        _chi.forEach(function(ch){
          var chUrl    = ANI.parse.url(ch.entry);
          var chIsCur  = ch.sn.number === currentSeason.number;
          var chEpCnt  = ANI.parse.getEpisodes(ch.a).length
            || (ch.a && ch.a._ep_count)
            || (ch.a && ch.a.series && ch.a.series.info && ch.a.series.info.total_ep)
            || '?';
          var chTitle  = (ch.a && ch.a.series && ch.a.series.title) ? ch.a.series.title : '';
          var chClass  = 'snav-child' + (chIsCur ? ' snav-child--active' : '');
          var chChev   = chIsCur ? '' : '<svg class="snav-chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
          gHtml += '<a href="' + chUrl + '" class="' + chClass + '">'
            + '<div class="snav-child__info">'
              + '<span class="snav-child__label">' + ANI.util.esc(ch.sn.title) + '</span>'
              + (chTitle ? '<span class="snav-child__sep">:</span><span class="snav-child__name">' + ANI.util.esc(chTitle) + '</span>' : '')
            + '</div>'
            + (chEpCnt !== '?' ? '<span class="snav-child__ep">' + chEpCnt + ' Ep</span>' : '')
            + chChev
          + '</a>';
        });

        return '<div class="snav-group">' + gHtml + '</div>';
      }).join('');

      seasonNavHtml = '<div class="season-nav">'
        + '<div class="season-nav__label">'
          + '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="2" y="2" width="20" height="20" rx="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/></svg>'
          + 'Season'
        + '</div>'
        + '<div class="season-nav__scroll-wrap">'
          + '<button class="snav-btn snav-btn--prev" id="snav-prev" aria-label="Sebelumnya">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>'
          + '</button>'
          + '<div class="snav-scroll" id="snav-scroll">' + _snavGroupsHtml + '</div>'
          + '<button class="snav-btn snav-btn--next" id="snav-next" aria-label="Selanjutnya">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>'
          + '</button>'
        + '</div>'
      + '</div>';
    }

    var _bcSeries = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([
          { label: 'Beranda', href: '/' },
          { label: 'Daftar Anime', href: '/daftar-anime' },
          { label: s.title }
        ], { series: true })
      : '';

    document.getElementById('app-content').innerHTML =
      '<div class="series-banner"><img class="series-banner__img" src="' + bannerUrl + '" alt="" loading="eager" onerror="if(this.src.indexOf(\'/w1280/\')!==-1){this.onerror=null;this.src=this.src.replace(\'/t/p/w1280/\',\'/t/p/w780/\');}"/><div class="series-banner__grad"></div>' + _bcSeries + '</div>'
      + '<div class="series-main">'
        + '<div class="series-poster-col">'
          + '<div class="series-poster series-poster--clickable" id="series-poster-trigger" role="button" tabindex="0" aria-label="Lihat gallery"><img src="' + coverUrl + '" alt="' + ANI.util.esc(s.title) + '"/><div class="series-poster__zoom-hint" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></div></div>'
          + '<div class="series-poster-actions">'
            + '<a href="' + firstEpUrl + '" class="btn-tonton"><svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>Tonton</a>'
            + '<button class="btn-outline btn-share" id="btn-share" type="button" aria-label="Bagikan anime ini" style="justify-content:center;width:100%"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>Bagikan</button>'
            + '<div style="position:relative"><button class="btn-outline" id="bm-btn" style="justify-content:center;width:100%"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg><span id="bm-label">Watchlist</span></button><div class="bm-dropdown" id="bm-dropdown"><button class="bm-dropdown__item" data-st="watching"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="5,3 19,12 5,21"/></svg>Sedang Ditonton</button><button class="bm-dropdown__item" data-st="plan_to_watch"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>Rencana Tonton</button><button class="bm-dropdown__item" data-st="completed"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>Selesai</button><button class="bm-dropdown__item" data-st="on_hold"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>Ditunda</button><button class="bm-dropdown__item" data-st="dropped"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>Diberhentikan</button><div style="height:1px;background:var(--c-border);margin:4px 0"></div><button class="bm-dropdown__item bm-dropdown__remove" data-st="remove"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>Hapus dari Watchlist</button></div></div>'
            + trailerBtn
          + '</div>'
          + '<div class="series-cast-wrap" id="series-cast-wrap" style="display:none"></div>'
        + '</div>'
        + '<div class="series-info-col">'
          + '<h1 class="series-title">' + ANI.util.esc(s.title) + '</h1>'
          + '<div class="series-title-alt">' + (s.alt ? s.alt.join(' &bull; ') : '') + '</div>'
          + '<div class="series-genres-wrap"><div class="series-genres" id="series-genres-pills">' + genreHtml + '</div><button class="btn-genres-toggle" id="btn-genres-toggle"></button></div>'
          + '<div class="series-stats">'
            + '<div class="stat-score">'
              + '<div class="stat-score__val"><svg viewBox="0 0 24 24" fill="var(--c-yellow)" width="18" height="18"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>' + (info.score || '\u2014') + '</div>'
              + '<div class="stat-score__lbl">Score</div>'
              + (info.score ? '<div class="stat-score__sub">/ 10</div>' : '')
            + '</div>'
            + '<div class="stat-grid">'
              + '<div class="stat-row"><span class="stat-row__lbl">Episode</span><span class="stat-row__val">' + (info.total_ep || '?') + '</span></div>'
              + '<div class="stat-row"><span class="stat-row__lbl">Status</span><span class="stat-row__val stat-row__val--' + ((info.status||'').toLowerCase()==='ongoing'?'green':(info.status||'').toLowerCase()==='upcoming'?'yellow':'') + '">' + (info.status || '-') + '</span></div>'
              + '<div class="stat-row"><span class="stat-row__lbl">Tahun</span><span class="stat-row__val">' + (info.year || '-') + '</span></div>'
            + '</div>'
          + '</div>'
          + '<div class="series-synopsis-lbl">Sinopsis</div>'
          + synHtml
          + '<button class="mobile-info-toggle" id="mobile-info-btn">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>'
            + 'Informasi Lengkap'
          + '</button>'
          + '<div class="mobile-info-panel" id="mobile-info-panel">'
            + '<div class="widget-box" style="margin-top:0">'
              + '<div class="info-table">' + infoTableHtml + '</div>'
            + '</div>'
          + '</div>'
          + batchMobileHtml
          + '<div class="ep-section">'
            + '<div class="ep-sec-header"><div class="ep-sec-title">Daftar Episode</div>'
              + '<div class="ep-view-btns">'
                + '<button class="ep-view-btn is-active" id="btn-ep-grid" title="Grid"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg></button>'
                + '<button class="ep-view-btn" id="btn-ep-list" title="List"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg></button>'
              + '</div>'
            + '</div>'
            + '<div class="ep-scroll-wrap"><div id="ep-container" class="ep-grid">' + epHtml + '</div></div>'
          + '</div>'
          + seasonNavHtml
          + '<div class="series-cast-wrap series-cast-wrap--mobile" id="series-cast-wrap-mobile" style="display:none"></div>'
        + '</div>'
        + '<aside class="series-sidebar-col">'
          + '<div class="widget-box">'
            + '<div class="widget-title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>Informasi</div>'
            + '<div class="info-table">' + infoTableHtml + '</div>'
          + '</div>'
          + batchSidebarHtml
        + '</aside>'
      + '</div>';

    /* Event listeners */
    var synToggle = document.getElementById('syn-toggle');
    if(synToggle){
      var expanded = false;
      synToggle.addEventListener('click', function(){
        expanded = !expanded;
        document.getElementById('syn-text').innerHTML = expanded ? fullSynRendered : shortSynText;
        synToggle.innerHTML = expanded ? 'Tutup &#9650;' : 'Baca selengkapnya &#9660;';
      });
    }

    /* ── Share button: Web Share API + clipboard fallback + toast ── */
    var _shareBtn = document.getElementById('btn-share');
    if(_shareBtn && ANI.polish && ANI.polish.share){
      _shareBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ANI.polish.share({
          url: window.location.origin + window.location.pathname,
          title: s.title,
          text: 'Nonton ' + s.title + ' sub Indo di Aneetaku'
        });
      });
    }

    /* ── Genre pills collapse toggle (dynamic 2-row) ── */
    var genresPills  = document.getElementById('series-genres-pills');
    var genresToggle = document.getElementById('btn-genres-toggle');
    if(genresPills && genresToggle){
      var svgDown = '<svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>';
      var svgUp   = '<svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"/></svg>';
      var _genreExpanded = false;
      var _twoRowH = 0;
      var _measureAndCollapse = function(){
        var pills = genresPills.children;
        if(!pills.length) return;
        var boxTop = genresPills.getBoundingClientRect().top;
        var rowTops = [];
        var lastTop = -999;
        for(var i = 0; i < pills.length; i++){
          var t = Math.round(pills[i].getBoundingClientRect().top - boxTop);
          if(Math.abs(t - lastTop) > 2){ rowTops.push(t); lastTop = t; }
        }
        if(rowTops.length > 2){
          var row2Bottom = 0;
          for(var j = 0; j < pills.length; j++){
            var pt = Math.round(pills[j].getBoundingClientRect().top - boxTop);
            if(Math.abs(pt - rowTops[1]) < 3){
              var b = Math.ceil(pills[j].getBoundingClientRect().bottom - boxTop);
              if(b > row2Bottom) row2Bottom = b;
            }
          }
          _twoRowH = row2Bottom + 4;
          genresPills.classList.add('is-collapsed');
          genresPills.style.maxHeight = _twoRowH + 'px';
          genresToggle.classList.add('is-visible');
          genresToggle.innerHTML = 'Tampilkan semua ' + svgDown;
        }
      };
      requestAnimationFrame(function(){ requestAnimationFrame(_measureAndCollapse); });
      genresToggle.addEventListener('click', function(){
        _genreExpanded = !_genreExpanded;
        if(_genreExpanded){
          genresPills.classList.remove('is-collapsed');
          genresPills.style.maxHeight = genresPills.scrollHeight + 'px';
          genresToggle.innerHTML = 'Sembunyikan ' + svgUp;
        } else {
          genresPills.classList.add('is-collapsed');
          genresPills.style.maxHeight = _twoRowH + 'px';
          genresToggle.innerHTML = 'Tampilkan semua ' + svgDown;
        }
      });
    }

    /* ── Mobile info panel toggle ── */
    try {
      document.addEventListener('click', function(e){
        var btn = e.target.closest('#mobile-info-btn');
        if(!btn) return;
        var panel = document.getElementById('mobile-info-panel');
        if(!panel) return;
        var open = panel.style.display === 'block';
        panel.style.display = open ? '' : 'block';
        btn.classList.toggle('is-open', !open);
        btn.querySelector('svg').style.transform = !open ? 'rotate(180deg)' : '';
      });
    } catch(e){}

    /* ── Episode grid/list toggle ── */
    var epContainer = document.getElementById('ep-container');
    if(epContainer){
      var _btnGrid = document.getElementById('btn-ep-grid');
      var _btnList = document.getElementById('btn-ep-list');
      if(_btnGrid && _btnList){
        _btnGrid.addEventListener('click', function(){
          epContainer.className = 'ep-grid';
          epContainer.innerHTML = self.epGridHtml;
          _btnGrid.classList.add('is-active');
          _btnList.classList.remove('is-active');
        });
        _btnList.addEventListener('click', function(){
          epContainer.className = 'ep-list-view';
          epContainer.innerHTML = self.buildEpList(episodes);
          _btnList.classList.add('is-active');
          _btnGrid.classList.remove('is-active');
        });
      }
    }

    /* ── Batch download handler (sidebar + mobile) ── */
    function handleBatchClick(e) {
      var btn = e.target.closest('[data-q]');
      if (!btn) return;
      var q = btn.dataset.q;
      var slug = (self.data && self.data.ani && self.data.ani.series && self.data.ani.series.slug) || '';
      if (!slug || !q) { alert('Data tidak tersedia'); return; }
      ANI.dl.start({
        signUrl: ANI.api._BASE + '/api/dl/sign-batch?slug=' + encodeURIComponent(slug) + '&q=' + encodeURIComponent(q),
        displayName: 'Batch RAR (' + q + ')',
        meta: q + ' \u2022 Batch Archive'
      });
    }
    var batchSidebar = document.getElementById('batch-sidebar');
    if (batchSidebar) batchSidebar.addEventListener('click', handleBatchClick);
    var batchMobile = document.getElementById('batch-mobile');
    if (batchMobile) batchMobile.addEventListener('click', handleBatchClick);

    /* ── Season Nav <> scroll buttons ── */
    try {
      var _snavEl    = document.getElementById('snav-scroll');
      var _snavPrev  = document.getElementById('snav-prev');
      var _snavNext  = document.getElementById('snav-next');
      if(_snavEl && _snavPrev && _snavNext){
        /* Sembunyikan jika tidak ada overflow */
        var _snavCheck = function(){
          var hasOvf = _snavEl.scrollWidth > _snavEl.clientWidth + 4;
          _snavPrev.style.display = hasOvf ? '' : 'none';
          _snavNext.style.display = hasOvf ? '' : 'none';
          if(!hasOvf) return;
          var atStart = _snavEl.scrollLeft <= 4;
          var atEnd   = _snavEl.scrollLeft + _snavEl.clientWidth >= _snavEl.scrollWidth - 4;
          _snavPrev.style.opacity        = atStart ? '0.3' : '1';
          _snavPrev.style.pointerEvents  = atStart ? 'none' : '';
          _snavNext.style.opacity        = atEnd   ? '0.3' : '1';
          _snavNext.style.pointerEvents  = atEnd   ? 'none' : '';
        };
        /* Scroll by satu group width (~group flex-basis) */
        var _snavStep = function(){
          var g = _snavEl.querySelector('.snav-group');
          return g ? g.offsetWidth + 10 : 220;
        };
        _snavPrev.addEventListener('click', function(){
          _snavEl.scrollBy({ left: -_snavStep(), behavior: 'smooth' });
        });
        _snavNext.addEventListener('click', function(){
          _snavEl.scrollBy({ left: _snavStep(), behavior: 'smooth' });
        });
        _snavEl.addEventListener('scroll', _snavCheck, { passive: true });
        /* Delay check + auto-scroll ke active group setelah layout settled */
        requestAnimationFrame(function(){ setTimeout(function(){
          _snavCheck();
          /* Abbreviate "Season N" → "SN" jika overflow */
          _snavEl.querySelectorAll('.snav-title').forEach(function(el){
            if(el.scrollWidth > el.clientWidth){
              var shortened = el.textContent.replace(/^season\s+0*(\d+)$/i, 'S$1');
              if(shortened !== el.textContent) el.textContent = shortened;
            }
          });
          /* Cari group yang mengandung active card/child */
          var activeEl = _snavEl.querySelector('.snav-card--active, .snav-child--active');
          if(activeEl){
            var activeGroup = activeEl.closest('.snav-group');
            if(activeGroup && activeGroup.offsetLeft > 0){
              _snavEl.scrollLeft = activeGroup.offsetLeft;
            }
          }
        }, 80); });
      }
    } catch(snavErr){ console.warn('snav btn error:', snavErr); }

    /* ── Bookmark handler (series page) ── */
    try {
      var _bmBtn = document.getElementById('bm-btn');
      var _bmLabel = document.getElementById('bm-label');
      var _bmDd = document.getElementById('bm-dropdown');
      if (_bmBtn && _bmDd) {
        var _bmSlug = s.slug || '';
        var _bmOpen = false;
        var _statusLabels = {watching:'Ditonton',completed:'Selesai',on_hold:'Ditunda',dropped:'Drop',plan_to_watch:'Rencana'};

        if (ANI.user.isLoggedIn()) {
          ANI.historySync.getBookmark(_bmSlug).then(function(st) {
            if (st) {
              _bmBtn.classList.add('is-bookmarked');
              _bmLabel.textContent = _statusLabels[st] || 'Watchlist';
              _bmDd.querySelectorAll('.bm-dropdown__item').forEach(function(it) {
                it.classList.toggle('is-active', it.dataset.st === st);
              });
            }
          });

          _bmBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            _bmOpen = !_bmOpen;
            _bmDd.classList.toggle('is-open', _bmOpen);
          });
          document.addEventListener('click', function() { _bmDd.classList.remove('is-open'); _bmOpen = false; });

          _bmDd.addEventListener('click', function(e) {
            var item = e.target.closest('.bm-dropdown__item');
            if (!item) return;
            var st = item.dataset.st;
            _bmDd.classList.remove('is-open');
            _bmOpen = false;
            if (st === 'remove') {
              ANI.userApi.removeWatchlist(_bmSlug).then(function() {
                _bmBtn.classList.remove('is-bookmarked');
                _bmLabel.textContent = 'Watchlist';
                _bmDd.querySelectorAll('.bm-dropdown__item').forEach(function(it) { it.classList.remove('is-active'); });
                ANI.authUI._showToast('Dihapus dari watchlist');
              });
            } else {
              ANI.userApi.addWatchlist(_bmSlug, st).then(function() {
                _bmBtn.classList.add('is-bookmarked');
                _bmLabel.textContent = _statusLabels[st] || st;
                _bmDd.querySelectorAll('.bm-dropdown__item').forEach(function(it) { it.classList.toggle('is-active', it.dataset.st === st); });
                ANI.authUI._showToast('Ditambahkan ke ' + (_statusLabels[st] || 'watchlist'));
              });
            }
          });
        } else {
          _bmBtn.addEventListener('click', function() { ANI.authUI.showLoginModal(); });
        }
      }
    } catch(bmErr) { console.warn('Bookmark init error:', bmErr); }

    /* ── Gallery lightbox trigger ── */
    try {
      var _galTrig = document.getElementById('series-poster-trigger');
      if (_galTrig && ANI.gallery && typeof ANI.gallery.openFromAnime === 'function') {
        var _galHandler = function(){
          var _ani = self.data && self.data.ani;
          if (!_ani || !_ani.series) return;
          var _row = _ani._raw || (self.data && self.data.entry && self.data.entry._raw) || null;
          var _gal = (_row && Array.isArray(_row.gallery)) ? _row.gallery : [];
          ANI.gallery.openFromAnime(_ani.series.cover || '', _ani.series.title || '', _gal);
        };
        _galTrig.addEventListener('click', _galHandler);
        _galTrig.addEventListener('keydown', function(e){
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); _galHandler(); }
        });
      }
    } catch(galErr) { console.warn('[Aneetaku] Gallery wire error:', galErr); }

    /* ── Cast section (Sprint 2 — pemeran live-action, member-only) ── */
    try {
      var _aniCast = self.data && self.data.ani;
      var _rowCast = _aniCast && _aniCast._raw || (self.data && self.data.entry && self.data.entry._raw) || null;
      var _cast = (_rowCast && Array.isArray(_rowCast.cast)) ? _rowCast.cast : [];
      var _isLoggedInCast = false;
      try { _isLoggedInCast = !!(ANI.user && ANI.user.isLoggedIn && ANI.user.isLoggedIn()); } catch(_) {}
      if (_cast.length && _isLoggedInCast && ANI.pemeran && ANI.pemeran.renderCastSection) {
        ANI.pemeran.renderCastSection(_cast);
      }
    } catch(castErr) { console.warn('[Aneetaku] Cast section error:', castErr); }
  },

  buildEpGrid: function(episodes){
    return episodes.map(function(ep){
      var thumb = ep.thumb || 'https://via.placeholder.com/320x180/10101c/6c63ff?text=Ep+' + ep.ep;
      var url = window.location.pathname + '?ep=' + ep.ep;
      return '<a href="' + url + '" class="ep-card"><div class="ep-thumb"><img src="' + thumb + '" alt="' + ANI.util.esc(ep.title||'Episode '+ep.ep) + '" loading="lazy"/><span class="ep-num-badge">EP ' + ep.ep + '</span></div><div class="ep-card-body"><div class="ep-card-title">' + (ep.title || 'Episode ' + ep.ep) + '</div><div class="ep-card-date">' + (ep.airDate || '') + '</div></div></a>';
    }).join('');
  },

  buildEpList: function(episodes){
    return episodes.map(function(ep){
      var thumb = ep.thumb || 'https://via.placeholder.com/160x90/10101c/6c63ff?text=Ep+' + ep.ep;
      var url = window.location.pathname + '?ep=' + ep.ep;
      return '<a href="' + url + '" class="ep-list-item"><div class="ep-list-thumb"><img src="' + thumb + '" alt="" loading="lazy"/></div><div class="ep-list-info"><div class="ep-list-num">Episode ' + ep.ep + '</div><div class="ep-list-title">' + (ep.title || 'Episode ' + ep.ep) + '</div><div class="ep-list-date">' + (ep.airDate || '') + '</div></div></a>';
    }).join('');
  },


  /* ═══ PLAYER SECTION — verbatim from v27 ═══ */

  /* ── Render: Episode Player ── */
  renderPlayer: function(epNum){
    var self  = this;
    var ani   = this.data.ani;
    var s     = ani.series;
    var eps   = ANI.parse.getEpisodes(ani);
    var ep    = eps.find(function(e){ return e.ep === epNum; }) || eps[0];
    if(!ep){ this.renderError('Episode ' + epNum + ' tidak ditemukan.'); return; }
    this.currentEp = ep;
    var ls = self._ls;

    var isMovie      = (s.info && s.info.type && s.info.type.toLowerCase() === 'movie');
    var currentSeason = ani.season || { number: 1, title: 'Season 1' };
    var servers      = ep.servers || [];
    var downloads    = ep.downloads || [];

    /* ── Server key: stable ID per kategori (independen dari nama D1) ── */
    var _srvKey = function(sv){
      var n = (sv.name || '').toLowerCase();
      if(sv.type === 'hls' && n.indexOf('av1') !== -1) return 'prototype';
      if(sv.type === 'hls')    return 'cloud';
      if(sv.type === 'gphoto') return 'drive';
      if(sv.type === 'gdrive') return 'ftp';
      if(sv.type === 'direct') return 'edge';
      if(sv.type === 'embed')  return 'flux';
      return 'other';
    };
    /* ── Sort servers: Cloud(HLS) → Drive(GPhoto) → Edge(direct) → FTP(gdrive) → Flux(embed) → Prototype(AV1) ── */
    var _srvPrio = function(sv){
      var k = _srvKey(sv);
      if(k === 'cloud')     return 0;
      if(k === 'drive')     return 1;
      if(k === 'edge')      return 2;
      if(k === 'ftp')       return 3;
      if(k === 'flux')      return 4;
      if(k === 'prototype') return 5;
      return 6;
    };
    /* Annotate _origIdx SEBELUM sort — backend pakai array dari D1 (unsort),
       jadi /api/stream/sign?idx=N harus pakai original D1 index, bukan post-sort. */
    for (var _oi = 0; _oi < servers.length; _oi++) { servers[_oi]._origIdx = _oi; }
    servers.sort(function(a,b){ return _srvPrio(a) - _srvPrio(b); });

    /* ── Server preference from localStorage (match by server-key, bukan nama D1) ── */
    var srvPref = '';
    try { srvPref = (localStorage.getItem('aneetaku_srv') || '').toLowerCase(); } catch(e){}
    var firstServer = servers[0] || null;
    if(srvPref && servers.length > 1){
      var preferred = null;
      for(var si = 0; si < servers.length; si++){
        if(_srvKey(servers[si]) === srvPref){ preferred = servers[si]; break; }
      }
      if(preferred) firstServer = preferred;
    }
    var coverUrl     = ANI.util.driveThumb(s.cover, 400);
    /* ep.oped adalah field terpisah di aniData, bukan query param server URL.
       parseSkip menerima raw query string (dari ep.oped) atau full URL (embed server). */
    var skip         = self.parseSkip(ep.oped || (firstServer ? firstServer.url : ''));

    var epIdx  = eps.indexOf(ep);
    var prevEp = eps[epIdx - 1] || null;
    var nextEp = eps[epIdx + 1] || null;
    var prevUrl = prevEp ? window.location.pathname + '?ep=' + prevEp.ep : null;
    var nextUrl = nextEp ? window.location.pathname + '?ep=' + nextEp.ep : null;

    self.playerCtx = {
      seriesTitle: s.title || '',
      seasonTitle: currentSeason.title || '',
      epNum: ep.ep,
      epTitle: ep.title || 'Episode ' + ep.ep,
      videoKey: (s.slug||'') + '_ep' + ep.ep,
      prevUrl: prevUrl,
      nextUrl: nextUrl,
      isMovie: isMovie
    };

    /* ── Server tabs ── */
    var _srvDisplay = function(sv){
      var k = _srvKey(sv);
      if(k === 'cloud')     return { name: 'Cloud',     badge: 'HLS'  };
      if(k === 'drive')     return { name: 'Drive',     badge: 'MP4'  };
      if(k === 'edge')      return { name: 'Edge',      badge: 'H264' };
      if(k === 'ftp')       return { name: 'FTP',       badge: 'GD'   };
      if(k === 'flux')      return { name: 'Flux',      badge: 'HD'   };
      if(k === 'prototype') return { name: 'Prototype', badge: 'AV1'  };
      return { name: sv.name || '', badge: '' };
    };
    var serverTabsHtml = servers.map(function(sv, i){
      var disp = _srvDisplay(sv);
      var isActive = (sv === firstServer) ? ' is-active' : '';
      var warn = sv.type === 'embed' ? '<span style="color:#f59e0b;margin-left:2px" title="Server pihak ketiga, mungkin ada iklan">\u26a0</span>' : '';
      return '<button class="player-server-tab'+isActive+'" data-idx="'+i+'">'
        + ANI.util.esc(disp.name)
        + (disp.badge ? '<span class="stag">'+disp.badge+'</span>' : '')
        + warn
        +'</button>';
    }).join('');

    /* ── Prev / Next buttons (smart — hanya tampil jika ada) ── */
    var prevBtn = prevUrl
      ? '<a href="'+prevUrl+'" class="player-nav-btn"><svg fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" viewBox="0 0 24 24"><polyline points="15,18 9,12 15,6"/></svg>Prev</a>'
      : '';
    var nextBtn = nextUrl
      ? '<a href="'+nextUrl+'" class="player-nav-btn">Next<svg fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" viewBox="0 0 24 24"><polyline points="9,18 15,12 9,6"/></svg></a>'
      : '';

    /* ── Season nav (hanya jika multi-season) ── */
    var seasonNavHtml = '';
    if(self.allSeasons.length > 1){
      var curIdx = self.allSeasons.findIndex(function(e){
        var a = ANI.parse.aniData(e);
        return a && a.season && a.season.number === currentSeason.number;
      });
      var prevSeason = curIdx > 0 ? self.allSeasons[curIdx - 1] : null;
      var nextSeason = curIdx < self.allSeasons.length - 1 ? self.allSeasons[curIdx + 1] : null;
      var svgL = '<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="15,18 9,12 15,6"/></svg>';
      var svgR = '<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="9,18 15,12 9,6"/></svg>';
      seasonNavHtml = '<div class="pis-season-nav">'
        + (prevSeason ? '<a href="'+ANI.parse.url(prevSeason)+'?ep=1" class="pis-season-btn">'+svgL+(function(){ var a=ANI.parse.aniData(prevSeason); return a&&a.season?a.season.title:'S'+(curIdx); })()+'</a>' : '')
        + '<span class="pis-season-cur">'+currentSeason.title+'</span>'
        + (nextSeason ? '<a href="'+ANI.parse.url(nextSeason)+'?ep=1" class="pis-season-btn">'+(function(){ var a=ANI.parse.aniData(nextSeason); return a&&a.season?a.season.title:'S'+(curIdx+2); })()+svgR+'</a>' : '')
        +'</div>';
    }

    /* ── Meta info: ep label saja, tanpa hitungan total ── */
    var epLabel = isMovie       ? (ep.title || '')       : ('Ep ' + ep.ep + (ep.title ? ' \u2014 ' + ep.title : ''));

    /* ── Download dropdown ── */
    var dlHtml = '';
    /* Build unified download list: direct (Filedon-aware + URL stored) + videas */
    var dlEntries = [];
    for(var _di = 0; _di < servers.length; _di++){
      var _ds = servers[_di];
      if(_ds.type === 'direct' && _ds.qualities && _ds.qualities.length){
        var _dc = /h264/i.test(_ds.name||'') ? 'H264' : 'AV1';
        for(var _qi = 0; _qi < _ds.qualities.length; _qi++){
          var _qo = _ds.qualities[_qi];
          /* Dedup per quality label — cegah duplikasi kalau ada 2 direct server */
          var _alreadyIn = false;
          for(var _dck = 0; _dck < dlEntries.length; _dck++){
            if(dlEntries[_dck].q === _qo.q){ _alreadyIn = true; break; }
          }
          if(_alreadyIn) continue;
          var _qUrl = _qo.url || '';
          var _src = (_qUrl.indexOf('r2.filedon.co') !== -1) ? 'filedon' : 'direct';
          dlEntries.push({ q: _qo.q, codec: _dc, source: _src, url: _qUrl });
        }
      }
    }
    for(var _vi = 0; _vi < downloads.length; _vi++){
      var _d = downloads[_vi];
      var _vl = (_d.label||'').toLowerCase(); var _vq = _vl.indexOf('1080') !== -1 ? '1080p' : _vl.indexOf('720') !== -1 ? '720p' : _vl.indexOf('480') !== -1 ? '480p' : 'source';
      /* Detect gdrive entry via _source flag (di-set di sanitizeDownloadsJson) */
      var _vSrc = (_d._source === 'gdrive') ? 'gdrive' : 'videas';
      /* BUG-002: dedup videas vs filedon/IA — Videas hanya muncul kalau quality belum ada */
      var _vAlready = false;
      for(var _vck = 0; _vck < dlEntries.length; _vck++){
        if(dlEntries[_vck].q === _vq){ _vAlready = true; break; }
      }
      if(_vAlready) continue;
      dlEntries.push({ q: _vq, codec: 'H264', source: _vSrc, url: '' });
    }
    if(dlEntries.length){
      var svgDl = '<svg fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
      var svgArr = '<svg class="arr" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>';
      var dlItems = dlEntries.map(function(d){
        return '<div class="dl-drop-item" data-q="'+ANI.util.esc(d.q)+'" data-source="'+ANI.util.esc(d.source)+'"'
          + (d.url ? ' data-url="'+ANI.util.esc(d.url)+'"' : '')
          + '>'
          + svgDl + '<span class="dl-res">' + ANI.util.esc(d.q) + '</span>'
          + '<span class="dl-codec dl-codec--' + d.codec.toLowerCase() + '">' + ANI.util.esc(d.codec) + '</span>'
          +'</div>';
      }).join('');
      dlHtml = '<div class="dl-drop-wrap">'
        + '<button class="dl-drop-btn" id="dl-drop-btn">'+svgDl+'Unduh'+svgArr+'</button>'
        + '<div class="dl-drop-panel" id="dl-drop-panel">'+dlItems+'</div>'
        +'</div>';
    }

    /* ── Episode grid (numeric) ── */
    var numGrid = eps.map(function(e){
      var url2    = window.location.pathname + '?ep=' + e.ep;
      var wKey    = 'aneetaku_w_' + (s.slug||'') + '_ep' + e.ep;
      var watched = !!ls.get(wKey);
      var cls     = 'ep-num-item'
                  + (e.ep === epNum ? ' is-active' : '')
                  + (watched         ? ' is-watched' : '');
      return '<a href="'+url2+'" class="'+cls+'" data-ep="'+e.ep+'">'+String(e.ep).padStart(2,'0')+'</a>';
    }).join('');

    /* ── Episode list ── */
    var numList = eps.map(function(e){
      var url2    = window.location.pathname + '?ep=' + e.ep;
      var thumb   = e.thumb || 'https://via.placeholder.com/160x90/10101c/6c63ff?text=Ep+'+e.ep;
      var isCur   = e.ep === epNum;
      var wKey2   = 'aneetaku_w_' + (s.slug||'') + '_ep' + e.ep;
      var watched2= !!ls.get(wKey2);
      var cls     = 'ep-list-row'
                  + (isCur     ? ' is-active'  : '')
                  + (watched2  ? ' is-watched' : '');
      return '<a href="'+url2+'" class="'+cls+'" data-ep="'+e.ep+'">'
        + '<div class="ep-list-row-thumb"><img src="'+thumb+'" alt="" loading="lazy"/></div>'
        + '<div class="ep-list-row-info">'
          + '<div class="ep-list-row-num">Episode '+e.ep+'</div>'
          + '<div class="ep-list-row-title">'+ANI.util.esc(e.title||'Episode '+e.ep)+'</div>'
      + '</div>'
      + (isCur ? '<span class="ep-now-badge">NOW</span>' : '')
      + '</a>';
    }).join('');

    /* ── Build HTML ── */
    document.getElementById('app-content').innerHTML =
      '<div class="player-page">'
        /* player-unit: single wrapper so player + action-bar are one seamless block */
        + '<div class="player-unit">'
          + '<div class="player-box player-box--iframe" id="player-box"><div class="player-placeholder"><div class="spinner"></div></div></div>'
          + '<div class="player-action-bar">'
            + '<div class="player-server-col">'
              + '<span class="player-server-lbl">Server</span>'
              + '<div class="player-server-tabs" id="server-tabs">'+serverTabsHtml+'</div>'
            + '</div>'
            + (prevBtn||nextBtn
              ? '<span class="player-ab-sep"></span>'
                + '<div class="player-nav">'
                  + '<span class="player-nav-lbl">Episode</span>'
                  + '<div class="player-nav-row">'+prevBtn+nextBtn+'</div>'
                + '</div>'
              : '')
          + '</div>'
        + '</div>'

        /* Info strip */
        + '<div class="player-info-strip">'
          + '<div class="pis-cover"><img src="'+coverUrl+'" alt="'+ANI.util.esc(s.title)+'"/></div>'
          + '<div class="pis-body">'
            + '<div class="pis-title">'+ANI.util.esc(s.title)+'</div>'
            + (epLabel ? '<div class="pis-meta">'+ANI.util.esc(epLabel)+'</div>' : '')
            + seasonNavHtml
          +'</div>'
          + '<div class="pis-actions">'
            + '<a href="'+window.location.pathname+'" class="pis-detail-btn">'
              + '<svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>'
              + 'Detail'
            +'</a>'
            + dlHtml
          +'</div>'
        +'</div>'

        /* Episode section */
        + ((!isMovie && eps.length > 1) ? (
          '<div class="player-ep-section">'
            + '<div class="player-ep-header">'
              + '<span class="player-ep-label">Episode</span>'
              + '<input class="player-ep-search" id="ep-search" type="text" placeholder="Cari nomor..." inputmode="numeric" autocomplete="off" spellcheck="false"/>'
              + '<div class="player-ep-toggle">'
                + '<button class="player-ep-toggle-btn is-active" id="btn-ep-grid" title="Grid"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg></button>'
                + '<button class="player-ep-toggle-btn" id="btn-ep-list" title="List"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg></button>'
              +'</div>'
            +'</div>'
            + '<div class="ep-num-grid" id="ep-container">'+numGrid+'</div>'
          +'</div>'
        ) : '')

        /* Movie synopsis — fill empty space */
        + (isMovie && s.synopsis ? (function(){
            var _raw = s.synopsis || '';
            var _esc = ANI.util.esc(_raw);
            var _paras = _esc.split(/\n\s*\n/);
            var _rendered = _paras.length > 1
              ? _paras.map(function(p){ return '<p class="pms-para">' + p.replace(/\n/g,'<br>') + '</p>'; }).join('')
              : '<p class="pms-para">' + _esc.replace(/\n/g,'<br>') + '</p>';
            return '<div class="player-movie-synopsis">'
              + '<div class="pms-label">Sinopsis</div>'
              + '<div class="pms-text is-clamped" id="pms-text">' + _rendered + '</div>'
              + '<button class="pms-toggle" id="pms-toggle">Baca selengkapnya &#9660;</button>'
            +'</div>';
          })() : '')

      +'</div>';

    /* ── Movie synopsis toggle ── */
    var pmsToggle = document.getElementById('pms-toggle');
    var pmsText   = document.getElementById('pms-text');
    if(pmsToggle && pmsText){
      var _checkPmsOverflow = function(){
        pmsText.classList.remove('is-clamped');
        var fullH = pmsText.scrollHeight;
        pmsText.classList.add('is-clamped');
        var clampH = pmsText.clientHeight;
        if(fullH <= clampH + 4){
          pmsText.classList.remove('is-clamped');
          pmsToggle.style.display = 'none';
        }
      };
      requestAnimationFrame(function(){ requestAnimationFrame(_checkPmsOverflow); });
      pmsToggle.addEventListener('click', function(){
        var clamped = pmsText.classList.toggle('is-clamped');
        pmsToggle.innerHTML = clamped ? 'Baca selengkapnya &#9660;' : 'Tutup &#9650;';
      });
    }

   /* ── Bookmark handler (Patch 3) ── */
    try {
      var _bmBtn = document.getElementById('bm-btn');
      var _bmLabel = document.getElementById('bm-label');
      var _bmDd = document.getElementById('bm-dropdown');
      if (_bmBtn && _bmDd) {
        var _bmSlug = s.slug || '';
        var _bmOpen = false;
        var _statusLabels = {watching:'Ditonton',completed:'Selesai',on_hold:'Ditunda',dropped:'Drop',plan_to_watch:'Rencana'};

        if (ANI.user.isLoggedIn()) {
          ANI.historySync.getBookmark(_bmSlug).then(function(st) {
            if (st) {
              _bmBtn.classList.add('is-bookmarked');
              _bmLabel.textContent = _statusLabels[st] || 'Watchlist';
              _bmDd.querySelectorAll('.bm-dropdown__item').forEach(function(it) {
                it.classList.toggle('is-active', it.dataset.st === st);
              });
            }
          });

          _bmBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            _bmOpen = !_bmOpen;
            _bmDd.classList.toggle('is-open', _bmOpen);
          });
          document.addEventListener('click', function() { _bmDd.classList.remove('is-open'); _bmOpen = false; });

          _bmDd.addEventListener('click', function(e) {
            var item = e.target.closest('.bm-dropdown__item');
            if (!item) return;
            var st = item.dataset.st;
            _bmDd.classList.remove('is-open');
            _bmOpen = false;
            if (st === 'remove') {
              ANI.userApi.removeWatchlist(_bmSlug).then(function() {
                _bmBtn.classList.remove('is-bookmarked');
                _bmLabel.textContent = 'Watchlist';
                _bmDd.querySelectorAll('.bm-dropdown__item').forEach(function(it) { it.classList.remove('is-active'); });
                ANI.authUI._showToast('Dihapus dari watchlist');
              });
            } else {
              ANI.userApi.addWatchlist(_bmSlug, st).then(function() {
                _bmBtn.classList.add('is-bookmarked');
                _bmLabel.textContent = _statusLabels[st] || st;
                _bmDd.querySelectorAll('.bm-dropdown__item').forEach(function(it) { it.classList.toggle('is-active', it.dataset.st === st); });
                ANI.authUI._showToast('Ditambahkan ke ' + (_statusLabels[st] || 'watchlist'));
              });
            }
          });
        } else {
          _bmBtn.addEventListener('click', function() { ANI.authUI.showLoginModal(); });
        }
      }
    } catch(bmErr) { console.warn('Bookmark init error:', bmErr); }
     
    /* ── Load server ── */
    self._servers = servers; /* simpan agar loadServer bisa lookup tab alternatif */
    if(firstServer) self.loadServer(firstServer, skip);
    else {
      var box = document.getElementById('player-box');
      if(box) ANI.util.playerStatus(box, 'empty', 'Belum ada server', 'Episode ini belum punya server stream yang aktif.');
    }

    /* ── Server tab click ── */
    var serverTabsEl = document.getElementById('server-tabs');
    if(serverTabsEl){
      serverTabsEl.addEventListener('click', function(e){
        var btn = e.target.closest('.player-server-tab');
        if(!btn) return;
        serverTabsEl.querySelectorAll('.player-server-tab').forEach(function(t){ t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var sv = servers[parseInt(btn.dataset.idx)];
        if(sv){
          try { ANI.pref.setServer(_srvKey(sv)); } catch(e){}
          self.loadServer(sv, self.parseSkip(self.currentEp ? self.currentEp.oped || '' : ''));
        }
      });
    }

    /* ── Download dropdown ── */
    var dlBtn   = document.getElementById('dl-drop-btn');
    var dlPanel = document.getElementById('dl-drop-panel');
    if(dlBtn && dlPanel){
      dlBtn.addEventListener('click', function(e){
        e.stopPropagation();
        var open = dlPanel.classList.toggle('is-open');
        dlBtn.classList.toggle('is-open', open);
      });
      dlPanel.addEventListener('click', function(e){
        var item = e.target.closest('.dl-drop-item');
        if(!item) return;
        var q = item.dataset.q || 'source';
        var source = item.dataset.source || 'videas';
        var slug = (self.data && self.data.ani && self.data.ani.series && self.data.ani.series.slug) || '';
        var epNum = self.currentEp ? self.currentEp.ep : 0;
        if(!slug || !epNum){ alert('Data episode tidak tersedia'); return; }
        dlPanel.classList.remove('is-open');
        dlBtn.classList.remove('is-open');
        var srcLabel = source === 'videas'  ? 'Videas H264'
                     : source === 'filedon' ? 'Filedon H264'
                     : source === 'direct'  ? 'Direct H264'
                     : source === 'gdrive'  ? 'GDrive H264'
                     : source.toUpperCase();
        ANI.dl.start({
          signUrl: ANI.api._BASE + '/api/dl/sign?slug=' + encodeURIComponent(slug) + '&ep=' + epNum + '&q=' + encodeURIComponent(q) + '&source=' + source,
          displayName: 'Episode ' + epNum,
          meta: q + ' \u2022 ' + srcLabel
        });
      });
      document.addEventListener('click', function(e){
        if(dlBtn && !dlBtn.contains(e.target) && dlPanel && !dlPanel.contains(e.target)){
          dlPanel.classList.remove('is-open');
          dlBtn.classList.remove('is-open');
        }
      });
    }

    /* ── Episode grid/list toggle + search ── */
    var epContainer = document.getElementById('ep-container');
    var epSearch    = document.getElementById('ep-search');
    var _isGrid     = true;

    function _renderEpGrid(){ return numGrid; }
    function _renderEpList(){ return numList; }

    function _applySearch(q){
      if(!q){ /* clear */ epContainer.querySelectorAll('.ep-num-item,.ep-list-row').forEach(function(el){ el.classList.remove('is-search-match'); }); return; }
      epContainer.querySelectorAll(_isGrid?'.ep-num-item':'.ep-list-row').forEach(function(el){
        var ep2 = String(el.dataset.ep||'');
        var pad = ep2.padStart(2,'0');
        var match = ep2.indexOf(q) !== -1 || pad.indexOf(q) !== -1;
        el.classList.toggle('is-search-match', match);
        if(match) el.scrollIntoView({block:'nearest'});
      });
    }

    var btnGrid = document.getElementById('btn-ep-grid');
    var btnList = document.getElementById('btn-ep-list');
    if(btnGrid && btnList && epContainer){
      btnGrid.addEventListener('click', function(){
        _isGrid = true;
        epContainer.className = 'ep-num-grid';
        epContainer.innerHTML = _renderEpGrid();
        btnGrid.classList.add('is-active'); btnList.classList.remove('is-active');
        if(epSearch) _applySearch(epSearch.value.trim());
      });
      btnList.addEventListener('click', function(){
        _isGrid = false;
        epContainer.className = 'ep-list-new';
        epContainer.innerHTML = _renderEpList();
        btnList.classList.add('is-active'); btnGrid.classList.remove('is-active');
        if(epSearch) _applySearch(epSearch.value.trim());
      });
    }
    if(epSearch){
      epSearch.addEventListener('input', function(){ _applySearch(this.value.trim()); });
      epSearch.addEventListener('click', function(e){ e.stopPropagation(); });
      epSearch.addEventListener('keydown', function(e){
        if(e.key === 'Enter'){
          var first = epContainer && epContainer.querySelector('.ep-num-item.is-search-match,.ep-list-row.is-search-match');
          if(first) location.href = first.href;
        }
      });
    }

    /* ── Scroll active episode into view ── */
    setTimeout(function(){
      var activeEl = epContainer && epContainer.querySelector('.ep-num-item.is-active,.ep-list-row.is-active');
      if(activeEl) activeEl.scrollIntoView({block:'nearest', behavior:'smooth'});
    }, 150);

    /* ── iframe auto-next message ── */
    window.addEventListener('message', function(e){
      if(!e.data || typeof e.data !== 'object') return;
      if(e.data.event === 'sp-ended' && nextUrl) setTimeout(function(){ location.href = nextUrl; }, 3000);
    });
  },

  /* ═══ localStorage helper ═══ */
  _ls: {
    get:function(k){try{return localStorage.getItem(k)}catch(e){return null}},
    set:function(k,v){try{localStorage.setItem(k,v)}catch(e){}},
    rm:function(k){try{localStorage.removeItem(k)}catch(e){}}
  },

  /* ═══ SVG icons ═══ */
  _ico: {
    skip:'<svg viewBox="0 0 16 16" width="16" height="16" fill="#fff"><path d="M4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093z"/></svg>',
    quality:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>',
    autonext:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4l10 8-10 8V4z"/><path d="M19 5v14"/></svg>',
    turbo:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    prevEp:'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 17L13 12L18 7"/><path d="M11 17L6 12L11 7"/></svg>',
    nextEp:'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 17L11 12L6 7"/><path d="M13 17L18 12L13 7"/></svg>',
    fullscreen:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>',
    exitFullscreen:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3"/><path d="M21 8h-3a2 2 0 0 1-2-2V3"/><path d="M3 16h3a2 2 0 0 1 2 2v3"/><path d="M16 21v-3a2 2 0 0 1 2-2h3"/></svg>'
  },

  loadServer: function(server, skip){
    var self = this;
    var box  = document.getElementById('player-box');
    /* Track server aktif untuk error recovery */
    if(!self.playerCtx) self.playerCtx = {};
    if(!self.playerCtx.servers) self.playerCtx.servers = [];
    self.playerCtx.activeIdx = self.playerCtx.servers.length;
    self.playerCtx.servers.push(server);
    if(!box) return;

    /* Restore window.open jika sebelumnya di-override oleh embed */
    try { if(window._aniOrigOpen){ window.open = window._aniOrigOpen; } } catch(e){}

    if(self.artInstance){ try{ self.artInstance.destroy(); }catch(e){} self.artInstance = null; }

    var videoUrl = null;
    var url = server.url || '';

    /* Simpan server aktif untuk keperluan remount (quality switch direct) */
    self._currentServer = server;
 

    /* ── type:direct — qualities array [{q,url}] ── */
    if(server.type === 'direct' && server.qualities && server.qualities.length){
      /* Ambil quality yang tersimpan di localStorage, fallback ke index 0 (tertinggi) */
      var savedQ = null;
      try { savedQ = localStorage.getItem('aneetaku_direct_q'); } catch(e){}
      var qualities = server.qualities;
      var chosenQ = qualities[0];
      if(savedQ){
        for(var qi=0; qi<qualities.length; qi++){
          if(qualities[qi].q === savedQ){ chosenQ = qualities[qi]; break; }
        }
      }
      url = chosenQ.url || '';
      /* Simpan context qualities agar quality switcher bisa akses */
      self._directQualities = qualities;
      self._directChosenQ   = chosenQ.q;
      /* Filedon fallback context: aktif kalau chosen quality URL == r2.filedon.co DAN ada fallback_url */
      self._filedonFallback = null;
      if(url.indexOf('r2.filedon.co') !== -1 && chosenQ.fallback_url){
        self._filedonFallback = { url: chosenQ.fallback_url, timer: null, triggered: false };
      }
    }

    /* ── UNIFIED Stream Privacy: semua source via /api/stream/sign → stream.aneetaku.cloud ──
       Detect: gphoto, Videas HLS, Filedon MP4, IA MP4 → call sign endpoint, dapat URL token,
       lalu re-enter loadServer dengan URL stream worker yang opaque.
       URL stream.aneetaku.cloud tidak punya `?url=` → source asli hidden di KV server-side. */
    var _needSign = false;
    /* Server-side sanitize set _needSign:true di payload — gunakan flag dulu, fallback substring untuk legacy/admin */
    if (server._needSign === true)                                             _needSign = true;
    else if (server.type === 'gphoto')                                         _needSign = true;
    else if (server.type === 'gdrive')                                         _needSign = true;
    else if (server.type === 'hls'    && url.indexOf('videas.fr')      !== -1) _needSign = true;
    else if (server.type === 'direct' && url.indexOf('r2.filedon.co')  !== -1) _needSign = true;
    else if (server.type === 'direct' && url.indexOf('archive.org')    !== -1) _needSign = true;
    /* Skip kalau URL sudah token stream.aneetaku.cloud (recursive call setelah sign sukses) */
    if (url.indexOf('stream.aneetaku.cloud') !== -1) _needSign = false;

    if (_needSign) {
      try {
        box.className = 'player-box player-box--video';
        ANI.util.playerStatus(box, 'loading', 'Mempersiapkan stream...');
        var _signSlug = (self.data && self.data.ani && self.data.ani.series && self.data.ani.series.slug) || '';
        var _signEp   = self.currentEp ? self.currentEp.ep : 0;
        if (!_signSlug || !_signEp) {
          ANI.util.playerStatus(box, 'error', 'Episode tidak ditemukan', 'Tidak bisa generate URL stream.');
          return;
        }
        /* Pakai ORIGINAL D1 idx (di-annotate sebelum frontend sort) —
           backend pakai array unsort dari D1, jadi index harus original. */
        var _signIdx = (typeof server._origIdx === 'number') ? server._origIdx : -1;
        var _signServer = encodeURIComponent(server.name || '');
        var _signUrl = ANI.api._BASE + '/api/stream/sign?slug=' + encodeURIComponent(_signSlug)
          + '&ep=' + _signEp
          + (_signIdx >= 0 ? ('&idx=' + _signIdx) : '')
          + (_signServer ? ('&server=' + _signServer) : '');
        fetch(_signUrl)
          .then(function(r){ return r.json(); })
          .then(function(d){
            if (d && d.url) {
              /* Re-enter loadServer dengan URL token; map type sesuai response.src */
              var _newType = server.type;
              if (d.src === 'videas')                                               _newType = 'hls';
              else if (d.src === 'filedon' || d.src === 'ia' || d.src === 'gphoto' || d.src === 'gdrive') _newType = 'direct';
              var _sv = Object.assign({}, server, { url: d.url, type: _newType });
              /* Populate qualities dari response — token URL per quality variant */
              if (d.qualities && d.qualities.length > 0) {
                _sv.qualities = d.qualities; /* [{q, url}] dengan URL = stream.aneetaku.cloud token */
              } else {
                _sv.qualities = null;
              }
              self.loadServer(_sv, skip);
            } else {
              ANI.util.playerStatus(box, 'error', 'Stream sign gagal', (d && d.error) || 'Server tidak merespons. Coba ganti server atau refresh halaman.');
            }
          })
          .catch(function(err){
            ANI.util.playerStatus(box, 'error', 'Stream sign error', err.message || 'Koneksi network bermasalah. Cek internet kamu.');
          });
        return;
      } catch (e) {
        console.error('[Aneetaku] stream sign error:', e);
      }
    }

    if(server.type === 'hls'){
      videoUrl = url;
    } else if(server.type === 'direct'){
      videoUrl = url;
    } else if(url.indexOf('speedcloud')!==-1 || url.indexOf('link=')!==-1){
      try{
        var parsed = new URL(url, location.origin);
        videoUrl = parsed.searchParams.get('link') || null;
      }catch(e){}
    } else if(/\.m3u8/i.test(url)){
      videoUrl = url;
    } else if(/\.mp4/i.test(url)){
      videoUrl = url;
    }

    if(videoUrl){
      box.className = 'player-box player-box--video';
      box.innerHTML = '<div class="artplayer-app" id="artplayer-mount"></div>';

      /* ── AV1 preflight: cek sekali, cache di self._supAV1 ── */
      if(typeof self._supAV1 === 'undefined'){
        try{ self._supAV1 = !!(window.MediaSource && MediaSource.isTypeSupported('video/mp4; codecs="av01.0.05M.08"')); }
        catch(e){ self._supAV1 = false; }
      }

      /* Hapus banner lama (muncul saat user ganti server) */
      var oldWarn = document.getElementById('av1-warn');
      if(oldWarn) oldWarn.parentNode.removeChild(oldWarn);

      /* Bersihkan pulse dari semua tab */
      var tabsEl = document.getElementById('server-tabs');
      if(tabsEl) tabsEl.querySelectorAll('.av1-suggest').forEach(function(t){ t.classList.remove('av1-suggest'); });

      /* Tampilkan warning kalau server ini AV1 dan browser tidak support */
      var isAv1Server = /av1/i.test(server.name || '');
      if(!self._supAV1 && isAv1Server){
        var warn = document.createElement('div');
        warn.id  = 'av1-warn';
        warn.className = 'av1-warn';
        warn.innerHTML =
          '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 24 24">'
          + '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>'
          + '<line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
          + '<span>Browser atau device kamu <b>tidak mendukung AV1</b>. '
          + 'Ganti ke server <b>H264</b> di bawah, atau gunakan Chrome 90+ / Edge 90+ di desktop.</span>';
        /* Sisip setelah player-box, sebelum action-bar */
        box.parentNode.insertBefore(warn, box.nextSibling);

        /* Highlight tab server non-AV1 pertama yang tersedia */
        var servers = self._servers || [];
        if(tabsEl){
          var allTabs = tabsEl.querySelectorAll('.player-server-tab');
          for(var ti = 0; ti < allTabs.length; ti++){
            var sv = servers[ti];
            if(sv && !/av1/i.test(sv.name || '')){
              allTabs[ti].classList.add('av1-suggest');
              break;
            }
          }
        }
      }

      /* ── AV1 mobile advisory (hanya mobile + server AV1 + belum dismissed) ── */
      var _doMount = function(){ 
        if(/aneetaku\.cloud/i.test(videoUrl)){
          fetch('https://cdn.aneetaku.cloud/api/auth',{method:'GET',credentials:'include',cache:'no-store'})
            .then(function(){ self.mountArtplayer(videoUrl, skip); })
            .catch(function(){ self.mountArtplayer(videoUrl, skip); });
        } else {
          self.mountArtplayer(videoUrl, skip);
        }
      };

      var isMobile = window.innerWidth <= 768;
      var isAv1Srv = /av1/i.test(server.name || '');
      var av1MobKey = 'aneetaku_av1mob_ok';
      var av1MobOk = false;
      try { av1MobOk = localStorage.getItem(av1MobKey) === '1'; } catch(e){}

      if(isMobile && isAv1Srv && !av1MobOk){
        box.className = 'player-box player-box--advisory';
        box.innerHTML = '<div class="av1-mob-advisory">'
          + '<div class="av1m-title"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#60a5fa" stroke-width="2" stroke-linecap="round" style="flex-shrink:0"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>Catatan untuk Pengguna Mobile</div>'
          + '<div class="av1m-body">'
            + '<p>Server <strong>AV1</strong> menggunakan codec video generasi terbaru yang sangat efisien, '
            + 'namun <strong>tidak semua perangkat mobile</strong> mendukung pemutaran hardware AV1.</p>'
            + '<p><strong>Kamu mungkin mengalami:</strong></p>'
            + '<ul>'
              + '<li>Buffering berlebihan meskipun koneksi internet stabil</li>'
              + '<li>Video patah-patah atau lag saat pemutaran</li>'
              + '<li>Baterai cepat habis karena decoding via software</li>'
            + '</ul>'
            + '<p><strong>Rekomendasi:</strong></p>'
            + '<ul>'
              + '<li>Gunakan server lain (AV2, H264) untuk pengalaman terbaik di mobile</li>'
              + '<li>AV1 hardware decode tersedia di chipset baru: Dimensity 1000+, Snapdragon 8 Gen 1+, Exynos 2200+, Google Tensor</li>'
              + '<li>iOS Safari <strong>tidak mendukung</strong> AV1 (kecuali iPhone 15 Pro ke atas)</li>'
            + '</ul>'
            + '<p style="color:var(--c-muted);font-size:.68rem">Jika kamu yakin perangkatmu mendukung AV1, silakan lanjutkan.</p>'
          + '</div>'
          + '<div class="av1m-actions">'
            + '<label class="av1m-remember"><input type="checkbox" id="av1m-remember"> Jangan tampilkan lagi</label>'
            + '<div class="av1m-btns" id="av1m-btns-wrap">'
              + '<button id="av1m-switch" class="av1m-btn av1m-btn--alt" style="display:none">Server Lain</button>'
              + '<button id="av1m-proceed" class="av1m-btn av1m-btn--go">Lanjutkan AV1</button>'
            + '</div>'
          + '</div>'
        + '</div>';

        /* Tombol Lanjutkan AV1 */
        var procBtn = document.getElementById('av1m-proceed');
        if(procBtn){
          procBtn.onclick = function(){
            var rem = document.getElementById('av1m-remember');
            if(rem && rem.checked){ try { localStorage.setItem(av1MobKey, '1'); } catch(e){} }
            box.className = 'player-box player-box--video';
            box.innerHTML = '<div class="artplayer-app" id="artplayer-mount"></div>';
            _doMount();
          };
        }

        /* Tombol Server Lain — cari server non-AV1 pertama yang tersedia */
        var switchBtn = document.getElementById('av1m-switch');
        if(switchBtn){
          var srvs = self._servers || [];
          var altIdx = -1;
          for(var si = 0; si < srvs.length; si++){
            if(!/av1/i.test(srvs[si].name || '')){
              altIdx = si;
              break;
            }
          }
          /* Tampilkan tombol hanya jika ada server alternatif */
          if(altIdx >= 0){
            var altName = srvs[altIdx].name || 'Server Lain';
            switchBtn.textContent = 'Pindah ' + altName;
            switchBtn.style.display = '';
            switchBtn.onclick = function(){
              var rem = document.getElementById('av1m-remember');
              if(rem && rem.checked){ try { localStorage.setItem(av1MobKey, '1'); } catch(e){} }
              var tabsContainer = document.getElementById('server-tabs');
              if(tabsContainer){
                var tabs = tabsContainer.querySelectorAll('.player-server-tab');
                if(tabs[altIdx]){ tabs[altIdx].click(); }
              }
            };
          }
        }
      } else {
        _doMount();
      }
    } else if(url){
      /* ── Embed server (Abyss, dll) — tampilkan warning dulu ── */
      var embedPrefKey = 'aneetaku_embed_ok';
      var embedOk = false;
      try { embedOk = localStorage.getItem(embedPrefKey) === '1'; } catch(e){}

      var _loadEmbed = function(){
        /* Inject thumbnail jika embed support ?thumbnail= dan ep punya thumb */
        var embedUrl = url;
        var epThumb = (self.currentEp && self.currentEp.thumb) || '';
        if(epThumb && (embedUrl.indexOf('abyssplayer.com') !== -1 || embedUrl.indexOf('short.icu') !== -1)){
          embedUrl += (embedUrl.indexOf('?') === -1 ? '?' : '&') + 'thumbnail=' + encodeURIComponent(epThumb);
        }
        box.className = 'player-box player-box--iframe';
        box.innerHTML = '<iframe id="embed-frame" src="' + ANI.util.esc(embedUrl) + '" allowfullscreen scrolling="no" referrerpolicy="no-referrer" allow="autoplay *; encrypted-media *; fullscreen *; picture-in-picture *"></iframe>';
      };

      if(embedOk){
        _loadEmbed();
      } else {
        box.className = 'player-box player-box--iframe';
        box.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;text-align:center;padding:16px;gap:8px;background:var(--c-bg)">'
          + '<div style="font-family:var(--font-display);font-weight:700;font-size:.9rem;color:var(--c-text);display:inline-flex;align-items:center;gap:5px"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" style="flex-shrink:0"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>Server Pihak Ketiga</div>'
          + '<div style="font-size:.75rem;color:var(--c-muted);max-width:280px;line-height:1.4">Mungkin ada <strong style="color:#f59e0b">iklan popup</strong>. Gunakan AV1/H264 untuk bebas iklan.</div>'
          + '<label style="display:flex;align-items:center;gap:5px;font-size:.7rem;color:var(--c-muted);cursor:pointer"><input type="checkbox" id="embed-remember" style="width:auto;accent-color:#6c63ff"> Ingat pilihan</label>'
          + '<button id="embed-proceed" style="margin-top:4px;background:var(--g-accent);color:#fff;border:none;padding:8px 24px;border-radius:var(--r-md);font-family:var(--font-display);font-weight:600;font-size:.8rem;cursor:pointer">Lanjutkan</button>'
          + '</div>';
        var proceedBtn = document.getElementById('embed-proceed');
        if(proceedBtn){
          proceedBtn.onclick = function(){
            var remember = document.getElementById('embed-remember');
            if(remember && remember.checked){
              try { localStorage.setItem(embedPrefKey, '1'); } catch(e){}
            }
            _loadEmbed();
          };
        }
      }
    } else {
      ANI.util.playerStatus(box, 'empty', 'Server tidak tersedia', 'Coba pilih server lain atau refresh halaman.');
    }
  },

  mountArtplayer: function(videoUrl, skip){
    var self = this;
    var ep   = this.currentEp;
    var ctx  = this.playerCtx || {};
    var ls   = this._ls;
    var ico  = this._ico;
    var opS  = skip.intro[0], opE = skip.intro[1];
    var edS  = skip.outro[0], edE = skip.outro[1];
    var hasOp = opS !== null && opE !== null && opE > opS;
    var hasEd = edS !== null && edE !== null && edE > edS;
    var tries = 0;
    var wait = setInterval(function(){
      tries++;
      if(typeof Artplayer !== 'undefined' && typeof Hls !== 'undefined'){
        clearInterval(wait);
        try{ self._initArt(videoUrl, ep, ctx, ls, ico, skip, hasOp, hasEd, opS, opE, edS, edE); }
        catch(e){ console.error('Artplayer init error:', e); }
      }
      if(tries > 60){ clearInterval(wait); }
    }, 100);
  },

  _initArt: function(videoUrl, ep, ctx, ls, ico, skip, hasOp, hasEd, opS, opE, edS, edE){
    var self = this;
    var isM3u8 = /\.m3u8/i.test(videoUrl);
    var prevUrl = ctx.prevUrl;
    var nextUrl = ctx.nextUrl;

    /* ── Build layers ── */
    var layers = [];
    /* Title overlay */
    if(ctx.seriesTitle){
      var titleSub = ctx.isMovie ? 'Movie' : ANI.util.esc(ctx.seasonTitle + ' \u2022 Ep ' + String(ctx.epNum).padStart(2,'0'));
      layers.push({
        name:'title-overlay',
        html:'<div class="ani-title-overlay"><div class="ani-title-main"><span>' + ANI.util.esc(ctx.seriesTitle) + '</span></div><div class="ani-title-sub">' + titleSub + '</div></div>'
      });
    }
    /* Skip intro layer */
    if(hasOp){
      layers.push({
        name:'skip-op',
        html:'<div class="ani-skip-btn" id="ani-skip-op">' + ico.skip + ' SKIP INTRO</div>',
        click:function(){ this.currentTime = opE; }
      });
    }
    /* Skip ending layer */
    if(hasEd){
      layers.push({
        name:'skip-ed',
        html:'<div class="ani-skip-btn" id="ani-skip-ed">' + ico.skip + ' SKIP OUTRO</div>',
        click:function(){
          var dur = this.duration || 9999;
          if(edE >= dur - 2){
            /* ED end is at/past video end — trigger next episode */
            if(nextUrl) location.href = nextUrl;
            else this.currentTime = dur;
          } else {
            this.currentTime = edE;
          }
        }
      });
    }

    /* ── Build controls ── */
    var controls = [];
    controls.push({
      name:'prevEp',
      position:'right',
      html:ico.prevEp,
      tooltip:'Episode Sebelumnya',
      click:function(){ if(prevUrl) location.href = prevUrl; }
    });
    controls.push({
      name:'nextEp',
      position:'right',
      html:ico.nextEp,
      tooltip:'Episode Selanjutnya',
      click:function(){ if(nextUrl) location.href = nextUrl; }
    });

    /* ── Create Artplayer ── */
    var art = new Artplayer({
      container:'#artplayer-mount',
      url:videoUrl,
      type:isM3u8?'m3u8':(/\.mp4/i.test(videoUrl)?'mp4':'m3u8'),
      theme:'#6c63ff',
      volume:0.8,
      autoplay:false,
      pip:false,
      setting:true,
      fullscreen:true,
      fullscreenWeb:false,
      playsInline:true,
      miniProgressBar:true,
      playbackRate:true,
      aspectRatio:false,
      screenshot:false,
      hotkey:false,
      mutex:true,
      backdrop:true,
      lang:'id',
      poster:ep&&ep.thumb?ANI.util.tmdbThumbHD(ep.thumb):'',
      moreVideoAttr:{crossOrigin:'anonymous',preload:'metadata',playsinline:true},
      layers:layers,
      controls:controls,
      customType:{
        m3u8:function(video,url,art){
          if(Hls.isSupported()){
            if(art.hls) art.hls.destroy();

            /* ── AV1/fMP4 capability detection ── */
            var supAV1 = false;
            try{ supAV1 = !!(window.MediaSource && MediaSource.isTypeSupported('video/mp4; codecs="av01.0.05M.08"')); }catch(e){}

            /* ── HLS.js config: dioptimasi untuk AV1 fMP4 dari R2 ── */
            var mem = navigator.deviceMemory || 4;
            var isHighEnd = mem >= 4;
            var hls = new Hls({
              xhrSetup:function(xhr,url){ if(/aneetaku\.cloud/i.test(url)){ xhr.withCredentials = true; } },
              capLevelToPlayerSize:true,
              enableWorker:true,
              workerPath:null,
              startFragPrefetch:true,
              lowLatencyMode:false,
              /* Buffer: AV1 decode cepat, buffer lebih besar aman */
              maxBufferLength: isHighEnd ? 60 : 30,
              maxMaxBufferLength: isHighEnd ? 600 : 120,
              maxBufferSize: isHighEnd ? (120*1000*1000) : (40*1000*1000),
              /* ABR: mulai dari kualitas tertinggi, biarkan ABR turunkan bila perlu */
              startLevel:-1,
              testBandwidth:true,
              abrEwmaDefaultEstimate: 6000000,
              abrEwmaFastVoD:3.0,
              abrEwmaSlowVoD:9.0,
              /* fMP4 fragments */
              progressive:false,
              /* Retry yang robust untuk R2 */
              fragLoadingMaxRetry:6,
              fragLoadingRetryDelay:1000,
              fragLoadingMaxRetryTimeout:8000,
              manifestLoadingMaxRetry:3,
              manifestLoadingRetryDelay:500,
              levelLoadingMaxRetry:4
            });
            hls.loadSource(url);
            hls.attachMedia(video);
            art.hls = hls;

            /* Apply turbo mode buffer settings */
            function applyTurbo(on){
              var mem = navigator.deviceMemory || 4;
              var pro = mem > 8;
              hls.config.maxMaxBufferLength = on ? 3600 : (pro ? 120 : 40);
              hls.config.maxBufferSize = on ? (pro ? 1e9 : 3e8) : (pro ? 8e7 : 2e7);
            }

            hls.on(Hls.Events.MANIFEST_PARSED, function(){
              /* AV1 warning sudah ditangani oleh banner persisten di loadServer.
                 Notice transient dihapus — user tidak perlu lihat dua kali. */

              /* ── Quality selector dengan memory ── */
              var levels = hls.levels.map(function(lv,i){
                return { default:false, html:(lv.height||'Auto')+'P', levelId:i, h:lv.height };
              });
              levels.unshift({ default:true, html:'Otomatis', levelId:-1 });

              var savedRes = ls.get('aneetaku_res');
              var qTip = 'Otomatis';
              if(savedRes){
                var match = levels.find(function(x){ return x.h == savedRes && x.levelId !== -1; });
                if(match){ hls.currentLevel = match.levelId; qTip = match.html; levels.forEach(function(x){ x.default = (x.levelId === match.levelId); }); }
              } else { hls.startLevel = 0; }

              art.setting.add({
                html:'Kualitas',
                icon:ico.quality,
                width:150,
                tooltip:qTip,
                selector:levels,
                onSelect:function(item){
                  if(item.levelId === -1){ ls.rm('aneetaku_res'); ls.rm('aneetaku_turbo'); applyTurbo(false); }
                  else { ls.set('aneetaku_res', hls.levels[item.levelId].height); }
                  try { ANI.pref._pushToServer({ quality: item.levelId === -1 ? 'auto' : (hls.levels[item.levelId].height <= 480 ? 'hemat' : 'tertinggi') }); } catch(e){}
                  hls.currentLevel = item.levelId;
                  return item.html;
                }
              });

              /* ── Auto-next toggle ── */
              art.setting.add({
                html:'Lanjut Otomatis',
                icon:ico.autonext,
                tooltip:ls.get('aneetaku_autonext')==='true'?'Nyala':'Mati',
                switch:ls.get('aneetaku_autonext')==='true',
                onSwitch:function(item){
                  var on = !item.switch;
                  ls.set('aneetaku_autonext', on);
                  item.tooltip = on ? 'Nyala' : 'Mati';
                  return on;
                }
              });

              /* ── Turbo mode ── */
              var initTurbo = ls.get('aneetaku_turbo')==='true';
              if(initTurbo && !ls.get('aneetaku_res')){ initTurbo = false; ls.rm('aneetaku_turbo'); }
              applyTurbo(initTurbo);

              art.setting.add({
                html:'Mode Turbo',
                icon:ico.turbo,
                tooltip:initTurbo?'Nyala':'Mati',
                switch:initTurbo,
                onSwitch:function(item){
                  var willOn = !item.switch;
                  if(willOn && !ls.get('aneetaku_res')){
                    /* Must select quality first */
                    art.notice.show = 'Pilih kualitas manual dulu untuk Mode Turbo!';
                    return false;
                  }
                  if(willOn){ ls.set('aneetaku_turbo','true'); applyTurbo(true); item.tooltip='Nyala'; return true; }
                  else { ls.rm('aneetaku_turbo'); applyTurbo(false); item.tooltip='Mati'; return false; }
                }
              });
            });

            /* Error recovery yang lebih robust */
            hls.on(Hls.Events.ERROR, function(ev, d){
              if(d.fatal){
                if(d.type === Hls.ErrorTypes.NETWORK_ERROR) hls.startLoad();
                else if(d.type === Hls.ErrorTypes.MEDIA_ERROR) hls.recoverMediaError();
                else { hls.destroy(); art.notice.show = 'Stream error. Coba ganti server.'; }
              }
            });

            art.on('destroy', function(){ hls.destroy(); });
          } else if(video.canPlayType('application/vnd.apple.mpegurl')){
            /* iOS native HLS — AV1 tidak didukung sama sekali di iOS via MSE.
               Banner sudah tampil dari loadServer. Cukup set src dan biarkan
               native player coba decode — worst case user sudah lihat banner. */
            video.src = url;
          } else {
            art.notice.show = 'Browser tidak mendukung HLS.';
          }
        }
      }
    });

    self.artInstance = art;
    var mKey = 'aneetaku_seen_' + (ctx.videoKey || videoUrl.substring(0,60));

    /* ═══ ON READY ═══ */
    art.on('ready', function(){
      var $player = art.template.$player;

      /* ── FIX OVERFLOW via JS — dieksekusi setelah Artplayer inject CSS-nya,
         jadi style.setProperty(...'important') SELALU menang ── */
      var _ov = function(sel){
        var el = $player && $player.querySelector(sel);
        if(el) el.style.setProperty('overflow','visible','important');
      };
      /* Seluruh parent chain volume panel harus visible */
      _ov('.art-video-player');
      _ov('.art-bottom');
      _ov('.art-controls');
      _ov('.art-controls-left');
      _ov('.art-controls-right');
      _ov('.art-control-volume');
      var $vPanel = $player && $player.querySelector('.art-volume-panel');
      if($vPanel){ $vPanel.style.setProperty('overflow','visible','important'); $vPanel.style.setProperty('z-index','200','important'); }

      /* ── BORDER-RADIUS langsung ke <video> element — tidak butuh overflow:hidden di parent ── */
      var isMob = window.innerWidth <= 768;
      var BR = isMob ? '10px 10px 0 0' : '16px 16px 0 0';
      var $vid = $player && $player.querySelector('video');
      if($vid){ $vid.style.borderRadius = BR; }
      /* Poster image dan background juga */
      var $poster = $player && $player.querySelector('.art-poster');
      if($poster){ $poster.style.borderRadius = BR; }
      var $vp = $player && $player.querySelector('.art-video-player');
      if($vp){ $vp.style.borderRadius = BR; }

      /* ── HIDE prevEp/nextEp controls ── */
      var $prevCtrl = $player && $player.querySelector('.art-control-prevEp');
      var $nextCtrl = $player && $player.querySelector('.art-control-nextEp');
      var _setNavVis = function(vis){
        if($prevCtrl) $prevCtrl.style.setProperty('display', vis ? 'flex' : 'none', 'important');
        if($nextCtrl) $nextCtrl.style.setProperty('display', vis ? 'flex' : 'none', 'important');
      };
      _setNavVis(false);
      art.on('fullscreen',    function(s){ _setNavVis(s); });
      art.on('fullscreenWeb', function(s){ _setNavVis(s); });
      /* ── Resume playback ── */
      /* Resume dari quality switch (direct server) */
      if(self._directResumeAt && self._directResumeAt > 1){
        var _rAt = self._directResumeAt;
        self._directResumeAt = 0;
        var doSeek = function(){
          art.currentTime = _rAt;
          art.play().catch(function(){});
        };
        if(art.duration > 0){ doSeek(); }
        else { art.once('video:loadedmetadata', doSeek); }
      } else {
        /* Resume normal dari lastTime / banner lanjut nonton */
        var lastTime = parseFloat(ls.get(mKey)) || 0;
        if(lastTime > 20){
          art.pause();
          var timeStr = ANI.util.fmtTime(lastTime);
          var banner = document.createElement('div');
          banner.className = 'ani-banner';
          banner.innerHTML = '<div class="ani-modal"><h3>Lanjut Nonton?</h3><p>Terakhir kamu menonton sampai <b>' + timeStr + '</b></p><div class="ani-btns"><button class="ani-btn ani-btn-pri" id="ani-resume">LANJUT</button><button class="ani-btn ani-btn-sec" id="ani-restart">DARI AWAL</button></div></div>';
          art.template.$player.appendChild(banner);
          setTimeout(function(){ banner.classList.add('active'); }, 50);
          document.getElementById('ani-resume').onclick = function(){
            art.currentTime = lastTime;
            banner.classList.remove('active');
            setTimeout(function(){ banner.remove(); art.play().catch(function(){}); }, 400);
          };
          document.getElementById('ani-restart').onclick = function(){
            ls.rm(mKey);
            banner.classList.remove('active');
            setTimeout(function(){ banner.remove(); art.play().catch(function(){}); }, 400);
          };
        } else {
          art.play().catch(function(){});
        }
      }
      /* ── Video error recovery untuk direct/gphoto (URL expired saat pause lama) ── */
      if(!isM3u8) try{
        if(typeof self._directRecoverAttempts !== 'number') self._directRecoverAttempts = 0;
        art.template.$video.addEventListener('error', function(){
          if(self._directRecoverAttempts >= 2) return; /* max 2× recovery */
          self._directRecoverAttempts++;
          var savedTime = art.currentTime || parseFloat(ls.get(mKey)) || 0;
          console.warn('[Aneetaku] Video error, recovering at', savedTime);

          /* Cek apakah ini gphoto (bisa re-resolve URL) */
          var curCtx = self.playerCtx || {};
          var curServer = (curCtx.servers && typeof curCtx.activeIdx === 'number') ? curCtx.servers[curCtx.activeIdx] : null;
          if(curServer && curServer._gpAlbum){
            /* Re-resolve gphoto URL */
            var _gpEp = self.currentEp ? self.currentEp.ep : 1;
            fetch('https://gphoto.aneetaku.cloud/resolve?album=' + encodeURIComponent(curServer._gpAlbum) + '&ep=' + _gpEp)
              .then(function(r){ return r.json(); })
              .then(function(data){
                if(data && data.proxy){
                  self._directResumeAt = savedTime;
                  var qs = (data.qualities && data.qualities.length) ? data.qualities : [{q:'1080p',url:data.proxy}];
                  art.option.url = qs[0].url;
                  art.video.src = qs[0].url;
                }
              }).catch(function(){});
          } else {
            /* Direct/IA — kalau Filedon context active dan punya fallback IA, switch.
               Flag _ff.triggered cegah double-fire; URL check dropped karena
               setelah auto-proxy wrap, URL-nya filedon.aneetaku.cloud, bukan r2.filedon.co */
            var curUrl = art.option.url || art.video.src;
            var _ff = self._filedonFallback;
            if(_ff && !_ff.triggered){
              _ff.triggered = true;
              if(_ff.timer){ clearTimeout(_ff.timer); _ff.timer = null; }
              var _fbErr = _ff.url;
              /* Wrap via ia.aneetaku.cloud kalau URL raw archive.org */
              if(_fbErr.indexOf('archive.org') !== -1 && _fbErr.indexOf('ia.aneetaku.cloud') === -1){
                _fbErr = 'https://ia.aneetaku.cloud/?url=' + encodeURIComponent(_fbErr);
              }
              console.warn('[Aneetaku] Filedon error — fallback ke IA:', _fbErr);
              self._directResumeAt = savedTime;
              art.video.src = _fbErr;
            } else if(curUrl){
              self._directResumeAt = savedTime;
              art.video.src = curUrl;
            }
          }
        });
      }catch(e){}

      /* ── Filedon → IA timeout watchdog (8s dari loadstart) ── */
      /* Watchdog selalu di-register agar aktif setelah quality switch mengisi _filedonFallback baru */
      if(!isM3u8) try{
        if(art.template && art.template.$video){
          art.template.$video.addEventListener('loadstart', function(){
            /* Baca _filedonFallback secara dinamis — tidak capture sekali agar
               quality switch yang reset object ini tetap terpantau */
            var _ff2 = self._filedonFallback;
            if(!_ff2 || _ff2.triggered || _ff2.timer) return;
            _ff2.timer = setTimeout(function(){
              /* Re-baca lagi agar tidak pakai referensi stale */
              var _ff2c = self._filedonFallback;
              if(!_ff2c || _ff2c.triggered) return;
              _ff2c.triggered = true;
              _ff2c.timer = null;
              var _fbT = _ff2c.url;
              if(_fbT.indexOf('archive.org') !== -1 && _fbT.indexOf('ia.aneetaku.cloud') === -1){
                _fbT = 'https://ia.aneetaku.cloud/?url=' + encodeURIComponent(_fbT);
              }
              console.warn('[Aneetaku] Filedon timeout 8s — fallback ke IA:', _fbT);
              art.video.src = _fbT;
              art.video.load();
              art.video.play().catch(function(){});
            }, 8000);
          });
          /* Clear timer kalau source OK */
          art.template.$video.addEventListener('canplay', function(){
            var _ff2 = self._filedonFallback;
            if(_ff2 && _ff2.timer){ clearTimeout(_ff2.timer); _ff2.timer = null; }
          });
          art.template.$video.addEventListener('playing', function(){
            var _ff2 = self._filedonFallback;
            if(_ff2 && _ff2.timer){ clearTimeout(_ff2.timer); _ff2.timer = null; }
          });
        }
      }catch(e){}

      /* ── Draw progress highlights ── */
      var drawHL = function(){
        var dur = art.duration;
        if(!dur || dur <= 0 || !art.template.$progress) return;
        var track = art.template.$progress.querySelector('.art-control-progress-inner') || art.template.$progress;
        if(!track) return;
        track.querySelectorAll('.ani-hl').forEach(function(el){ el.remove(); });
        var addHL = function(s, e){
          var ce = Math.min(e, dur); 
          if(ce > s && s < dur){
            var hl = document.createElement('div');
            hl.className = 'ani-hl';
            hl.style.cssText = 'left:' + (s/dur*100) + '%;width:' + ((e-s)/dur*100) + '%';
            track.appendChild(hl);
          }
        };
        if(hasOp) addHL(opS, opE);
        if(hasEd) addHL(edS, edE);
      };
      art.on('video:durationchange', drawHL);
      art.on('video:loadedmetadata', drawHL);
      setTimeout(drawHL, 500);

      /* ── Settings untuk type:direct: Kualitas + Lanjut Otomatis ── */
      /* HLS settings sudah di-inject oleh MANIFEST_PARSED — skip di sini */
      if(!isM3u8) try{
        var dqs = self._directQualities;
        if(dqs && dqs.length > 1){
          var dSel = dqs.map(function(qo){
            return { default: qo.q === self._directChosenQ, html: qo.q, q: qo.q, url: qo.url, fallback_url: qo.fallback_url || null };
          });
          art.setting.add({
            html: 'Kualitas',
            icon: ico.quality,
            width: 150,
            tooltip: self._directChosenQ || dqs[0].q,
            selector: dSel,
            onSelect: function(item){
              try { localStorage.setItem('aneetaku_direct_q', item.q); } catch(e){}
              self._directChosenQ = item.q;
              var ct = art.currentTime || 0;
              var wasPlaying = !art.video.paused;

              /* ── Direct src swap — BYPASS art.switchUrl() ──
                 switchUrl() re-invoke customType handler → HLS.js jalan
                 untuk mp4 → reconnect loop + error.
                 Direct src swap: tidak trigger customType, settings utuh,
                 resume reliable via native loadedmetadata. */
              var newUrl = item.url;
              /* Re-apply proxy wrapping (qualities[] simpan URL mentah) */
              if(newUrl.indexOf('r2.filedon.co') !== -1 && newUrl.indexOf('filedon.aneetaku.cloud') === -1){
                newUrl = 'https://filedon.aneetaku.cloud/?url=' + encodeURIComponent(newUrl);
              }
              if(newUrl.indexOf('archive.org') !== -1 && newUrl.indexOf('ia.aneetaku.cloud') === -1){
                newUrl = 'https://ia.aneetaku.cloud/?url=' + encodeURIComponent(newUrl);
              }
              /* Reset fallback context untuk quality baru + reset error counter */
              self._filedonFallback = null;
              if(item.url && item.url.indexOf('r2.filedon.co') !== -1 && item.fallback_url){
                self._filedonFallback = { url: item.fallback_url, timer: null, triggered: false };
              }
              self._directRecoverAttempts = 0;

              /* Manual swap — clean & minimal. Browser auto-pause saat src
                 berubah, load() pastikan resource selection ke URL baru.
                 Posisi seek di-restore via art.once('video:loadedmetadata').
                 Catatan: aggressive reset (removeAttribute + double-load) sudah
                 dihapus karena bikin network spike + stutter, dan bug awal
                 ternyata di data filename, bukan di swap logic. */
              art.option.url = newUrl;       /* sync internal Artplayer state */
              art.video.src  = newUrl;       /* swap source di element <video> */
              try { art.video.load(); } catch(e) {} /* paksa fetch URL baru */

              art.once('video:loadedmetadata', function(){
                if(ct > 1) try { art.currentTime = ct; } catch(e) {}
                if(wasPlaying) art.play().catch(function(){});
              });

              return item.html;
            }
          });
        }
        /* Lanjut Otomatis */
        art.setting.add({
          html: 'Lanjut Otomatis',
          icon: ico.autonext,
          tooltip: ls.get('aneetaku_autonext') === 'true' ? 'Nyala' : 'Mati',
          switch: ls.get('aneetaku_autonext') === 'true',
          onSwitch: function(item){
            var on = !item.switch;
            ls.set('aneetaku_autonext', String(on));
            item.tooltip = on ? 'Nyala' : 'Mati';
            return on;
          }
        });
      }catch(e){}
    });

    /* ═══ TIME UPDATE — skip visibility + save position ═══ */
    var lastSave = 0;
    var btnOp = hasOp ? (art.layers['skip-op'] ? art.layers['skip-op'].querySelector('.ani-skip-btn') : null) : null;
    var btnEd = hasEd ? (art.layers['skip-ed'] ? art.layers['skip-ed'].querySelector('.ani-skip-btn') : null) : null;
    var opVis = false, edVis = false;

    var _markedWatched = false;
    art.on('video:timeupdate', function(){
      var t = art.currentTime;
      /* Save progress every 5s */
      if(t > 20 && Math.abs(t - lastSave) > 5){ ls.set(mKey, t); lastSave = t; }
      /* Sync ke server (Patch 3) */
      try {
        var _slug = (self.data && self.data.ani && self.data.ani.series) ? self.data.ani.series.slug : '';
        var _epn = self.currentEp ? self.currentEp.ep : 0;
        if (_slug && _epn) ANI.historySync.track(_slug, _epn, t, art.duration || 0);
      } catch(e) {}
      /* Mark watched at 85% — even if tab closed before end */
      if(!_markedWatched && art.duration > 0 && t / art.duration >= 0.85){
        _markedWatched = true;
        if(ctx.videoKey) ls.set('aneetaku_w_' + ctx.videoKey, '1');
      }
      /* Skip button fade */
      if(btnOp){
        var show = hasOp && t >= opS && t <= opE - 2;
        if(show !== opVis){
          opVis = show;
          if(show){ btnOp.style.display='flex'; setTimeout(function(){btnOp.style.opacity='1'},10); }
          else { btnOp.style.opacity='0'; setTimeout(function(){if(!opVis) btnOp.style.display='none'},400); }
        }
      }
      if(btnEd){
        var clampedEdE = (art.duration > 0 && edE > art.duration) ? art.duration : edE;
        var show2 = hasEd && t >= edS && t <= clampedEdE - 1;
        if(show2 !== edVis){
          edVis = show2;
          if(show2){ btnEd.style.display='flex'; setTimeout(function(){btnEd.style.opacity='1'},10); }
          else { btnEd.style.opacity='0'; setTimeout(function(){if(!edVis) btnEd.style.display='none'},400); }
        }
      }
    });

    /* ═══ FULLSCREEN — landscape lock mobile ═══ */
    art.on('fullscreen', function(state){
      try{
        if(state && screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape').catch(function(){});
        else if(!state && screen.orientation && screen.orientation.unlock) screen.orientation.unlock();
      }catch(e){}
    });
    art.on('fullscreenWeb', function(state){
      try{
        if(state && screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape').catch(function(){});
        else if(!state && screen.orientation && screen.orientation.unlock) screen.orientation.unlock();
      }catch(e){}
    });

    /* ═══ VIDEO ENDED — auto-next or dialog ═══ */
    art.on('video:ended', function(){
      ls.rm(mKey); /* clear saved position */
      /* Flush history sync (Patch 3) */
      try {
        var _slug2 = (self.data && self.data.ani && self.data.ani.series) ? self.data.ani.series.slug : '';
        var _epn2 = self.currentEp ? self.currentEp.ep : 0;
        if (_slug2 && _epn2) ANI.historySync.flushNow(_slug2, _epn2, art.duration || 0, art.duration || 0);
      } catch(e) {}
      /* Mark episode as watched */
      if(ctx.videoKey) ls.set('aneetaku_w_' + ctx.videoKey, '1');
      if(ls.get('aneetaku_autonext') === 'true' && nextUrl){
        location.href = nextUrl;
        return;
      }
      if(!nextUrl) return;
      var banner = document.createElement('div');
      banner.className = 'ani-banner';
      banner.innerHTML = '<div class="ani-modal"><h3>Episode Selesai</h3><p>Putar episode selanjutnya?</p><div class="ani-btns"><button class="ani-btn ani-btn-pri" id="ani-autonext">LANJUT <span id="ani-cd">10</span>s</button><button class="ani-btn ani-btn-sec" id="ani-cancel">BATAL</button></div></div>';
      art.template.$player.appendChild(banner);
      setTimeout(function(){ banner.classList.add('active'); }, 50);
      var cd = 10;
      var cdTimer = setInterval(function(){
        cd--;
        var el = document.getElementById('ani-cd');
        if(el) el.textContent = cd;
        if(cd <= 0){ clearInterval(cdTimer); location.href = nextUrl; }
      }, 1000);
      document.getElementById('ani-autonext').onclick = function(){ clearInterval(cdTimer); location.href = nextUrl; };
      document.getElementById('ani-cancel').onclick = function(){
        clearInterval(cdTimer);
        banner.classList.remove('active');
        setTimeout(function(){ banner.remove(); }, 400);
      };
    });

    /* ═══ KEYBOARD — capture phase agar preventDefault sebelum browser default ═══ */
    /* Guard: hanya register 1×, mencegah listener duplikat saat ganti server/gphoto resolve */
    if(!self._kbBound){
      self._kbBound = true;
      document.addEventListener('keydown', function(e){
        /* Jangan handle saat focus di input/textarea (cari anime, cari nomor, dll) */
        if(e.target.tagName==='INPUT'||e.target.tagName==='TEXTAREA'||e.target.isContentEditable) return;
        var a = self.artInstance; if(!a) return;
        switch(e.key){
          case ' ':case 'k':e.preventDefault();a.playing?a.pause():a.play();break;
          case 'f':e.preventDefault();a.fullscreen=!a.fullscreen;break;
          case 'ArrowLeft':e.preventDefault();a.currentTime=Math.max(0,a.currentTime-5);break;
          case 'ArrowRight':e.preventDefault();a.currentTime=Math.min(a.duration,a.currentTime+5);break;
          case 'ArrowUp':e.preventDefault();a.volume=Math.min(1,Math.round((a.volume+0.1)*10)/10);break;
          case 'ArrowDown':e.preventDefault();a.volume=Math.max(0,Math.round((a.volume-0.1)*10)/10);break;
          case 'm':e.preventDefault();a.muted=!a.muted;break;
        }
      }, true); /* capture:true — intercept sebelum browser default */
    }

    /* ═══ MOBILE VOLUME — single tap: tampilkan slider, double tap: mute ═══
       Artplayer hanya menampilkan volume panel via mouseenter (desktop hover).
       Touch device tidak punya mouseenter → kita tampilkan panel secara manual. ═══ */
    (function(){
      if(!('ontouchstart' in window)) return;
      art.on('ready', function(){
        var $volBtn  = art.template.$player.querySelector('.art-control-volume');
        var $volPanel = art.template.$player.querySelector('.art-volume-panel');
        if(!$volBtn || !$volPanel) return;

        var _lastTap = 0;
        var _panelOpen = false;

        function _showPanel(){
          _panelOpen = true;
          $volPanel.style.setProperty('display','flex','important');
          $volPanel.style.setProperty('opacity','1','important');
          $volPanel.style.setProperty('visibility','visible','important');
        }
        function _hidePanel(){
          _panelOpen = false;
          $volPanel.style.removeProperty('display');
          $volPanel.style.removeProperty('opacity');
          $volPanel.style.removeProperty('visibility');
        }

        $volBtn.addEventListener('touchend', function(e){
          var now = Date.now();
          var isDouble = (now - _lastTap) < 320;
          _lastTap = now;
          e.preventDefault();
          e.stopPropagation();
          if(isDouble){ _hidePanel(); art.muted = !art.muted; }
          else {
            if(_panelOpen){ _hidePanel(); }
            else { _showPanel(); setTimeout(function(){ if(_panelOpen) _hidePanel(); }, 3000); }
          }
        }, {passive:false});

        art.template.$player.addEventListener('touchstart', function(e){
          if(_panelOpen && !$volBtn.contains(e.target)) _hidePanel();
        }, {passive:true});
      });
    })();
  },

  parseSkip: function(url){
    var result = { intro: [null, null], outro: [null, null] };
    if(!url) return result;
    try{
      /* ep.oped adalah raw query string: "ops=90&ope=180&eds=1200&ede=1290"
         Server embed (speedcloud) berisi full URL dengan params di dalamnya.
         Normalkan keduanya ke URLSearchParams. */
      var params;
      if(url.indexOf('://') !== -1 || url.charAt(0) === '/'){
        /* Full URL atau absolute path — parse via URL constructor */
        params = new URL(url, window.location.origin).searchParams;
      } else {
        /* Raw query string dari ep.oped — langsung ke URLSearchParams */
        params = new URLSearchParams(url);
      }
      var ops = params.get('ops');
      var ope = params.get('ope');
      var eds = params.get('eds');
      var ede = params.get('ede');
      if(ops !== null) result.intro = [parseFloat(ops), parseFloat(ope)];
      if(eds !== null) result.outro = [parseFloat(eds), parseFloat(ede)];
    }catch(e){}
    return result;
  },

  renderError: function(msg){
    document.getElementById('app-content').innerHTML =
      '<div style="display:flex;align-items:center;justify-content:center;min-height:50vh;flex-direction:column;gap:16px">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
        + '<p style="color:var(--c-muted);font-family:var(--font-display)">' + msg + '</p>'
        + '<a href="/" class="btn-secondary">Kembali ke Beranda</a>'
      + '</div>';
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — Module: Gallery Lightbox
   Sprint 1 — anime_gallery feature

   Trigger: klik poster di /anime/:slug
   Open: lightbox fullscreen, blur backdrop, thumbnail strip,
         nav arrows desktop / swipe mobile, keyboard shortcuts.

   Image source priority (untuk active poster — index 0):
     coverUrl (TMDB w342) → upgraded ke /original/ via tmdbOriginal()

   Sumber gallery item (index 1+):
     anime_gallery rows dari D1 (source_type tmdb/gphoto/r2/external).
   ═══════════════════════════════════════════════ */

ANI.gallery = {
  el: null,
  images: [],
  idx: 0,
  _esc: null,
  _touchStartX: 0,
  _touchStartY: 0,

  /* Build images array dari anime cover + gallery rows, lalu open() */
  openFromAnime: function(coverUrl, title, galleryRows){
    var images = [];

    /* Active poster — index 0 */
    if (coverUrl) {
      var fullCover = ANI.util.tmdbOriginal(coverUrl) || coverUrl;
      images.push({
        url: fullCover,
        thumb: coverUrl,
        caption: 'Poster',
        category: 'poster'
      });
    }

    /* Gallery items — sudah di-sort sort_order ASC dari API */
    var rows = galleryRows || [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i] || {};
      if (!r.url) continue;
      var fullUrl  = r.url;
      var thumbUrl = r.thumb_url || r.url;

      /* Untuk source_type tmdb, url biasanya path "/abc.jpg" tanpa host.
         Frontend prefix CDN TMDB. Kalau sudah full URL, biarkan. */
      if (r.source_type === 'tmdb' && fullUrl.indexOf('http') !== 0) {
        var tmdbBase = 'https://image.tmdb.org/t/p/';
        if (fullUrl.charAt(0) !== '/') fullUrl = '/' + fullUrl;
        thumbUrl = tmdbBase + 'w500' + fullUrl;
        fullUrl  = tmdbBase + 'original' + fullUrl;
      }

      images.push({
        url: fullUrl,
        thumb: thumbUrl,
        caption: r.caption || '',
        category: r.category || 'screenshot',
        width: r.width || 0,
        height: r.height || 0
      });
    }

    if (images.length === 0) return;
    this.open(images, 0, title || '');
  },

  open: function(images, startIdx, title){
    var self = this;
    self.images = images || [];
    self.idx = Math.max(0, Math.min(startIdx | 0, self.images.length - 1));

    /* Build root element */
    if (!self.el) {
      var el = document.createElement('div');
      el.className = 'gal-lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', 'Gallery');
      el.innerHTML =
        '<div class="gal-backdrop" data-gal-close="1"></div>' +
        '<div class="gal-viewport">' +
          '<button class="gal-close" aria-label="Tutup" data-gal-close="1">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<div class="gal-counter"><span class="gal-counter__cur">1</span> / <span class="gal-counter__tot">1</span></div>' +
          '<button class="gal-nav gal-nav--prev" aria-label="Sebelumnya" data-gal-nav="prev">' +
            '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="15 18 9 12 15 6"/></svg>' +
          '</button>' +
          '<div class="gal-stage">' +
            '<img class="gal-image" alt="" />' +
            '<div class="gal-caption"></div>' +
            '<div class="gal-loader" aria-hidden="true"></div>' +
          '</div>' +
          '<button class="gal-nav gal-nav--next" aria-label="Berikutnya" data-gal-nav="next">' +
            '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>' +
          '</button>' +
          '<div class="gal-thumbs" role="tablist"></div>' +
        '</div>';
      document.body.appendChild(el);
      self.el = el;

      /* Bind events sekali */
      el.addEventListener('click', function(e){
        var t = e.target;
        if (t.closest && t.closest('[data-gal-close]')) { self.close(); return; }
        var nav = t.closest && t.closest('[data-gal-nav]');
        if (nav) {
          if (nav.getAttribute('data-gal-nav') === 'next') self.next();
          else self.prev();
          return;
        }
        var thumb = t.closest && t.closest('.gal-thumb');
        if (thumb) {
          var i = parseInt(thumb.getAttribute('data-i'), 10);
          if (!isNaN(i)) self.setActive(i);
        }
      });

      /* Touch swipe (mobile) */
      var stage = el.querySelector('.gal-stage');
      stage.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        self._touchStartX = e.touches[0].clientX;
        self._touchStartY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function(e){
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - self._touchStartX;
        var dy = e.changedTouches[0].clientY - self._touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) self.next(); else self.prev();
        }
      });
    }

    /* Build thumbnails */
    var thumbsEl = self.el.querySelector('.gal-thumbs');
    var th = '';
    for (var i = 0; i < self.images.length; i++) {
      var im = self.images[i];
      var tu = im.thumb || im.url;
      th += '<button class="gal-thumb" data-i="' + i + '" role="tab" aria-label="' + ANI.util.esc(im.caption || ('Image ' + (i+1))) + '">' +
              '<img src="' + ANI.util.esc(tu) + '" alt="" loading="lazy" />' +
            '</button>';
    }
    thumbsEl.innerHTML = th;

    self.el.querySelector('.gal-counter__tot').textContent = self.images.length;

    /* Show */
    self.el.classList.add('is-open');
    document.documentElement.classList.add('gal-locked');
    document.body.classList.add('gal-locked');

    /* Keyboard handler */
    self._esc = function(e){
      if (e.key === 'Escape')      self.close();
      else if (e.key === 'ArrowLeft')  self.prev();
      else if (e.key === 'ArrowRight') self.next();
    };
    document.addEventListener('keydown', self._esc);

    self.setActive(self.idx, true);
  },

  setActive: function(i, force){
    var self = this;
    if (!self.images.length) return;
    if (i < 0) i = self.images.length - 1;
    if (i >= self.images.length) i = 0;
    if (!force && i === self.idx) return;
    self.idx = i;

    var im = self.images[i];
    var imgEl = self.el.querySelector('.gal-image');
    var capEl = self.el.querySelector('.gal-caption');
    var loaderEl = self.el.querySelector('.gal-loader');

    /* Loader on */
    if (loaderEl) loaderEl.classList.add('is-loading');
    imgEl.classList.remove('is-ready');

    /* Set src dengan fade-in saat load */
    var newSrc = im.url;
    var tmpImg = new Image();
    tmpImg.onload = function(){
      imgEl.src = newSrc;
      imgEl.classList.add('is-ready');
      if (loaderEl) loaderEl.classList.remove('is-loading');
    };
    tmpImg.onerror = function(){
      /* Fallback ke thumb kalau full gagal */
      if (im.thumb && im.thumb !== newSrc) {
        imgEl.src = im.thumb;
        imgEl.classList.add('is-ready');
      }
      if (loaderEl) loaderEl.classList.remove('is-loading');
    };
    tmpImg.src = newSrc;

    capEl.textContent = im.caption || '';
    capEl.style.display = im.caption ? 'block' : 'none';

    /* Update counter */
    self.el.querySelector('.gal-counter__cur').textContent = (i + 1);

    /* Update active thumb */
    var thumbs = self.el.querySelectorAll('.gal-thumb');
    for (var ti = 0; ti < thumbs.length; ti++) {
      thumbs[ti].classList.toggle('is-active', ti === i);
    }
    /* Scroll active thumb into view */
    var activeThumb = thumbs[i];
    if (activeThumb && activeThumb.scrollIntoView) {
      try { activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
      catch(e) { activeThumb.scrollIntoView(); }
    }
  },

  next: function(){ this.setActive(this.idx + 1); },
  prev: function(){ this.setActive(this.idx - 1); },

  close: function(){
    var self = this;
    if (!self.el) return;
    self.el.classList.remove('is-open');
    document.documentElement.classList.remove('gal-locked');
    document.body.classList.remove('gal-locked');
    if (self._esc) {
      document.removeEventListener('keydown', self._esc);
      self._esc = null;
    }
  }
};


/* ═══════════════════════════════════════════════
   ANEETAKU — Module: Pemeran (Cast — Live Action)
   Sprint 2 — eksperimental, member-only

   Routes:
     /pemeran           → list semua pemeran active
     /pemeran/:slug     → detail (bio, filmography, gallery)

   Auth gating: keduanya logged-in only. Guest → login prompt.
   Cast section di anime detail di-render dari anime.cast (lihat
   trigger di ANI.series.renderSeriesPage), juga member-only.
   ═══════════════════════════════════════════════ */

ANI.pemeran = {
  _list: null,
  _filterQ: '',

  _isLoggedIn: function() {
    try { return !!(ANI.user && ANI.user.isLoggedIn && ANI.user.isLoggedIn()); }
    catch(e) { return false; }
  },

  _avatarUrl: function(p) {
    if (!p) return '';
    var url = p.active_photo_url || '';
    if (!url) return '';
    if (url.indexOf('http') !== 0 && url.charAt(0) === '/') {
      return 'https://image.tmdb.org/t/p/w500' + url;
    }
    if (url.indexOf('http') !== 0) {
      return 'https://image.tmdb.org/t/p/w500/' + url;
    }
    return url;
  },

  _renderLoginPrompt: function(label) {
    var content = document.getElementById('app-content');
    if (!content) return;
    content.innerHTML =
      '<div class="pmr-login-prompt">' +
        '<div class="pmr-login-icon"><svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6"/><path d="M23 11h-6"/></svg></div>' +
        '<h2 class="pmr-login-title">Pemeran <span class="pmr-beta">BETA</span></h2>' +
        '<p class="pmr-login-msg">Halaman ' + ANI.util.esc(label || 'Pemeran') + ' eksklusif untuk member yang sudah login. Login untuk melihat profil pemeran live-action dan filmografi mereka.</p>' +
        '<div class="pmr-login-actions">' +
          '<button class="btn-primary" id="pmr-login-btn">Login dengan Google</button>' +
          '<a href="/" class="btn-outline">← Kembali ke Beranda</a>' +
        '</div>' +
      '</div>';
    var btn = document.getElementById('pmr-login-btn');
    if (btn) btn.addEventListener('click', function(){
      try { ANI.authUI.showLoginModal(); }
      catch(e) { window.location.href = '/'; }
    });
  },

  initList: function() {
    var self = this;
    if (!self._isLoggedIn()) { self._renderLoginPrompt('Daftar Pemeran'); return; }
    self._renderListShell();
    self._loadList();
  },

  _renderListShell: function() {
    var content = document.getElementById('app-content');
    if (!content) return;
    var q = ANI.util.esc(this._filterQ || '');
    var _bcPmr = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([{ label:'Beranda', href:'/' }, { label:'Pemeran' }])
      : '';
    content.innerHTML = _bcPmr +
      '<div class="pmr-list-page">' +
        '<div class="pmr-list-hdr">' +
          '<h1 class="pmr-list-title">Pemeran <span class="pmr-beta">BETA</span></h1>' +
          '<p class="pmr-list-sub">Profil pemeran live-action yang tampil di Aneetaku. Fitur eksperimental.</p>' +
          '<div class="pmr-list-search"><input id="pmr-search" type="text" placeholder="Cari nama pemeran..." value="' + q + '" /></div>' +
        '</div>' +
        '<div id="pmr-list-grid" class="pmr-list-grid"><div class="pmr-loading">Memuat pemeran...</div></div>' +
      '</div>';
    var input = document.getElementById('pmr-search');
    if (input) {
      var t = null;
      input.addEventListener('input', function(){
        clearTimeout(t);
        var v = input.value;
        t = setTimeout(function(){
          ANI.pemeran._filterQ = v;
          ANI.pemeran._loadList();
        }, 300);
      });
    }
  },

  _loadList: function() {
    var self = this;
    var grid = document.getElementById('pmr-list-grid');
    if (grid) grid.innerHTML = '<div class="pmr-loading">Memuat pemeran...</div>';
    ANI.api.pemeranList({ q: self._filterQ, limit: 200 })
      .then(function(r){
        var items = (r && r.data) || [];
        self._list = items;
        self._renderListGrid(items);
      })
      .catch(function(e){
        if (grid) grid.innerHTML = '<div class="pmr-empty">Gagal memuat: ' + ANI.util.esc(e.message || '') + '</div>';
      });
  },

  _renderListGrid: function(items) {
    var grid = document.getElementById('pmr-list-grid');
    if (!grid) return;
    if (!items.length) {
      grid.innerHTML = '<div class="pmr-empty">' +
        (this._filterQ ? 'Tidak ada pemeran yang cocok dengan pencarian.' : 'Belum ada pemeran terdaftar.') +
      '</div>';
      return;
    }
    var h = '';
    for (var i = 0; i < items.length; i++) {
      var p = items[i];
      var av = this._avatarUrl(p);
      h += '<a href="/pemeran/' + ANI.util.esc(p.slug) + '" class="pmr-card">' +
        '<div class="pmr-card-avatar">' +
          (av ? '<img src="' + ANI.util.esc(av) + '" alt="" loading="lazy" />' : '<div class="pmr-card-noavatar">' + ANI.util.esc((p.name||'?').charAt(0)) + '</div>') +
        '</div>' +
        '<div class="pmr-card-name">' + ANI.util.esc(p.name || '') + '</div>' +
        (p.nationality ? '<div class="pmr-card-meta">' + ANI.util.esc(p.nationality) + '</div>' : '') +
      '</a>';
    }
    grid.innerHTML = h;
  },

  initDetail: function(slug) {
    var self = this;
    if (!self._isLoggedIn()) { self._renderLoginPrompt('Detail Pemeran'); return; }
    var content = document.getElementById('app-content');
    if (content) content.innerHTML = '<div class="pmr-loading" style="padding:60px 0;text-align:center">Memuat profil pemeran...</div>';

    ANI.api.pemeranBySlug(slug)
      .then(function(r){
        var p = r && r.data;
        if (!p) {
          if (content) content.innerHTML = '<div class="pmr-empty">Pemeran tidak ditemukan: ' + ANI.util.esc(slug) + '</div>';
          return;
        }
        try { setTitle(p.name || 'Pemeran'); } catch(_) {}
        self._renderDetail(p);
      })
      .catch(function(e){
        if (content) content.innerHTML = '<div class="pmr-empty">Gagal memuat: ' + ANI.util.esc(e.message || '') + '</div>';
      });
  },

  _renderDetail: function(p) {
    var content = document.getElementById('app-content');
    if (!content) return;
    var av = this._avatarUrl(p);
    var altNames = (Array.isArray(p.alt_names) && p.alt_names.length) ? p.alt_names.join(' · ') : '';
    var birth = '';
    if (p.birth_date)  birth += p.birth_date;
    if (p.birth_place) birth += (birth ? ' · ' : '') + p.birth_place;

    var bindings = p.bindings || [];
    var filmHtml = '';
    if (bindings.length) {
      filmHtml += '<div class="pmr-film-grid">';
      for (var i = 0; i < bindings.length; i++) {
        var b = bindings[i];
        var animeCover = b.anime_cover || '';
        if (animeCover && animeCover.indexOf('http') !== 0 && animeCover.charAt(0) === '/') {
          animeCover = 'https://image.tmdb.org/t/p/w300' + animeCover;
        } else if (animeCover && animeCover.indexOf('http') !== 0) {
          animeCover = 'https://image.tmdb.org/t/p/w300/' + animeCover;
        }
        filmHtml += '<a href="/anime/' + ANI.util.esc(b.anime_slug || '') + '" class="pmr-film-card">' +
          '<div class="pmr-film-cover">' +
            (animeCover ? '<img src="' + ANI.util.esc(animeCover) + '" alt="" loading="lazy" />' : '<div class="pmr-film-noavatar">?</div>') +
          '</div>' +
          '<div class="pmr-film-title">' + ANI.util.esc(b.anime_title || b.anime_slug || '') + '</div>' +
          (b.character_name ? '<div class="pmr-film-role">as ' + ANI.util.esc(b.character_name) + '</div>' : '') +
        '</a>';
      }
      filmHtml += '</div>';
    } else {
      filmHtml = '<div class="pmr-empty-card">' +
        '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" opacity=".4"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M7 3v18"/><path d="M17 3v18"/><path d="M3 12h18"/></svg>' +
        '<div>Belum ada series yang ter-binding</div>' +
      '</div>';
    }

    var galRows = p.gallery || [];
    var galThumbs = '';
    if (galRows.length) {
      galThumbs += '<div class="pmr-gal-strip" id="pmr-gal-strip">';
      for (var gi = 0; gi < galRows.length; gi++) {
        var g = galRows[gi];
        var thumb = g.thumb_url || g.url;
        if (g.source_type === 'tmdb' && thumb.indexOf('http') !== 0) {
          if (thumb.charAt(0) !== '/') thumb = '/' + thumb;
          thumb = 'https://image.tmdb.org/t/p/w500' + thumb;
        }
        galThumbs += '<button class="pmr-gal-thumb" data-i="' + gi + '" type="button"><img src="' + ANI.util.esc(thumb) + '" alt="" loading="lazy" /></button>';
      }
      galThumbs += '</div>';
    }

    /* SVG icons (Aneetaku style — line stroke 2) */
    var svgPin   = '<svg class="pmr-meta-ico" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';
    var svgGlobe = '<svg class="pmr-meta-ico" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>';
    var svgCake  = '<svg class="pmr-meta-ico" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/><path d="M4 16s1-1 4-1 5 2 8 2 4-1 4-1"/><path d="M2 21h20"/><path d="M7 8v3"/><path d="M12 8v3"/><path d="M17 8v3"/><path d="M7 4h.01"/><path d="M12 4h.01"/><path d="M17 4h.01"/></svg>';

    /* Banner background — pakai avatar sebagai blurred backdrop kalau ada */
    var bannerStyle = av ? 'background-image:url(' + ANI.util.esc(av) + ')' : '';

    /* Build meta rows (split birth_date dan place untuk icon yang berbeda) */
    var metaHtml = '';
    if (p.birth_date)  metaHtml += '<div class="pmr-meta-row">' + svgCake  + '<span>' + ANI.util.esc(p.birth_date) + '</span></div>';
    if (p.birth_place) metaHtml += '<div class="pmr-meta-row">' + svgPin   + '<span>' + ANI.util.esc(p.birth_place) + '</span></div>';
    if (p.nationality) metaHtml += '<div class="pmr-meta-row">' + svgGlobe + '<span>' + ANI.util.esc(p.nationality) + '</span></div>';

    /* External IDs links */
    var ext = p.external_ids || {};
    var extLinks = '';
    if (ext.instagram) extLinks += '<a href="https://instagram.com/' + ANI.util.esc(ext.instagram) + '" target="_blank" rel="noopener" class="pmr-ext-link" title="Instagram"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg></a>';
    if (ext.twitter)   extLinks += '<a href="https://twitter.com/' + ANI.util.esc(ext.twitter) + '" target="_blank" rel="noopener" class="pmr-ext-link" title="Twitter"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"/></svg></a>';

    var _bcPmrD = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([
          { label:'Beranda', href:'/' },
          { label:'Pemeran', href:'/pemeran' },
          { label: p.name || 'Detail' }
        ])
      : '';
    content.innerHTML = _bcPmrD +
      '<div class="pmr-detail">' +
        '<div class="pmr-detail-banner" style="' + bannerStyle + '"></div>' +
        '<div class="pmr-detail-head">' +
          '<div class="pmr-detail-avatar">' +
            (av ? '<img id="pmr-main-avatar" src="' + ANI.util.esc(av) + '" alt="" />' : '<div class="pmr-card-noavatar pmr-noavatar--big">' + ANI.util.esc((p.name||'?').charAt(0)) + '</div>') +
          '</div>' +
          '<div class="pmr-detail-info">' +
            '<h1 class="pmr-detail-name">' + ANI.util.esc(p.name || '') + ' <span class="pmr-beta">BETA</span></h1>' +
            (altNames ? '<div class="pmr-detail-alt">' + ANI.util.esc(altNames) + '</div>' : '') +
            (metaHtml ? '<div class="pmr-meta-grid">' + metaHtml + '</div>' : '') +
            (extLinks ? '<div class="pmr-ext-links">' + extLinks + '</div>' : '') +
          '</div>' +
        '</div>' +
        (p.bio ? '<div class="pmr-bio-card"><div class="pmr-bio-text">' + ANI.util.esc(p.bio).replace(/\n/g, '<br>') + '</div></div>' : '') +
        (galRows.length ? '<div class="pmr-detail-section"><h3 class="pmr-section-title"><span class="pmr-section-bar"></span>Galeri <span class="pmr-section-count">' + galRows.length + '</span></h3>' + galThumbs + '</div>' : '') +
        '<div class="pmr-detail-section"><h3 class="pmr-section-title"><span class="pmr-section-bar"></span>Filmografi <span class="pmr-section-count">' + bindings.length + '</span></h3>' + filmHtml + '</div>' +
      '</div>';

    /* Wire gallery thumbnails → reuse Sprint 1 lightbox */
    if (galRows.length && ANI.gallery && ANI.gallery.openFromAnime) {
      var strip = document.getElementById('pmr-gal-strip');
      if (strip) {
        strip.addEventListener('click', function(e){
          var btn = e.target.closest && e.target.closest('.pmr-gal-thumb');
          if (!btn) return;
          var idx = parseInt(btn.getAttribute('data-i'), 10);
          if (isNaN(idx)) idx = 0;
          var images = [];
          for (var i = 0; i < galRows.length; i++) {
            var g = galRows[i];
            var fullUrl  = g.url;
            var thumbUrl = g.thumb_url || g.url;
            if (g.source_type === 'tmdb' && fullUrl.indexOf('http') !== 0) {
              if (fullUrl.charAt(0) !== '/') fullUrl = '/' + fullUrl;
              thumbUrl = 'https://image.tmdb.org/t/p/w500' + fullUrl;
              fullUrl  = 'https://image.tmdb.org/t/p/original' + fullUrl;
            }
            images.push({ url: fullUrl, thumb: thumbUrl, caption: g.caption || '' });
          }
          ANI.gallery.open(images, idx, p.name || '');
        });
      }
    }

    /* Click avatar → open lightbox dengan avatar di index 0 */
    var avatarImg = document.getElementById('pmr-main-avatar');
    if (avatarImg && ANI.gallery && ANI.gallery.open) {
      avatarImg.style.cursor = 'zoom-in';
      avatarImg.addEventListener('click', function(){
        var images = [];
        if (av) {
          var fullAv = av;
          if (av.indexOf('image.tmdb.org') !== -1) {
            fullAv = av.replace(/\/t\/p\/[^\/]+\//, '/t/p/original/');
          }
          images.push({ url: fullAv, thumb: av, caption: 'Foto Profil' });
        }
        for (var i = 0; i < galRows.length; i++) {
          var g = galRows[i];
          var fullUrl  = g.url;
          var thumbUrl = g.thumb_url || g.url;
          if (g.source_type === 'tmdb' && fullUrl.indexOf('http') !== 0) {
            if (fullUrl.charAt(0) !== '/') fullUrl = '/' + fullUrl;
            thumbUrl = 'https://image.tmdb.org/t/p/w500' + fullUrl;
            fullUrl  = 'https://image.tmdb.org/t/p/original' + fullUrl;
          }
          images.push({ url: fullUrl, thumb: thumbUrl, caption: g.caption || '' });
        }
        if (images.length) ANI.gallery.open(images, 0, p.name || '');
      });
    }
  },

  /* Render cast section (dipanggil dari ANI.series.renderSeriesPage) */
  renderCastSection: function(castRows) {
    if (!castRows || !castRows.length) return;
    var self = this;

    var html =
      '<div class="series-cast-title">Pemeran <span class="pmr-beta">BETA</span></div>' +
      '<div class="series-cast-list">';
    for (var i = 0; i < castRows.length; i++) {
      var c = castRows[i];
      var av = self._avatarUrl({ active_photo_url: c.active_photo_url });
      var role = c.character_name || '';
      html +=
        '<a href="/pemeran/' + ANI.util.esc(c.pemeran_slug || '') + '" class="series-cast-item" title="' + ANI.util.esc(role || c.pemeran_name || '') + '">' +
          '<div class="series-cast-avatar">' +
            (av ? '<img src="' + ANI.util.esc(av) + '" alt="" loading="lazy" />' : '<div class="series-cast-noavatar">' + ANI.util.esc((c.pemeran_name||'?').charAt(0)) + '</div>') +
          '</div>' +
          '<div class="series-cast-name">' + ANI.util.esc(c.pemeran_name || '') + '</div>' +
          (role ? '<div class="series-cast-role">as ' + ANI.util.esc(role) + '</div>' : '') +
        '</a>';
    }
    html += '</div>';

    var wrapDesktop = document.getElementById('series-cast-wrap');
    var wrapMobile  = document.getElementById('series-cast-wrap-mobile');
    if (wrapDesktop) { wrapDesktop.innerHTML = html; wrapDesktop.style.display = ''; }
    if (wrapMobile)  { wrapMobile.innerHTML  = html; wrapMobile.style.display  = ''; }
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 07: Catalog
   
   PERUBAHAN dari v27:
   - _fetchAll(): satu API call ke Worker, bukan Blogger Feed pagination
   - prefetch(): sama — satu API call + fromDBSlim()
   - Semua filter/sort/render logic: TIDAK BERUBAH
   ═══════════════════════════════════════════════ */

ANI.catalog = {
  /* ── State ── */
  _page: 1,
  _perPage: 24,
  _total: 0,
  _facets: null,    /* { genres:{}, years:{}, studios:{} } */
  _facetsLoaded: false,
  _viewMode: 'grid',  /* 'grid' | 'list' */
  _lastSlims: [],     /* cache for view toggle without re-fetch */

  filters: {
    type: 'all',
    status: 'all',
    genreStates: {},  /* { action: 1, harem: 2 } — 1=include, 2=exclude */
    season: 'all',
    year: 'all',
    studio: 'all',
    sort: 'latest',
    nsfwFilter: 'hide'  /* 'hide' | 'show' | 'only' */
  },

  PAGE_SIZE: 24,  /* alias untuk compatibility */

  /* ══════════════════════════════════════════════
     PUBLIK: titik masuk
     ══════════════════════════════════════════════ */
  init: function(){
    var self = this;
    try{ document.title = 'Daftar Anime | Aneetaku'; }catch(e){}

    /* Reset transient state */
    self._total = 0; self._facets = null; self._facetsLoaded = false; self._lastSlims = [];

    /* Restore state from URL params */
    var urlState = self._loadFromURL();
    self._page = urlState.page;
    self._viewMode = urlState.viewMode;
    self.filters = urlState.filters;

    document.getElementById('app-content').innerHTML = self._buildLayout();
    self._bindUI();

    /* Restore sort label text from state */
    var sortLabels = { latest:'Terakhir Diperbarui', oldest:'Paling Lama', az:'A → Z', za:'Z → A', score:'Rating Tertinggi' };
    var lbl = document.getElementById('cf-sort-label');
    if(lbl && self.filters.sort !== 'latest') lbl.textContent = sortLabels[self.filters.sort] || self.filters.sort;
    var sortPanel = document.getElementById('cf-sort-panel');
    if(sortPanel){
      sortPanel.querySelectorAll('.sort-dropdown-item').forEach(function(it){
        it.classList.toggle('is-active', it.dataset.sort === self.filters.sort);
      });
    }

    /* Update filter button badges for any restored active filters */
    ['type','status','genre','season','year','studio','nsfw'].forEach(function(k){ self._updateBtn(k); });

    /* Load hero (async, independent) */
    self._loadHero();

    /* Load facets + first page in parallel */
    self._loadFacets();
    self._loadPage(self._page);
  },

  /* prefetch: no-op — tidak perlu lagi di server-side mode */
  prefetch: function(){},

  /* ══════════════════════════════════════════════
     URL STATE — serialize & restore filter/page/view
     ══════════════════════════════════════════════ */
  _loadFromURL: function(){
    var p;
    try { p = new URLSearchParams(window.location.search); } catch(e) { p = { get: function(){ return null; } }; }
    function _normVal(v){ return v ? v.toLowerCase().replace(/ /g,'_') : 'all'; }
    var state = {
      page: Math.max(parseInt(p.get('page')) || 1, 1),
      viewMode: p.get('view') === 'list' ? 'list' : 'grid',
      filters: {
        type: _normVal(p.get('type')),
        status: _normVal(p.get('status')),
        genreStates: {},
        season: _normVal(p.get('season')),
        year: p.get('year') || 'all',
        studio: p.get('studio') || 'all',
        sort: p.get('sort') || 'latest',
        nsfwFilter: p.get('nsfw_f') || 'hide'
      }
    };
    var gi = p.get('gi'); if(gi) gi.split(',').forEach(function(g){ var t=g.trim(); if(t) state.filters.genreStates[t] = 1; });
    var ge = p.get('ge'); if(ge) ge.split(',').forEach(function(g){ var t=g.trim(); if(t) state.filters.genreStates[t] = 2; });
    return state;
  },

  _saveToURL: function(){
    try {
      var f = this.filters;
      var p = new URLSearchParams();
      if(this._page > 1) p.set('page', this._page);
      if(f.sort !== 'latest') p.set('sort', f.sort);
      if(f.type !== 'all') p.set('type', f.type);
      if(f.status !== 'all') p.set('status', f.status);
      if(f.season !== 'all') p.set('season', f.season);
      if(f.year !== 'all') p.set('year', f.year);
      if(f.studio !== 'all') p.set('studio', f.studio);
      var inc = [], exc = [];
      Object.keys(f.genreStates).forEach(function(g){ if(f.genreStates[g]===1) inc.push(g); else if(f.genreStates[g]===2) exc.push(g); });
      if(inc.length) p.set('gi', inc.join(','));
      if(exc.length) p.set('ge', exc.join(','));
      if(this._viewMode === 'list') p.set('view', 'list');
      try { if(ANI.pref.getNsfw() && f.nsfwFilter !== 'hide') p.set('nsfw_f', f.nsfwFilter); } catch(e){}
      var qs = p.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    } catch(e){}
  },

  /* ══════════════════════════════════════════════
     LAYOUT
     ══════════════════════════════════════════════ */
  _buildLayout: function(){
    var self = this;
    var _bc = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([{ label:'Beranda', href:'/' }, { label:'Daftar Anime' }])
      : '';
    /* NSFW filter button \u2014 only if pref enabled */
    var nsfwFilterBtn = (function(){
      try { if(!ANI.pref.getNsfw()) return ''; } catch(e){ return ''; }
      return '<div class="filter-group" data-fgroup="nsfw">'+
        '<button class="filter-btn" data-fbkey="nsfw">'+
          'NSFW'+
          '<svg class="fb-arr" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>'+
        '</button>'+
      '</div>';
    })();
    /* View toggle: grid active by default unless list mode restored */
    var gridActive = self._viewMode !== 'list' ? ' is-active' : '';
    var listActive = self._viewMode === 'list' ? ' is-active' : '';
    /* Grid container class based on view mode */
    var gridClass = self._viewMode === 'list' ? 'anime-list' : 'anime-grid';
    return _bc +
      '<div id="cf-hero-wrap"><div class="catalog-hero-skel"></div></div>'+
      '<div class="catalog-page">'+
      '<div class="catalog-filters-wrap">'+
      '<div class="catalog-filters" id="cf-bar">'+
        this._mkFilterGroup('Tipe',   'type',   (function(){var t=['TV','Movie','OVA','ONA','Special']; try{ if(ANI.pref.getExperimental()) t=t.concat(['Donghua','3D Animation','Live Action']); }catch(e){} return t;})(), false)+
        this._mkFilterGroup('Status', 'status', ['Ongoing','Completed','Upcoming'],  false)+
        this._mkFilterGroup('Genre',  'genre',  [], true)+
        this._mkFilterGroup('Musim',  'season', ['Spring','Summer','Fall','Winter'],  false)+
        '<div class="filter-group" data-fgroup="year">'+
          '<button class="filter-btn" data-fbkey="year">'+
            'Tahun'+
            '<svg class="fb-arr" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>'+
          '</button>'+
        '</div>'+
        '<div class="filter-group" data-fgroup="studio">'+
          '<button class="filter-btn" data-fbkey="studio">'+
            'Studio'+
            '<svg class="fb-arr" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>'+
          '</button>'+
        '</div>'+
        nsfwFilterBtn+
        '<button class="filter-btn" id="cf-reset-all">'+
          '<svg class="fb-arr" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0"/><path d="M9 9l3-3 3 3"/><path d="M12 6v6"/></svg>'+
          'Reset'+
        '</button>'+
      '</div>'+
      '<div id="cf-panels-host"></div>'+
      '</div>'+
      /* Toolbar */
      '<div class="catalog-toolbar">'+
        '<div class="catalog-count" id="cf-count">Memuat...</div>'+
        '<div class="catalog-spacer"></div>'+
        '<div class="catalog-view-toggle" id="cf-view-toggle">'+
          '<button class="cvt-btn'+gridActive+'" data-view="grid" title="Tampilan Grid">'+
            '<svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>'+
          '</button>'+
          '<button class="cvt-btn'+listActive+'" data-view="list" title="Tampilan List">'+
            '<svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>'+
          '</button>'+
        '</div>'+
        '<div class="sort-dropdown" id="cf-sort-wrap">'+
          '<button class="sort-dropdown-btn" id="cf-sort-btn">'+
            '<span id="cf-sort-label">Terakhir Diperbarui</span>'+
            '<svg class="fb-arr" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>'+
          '</button>'+
          '<div class="sort-dropdown-panel" id="cf-sort-panel">'+
            '<div class="sort-dropdown-item is-active" data-sort="latest" data-label="Terakhir Diperbarui">Terakhir Diperbarui<span class="sort-check">&#10003;</span></div>'+
            '<div class="sort-dropdown-item" data-sort="oldest" data-label="Paling Lama">Paling Lama<span class="sort-check">&#10003;</span></div>'+
            '<div class="sort-dropdown-item" data-sort="az" data-label="A \u2192 Z">A \u2192 Z<span class="sort-check">&#10003;</span></div>'+
            '<div class="sort-dropdown-item" data-sort="za" data-label="Z \u2192 A">Z \u2192 A<span class="sort-check">&#10003;</span></div>'+
            '<div class="sort-dropdown-item" data-sort="score" data-label="Rating Tertinggi">Rating Tertinggi<span class="sort-check">&#10003;</span></div>'+
          '</div>'+
        '</div>'+
      '</div>'+
      /* Pills */
      '<div class="catalog-pills-row" id="cf-pills"></div>'+
      /* Grid / List */
      '<div id="cf-grid" class="'+gridClass+'">'+
        ANI.render.skeletonCards(24, 'card')+
      '</div>'+
      /* Pagination */
      '<div id="cf-pagination"></div>'+
    '</div>';
  },

  _loadHero: function(){
    var wrap = document.getElementById('cf-hero-wrap');
    if(!wrap) return;
    /* Daily-random: same banner throughout the day, changes at midnight */
    var seed = Math.floor(Date.now() / 86400000);
    ANI.api.all({ sort: 'score', limit: 80, _nsfw: '0' }).then(function(res){
      var data = res.data || [];
      if(!data.length){ wrap.style.display = 'none'; return; }
      /* Prefer items with a TMDB banner; fall back to full pool if <5 have one */
      var withBanner = data.filter(function(r){ return r.banner; });
      var pool = withBanner.length >= 5 ? withBanner : data;
      var row = pool[seed % pool.length];
      var banner = row.banner ? ANI.util.tmdbBanner(row.banner) : ANI.util.driveThumb(row.cover, 1280);
      if(!banner){ wrap.style.display = 'none'; return; }
      wrap.innerHTML =
        '<div class="catalog-hero">'+
          '<img class="catalog-hero__img" src="'+banner+'" alt="" loading="eager" onerror="this.parentElement.style.display=\'none\'"/>'+
          '<div class="catalog-hero__overlay"></div>'+
          '<h1 class="catalog-hero__title">DAFTAR ANIME</h1>'+
        '</div>';
    }).catch(function(){
      var w = document.getElementById('cf-hero-wrap');
      if(w) w.style.display = 'none';
    });
  },

  _mkFilterGroup: function(label, key, opts, multi){
    return '<div class="filter-group" data-fgroup="'+key+'">'+
      '<button class="filter-btn" data-fbkey="'+key+'">'+
        label+
        '<svg class="fb-arr" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>'+
      '</button>'+
    '</div>';
  },

  /* ══════════════════════════════════════════════
     FACETS — populate dynamic filter panels
     ══════════════════════════════════════════════ */
  _loadFacets: function(){
    var self = this;
    ANI.api.facets().then(function(res){
      self._facets = res;
      self._facetsLoaded = true;
      self._buildDynamicPanels();
    }).catch(function(){
      self._facetsLoaded = true;
    });
  },

  /* ══════════════════════════════════════════════
     SERVER-SIDE LOAD PAGE
     Menggantikan _fetchAll + _applyAndRender + _renderGrid
     ══════════════════════════════════════════════ */
  _buildApiParams: function(page){
    var self = this;
    var f = self.filters;
    var p = { page: page, per_page: self._perPage, sort: f.sort };

    if(f.type !== 'all')   p.type   = f.type.replace(/_/g, ' ');
    if(f.status !== 'all') p.status = f.status;
    if(f.season !== 'all') p.season = f.season;
    if(f.year !== 'all')   p.year   = f.year;
    if(f.studio !== 'all') p.studio = f.studio;

    /* Genre include/exclude */
    var inc = [], exc = [];
    var gs = f.genreStates;
    var gsKeys = Object.keys(gs);
    for(var i = 0; i < gsKeys.length; i++){
      if(gs[gsKeys[i]] === 1) inc.push(gsKeys[i]);
      else if(gs[gsKeys[i]] === 2) exc.push(gsKeys[i]);
    }
    if(inc.length) p.genre_inc = inc.join(',');
    if(exc.length) p.genre_exc = exc.join(',');
    /* Juga set genre param untuk backward compat (single genre tanpa exclude) */
    if(inc.length === 1 && !exc.length) p.genre = inc[0];

    /* NSFW filter — overrides auto-add in ANI.api.all() when user has NSFW pref */
    try {
      if(ANI.pref.getNsfw()){
        var nf = f.nsfwFilter || 'hide';
        if(nf === 'show') p._nsfw = '1';
        else if(nf === 'only') p._nsfw = 'only';
        else p._nsfw = '0';  /* 'hide': explicit hide, overrides auto-add */
      }
    } catch(e){}

    return p;
  },

  _loadPage: function(page){
    var self = this;
    self._page = page;

    /* Sync URL immediately */
    self._saveToURL();

    /* Update pills & badges (immediate, sebelum fetch) */
    self._updatePills();

    /* Skeleton di grid */
    var grid = document.getElementById('cf-grid');
    if(grid){
      grid.className = self._viewMode === 'list' ? 'anime-list' : 'anime-grid';
      grid.innerHTML = ANI.render.skeletonCards(self._perPage, 'card');
    }

    /* Hide pagination saat loading */
    var pgContainer = document.getElementById('cf-pagination');
    if(pgContainer) pgContainer.innerHTML = '';

    /* Scroll ke atas saat bukan halaman 1 */
    if(page > 1) ANI.pagination.scrollToTop('.catalog-toolbar');

    var apiParams = self._buildApiParams(page);

    ANI.api.all(apiParams).then(function(res){
      var data = res.data || [];
      self._total = res.total || data.length;
      var totalPages = Math.ceil(self._total / self._perPage);

      /* Update count */
      var countEl = document.getElementById('cf-count');
      if(countEl) countEl.innerHTML = '<strong>'+self._total+'</strong> Koleksi';

      /* Render grid/list */
      if(!data.length){
        self._lastSlims = [];
        if(grid) grid.innerHTML = '<div class="catalog-empty">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">'+
            '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>'+
            '<line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>'+
          '</svg>'+
          '<h3>Tidak ada anime</h3>'+
          '<p>Coba ubah atau hapus beberapa filter</p>'+
        '</div>';
      } else {
        var slims = data.map(function(row){ return ANI.parse.fromDBSlim(row); });
        self._lastSlims = slims;
        if(grid){
          grid.className = self._viewMode === 'list' ? 'anime-list' : 'anime-grid';
          grid.innerHTML = slims.map(function(item, i){
            return self._viewMode === 'list' ? ANI.render.catalogListItem(item, i) : ANI.render.catalogCard(item, i);
          }).join('');
        }
      }

      /* Render pagination */
      if(pgContainer){
        pgContainer.innerHTML = ANI.pagination.render(page, totalPages, 'cf-pg');
        ANI.pagination.bind('cf-pg', function(pg){ self._loadPage(pg); });
      }
    }).catch(function(){
      if(grid) grid.innerHTML = '<div class="catalog-empty">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">'+
          '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>'+
          '<line x1="12" y1="16" x2="12.01" y2="16"/>'+
        '</svg>'+
        '<h3>Gagal memuat</h3>'+
        '<p>Terjadi kesalahan. Coba refresh halaman.</p>'+
      '</div>';
    });
  },

  /* Wrapper: setiap perubahan filter → reset ke page 1 */
  _applyAndRender: function(){
    this._loadPage(1);
  },

  /* ══════════════════════════════════════════════
     PANELS — build dari facets (bukan dari _data)
     ══════════════════════════════════════════════ */
  _buildPanels: function(){
    var self = this;
    var host = document.getElementById('cf-panels-host');
    if(!host) return;
    var _typeOpts = ['TV','Movie','OVA','ONA','Special'];
    try { if (ANI.pref.getExperimental()) _typeOpts = _typeOpts.concat(['Donghua','3D Animation','Live Action']); } catch(e){}
    var defs = [
      {key:'type',   opts:_typeOpts, multi:false},
      {key:'status', opts:['Ongoing','Completed','Upcoming'],   multi:false},
      {key:'genre',  opts:[],  multi:true,  dynamic:true},
      {key:'season', opts:['Spring','Summer','Fall','Winter'],  multi:false},
      {key:'year',   opts:[],  multi:false, dynamic:true},
      {key:'studio', opts:[],  multi:false, dynamic:true}
    ];
    var html = defs.map(function(d){
      var items = d.opts.map(function(opt){
        var val = opt.toLowerCase().replace(/ /g,'_');
        var isActive = (d.key !== 'genre' && self.filters[d.key] === val) ? ' is-active' : '';
        return '<div class="filter-panel__item'+isActive+'" data-key="'+d.key+'" data-val="'+val+'">'+
          (d.multi ? '<span class="fp-check"></span>' : '')+opt+
        '</div>';
      }).join('');
      var reset = d.multi ? '<button class="filter-reset" data-frreset="'+d.key+'">Hapus pilihan</button>' : '';
      var placeholder = d.dynamic ? '<div style="padding:8px 12px;font-size:.75rem;color:var(--c-muted);font-family:var(--font-display)">Memuat...</div>' : '';
      return '<div class="filter-panel" data-panel="'+d.key+'" id="cf-panel-'+d.key+'">'+placeholder+items+reset+'</div>';
    }).join('');

    /* NSFW filter panel — only if pref enabled */
    var nsfwPanelHtml = '';
    try {
      if(ANI.pref.getNsfw()){
        var nsfwOpts = [
          {val:'hide', label:'Sembunyikan'},
          {val:'show', label:'Tampilkan'},
          {val:'only', label:'Hanya NSFW'}
        ];
        nsfwPanelHtml = '<div class="filter-panel" data-panel="nsfw" id="cf-panel-nsfw">'+
          nsfwOpts.map(function(o){
            var isActive = self.filters.nsfwFilter === o.val ? ' is-active' : '';
            return '<div class="filter-panel__item'+isActive+'" data-key="nsfw" data-val="'+o.val+'">'+o.label+'</div>';
          }).join('')+
        '</div>';
      }
    } catch(e){}

    host.innerHTML = html + nsfwPanelHtml;
  },

  _buildDynamicPanels: function(){
    if(!this._facets) return;
    this._buildYearPanel();
    this._buildGenrePanel();
    this._buildStudioPanel();
  },

  _buildGenrePanel: function(){
    var self = this;
    if(!self._facets) return;
    var HARDCODED = [
      'Action','Adventure','Comedy','Drama','Fantasy','Horror',
      'Isekai','Josei','Mecha','Mystery','Reincarnation','Romance',
      'School','Sci-Fi','Seinen','Shoujo','Shounen',
      'Slice of Life','Sports','Supernatural','Thriller'
    ];
    var dataGenres = self._facets.genres || {};
    var hardcodedKeys = HARDCODED.map(function(g){ return g.toLowerCase().replace(/ /g,'_'); });

    function makeItem(val, label){
      var state = self.filters.genreStates[val] || 0;
      var cls = state===1 ? ' is-include' : state===2 ? ' is-exclude' : '';
      var cnt = dataGenres[val] || 0;
      var badge = cnt > 0 ? '<span class="fp-count">'+cnt+'</span>' : '';
      return '<div class="filter-panel__item'+cls+'" data-key="genre" data-val="'+val+'" data-state="'+state+'">'+
        '<span class="fp-check"></span>'+label+badge+
      '</div>';
    }

    var mainHtml = HARDCODED.map(function(label){
      var val = label.toLowerCase().replace(/ /g,'_');
      return makeItem(val, label);
    }).join('');

    var extras = Object.keys(dataGenres).filter(function(g){
      return hardcodedKeys.indexOf(g) === -1;
    }).sort();

    var extraHtml = '';
    var moreBtn = '';
    if(extras.length > 0){
      extraHtml = '<div class="genre-extra-list" id="genre-extra-list">'+
        extras.map(function(g){
          var label = g.replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();});
          return makeItem(g, label);
        }).join('')+
      '</div>';
      moreBtn = '<button class="genre-more-btn" id="genre-more-btn">'+
        'Lebih banyak ('+extras.length+')'+
        '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>'+
      '</button>';
    }

    var resetBtn = '<button class="filter-reset" data-frreset="genre">Hapus pilihan</button>';
    var panel = document.getElementById('cf-panel-genre');
    if(!panel) return;
    panel.innerHTML = mainHtml + moreBtn + extraHtml + resetBtn;

    var mb = document.getElementById('genre-more-btn');
    var el = document.getElementById('genre-extra-list');
    if(mb && el){
      mb.addEventListener('click', function(e){
        e.stopPropagation();
        var open = el.classList.toggle('is-open');
        mb.classList.toggle('is-open', open);
        mb.childNodes[0].textContent = (open ? 'Lebih sedikit' : 'Lebih banyak ('+extras.length+')');
      });
    }
    self._attachPanelSearch('cf-panel-genre', 15);
  },

  _buildStudioPanel: function(){
    var self = this;
    if(!self._facets) return;
    var studioData = self._facets.studios || {};
    var sorted = Object.keys(studioData).sort(function(a,b){ return a.localeCompare(b); });
    var panel = document.getElementById('cf-panel-studio');
    if(!panel) return;
    if(!sorted.length){
      panel.innerHTML = '<div style="padding:8px 12px;font-size:.75rem;color:var(--c-muted);font-family:var(--font-display)">Belum ada data studio</div>';
      return;
    }
    panel.innerHTML = sorted.map(function(s){
      var isActive = self.filters.studio === s;
      var cnt = studioData[s] || 0;
      var badge = cnt > 0 ? '<span class="fp-count">'+cnt+'</span>' : '';
      return '<div class="filter-panel__item'+(isActive?' is-active':'')+'" data-key="studio" data-val="'+ANI.util.esc(s)+'">'+ANI.util.esc(s)+badge+'</div>';
    }).join('') + '<button class="filter-reset" data-frreset="studio">Hapus pilihan</button>';
    self._attachPanelSearch('cf-panel-studio', 15);
  },

  _buildYearPanel: function(){
    var self = this;
    if(!self._facets) return;
    var yearData = self._facets.years || {};
    var sorted = Object.keys(yearData).sort(function(a,b){ return parseInt(b)-parseInt(a); });
    var panel = document.getElementById('cf-panel-year');
    if(!panel || !sorted.length) return;
    panel.innerHTML = sorted.map(function(y){
      var isActive = self.filters.year === y;
      var cnt = yearData[y] || 0;
      var badge = cnt > 0 ? '<span class="fp-count">'+cnt+'</span>' : '';
      return '<div class="filter-panel__item'+(isActive?' is-active':'')+'" data-key="year" data-val="'+y+'">'+y+badge+'</div>';
    }).join('');
    self._attachPanelSearch('cf-panel-year', 15);
  },

  _genSeasonList: function(){
    return ['Spring','Summer','Fall','Winter'];
  },

  _attachPanelSearch: function(panelId, threshold){
    var panel = document.getElementById(panelId);
    if(!panel) return;
    var items = panel.querySelectorAll('.filter-panel__item');
    if(items.length <= threshold) return;
    var searchWrap = document.createElement('div');
    searchWrap.className = 'panel-search-wrap';
    searchWrap.innerHTML = '<input class="panel-search" type="text" placeholder="Cari..." autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" inputmode="search"/>';
    var noResult = document.createElement('div');
    noResult.className = 'panel-no-result';
    noResult.textContent = 'Tidak ditemukan';
    panel.insertBefore(noResult, panel.firstChild);
    panel.insertBefore(searchWrap, panel.firstChild);
    var input = searchWrap.querySelector('.panel-search');

    var moreBtn   = panel.querySelector('.genre-more-btn');
    var extraList = panel.querySelector('.genre-extra-list');
    var _moreWasOpen = false;

    input.addEventListener('input', function(e){
      e.stopPropagation();
      var q = this.value.toLowerCase().trim();

      if(q){
        if(moreBtn)   moreBtn.style.display   = 'none';
        if(extraList){ _moreWasOpen = extraList.classList.contains('is-open'); extraList.style.display = 'block'; }
      } else {
        if(moreBtn)   moreBtn.style.display   = '';
        if(extraList){ extraList.style.display = ''; if(!_moreWasOpen) extraList.classList.remove('is-open'); }
        items.forEach(function(it){ it.classList.remove('panel-item-hidden'); });
        noResult.classList.remove('is-visible');
        return;
      }

      var visible = 0;
      items.forEach(function(it){
        var match = it.textContent.toLowerCase().indexOf(q) !== -1;
        it.classList.toggle('panel-item-hidden', !match);
        if(match) visible++;
      });
      noResult.classList.toggle('is-visible', visible === 0);
    });

    ['click','mousedown','touchstart','touchend','touchmove'].forEach(function(ev){
      searchWrap.addEventListener(ev, function(e){ e.stopPropagation(); }, {passive:false});
    });
  },

  /* ══════════════════════════════════════════════
     UI BINDING — filter/sort/panel interactions
     (Hampir tidak berubah dari versi sebelumnya.
      Satu-satunya perbedaan: _applyAndRender()
      sekarang = _loadPage(1) → server-side fetch)
     ══════════════════════════════════════════════ */
  _bindUI: function(){
    var self = this;
    var bar = document.getElementById('cf-bar');
    if(!bar) return;

    self._buildPanels();

    function positionPanel(panel, btn){
      var r = btn.getBoundingClientRect();
      var ph = panel.offsetHeight || 260;
      var spaceBelow = window.innerHeight - r.bottom - 8;
      var top = spaceBelow >= ph ? r.bottom + 6 : r.top - ph - 6;
      var left = Math.min(r.left, window.innerWidth - panel.offsetWidth - 8);
      panel.style.top  = top  + 'px';
      panel.style.left = Math.max(8, left) + 'px';
    }

    function closeAll(){
      document.querySelectorAll('.filter-panel').forEach(function(p){ p.classList.remove('is-open'); });
      bar.querySelectorAll('.filter-btn[data-fbkey]').forEach(function(b){ b.classList.remove('is-open'); });
    }

    bar.addEventListener('click', function(e){
      var fbtn = e.target.closest('.filter-btn[data-fbkey]');
      if(fbtn){
        e.stopPropagation();
        var key = fbtn.dataset.fbkey;
        var panel = document.getElementById('cf-panel-'+key);
        if(!panel) return;
        var wasOpen = panel.classList.contains('is-open');
        closeAll();
        if(!wasOpen){
          panel.classList.add('is-open');
          fbtn.classList.add('is-open');
          positionPanel(panel, fbtn);
        }
        return;
      }
      if(e.target.closest('#cf-reset-all')){
        self._resetAllFilters();
        return;
      }
    });

    document.getElementById('cf-panels-host').addEventListener('click', function(e){
      var item = e.target.closest('.filter-panel__item');
      if(item){
        var fkey = item.dataset.key;
        var fval = item.dataset.val;
        if(fkey === 'genre'){
          var cur = parseInt(item.dataset.state || '0');
          var next = (cur + 1) % 3;
          item.dataset.state = next;
          item.classList.remove('is-include','is-exclude');
          if(next === 1) item.classList.add('is-include');
          else if(next === 2) item.classList.add('is-exclude');
          if(next === 0) delete self.filters.genreStates[fval];
          else self.filters.genreStates[fval] = next;
        } else if(fkey === 'nsfw'){
          /* NSFW filter: always set to clicked value (default 'hide', not 'all') */
          self.filters.nsfwFilter = fval;
          document.querySelectorAll('#cf-panel-nsfw .filter-panel__item').forEach(function(it){
            it.classList.toggle('is-active', it.dataset.val === fval);
          });
          closeAll();
        } else {
          var alreadyActive = self.filters[fkey] === fval;
          self.filters[fkey] = alreadyActive ? 'all' : fval;
          document.querySelectorAll('#cf-panel-'+fkey+' .filter-panel__item').forEach(function(it){
            it.classList.toggle('is-active', it.dataset.val === self.filters[fkey]);
          });
          if(!alreadyActive){ closeAll(); }
        }
        self._updateBtn(fkey);
        self._applyAndRender();
        return;
      }
      var freset = e.target.closest('.filter-reset[data-frreset]');
      if(freset){
        var rkey = freset.dataset.frreset;
        if(rkey === 'genre'){
          self.filters.genreStates = {};
          document.querySelectorAll('#cf-panel-genre .filter-panel__item').forEach(function(it){
            it.classList.remove('is-include','is-exclude');
            it.dataset.state = '0';
          });
        } else {
          self.filters[rkey] = 'all';
          document.querySelectorAll('#cf-panel-'+rkey+' .filter-panel__item').forEach(function(it){
            it.classList.remove('is-active');
          });
        }
        self._updateBtn(rkey);
        self._applyAndRender();
      }
    });

    function _outsideClose(e){
      var host = document.getElementById('cf-panels-host');
      if(!bar.contains(e.target) && !(host && host.contains(e.target))){
        closeAll();
      }
    }
    document.addEventListener('click', _outsideClose);
    document.addEventListener('touchend', function(e){
      setTimeout(function(){ _outsideClose(e); }, 0);
    }, {passive:true});

    window.addEventListener('scroll', function(){
      var openPanel = document.querySelector('.filter-panel.is-open');
      if(!openPanel) return;
      var key = openPanel.dataset.panel;
      var btn = bar.querySelector('.filter-btn[data-fbkey="'+key+'"]');
      if(btn) positionPanel(openPanel, btn);
    }, {passive:true});

    var _lastVpW = window.innerWidth;
    window.addEventListener('resize', function(){
      var w = window.innerWidth;
      if(w !== _lastVpW){ _lastVpW = w; closeAll(); }
    });

    /* Sort dropdown */
    var sortBtn   = document.getElementById('cf-sort-btn');
    var sortPanel = document.getElementById('cf-sort-panel');
    var sortWrap  = document.getElementById('cf-sort-wrap');
    if(sortBtn && sortPanel){
      sortBtn.addEventListener('click', function(e){
        e.stopPropagation();
        var open = sortPanel.classList.toggle('is-open');
        sortBtn.classList.toggle('is-open', open);
      });
      sortPanel.addEventListener('click', function(e){
        var item = e.target.closest('.sort-dropdown-item');
        if(!item) return;
        self.filters.sort = item.dataset.sort;
        sortPanel.querySelectorAll('.sort-dropdown-item').forEach(function(it){
          it.classList.toggle('is-active', it.dataset.sort === self.filters.sort);
        });
        var lbl = document.getElementById('cf-sort-label');
        if(lbl) lbl.textContent = item.dataset.label || item.dataset.sort;
        sortPanel.classList.remove('is-open');
        sortBtn.classList.remove('is-open');
        self._applyAndRender();
      });
    }
    document.addEventListener('click', function(e){
      if(sortWrap && !sortWrap.contains(e.target)){
        if(sortPanel) sortPanel.classList.remove('is-open');
        if(sortBtn)   sortBtn.classList.remove('is-open');
      }
    });

    /* View toggle */
    var viewToggle = document.getElementById('cf-view-toggle');
    if(viewToggle){
      viewToggle.addEventListener('click', function(e){
        var btn = e.target.closest('.cvt-btn');
        if(!btn) return;
        var newMode = btn.dataset.view;
        if(newMode === self._viewMode) return;
        self._viewMode = newMode;
        viewToggle.querySelectorAll('.cvt-btn').forEach(function(b){
          b.classList.toggle('is-active', b.dataset.view === self._viewMode);
        });
        var grid = document.getElementById('cf-grid');
        if(grid){
          grid.className = self._viewMode === 'list' ? 'anime-list' : 'anime-grid';
          var slims = self._lastSlims || [];
          if(slims.length){
            grid.innerHTML = slims.map(function(item, i){
              return self._viewMode === 'list' ? ANI.render.catalogListItem(item, i) : ANI.render.catalogCard(item, i);
            }).join('');
          }
        }
        self._saveToURL();
      });
    }
  },

  _resetAllFilters: function(){
    var self = this;
    self.filters = { type:'all', status:'all', genreStates:{}, season:'all', year:'all', studio:'all', sort:self.filters.sort, nsfwFilter:'hide' };
    document.querySelectorAll('.filter-panel__item').forEach(function(it){
      it.classList.remove('is-active','is-include','is-exclude');
      if(it.dataset.state) it.dataset.state = '0';
    });
    /* Re-mark 'hide' as active in nsfw panel */
    document.querySelectorAll('#cf-panel-nsfw .filter-panel__item').forEach(function(it){
      it.classList.toggle('is-active', it.dataset.val === 'hide');
    });
    ['type','status','genre','season','year','studio','nsfw'].forEach(function(k){ self._updateBtn(k); });
    self._applyAndRender();
  },

  _updateBtn: function(key){
    var bar = document.getElementById('cf-bar');
    if(!bar) return;
    var btn = bar.querySelector('.filter-btn[data-fbkey="'+key+'"]');
    if(!btn) return;
    var old = btn.querySelector('.fb-count');
    if(old) old.remove();
    var count = (key === 'genre') ? Object.keys(this.filters.genreStates).length :
                (key === 'nsfw') ? (this.filters.nsfwFilter !== 'hide' ? 1 : 0) :
                (this.filters[key] !== 'all' ? 1 : 0);
    if(count > 0){
      btn.classList.add('is-active');
      btn.insertAdjacentHTML('beforeend','<span class="fb-count">'+count+'</span>');
    } else {
      btn.classList.remove('is-active');
    }
  },

  _updatePills: function(){
    var self = this;
    var container = document.getElementById('cf-pills');
    if(!container) return;

    var pills = [];
    if(self.filters.type !== 'all') pills.push({k:'type',v:self.filters.type,label:self.filters.type.replace(/_/g,' ').toUpperCase(),color:''});
    if(self.filters.status !== 'all') pills.push({k:'status',v:self.filters.status,label:self.filters.status,color:''});
    Object.keys(self.filters.genreStates).forEach(function(g){
      var state = self.filters.genreStates[g];
      var label = g.replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();});
      var prefix = state===1 ? '+' : '\u2212';
      var color  = state===1 ? '' : 'exclude';
      pills.push({k:'genre',v:g,label:prefix+label,color:color});
    });
    if(self.filters.season !== 'all') pills.push({k:'season',v:self.filters.season,label:self.filters.season,color:''});
    if(self.filters.year   !== 'all') pills.push({k:'year',  v:self.filters.year,  label:self.filters.year,  color:''});
    if(self.filters.studio !== 'all') pills.push({k:'studio',v:self.filters.studio,label:self.filters.studio,color:''});
    try {
      if(ANI.pref.getNsfw() && self.filters.nsfwFilter !== 'hide'){
        var nsfwLabel = self.filters.nsfwFilter === 'show' ? 'NSFW: Tampilkan' : 'NSFW: Hanya NSFW';
        pills.push({k:'nsfw',v:self.filters.nsfwFilter,label:nsfwLabel,color:''});
      }
    } catch(e){}

    container.innerHTML = pills.map(function(p){
      return '<span class="active-pill'+(p.color==='exclude'?' is-exclude':'')+'">'+(p.label)+
        '<button data-pk="'+p.k+'" data-pv="'+p.v+'" title="Hapus filter">&#10005;</button>'+
      '</span>';
    }).join('');

    container.querySelectorAll('.active-pill button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var k = this.dataset.pk, v = this.dataset.pv;
        if(k === 'genre'){
          delete self.filters.genreStates[v];
          document.querySelectorAll('#cf-panel-genre .filter-panel__item[data-val="'+v+'"]').forEach(function(it){
            it.classList.remove('is-include','is-exclude');
            it.dataset.state = '0';
          });
        } else if(k === 'nsfw'){
          self.filters.nsfwFilter = 'hide';
          document.querySelectorAll('#cf-panel-nsfw .filter-panel__item').forEach(function(it){
            it.classList.toggle('is-active', it.dataset.val === 'hide');
          });
        } else {
          self.filters[k] = 'all';
          document.querySelectorAll('#cf-panel-'+k+' .filter-panel__item').forEach(function(it){ it.classList.remove('is-active'); });
        }
        self._updateBtn(k);
        self._applyAndRender();
      });
    });
  }
};
/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 08: Static Pages
   
   PERUBAHAN dari v27:
   - Hapus pageType check (routing di init() global)
   - Hapus Blogger Feed fallback (tidak ada /feeds/pages di CF)
   - Admin routing dipindah ke init() global
   - Halaman hardcoded (tentang, faq, dmca, privasi): TIDAK BERUBAH
   ═══════════════════════════════════════════════ */

ANI.staticPage = {
  init: function(){
    var path = window.location.pathname;
    var slug = path.replace('/p/','').replace(/\/$/,'');

    /* Halaman khusus — render langsung tanpa API */
    if(slug === 'tentang-kami' || slug === 'tentang') { this._tentang(); return; }
    if(slug === 'faq')                                { this._faq();    return; }
    if(slug === 'dmca')                               { this._dmca();   return; }
    if(slug === 'kebijakan-privasi' || slug === 'privasi') { this._privasi(); return; }

    /* Halaman statis tidak dikenal — tampilkan pesan */
    var appContent = document.getElementById('app-content');
    if(appContent){
      appContent.innerHTML = '<div class="static-page-wrap"><h1>' + ANI.util.esc(slug) + '</h1><p style="color:var(--c-muted)">Halaman ini belum tersedia.</p></div>';
    }
  },

  _set: function(html, pageTitle){
    if(pageTitle){ try{ document.title = pageTitle + ' | Aneetaku'; }catch(e){} }
    document.getElementById('app-content').innerHTML = '<div class="static-page-wrap">'+html+'</div>';
  },

  _render: function(title, html){
    this._set('<h1>'+ANI.util.esc(title)+'</h1><div class="post-body">'+html+'</div>');
  },

  /* ── TENTANG KAMI ── */
  _tentang: function(){
    this._set(
      '<div class="sp-hero">'+
        '<div class="sp-hero__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div>'+
        '<h1>Tentang Kami</h1>'+
        '<p>Platform streaming anime subtitle Indonesia yang hadir untuk komunitas pecinta anime Tanah Air.</p>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>Siapa Kami</div>'+
        '<div class="sp-prose">'+
          '<p><strong>Aneetaku</strong> adalah platform streaming anime berbahasa Indonesia yang dibangun dari kecintaan terhadap anime. Kami menghadirkan koleksi anime lengkap dengan subtitle Indonesia berkualitas, agar kamu bisa menikmati cerita favorit tanpa hambatan bahasa.</p>'+
          '<p>Kami bukan layanan komersial resmi. Aneetaku adalah proyek komunitas yang bertujuan memudahkan akses anime bagi penonton Indonesia, khususnya mereka yang belum bisa menikmati konten berbahasa Jepang atau Inggris secara langsung.</p>'+
        '</div>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>Yang Kami Tawarkan</div>'+
        '<div class="sp-cards">'+
          '<div class="sp-card"><div class="sp-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg></div><div class="sp-card__title">Streaming Gratis</div><div class="sp-card__desc">Tonton anime kapan saja tanpa biaya langganan.</div></div>'+
          '<div class="sp-card"><div class="sp-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div><div class="sp-card__title">Sub Indonesia</div><div class="sp-card__desc">Subtitle Indonesia yang akurat dan mudah dibaca.</div></div>'+
          '<div class="sp-card"><div class="sp-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div><div class="sp-card__title">Multi Kualitas</div><div class="sp-card__desc">Pilihan 480p, 720p, hingga 1080p sesuai koneksi.</div></div>'+
          '<div class="sp-card"><div class="sp-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg></div><div class="sp-card__title">Mobile Friendly</div><div class="sp-card__desc">Tampilan responsif, nyaman di HP maupun PC.</div></div>'+
        '</div>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>Hubungi Kami</div>'+
        '<div class="sp-prose"><p>Ada pertanyaan, laporan konten, atau ingin berkolaborasi? Jangan ragu menghubungi kami melalui email di bawah ini.</p></div>'+
        '<div class="sp-contact"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg><div><div class="sp-contact__label">Email</div><div class="sp-contact__val"><a href="mailto:admin@aneetaku.com" style="color:var(--c-accent)">admin@aneetaku.com</a></div></div></div>'+
      '</div>'+
      '<p class="sp-meta">Dibuat dengan &hearts; untuk komunitas anime Indonesia.</p>',
      'Tentang Kami'
    );
  },

  /* ── FAQ ── */
  _faq: function(){
    var faqs = [
      { q:'Apakah Aneetaku gratis?',
        a:'Ya, sepenuhnya gratis. Tidak ada biaya langganan atau fitur premium berbayar.' },
      { q:'Bagaimana cara menonton anime di Aneetaku?',
        a:'Cukup kunjungi halaman series anime yang ingin kamu tonton, lalu klik tombol <strong>Tonton Anime</strong> atau pilih episode dari daftar episode. Player akan langsung terbuka.' },
      { q:'Kualitas video apa saja yang tersedia?',
        a:'Kami menyediakan tiga pilihan kualitas: <strong>480p</strong> (hemat kuota), <strong>720p</strong> (standar), dan <strong>1080p FHD</strong>. Pilihan tersimpan otomatis untuk sesi berikutnya.' },
      { q:'Apakah ada fitur lanjutkan tonton?',
        a:'Ada. Posisi tontonan tersimpan otomatis. Saat kamu kembali ke episode yang sama, player akan melanjutkan dari posisi terakhir.' },
      { q:'Kenapa video tidak bisa diputar?',
        a:'Beberapa kemungkinan penyebab: koneksi internet lambat, browser tidak mendukung HLS, atau server sedang dalam pemeliharaan. Coba refresh halaman, ganti server di pilihan server, atau gunakan browser Chrome/Firefox versi terbaru.' },
      { q:'Bisakah saya mengunduh video?',
        a:'Fitur unduhan sedang dalam pengembangan. Saat ini hanya tersedia streaming langsung.' },
      { q:'Bagaimana cara melaporkan konten atau bug?',
        a:'Kamu bisa mengirim laporan melalui email ke <a href="mailto:admin@aneetaku.com" style="color:var(--c-accent)">admin@aneetaku.com</a> dengan menyertakan judul anime, nomor episode, dan deskripsi masalah.' },
      { q:'Apakah Aneetaku tersedia sebagai aplikasi mobile?',
        a:'Belum tersedia sebagai aplikasi native. Namun situs ini dioptimalkan untuk mobile — kamu bisa menambahkan ke Home Screen browser untuk pengalaman seperti aplikasi.' },
    ];
    var faqHtml = faqs.map(function(f,i){
      return '<div class="sp-faq-item" data-faq="'+i+'">'+
        '<div class="sp-faq-q">'+f.q+'<svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg></div>'+
        '<div class="sp-faq-a"><p>'+f.a+'</p></div>'+
      '</div>';
    }).join('');

    this._set(
      '<div class="sp-hero">'+
        '<div class="sp-hero__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></div>'+
        '<h1>FAQ</h1>'+
        '<p>Pertanyaan yang sering ditanyakan. Jika tidak menemukan jawaban, hubungi kami langsung.</p>'+
      '</div>'+
      '<div class="sp-faq">'+faqHtml+'</div>'+
      '<div class="sp-contact" style="margin-top:var(--s8)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg><div><div class="sp-contact__label">Masih ada pertanyaan?</div><div class="sp-contact__val"><a href="mailto:admin@aneetaku.com" style="color:var(--c-accent)">admin@aneetaku.com</a></div></div></div>',
      'FAQ'
    );

    /* FAQ accordion */
    document.querySelectorAll('.sp-faq-item').forEach(function(item){
      item.querySelector('.sp-faq-q').addEventListener('click', function(){
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.sp-faq-item').forEach(function(x){ x.classList.remove('is-open'); });
        if(!isOpen) item.classList.add('is-open');
      });
    });
  },

  /* ── DMCA ── */
  _dmca: function(){
    this._set(
      '<div class="sp-hero">'+
        '<div class="sp-hero__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>'+
        '<h1>DMCA &amp; Hak Cipta</h1>'+
        '<p>Kami menghormati hak kekayaan intelektual. Laporan pelanggaran ditangani serius dan segera.</p>'+
      '</div>'+

      '<div class="sp-notice">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'+
        '<p><strong>Perhatian:</strong> Aneetaku adalah platform komunitas. Seluruh konten yang ditayangkan dikelola dengan itikad baik. Jika kamu adalah pemegang hak cipta yang sah dan merasa kontenmu ditampilkan tanpa izin, kami akan segera menindaklanjuti laporan kamu.</p>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>Prosedur Pelaporan</div>'+
        '<div class="sp-prose">'+
          '<p>Untuk mengajukan laporan DMCA yang valid, kirimkan informasi berikut ke email kami:</p>'+
          '<ul>'+
            '<li>Nama lengkap dan informasi kontak kamu sebagai pelapor</li>'+
            '<li>Identifikasi karya berhak cipta yang diklaim dilanggar (judul, pemilik, bukti kepemilikan)</li>'+
            '<li>URL spesifik konten yang dimaksud di situs Aneetaku</li>'+
            '<li>Pernyataan bahwa kamu dengan itikad baik percaya penggunaan tersebut tidak diizinkan</li>'+
            '<li>Pernyataan bahwa informasi yang diberikan akurat, di bawah ancaman hukuman sumpah palsu</li>'+
            '<li>Tanda tangan elektronik atau fisik pemegang hak cipta atau agennya</li>'+
          '</ul>'+
        '</div>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>Waktu Penanganan</div>'+
        '<div class="sp-prose"><p>Kami berkomitmen merespons laporan DMCA yang valid dalam <strong>3&times;24 jam kerja</strong>. Konten yang terbukti melanggar akan segera diturunkan setelah verifikasi.</p></div>'+
      '</div>'+

      '<div class="sp-contact">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>'+
        '<div><div class="sp-contact__label">Kirim laporan DMCA ke</div><div class="sp-contact__val"><a href="mailto:dmca@aneetaku.com" style="color:var(--c-accent)">dmca@aneetaku.com</a></div></div>'+
      '</div>'+
      '<p class="sp-meta">Terakhir diperbarui: Maret 2026</p>',
      'DMCA'
    );
  },

  /* ── KEBIJAKAN PRIVASI ── */
  _privasi: function(){
    this._set(
      '<div class="sp-hero">'+
        '<div class="sp-hero__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>'+
        '<h1>Kebijakan Privasi</h1>'+
        '<p>Kami menjaga privasi penggunamu. Halaman ini menjelaskan data apa yang kami kumpulkan dan bagaimana penggunaannya.</p>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>Data yang Dikumpulkan</div>'+
        '<div class="sp-prose">'+
          '<p>Aneetaku <strong>tidak mengumpulkan data pribadi</strong> secara langsung. Situs ini berjalan di atas Cloudflare Pages dan menggunakan layanan pihak ketiga berikut:</p>'+
          '<ul>'+
            '<li><strong>Cloudflare</strong> — menyediakan hosting dan CDN. Data analitik dasar dikumpulkan sesuai <a href="https://www.cloudflare.com/privacypolicy/" target="_blank">Kebijakan Privasi Cloudflare</a>.</li>'+
            '<li><strong>Penyimpanan lokal browser</strong> — kami menyimpan preferensi tontonan (posisi video, kualitas pilihan, riwayat tonton) <em>di perangkatmu sendiri</em>. Data ini tidak dikirim ke server kami.</li>'+
          '</ul>'+
        '</div>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>Penggunaan Data</div>'+
        '<div class="sp-prose">'+
          '<p>Data yang ada hanya digunakan untuk:</p>'+
          '<ul>'+
            '<li>Menyimpan preferensi pengguna (kualitas video, posisi tonton) secara lokal di perangkatmu</li>'+
            '<li>Analitik pengunjung anonim melalui Cloudflare Analytics untuk memahami konten yang diminati</li>'+
          '</ul>'+
          '<p>Kami <strong>tidak menjual, menyewakan, atau membagikan</strong> data apapun kepada pihak ketiga untuk kepentingan komersial.</p>'+
        '</div>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>Cookie</div>'+
        '<div class="sp-prose">'+
          '<p>Situs ini menggunakan cookie minimal untuk autentikasi video streaming (CDN). Tidak ada cookie pelacakan atau iklan. Kamu bisa menonaktifkan cookie melalui pengaturan browser, namun beberapa fitur situs mungkin tidak berfungsi optimal.</p>'+
        '</div>'+
      '</div>'+

      '<div class="sp-section">'+
        '<div class="sp-section__title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>Perubahan Kebijakan</div>'+
        '<div class="sp-prose">'+
          '<p>Kebijakan ini dapat berubah sewaktu-waktu. Perubahan signifikan akan diinformasikan melalui pengumuman di situs. Dengan terus menggunakan Aneetaku setelah perubahan berlaku, kamu dianggap menyetujui kebijakan yang diperbarui.</p>'+
        '</div>'+
      '</div>'+

      '<div class="sp-contact">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>'+
        '<div><div class="sp-contact__label">Pertanyaan tentang privasi</div><div class="sp-contact__val"><a href="mailto:admin@aneetaku.com" style="color:var(--c-accent)">admin@aneetaku.com</a></div></div>'+
      '</div>'+
      '<p class="sp-meta">Terakhir diperbarui: Maret 2026</p>',
      'Kebijakan Privasi'
    );
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 09: Admin Panel v6 (D1 Integration + Multi-Season)
   ═══════════════════════════════════════════════ */


/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 11: User API + Preference Sync + Watchlist + History
   
   Patch 3: Tambah watchlist & history methods
   REPLACE TOTAL module 11 yang ada di app.js
   ═══════════════════════════════════════════════ */

ANI.userApi = {
  _BASE: 'https://user.aneetaku.cloud',

  _fetch: function(method, path, body) {
    var opts = { method: method, headers: { 'Content-Type': 'application/json' } };
    var token = ANI.user.token;
    if (token) opts.headers['Authorization'] = 'Bearer ' + token;
    if (body) opts.body = JSON.stringify(body);
    return fetch(this._BASE + path, opts).then(function(r) {
      return r.json().then(function(d) {
        if (!r.ok) throw new Error(d.error || 'Error ' + r.status);
        return d;
      });
    });
  },

  /* ── Auth ── */
  authGoogle: function(credential) { return this._fetch('POST', '/auth/google', { credential: credential }); },
  logout: function() { return this._fetch('POST', '/auth/logout'); },
  me: function() { return this._fetch('GET', '/auth/me'); },

  /* ── Profile ── */
  updateProfile: function(data) { return this._fetch('PUT', '/user/profile', data); },
  updatePreferences: function(data) { return this._fetch('PUT', '/user/preferences', data); },
  updatePrivacy: function(data) { return this._fetch('PUT', '/user/privacy', data); },
  exportData: function() {
    var token = ANI.user.token;
    return fetch(this._BASE + '/user/export', {
      method: 'GET',
      headers: token ? { 'Authorization': 'Bearer ' + token } : {}
    }).then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.error || 'Error ' + r.status); });
      return r.blob().then(function(blob) {
        var disp = r.headers.get('Content-Disposition') || '';
        var m = disp.match(/filename="([^"]+)"/);
        return { blob: blob, filename: m ? m[1] : 'aneetaku-export.json' };
      });
    });
  },
  deleteAccount: function(confirm) { return this._fetch('DELETE', '/user/account', { confirm: confirm }); },

  /* ── Watchlist (Patch 3) ── */
  getWatchlist: function(status, page, limit) {
    var qs = '?page=' + (page || 1) + '&limit=' + (limit || 20);
    if (status) qs += '&status=' + encodeURIComponent(status);
    return this._fetch('GET', '/watchlist' + qs);
  },
  addWatchlist: function(slug, status) {
    return this._fetch('POST', '/watchlist', { anime_slug: slug, status: status || 'plan_to_watch' });
  },
  updateWatchlistStatus: function(slug, status) {
    return this._fetch('PUT', '/watchlist/' + encodeURIComponent(slug), { status: status });
  },
  removeWatchlist: function(slug) {
    return this._fetch('DELETE', '/watchlist/' + encodeURIComponent(slug));
  },

  /* ── Watch History (Patch 3) ── */
  getHistory: function(page, limit) {
    return this._fetch('GET', '/history?page=' + (page || 1) + '&limit=' + (limit || 30));
  },
  getHistoryBySlug: function(slug) {
    return this._fetch('GET', '/history/' + encodeURIComponent(slug));
  },
  postHistory: function(slug, epNum, position, duration) {
    return this._fetch('POST', '/history', {
      anime_slug: slug, episode_num: epNum, position: position, duration: duration
    });
  },
  syncHistory: function(since) {
    return this._fetch('GET', '/history/sync?since=' + encodeURIComponent(since || '2000-01-01T00:00:00Z'));
  },

  /* ── Reports (Patch 4c) ── */
  getReports: function(status, page, limit) {
    var qs = '?page=' + (page || 1) + '&limit=' + (limit || 20);
    if (status) qs += '&status=' + encodeURIComponent(status);
    return this._fetch('GET', '/reports' + qs);
  },
  createReport: function(data) {
    return this._fetch('POST', '/reports', data);
  },
  updateReportStatus: function(id, status) {
    return this._fetch('PUT', '/reports/' + encodeURIComponent(id) + '/status', { status: status });
  },

  /* ── Requests (Patch 4c) ── */
  getRequests: function(sort, page, limit, status) {
    var qs = '?page=' + (page || 1) + '&limit=' + (limit || 20);
    if (sort) qs += '&sort=' + encodeURIComponent(sort);
    if (status) qs += '&status=' + encodeURIComponent(status);
    return this._fetch('GET', '/requests' + qs);
  },
  createRequest: function(data) {
    return this._fetch('POST', '/requests', data);
  },
  toggleVote: function(requestId) {
    return this._fetch('POST', '/requests/' + encodeURIComponent(requestId) + '/vote');
  },

  /* ── AniList search (Patch 4c) ── */
  searchAniList: function(query) {
    var gql = JSON.stringify({
      query: 'query($q:String){Page(page:1,perPage:8){media(search:$q,type:ANIME,sort:SEARCH_MATCH){id title{romaji native}coverImage{large}format seasonYear episodes genres status}}}',
      variables: { q: query }
    });
    return fetch('https://graphql.anilist.co', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: gql
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.data && d.data.Page && d.data.Page.media) return d.data.Page.media;
      return [];
    });
  }
};

/* ═══════════════════════════════════════════════
   ANI.pref — Preference sync bridge (unchanged from Patch 2)
   ═══════════════════════════════════════════════ */

ANI.pref = {
  getServer: function() {
    try { return localStorage.getItem('aneetaku_srv') || ''; } catch(e) { return ''; }
  },
  setServer: function(name) {
    try { localStorage.setItem('aneetaku_srv', name || ''); } catch(e) {}
    this._pushToServer({ server: (name || '').toLowerCase() });
  },
  getQuality: function() {
    try {
      var res = localStorage.getItem('aneetaku_res');
      if (!res) return 'auto';
      var h = parseInt(res, 10);
      if (h <= 480) return 'hemat';
      return 'tertinggi';
    } catch(e) { return 'auto'; }
  },
  setQuality: function(mode) {
    try {
      if (mode === 'auto') { localStorage.removeItem('aneetaku_res'); localStorage.removeItem('aneetaku_turbo'); }
      else if (mode === 'hemat') { localStorage.setItem('aneetaku_res', '480'); localStorage.removeItem('aneetaku_turbo'); }
      else if (mode === 'tertinggi') { localStorage.setItem('aneetaku_res', '9999'); localStorage.removeItem('aneetaku_turbo'); }
    } catch(e) {}
    this._pushToServer({ quality: mode });
  },
  getNsfw: function() {
    if (ANI.user.isLoggedIn() && ANI.user.data && ANI.user.data.preferences) {
      return ANI.user.data.preferences.nsfw === true;
    }
    return false;
  },
  setNsfw: function(on) {
    if (ANI.user.isLoggedIn() && ANI.user.data) {
      if (!ANI.user.data.preferences) ANI.user.data.preferences = {};
      ANI.user.data.preferences.nsfw = on;
      try { localStorage.setItem('aneetaku_user', JSON.stringify(ANI.user.data)); } catch(e) {}
    }
    this._pushToServer({ nsfw: on });
  },
  /* Experimental mode (admin-only switch — unlock 3 type tambahan: Donghua, 3D Animation, Live Action) */
  getExperimental: function() {
    try { return localStorage.getItem('aneetaku_experimental') === '1'; } catch(e) { return false; }
  },
  setExperimental: function(on) {
    try {
      if (on) localStorage.setItem('aneetaku_experimental', '1');
      else localStorage.removeItem('aneetaku_experimental');
    } catch(e) {}
  },
  syncFromServer: function(prefs) {
    if (!prefs) return;
    try {
      if (prefs.server) localStorage.setItem('aneetaku_srv', prefs.server.toLowerCase());
      if (prefs.quality === 'hemat') localStorage.setItem('aneetaku_res', '480');
      else if (prefs.quality === 'tertinggi') localStorage.setItem('aneetaku_res', '9999');
      else if (prefs.quality === 'auto') { localStorage.removeItem('aneetaku_res'); localStorage.removeItem('aneetaku_turbo'); }
    } catch(e) {}
  },
  _pushToServer: function(data) {
    if (!ANI.user.isLoggedIn()) return;
    try { ANI.userApi.updatePreferences(data); } catch(e) {}
  }
};

/* ═══════════════════════════════════════════════
   ANI.historySync — Watch history sync helper (Patch 3)
   
   localStorage tetap primary. Server sync = overlay.
   ═══════════════════════════════════════════════ */

ANI.historySync = {
  _syncTimer: null,
  _queue: [],  /* { slug, ep, pos, dur } */

  /**
   * Dipanggil dari player timeupdate (setiap 5 detik).
   * Tambah ke queue, flush setiap 30 detik.
   */
  track: function(slug, epNum, position, duration) {
    if (!ANI.user.isLoggedIn()) return;
    /* Update queue — replace existing entry untuk slug+ep yang sama */
    var found = false;
    for (var i = 0; i < this._queue.length; i++) {
      if (this._queue[i].slug === slug && this._queue[i].ep === epNum) {
        this._queue[i].pos = position;
        this._queue[i].dur = duration;
        found = true;
        break;
      }
    }
    if (!found) this._queue.push({ slug: slug, ep: epNum, pos: position, dur: duration });

    /* Start flush timer jika belum */
    if (!this._syncTimer) {
      var self = this;
      self._syncTimer = setTimeout(function() {
        self.flush();
        self._syncTimer = null;
      }, 30000); /* flush setiap 30 detik */
    }
  },

  /** Flush queue ke server (fire-and-forget) */
  flush: function() {
    if (!ANI.user.isLoggedIn() || this._queue.length === 0) return;
    var items = this._queue.slice(); /* copy */
    this._queue = [];
    for (var i = 0; i < items.length; i++) {
      try {
        ANI.userApi.postHistory(items[i].slug, items[i].ep, items[i].pos, items[i].dur);
      } catch(e) {}
    }
  },

  /** Immediate send (saat video end atau page unload) */
  flushNow: function(slug, epNum, position, duration) {
    if (!ANI.user.isLoggedIn()) return;
    try { ANI.userApi.postHistory(slug, epNum, position, duration); } catch(e) {}
  },

  /** Get bookmark status for a slug (returns Promise) */
  getBookmark: function(slug) {
    if (!ANI.user.isLoggedIn()) return Promise.resolve(null);
    return ANI.userApi.getWatchlist('', 1, 200).then(function(res) {
      var list = res.data || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].anime_slug === slug) return list[i].status;
      }
      return null;
    }).catch(function() { return null; });
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 12: Auth UI (login modal, user dropdown, state)
   
   Patch 1: Google OAuth, login modal, user dropdown
   ═══════════════════════════════════════════════ */

/* ── Auth Helpers (cache invalidation, route refresh, visual feedback) ── */
ANI._authHelpers = {
  invalidateNsfwCaches: function() {
    try { sessionStorage.removeItem('aneetaku_searchidx'); } catch(e){}
    try { sessionStorage.removeItem('aneetaku_searchidxn'); } catch(e){}
    try {
      if (ANI.searchIndex) {
        ANI.searchIndex._data = null;
        ANI.searchIndex._ready = false;
        ANI.searchIndex._loading = false;
      }
    } catch(e){}
    try { if (ANI.catalog && ANI.catalog._cache) ANI.catalog._cache = {}; } catch(e){}
    try { if (ANI.searchLabel && ANI.searchLabel._cache) ANI.searchLabel._cache = {}; } catch(e){}
    try { if (ANI.searchResult && ANI.searchResult._cache) ANI.searchResult._cache = {}; } catch(e){}
  },

  refreshCurrentRoute: function() {
    try {
      var path = window.location.pathname;
      var params = new URLSearchParams(window.location.search);

      /* Halaman dengan state stateful — JANGAN re-init.
         Cukup re-evaluate gating NSFW di halaman /anime/:slug. */
      if (path.indexOf('/anime/') === 0) {
        try {
          var data = ANI.series && ANI.series.data && ANI.series.data.ani && ANI.series.data.ani.series;
          if (data && data.is_nsfw && !ANI.pref.getNsfw()) {
            window.location.href = '/';
          }
        } catch(e){}
        return;
      }
      if (path === '/komunitas' || path === '/p/komunitas') {
        try { ANI.komunitas.destroy(); } catch(e){}
        try { ANI.komunitas.init(ANI.komunitas._room || 'chat'); } catch(e){ console.warn('[refreshRoute] komunitas', e); }
        return;
      }
      if (path.indexOf('/admin') === 0) return;
      if (path.indexOf('/user') === 0) return;
      if (path === '/tentang' || path === '/p/tentang') return;
      if (path === '/faq' || path === '/p/faq') return;
      if (path === '/dmca' || path === '/p/dmca') return;
      if (path === '/kebijakan-privasi' || path === '/p/kebijakan-privasi') return;

      /* Re-init halaman list-style (home, daftar, genre, status, search, jadwal) */
      if (path === '/' || path === '' || path === '/index.html') {
        try { ANI.home.init(); } catch(e){ console.warn('[refreshRoute] home', e); }
        return;
      }
      if (path === '/daftar-anime') {
        try { ANI.catalog.init(); } catch(e){ console.warn('[refreshRoute] catalog', e); }
        return;
      }
      if (path.indexOf('/genre/') === 0) {
        var genre = decodeURIComponent(path.replace('/genre/', ''));
        try { ANI.searchLabel.init('g:' + genre); } catch(e){ console.warn('[refreshRoute] genre', e); }
        return;
      }
      if (path.indexOf('/status/') === 0) {
        var status = decodeURIComponent(path.replace('/status/', ''));
        try { ANI.searchLabel.init('status:' + status); } catch(e){ console.warn('[refreshRoute] status', e); }
        return;
      }
      if (path.indexOf('/search/label/') === 0) {
        var label = decodeURIComponent(path.replace('/search/label/', ''));
        try { ANI.searchLabel.init(label); } catch(e){ console.warn('[refreshRoute] label', e); }
        return;
      }
      if (path === '/search') {
        var q = params.get('q') || '';
        if (q) { try { ANI.searchResult.init(q); } catch(e){ console.warn('[refreshRoute] search', e); } }
        return;
      }
      if (path === '/jadwal' || path === '/p/jadwal') {
        try { ANI.jadwal.init(); } catch(e){ console.warn('[refreshRoute] jadwal', e); }
        return;
      }
    } catch (e) {
      console.error('[Aneetaku] refreshCurrentRoute error:', e);
    }
  },

  showWelcomeStrip: function(username, isNew) {
    try {
      var existing = document.getElementById('ani-welcome');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      var card = document.createElement('div');
      card.id = 'ani-welcome';
      card.className = 'ani-welcome';

      var greet = isNew ? 'Selamat datang' : 'Halo,';
      var raw = (username || 'Aneetaku').toString();
      var esc = function(str) {
        return str.replace(/[<>"&]/g, function(c){
          return ({ '<':'&lt;', '>':'&gt;', '"':'&quot;', '&':'&amp;' })[c];
        });
      };
      var safeName = esc(raw);

      /* Avatar: foto user kalau ada, fallback inisial */
      var avHtml = '';
      try {
        var avUrl = '';
        try { avUrl = ANI.user.avatarUrl(); } catch(e){}
        if (avUrl) {
          avHtml = '<img src="' + esc(avUrl) + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:11px" onerror="this.outerHTML=\'' + esc((raw.charAt(0) || 'A').toUpperCase()) + '\'" />';
        } else {
          avHtml = (raw.charAt(0) || 'A').toUpperCase();
        }
      } catch(e) { avHtml = 'A'; }

      card.innerHTML =
        '<span class="ani-welcome__avatar" aria-hidden="true">' + avHtml + '</span>' +
        '<span class="ani-welcome__text">' +
          '<span class="ani-welcome__greet">' + greet + '</span>' +
          '<span class="ani-welcome__name">' + safeName + '</span>' +
        '</span>' +
        '<button class="ani-welcome__close" id="ani-welcome-close" aria-label="Tutup">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<span class="ani-welcome__bar" aria-hidden="true"></span>';

      document.body.appendChild(card);
      requestAnimationFrame(function() { card.classList.add('is-show'); });

      var hideTimer = setTimeout(function() {
        card.classList.remove('is-show');
        setTimeout(function() { if (card.parentNode) card.parentNode.removeChild(card); }, 400);
      }, 3600);

      var closeBtn = document.getElementById('ani-welcome-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          clearTimeout(hideTimer);
          card.classList.remove('is-show');
          setTimeout(function() { if (card.parentNode) card.parentNode.removeChild(card); }, 400);
        });
      }
    } catch (e) {
      console.error('[Aneetaku] welcomeStrip error:', e);
    }
  },

  pulseAvatar: function() {
    try {
      var av = document.querySelector('.hdr-avatar');
      if (!av) return;
      av.classList.remove('is-just-logged-in');
      /* Force reflow agar animasi restart kalau dipanggil berulang */
      void av.offsetWidth;
      av.classList.add('is-just-logged-in');
      setTimeout(function() { av.classList.remove('is-just-logged-in'); }, 1000);
    } catch (e) {}
  }
};

/* ── Auth State ── */
ANI.user = {
  token: null,
  data: null,
  _ready: false,

  isLoggedIn: function() { return !!this.token && !!this.data; },
  isAdmin: function() { return this.data && this.data.role === 'admin'; },
  isMod: function() { return this.data && (this.data.role === 'mod' || this.data.role === 'admin'); },

  /** Init: baca localStorage, verify session */
  init: function() {
    var self = this;
    try {
      self.token = localStorage.getItem('aneetaku_token') || null;
      var cached = localStorage.getItem('aneetaku_user');
      self.data = cached ? JSON.parse(cached) : null;
    } catch (e) {
      self.token = null;
      self.data = null;
    }

    /* Update UI langsung dari cache (instant, no flicker) */
    ANI.authUI.updateHeaderUI();

    /* Verify session di background jika ada token */
    if (self.token) {
      self.verify();
    }

    self._ready = true;
  },

  /** Verify session masih valid (debounce 5 menit) */
  verify: function(force) {
    var self = this;
    if (!force) {
      var lastV = 0;
      try { lastV = parseInt(sessionStorage.getItem('ani_last_verify') || '0', 10); } catch (e) {}
      if (Date.now() - lastV < 300000) return;
    }
    ANI.userApi.me().then(function(res) {
      self.data = res.user;
      try { localStorage.setItem('aneetaku_user', JSON.stringify(res.user)); } catch (e) {}
      try { sessionStorage.setItem('ani_last_verify', String(Date.now())); } catch (e) {}
      ANI.authUI.updateHeaderUI();
    }).catch(function() {
      /* Session expired / invalid → clear */
      self.clear();
      try { sessionStorage.removeItem('ani_last_verify'); } catch (e) {}
      ANI.authUI.updateHeaderUI();
    });
  },

  /** Set user data setelah login */
  set: function(token, userData) {
    this.token = token;
    this.data = userData;
    try {
      localStorage.setItem('aneetaku_token', token);
      localStorage.setItem('aneetaku_user', JSON.stringify(userData));
    } catch (e) {}
    ANI.authUI.updateHeaderUI();
  },

  /** Clear semua data (logout / expired) */
  clear: function() {
    this.token = null;
    this.data = null;
    try {
      localStorage.removeItem('aneetaku_token');
      localStorage.removeItem('aneetaku_user');
    } catch (e) {}
  },

  /** Get avatar URL */
  avatarUrl: function() {
    if (!this.data) return '';
    if (this.data.avatar === 'google') {
      return this.data.google_avatar || '';
    }
    /* Custom avatar preset */
    return '/assets/avatars/' + this.data.avatar + '.webp';
  },

  /** Get display initial (fallback jika avatar gagal load) */
  initial: function() {
    if (!this.data || !this.data.username) return 'A';
    return this.data.username.charAt(0).toUpperCase();
  }
};

/* ── Auth UI ── */
ANI.authUI = {
  _googleLoaded: false,
  _dropdownOpen: false,
  _modalOpen: false,

  /* ════════════════════════════════
     HEADER UI UPDATE
     ════════════════════════════════ */

  updateHeaderUI: function() {
    var avatarEl = document.querySelector('.hdr-avatar');
    if (!avatarEl) return;

    if (ANI.user.isLoggedIn()) {
      var url = ANI.user.avatarUrl();
      if (url) {
        avatarEl.innerHTML = '<img src="' + ANI.util.esc(url) + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:50%" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'flex\'" />'
          + '<span style="display:none;width:100%;height:100%;align-items:center;justify-content:center">' + ANI.user.initial() + '</span>';
      } else {
        avatarEl.textContent = ANI.user.initial();
      }
      avatarEl.classList.add('is-logged-in');
    } else {
      avatarEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
      avatarEl.classList.remove('is-logged-in');
    }
  },

  /* ════════════════════════════════
     AVATAR CLICK HANDLER
     ════════════════════════════════ */

  handleAvatarClick: function() {
    if (ANI.user.isLoggedIn()) {
      this.toggleDropdown();
    } else {
      this.showLoginModal();
    }
  },

  /* ════════════════════════════════
     LOGIN MODAL
     ════════════════════════════════ */

  showLoginModal: function() {
    var self = this;
    if (self._modalOpen) return;
    self._modalOpen = true;

    /* Buat overlay + modal */
    var overlay = document.createElement('div');
    overlay.id = 'auth-modal-overlay';
    overlay.className = 'auth-overlay';
    overlay.innerHTML =
      '<div class="auth-modal">' +
        '<button class="auth-modal__close" id="auth-modal-close" aria-label="Tutup">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="auth-modal__logo"><span class="logo">Anee<span class="logo-dim">taku</span></span></div>' +
        '<h2 class="auth-modal__title">Selamat Datang!</h2>' +
        '<p class="auth-modal__desc">Masuk untuk menyimpan watchlist, riwayat tonton, dan bergabung di komunitas.</p>' +
        '<div id="auth-modal-error" class="auth-modal__error" style="display:none"></div>' +
        '<button class="auth-google-btn" id="auth-google-btn">' +
          '<svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59a14.5 14.5 0 0 1 0-9.18l-7.98-6.19a24.008 24.008 0 0 0 0 21.56l7.98-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>' +
          '<span>Masuk dengan Google</span>' +
        '</button>' +
        '<div id="auth-loading" class="auth-modal__loading" style="display:none">' +
          '<div class="auth-spinner"></div>' +
          '<span>Memproses...</span>' +
        '</div>' +
        '<p class="auth-modal__footer">Dengan masuk, kamu menyetujui <a href="/kebijakan-privasi">Kebijakan Privasi</a> kami.</p>' +
      '</div>';

    document.body.appendChild(overlay);

    /* Animate in */
    requestAnimationFrame(function() {
      overlay.classList.add('is-open');
    });

    /* Event: close */
    var closeBtn = document.getElementById('auth-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() { self.closeLoginModal(); });
    }
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) self.closeLoginModal();
    });

    /* Event: Google login button */
    var googleBtn = document.getElementById('auth-google-btn');
    if (googleBtn) {
      googleBtn.addEventListener('click', function() {
        self._triggerGoogleLogin();
      });
    }

    /* Escape key */
    self._modalEscHandler = function(e) {
      if (e.key === 'Escape') self.closeLoginModal();
    };
    document.addEventListener('keydown', self._modalEscHandler);
  },

  closeLoginModal: function() {
    var self = this;
    var overlay = document.getElementById('auth-modal-overlay');
    if (overlay) {
      overlay.classList.remove('is-open');
      setTimeout(function() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 300);
    }
    if (self._modalEscHandler) {
      document.removeEventListener('keydown', self._modalEscHandler);
      self._modalEscHandler = null;
    }
    self._modalOpen = false;
  },

  /* ════════════════════════════════
     GOOGLE SIGN-IN
     ════════════════════════════════ */

  _initGoogle: function() {
    var self = this;
    if (self._googleLoaded) return;
    if (typeof google === 'undefined' || !google.accounts) return;

    google.accounts.id.initialize({
      client_id: ANI.cfg.googleClientId,
      callback: function(response) {
        self._handleGoogleCallback(response);
      },
      auto_select: false,
      cancel_on_tap_outside: true
    });

    self._googleLoaded = true;
  },

  _triggerGoogleLogin: function() {
    var self = this;
    self._initGoogle();

    if (!self._googleLoaded) {
      self._showModalError('Google Sign-In belum siap. Coba lagi dalam beberapa detik.');
      return;
    }

    /* Tampilkan loading */
    var btn = document.getElementById('auth-google-btn');
    var loading = document.getElementById('auth-loading');
    if (btn) btn.style.display = 'none';
    if (loading) loading.style.display = 'flex';

    /* Trigger One Tap / popup */
    try {
      google.accounts.id.prompt(function(notification) {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          /* One Tap tidak bisa ditampilkan — fallback ke popup */
          self._googlePopupFallback();
        }
      });
    } catch (e) {
      self._googlePopupFallback();
    }
  },

  _googlePopupFallback: function() {
    var self = this;

    /* Gunakan OAuth2 popup flow sebagai fallback */
    var clientId = ANI.cfg.googleClientId;
    var redirectUri = window.location.origin;
    var state = nanoid_simple(16);

    try { sessionStorage.setItem('gauth_state', state); } catch (e) {}

    var authUrl = 'https://accounts.google.com/o/oauth2/v2/auth'
      + '?client_id=' + encodeURIComponent(clientId)
      + '&redirect_uri=' + encodeURIComponent(redirectUri)
      + '&response_type=id_token'
      + '&scope=openid%20email%20profile'
      + '&nonce=' + nanoid_simple(16)
      + '&state=' + state
      + '&prompt=select_account';

    /* Buka popup */
    var w = 500, h = 600;
    var left = (screen.width - w) / 2;
    var top = (screen.height - h) / 2;
    var popup = window.open(authUrl, 'google_auth', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',toolbar=no,menubar=no');

    if (!popup) {
      /* Popup blocked — redirect langsung */
      window.location.href = authUrl;
      return;
    }

    /* Flag agar handler popup hanya fire sekali (postMessage menang race vs polling fallback) */
    var settled = false;
    var messageHandler = null;
    var pollTimer = null;
    var pollTimeout = null;

    var cleanup = function() {
      if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
      if (pollTimeout) { clearTimeout(pollTimeout); pollTimeout = null; }
      if (messageHandler) { try { window.removeEventListener('message', messageHandler); } catch(e){} messageHandler = null; }
      if (_bc) { try { _bc.close(); } catch(e){} _bc = null; }
      if (_storageHandler) { try { window.removeEventListener('storage', _storageHandler); } catch(e){} _storageHandler = null; }
      try { localStorage.removeItem('_gauth_popup_waiting'); } catch(e){}
    };

    /* ── Kiwi / Android browser: popup abre como nueva pestaña sin window.opener ── */
    /* Marcamos que hay un popup esperando; la nueva pestaña lo detecta y emite BC/storage */
    try { localStorage.setItem('_gauth_popup_waiting', state); } catch(e){}
    var _bc = null;
    var _storageHandler = null;
    try {
      _bc = new BroadcastChannel('aneetaku_auth');
      _bc.onmessage = function(ev) {
        if (ev.data && ev.data.type === 'aneetaku-auth') finish(ev.data.idToken || '', ev.data.state || '');
      };
    } catch(e){}
    _storageHandler = function(ev) {
      if (ev.key === '_gauth_result' && ev.newValue) {
        try {
          var d = JSON.parse(ev.newValue);
          if (d && d.idToken) { try { localStorage.removeItem('_gauth_result'); } catch(ee){} finish(d.idToken, d.state || ''); }
        } catch(ee){}
      }
    };
    try { window.addEventListener('storage', _storageHandler); } catch(e){}

    var finish = function(idToken, returnedState) {
      if (settled) return;
      settled = true;
      cleanup();
      try { if (popup && !popup.closed) popup.close(); } catch (e) {}

      /* Validasi state (CSRF protection) */
      var savedState = null;
      try { savedState = sessionStorage.getItem('gauth_state'); } catch (e) {}
      if (savedState && returnedState && returnedState !== savedState) {
        self._showModalError('Validasi keamanan gagal. Coba lagi.');
        self._resetModalButtons();
        return;
      }
      try { sessionStorage.removeItem('gauth_state'); } catch (e) {}

      if (idToken) {
        self._handleGoogleCallback({ credential: idToken });
      } else {
        self._showModalError('Login dibatalkan.');
        self._resetModalButtons();
      }
    };

    /* PRIMARY: dengarkan postMessage dari popup (handler di _checkRedirectResult) */
    messageHandler = function(e) {
      if (e.origin !== window.location.origin) return;
      if (!e.data || e.data.type !== 'aneetaku-auth') return;
      finish(e.data.idToken || '', e.data.state || '');
    };
    try { window.addEventListener('message', messageHandler); } catch (e) {}

    /* FALLBACK: polling popup URL — jaga-jaga jika postMessage gagal (extension blocking dll) */
    pollTimer = setInterval(function() {
      if (settled) return;
      try {
        if (!popup || popup.closed) {
          /* Popup ditutup user tanpa selesai login — beri delay agar postMessage sempat masuk dulu */
          setTimeout(function() {
            if (settled) return;
            cleanup();
            self._showModalError('Login dibatalkan.');
            self._resetModalButtons();
          }, 250);
          /* Stop polling sekarang, tapi biarkan messageHandler aktif sebentar */
          if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
          return;
        }
        var popupUrl = popup.location.href;
        if (popupUrl && popupUrl.indexOf(redirectUri) === 0) {
          /* Sudah balik ke origin kita. Coba baca hash kalau belum kena clear oleh popup. */
          var hash = popup.location.hash.substring(1);
          if (hash) {
            var params = new URLSearchParams(hash);
            var idToken = params.get('id_token');
            var st = params.get('state');
            if (idToken) {
              finish(idToken, st || '');
              return;
            }
          }
          /* Hash sudah kosong — popup mungkin sudah postMessage; jangan fail di sini.
             Beri jeda agar messageHandler sempat process. */
        }
      } catch (e) {
        /* Cross-origin — masih di halaman Google, lanjut poll */
      }
    }, 400);

    /* Timeout 5 menit — jaga-jaga popup dibiarkan terbuka */
    pollTimeout = setTimeout(function() {
      if (settled) return;
      cleanup();
      try { if (popup && !popup.closed) popup.close(); } catch (e) {}
      self._showModalError('Login timeout. Silakan coba lagi.');
      self._resetModalButtons();
    }, 300000);
  },

  _handleGoogleCallback: function(response) {
    var self = this;
    if (!response || !response.credential) {
      self._showModalError('Login gagal. Coba lagi.');
      self._resetModalButtons();
      return;
    }

    /* Kirim ke Worker */
    ANI.userApi.authGoogle(response.credential).then(function(res) {
      /* Berhasil! */
      ANI.user.set(res.token, res.user);
      try { ANI.pref.syncFromServer(res.user.preferences); } catch(e){}
      self.closeLoginModal();

      /* Visual feedback: avatar pulse + welcome strip (no toast — strip lebih solutif) */
      try { ANI._authHelpers.pulseAvatar(); } catch(e){}
      try { ANI._authHelpers.showWelcomeStrip(res.user && res.user.username, !!res.is_new); } catch(e){}

      /* Invalidate caches & refresh konten halaman saat ini supaya NSFW langsung berlaku */
      try { ANI._authHelpers.invalidateNsfwCaches(); } catch(e){}
      try { ANI._authHelpers.refreshCurrentRoute(); } catch(e){}
    }).catch(function(err) {
      self._showModalError(err.message || 'Gagal memproses login.');
      self._resetModalButtons();
    });
  },

  _showModalError: function(msg) {
    var errEl = document.getElementById('auth-modal-error');
    if (errEl) {
      errEl.textContent = msg;
      errEl.style.display = 'block';
    }
  },

  _resetModalButtons: function() {
    var btn = document.getElementById('auth-google-btn');
    var loading = document.getElementById('auth-loading');
    if (btn) btn.style.display = 'flex';
    if (loading) loading.style.display = 'none';
  },

  /* ════════════════════════════════
     USER DROPDOWN
     ════════════════════════════════ */

  toggleDropdown: function() {
    var self = this;
    if (self._dropdownOpen) {
      self.closeDropdown();
      return;
    }
    self._dropdownOpen = true;

    /* Hapus dropdown lama jika ada */
    var old = document.getElementById('user-dropdown');
    if (old) old.parentNode.removeChild(old);

    var u = ANI.user.data;
    var avatarUrl = ANI.user.avatarUrl();
    var avatarHtml = avatarUrl
      ? '<img src="' + ANI.util.esc(avatarUrl) + '" alt="" class="ud-avatar__img" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'flex\'" /><span class="ud-avatar__fallback" style="display:none">' + ANI.user.initial() + '</span>'
      : '<span class="ud-avatar__fallback">' + ANI.user.initial() + '</span>';

    var isMobile = window.innerWidth < 768;

    var dd = document.createElement('div');
    dd.id = 'user-dropdown';
    dd.className = 'user-dropdown';
    dd.innerHTML =
      '<div class="ud-header">' +
        '<div class="ud-avatar">' + avatarHtml + '</div>' +
        '<div class="ud-name">' + ANI.util.esc(u.username) + '</div>' +
      '</div>' +
      '<a href="/user" class="ud-pill ud-pill--primary">Pengaturan Akun</a>' +
      '<div class="ud-sep"></div>' +
      '<a href="/user/watchlist" class="ud-item">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>' +
        'Watchlist' +
      '</a>' +
      '<a href="/user/histori" class="ud-item">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
        'Histori' +
      '</a>' +
      '<div class="ud-sep"></div>' +
      '<a href="https://trakteer.id/aneetaku/tip" target="_blank" rel="noopener" class="ud-item">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>' +
        'Dukung Kami' +
      '</a>' +
      '<a href="/pemeran" class="ud-item">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6"/><path d="M23 11h-6"/></svg>' +
        'Pemeran <span class="ud-badge-beta">BETA</span>' +
      '</a>' +
      (isMobile ? (
        '<a href="#" class="ud-item" id="ud-notif-link">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>' +
          'Notifikasi' +
        '</a>'
      ) : '') +
      '<div class="ud-sep"></div>' +
      '<button class="ud-pill ud-pill--logout" id="ud-logout">Keluar</button>';

    /* Posisikan di bawah avatar */
    var avatarEl = document.querySelector('.hdr-avatar');
    if (avatarEl) {
      avatarEl.parentNode.style.position = 'relative';
      avatarEl.parentNode.appendChild(dd);
    } else {
      document.body.appendChild(dd);
    }

    /* Animate in */
    requestAnimationFrame(function() { dd.classList.add('is-open'); });

    /* Event: logout */
    var logoutBtn = document.getElementById('ud-logout');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        self._doLogout();
      });
    }

    /* Event: SPA navigation untuk internal links */
    dd.querySelectorAll('a[href^="/"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        e.preventDefault();
        self.closeDropdown();
        window.location.href = a.getAttribute('href');
      });
    });

    /* Event: close on click outside */
    self._dropdownOutsideHandler = function(e) {
      if (!dd.contains(e.target) && e.target !== avatarEl && !avatarEl.contains(e.target)) {
        self.closeDropdown();
      }
    };
    setTimeout(function() {
      document.addEventListener('click', self._dropdownOutsideHandler);
    }, 10);

    /* Escape */
    self._dropdownEscHandler = function(e) {
      if (e.key === 'Escape') self.closeDropdown();
    };
    document.addEventListener('keydown', self._dropdownEscHandler);
  },

  closeDropdown: function() {
    var self = this;
    var dd = document.getElementById('user-dropdown');
    if (dd) {
      dd.classList.remove('is-open');
      setTimeout(function() {
        if (dd.parentNode) dd.parentNode.removeChild(dd);
      }, 200);
    }
    if (self._dropdownOutsideHandler) {
      document.removeEventListener('click', self._dropdownOutsideHandler);
      self._dropdownOutsideHandler = null;
    }
    if (self._dropdownEscHandler) {
      document.removeEventListener('keydown', self._dropdownEscHandler);
      self._dropdownEscHandler = null;
    }
    self._dropdownOpen = false;
  },

  /* ════════════════════════════════
     LOGOUT
     ════════════════════════════════ */

  _doLogout: function() {
    var self = this;
    self.closeDropdown();

    ANI.userApi.logout().catch(function() {
      /* Ignore error — clear local state anyway */
    }).then(function() {
      ANI.user.clear();
      self.updateHeaderUI();

      /* Toast bottom variant info — visualisasi state berubah */
      self._showToast('Berhasil keluar.', 'info');

      /* Redirect jika di halaman yang butuh auth */
      var path = window.location.pathname;
      if (path.indexOf('/user') === 0) {
        window.location.href = '/';
        return;
      }

      /* Invalidate cache (mungkin sebelumnya NSFW on) lalu refresh konten */
      try { ANI._authHelpers.invalidateNsfwCaches(); } catch(e){}
      try { ANI._authHelpers.refreshCurrentRoute(); } catch(e){}
    });
  },

  /* ════════════════════════════════
     TOAST NOTIFICATION
     ════════════════════════════════ */

  _showToast: function(msg, variant) {
    var existing = document.getElementById('ani-toast');
    if (existing) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    toast.id = 'ani-toast';
    var cls = 'ani-toast';
    var iconSvg = '';
    if (variant === 'success') {
      cls += ' ani-toast--success';
      iconSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    } else if (variant === 'info') {
      cls += ' ani-toast--info';
      iconSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>';
    }
    toast.className = cls;
    if (iconSvg) {
      toast.innerHTML = '<span class="ani-toast__icon" aria-hidden="true">' + iconSvg + '</span><span class="ani-toast__msg"></span>';
      var msgEl = toast.querySelector('.ani-toast__msg');
      if (msgEl) msgEl.textContent = msg;
    } else {
      toast.textContent = msg;
    }
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-show');
    });

    setTimeout(function() {
      toast.classList.remove('is-show');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 3000);
  },

  /* ════════════════════════════════
     BIND EVENTS (dipanggil di init)
     ════════════════════════════════ */

  bind: function() {
    var self = this;
    var avatarEl = document.querySelector('.hdr-avatar');
    if (avatarEl) {
      avatarEl.addEventListener('click', function(e) {
        e.stopPropagation();
        self.handleAvatarClick();
      });
      avatarEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          self.handleAvatarClick();
        }
      });
    }

    /* Handle hash fragment dari Google redirect (mobile fallback) */
    self._checkRedirectResult();
  },

  /** Cek apakah ada id_token di hash (dari Google redirect flow) */
  _checkRedirectResult: function() {
    var self = this;
    var hash = window.location.hash;
    if (!hash || hash.indexOf('id_token') === -1) return;

    var params = new URLSearchParams(hash.substring(1));
    var idToken = params.get('id_token');
    if (!idToken) return;

    var returnedState = params.get('state');

    /* DETEKSI: kalau kita di popup window (window.opener ada), kirim token ke parent
       lalu tutup popup. Parent yang akan process login + show UI feedback.
       Ini menyelesaikan race condition: tanpa ini, popup akan clear hash
       sebelum parent sempat polling-baca, sehingga muncul "Login dibatalkan". */
    var inPopup = false;
    try {
      inPopup = !!(window.opener && window.opener !== window && !window.opener.closed);
    } catch (e) { inPopup = false; }

    if (inPopup) {
      try {
        window.opener.postMessage({
          type: 'aneetaku-auth',
          idToken: idToken,
          state: returnedState || ''
        }, window.location.origin);
      } catch (e) {
        console.warn('[Auth] postMessage to opener failed:', e && e.message);
      }
      /* Tutup popup setelah jeda kecil agar message tersampaikan */
      setTimeout(function() { try { window.close(); } catch (e) {} }, 120);
      return;
    }

    /* === Kiwi / browser yang buka popup sebagai tab tanpa window.opener === */
    /* Jika ada tab lain yang menunggu (_gauth_popup_waiting), kirim via BroadcastChannel
       + localStorage. Tab asli akan catch dan selesaikan login. Tab ini juga lanjut
       ke redirect flow biasa (idempoten — backend mengembalikan data yang sama). */
    var _popupWaiting = null;
    try { _popupWaiting = localStorage.getItem('_gauth_popup_waiting'); } catch(e){}
    if (_popupWaiting && idToken) {
      try {
        var _bcSend = new BroadcastChannel('aneetaku_auth');
        _bcSend.postMessage({ type: 'aneetaku-auth', idToken: idToken, state: returnedState || '' });
        _bcSend.close();
      } catch(e){}
      try { localStorage.setItem('_gauth_result', JSON.stringify({ idToken: idToken, state: returnedState || '', ts: Date.now() })); } catch(e){}
    }

    /* === Mobile redirect flow (full-page redirect, bukan popup) === */

    /* Validasi state parameter (CSRF protection) */
    var savedState = null;
    try { savedState = sessionStorage.getItem('gauth_state'); } catch (e) {}
    if (savedState && returnedState !== savedState) return;
    try { sessionStorage.removeItem('gauth_state'); } catch (e) {}

    /* Clear hash */
    try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}

    /* Process login */
    ANI.userApi.authGoogle(idToken).then(function(res) {
      ANI.user.set(res.token, res.user);
      try { ANI.pref.syncFromServer(res.user.preferences); } catch(e){}
      ANI.authUI.updateHeaderUI();

      /* Visual feedback: avatar pulse + welcome strip */
      try { ANI._authHelpers.pulseAvatar(); } catch(e){}
      try { ANI._authHelpers.showWelcomeStrip(res.user && res.user.username, !!res.is_new); } catch(e){}

      /* Invalidate caches & refresh konten halaman saat ini */
      try { ANI._authHelpers.invalidateNsfwCaches(); } catch(e){}
      try { ANI._authHelpers.refreshCurrentRoute(); } catch(e){}
    }).catch(function(err) {
      console.warn('[Auth] Redirect login failed:', err.message);
    });
  }
};

/* ── Simple nanoid untuk state parameter ── */
function nanoid_simple(size) {
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var bytes = crypto.getRandomValues(new Uint8Array(size || 16));
  var id = '';
  for (var i = 0; i < size; i++) {
    id += chars[bytes[i] % chars.length];
  }
  return id;
}

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 13: User Pages (/user)
   
   Patch 2: Profil, Preferensi, Hapus Akun
   ═══════════════════════════════════════════════ */

ANI.userPages = {

  /* ═══ MAIN RENDER ═══ */
  renderProfile: function() {
    var self = this;
    if (!ANI.user.isLoggedIn()) {
      document.getElementById('app-content').innerHTML =
        '<div class="static-page-wrap" style="text-align:center;padding-top:80px">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
        + '<h2 style="margin-top:var(--s4)">Kamu belum masuk</h2>'
        + '<p style="color:var(--c-muted);margin-top:var(--s2)">Masuk terlebih dahulu untuk mengakses pengaturan akun.</p>'
        + '</div>';
      return;
    }

    var u = ANI.user.data;
    var avatarUrl = ANI.user.avatarUrl();
    var currentServer = ANI.pref.getServer().toLowerCase() || '';
    var currentQuality = ANI.pref.getQuality();
    var currentNsfw = ANI.pref.getNsfw();

    /* ── Hitung cooldown username ── */
    var canChangeName = true;
    var daysLeft = 0;
    if (u.username_changed_at) {
      var ms = Date.now() - new Date(u.username_changed_at + (u.username_changed_at.indexOf('Z') === -1 ? 'Z' : '')).getTime();
      var daysSince = ms / 86400000;
      if (daysSince < 30) { canChangeName = false; daysLeft = Math.ceil(30 - daysSince); }
    }

    /* ── Server descriptions ── */
    var srvDescriptions = {
      av1: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#60a5fa" stroke-width="2" style="flex-shrink:0;margin-top:1px"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
        + '<div>Server paling kencang dengan kualitas terbaik. Codec AV1 membutuhkan perangkat modern untuk pemutaran optimal:'
        + '<div class="up-srv-chips">'
        + '<span class="up-srv-chip">Snapdragon 8 Gen 1+</span>'
        + '<span class="up-srv-chip">Dimensity 1000+</span>'
        + '<span class="up-srv-chip">Exynos 2200+</span>'
        + '<span class="up-srv-chip">Google Tensor</span>'
        + '<span class="up-srv-chip">Desktop Chrome 90+</span>'
        + '</div>'
        + '<span class="up-srv-note">Di perangkat lama, video mungkin buffering atau patah-patah.</span>'
        + '</div>',
      h264: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" stroke-width="2" style="flex-shrink:0;margin-top:1px"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
        + '<div>Didukung oleh semua browser dan perangkat tanpa syarat khusus. Namun server pihak ketiga yang digunakan tidak selalu stabil &mdash; video kadang dimuat lambat meskipun koneksi internetmu bagus.</div>',
      abyss: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c084fc" stroke-width="2" style="flex-shrink:0;margin-top:1px"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
        + '<div>Perpaduan server cepat dan codec universal yang bisa diputar di semua perangkat. Kekurangan: memiliki <strong>iklan popup</strong>, serta fitur skip OP/ED dan lanjut otomatis <strong>tidak tersedia</strong> di server ini.</div>'
    };

    var privacy = (u.privacy || {});
    var sections = [
      { id: 'akun',     label: 'Akun',           icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' },
      { id: 'pref',     label: 'Preferensi',     icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>' },
      { id: 'privasi',  label: 'Privasi',        icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' },
      { id: 'data',     label: 'Data',           icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>' },
      { id: 'danger',   label: 'Zona Berbahaya', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' }
    ];

    var expanded = false;
    try { expanded = localStorage.getItem('aneetaku_sidenav_expanded') === '1'; } catch(e) {}

    var sideNav = '<nav class="up-sidenav' + (expanded ? ' is-expanded' : '') + '" id="up-sidenav" aria-label="Pengaturan">';
    sections.forEach(function(s, idx) {
      if (s.id === 'danger') {
        sideNav += '<span class="up-sidenav__divider" aria-hidden="true"></span>';
      }
      sideNav += '<button type="button" class="up-sidenav__item' + (idx === 0 ? ' is-active' : '') + (s.id === 'danger' ? ' up-sidenav__item--danger' : '') + '" data-target="up-sec-' + s.id + '" title="' + s.label + '">'
        + '<span class="up-sidenav__icon">' + s.icon + '</span>'
        + '<span class="up-sidenav__label">' + s.label + '</span>'
        + '</button>';
    });
    sideNav += '<span class="up-sidenav__divider up-sidenav__divider--btm" aria-hidden="true"></span>'
      + '<button type="button" class="up-sidenav__item up-sidenav__toggle" id="up-sidenav-toggle" title="' + (expanded ? 'Kecilkan menu' : 'Lebarkan menu') + '" aria-label="Toggle menu width">'
      +   '<span class="up-sidenav__icon">'
      +     '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>'
      +   '</span>'
      +   '<span class="up-sidenav__label">' + (expanded ? 'Kecilkan' : 'Lebarkan') + '</span>'
      + '</button>';
    sideNav += '</nav>';

    var roleLabels = { admin: 'Admin', mod: 'Moderator', user: 'User', banned: 'Banned' };
    var roleKey = (u.role || 'user').toLowerCase();
    var roleLabel = roleLabels[roleKey] || 'User';
    var hasGoogle = !!(u.google_avatar || u.email);

    var html =
      '<div class="up-wrap">'
      + sideNav
      + '<div class="up-main">'
      + '<div class="up-header">'
      +   '<h1>Pengaturan Akun</h1>'
      +   '<p class="up-header__sub">Kelola profil, preferensi tontonan, dan privasi akunmu.</p>'
      + '</div>'

      /* ════ AKUN ════ */
      + '<section class="up-section" id="up-sec-akun">'
      +   '<div class="up-section__title">'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
      +     'Akun'
      +   '</div>'

      /* Avatar */
      +   '<div class="up-field">'
      +     '<label class="up-label">Avatar</label>'
      +     '<div class="up-avatar-current">'
      +       '<div class="up-avatar-preview" id="up-av-preview">' + (avatarUrl ? '<img src="' + ANI.util.esc(avatarUrl) + '" onerror="this.parentNode.textContent=\'' + ANI.user.initial() + '\'" />' : ANI.user.initial()) + '</div>'
      +       '<button class="up-btn-outline" id="up-av-change">Ganti Avatar</button>'
      +     '</div>'
      +     '<div class="up-avatar-grid" id="up-av-grid" style="display:none">'
      +       '<div class="up-av-item' + (u.avatar === 'google' ? ' is-active' : '') + '" data-av="google">'
      +         (u.google_avatar ? '<img src="' + ANI.util.esc(u.google_avatar) + '" />' : '<span>G</span>') + '<div class="up-av-label">Google</div>'
      +       '</div>';

    for (var i = 1; i <= 20; i++) {
      var avId = 'av-' + (i < 10 ? '0' : '') + i;
      html += '<div class="up-av-item' + (u.avatar === avId ? ' is-active' : '') + '" data-av="' + avId + '">'
        + '<img src="/assets/avatars/' + avId + '.webp" onerror="this.outerHTML=\'<span>' + i + '</span>\'" />'
        + '</div>';
    }

    html += '</div></div>'

      /* Username */
      + '<div class="up-field">'
      +   '<label class="up-label">Username</label>'
      +   '<div class="up-input-row">'
      +     '<input class="up-input" id="up-username" value="' + ANI.util.esc(u.username) + '" maxlength="20" ' + (canChangeName ? '' : 'disabled') + ' autocomplete="off" />'
      +     '<button class="up-btn-primary up-btn-sm" id="up-save-name" disabled>Simpan</button>'
      +   '</div>'
      +   '<div class="up-username-meta">'
      +     '<span class="up-username-counter" id="up-username-counter">' + (u.username || '').length + '/20</span>'
      +     (canChangeName
          ? '<span class="up-hint">3-20 karakter. Huruf, angka, underscore.</span>'
          : '<span class="up-hint up-hint--warn">Bisa diganti lagi dalam ' + daysLeft + ' hari</span>')
      +   '</div>'
      + '</div>'

      /* Meta read-only grid: ID, Email, Tanggal, Role, Provider */
      + '<div class="up-meta-grid">'
      +   '<div class="up-meta-cell">'
      +     '<span class="up-meta-key">ID Akun</span>'
      +     '<span class="up-meta-val up-meta-mono">' + ANI.util.esc(u.id) + '</span>'
      +   '</div>'
      +   (u.email ? (
            '<div class="up-meta-cell">'
            + '<span class="up-meta-key">Email</span>'
            + '<span class="up-meta-val">' + ANI.util.esc(u.email) + '</span>'
          + '</div>'
        ) : '')
      +   '<div class="up-meta-cell">'
      +     '<span class="up-meta-key">Bergabung</span>'
      +     '<span class="up-meta-val">' + self._formatTanggal(u.created_at) + '</span>'
      +   '</div>'
      +   '<div class="up-meta-cell">'
      +     '<span class="up-meta-key">Role</span>'
      +     '<span class="up-role-badge up-role-badge--' + roleKey + '">' + roleLabel + '</span>'
      +   '</div>'
      +   (hasGoogle ? (
            '<div class="up-meta-cell up-meta-cell--full">'
            + '<span class="up-meta-key">Login via</span>'
            + '<span class="up-provider-chip">'
            +   '<svg width="14" height="14" viewBox="0 0 18 18" aria-hidden="true"><path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.49h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.9c1.7-1.57 2.7-3.88 2.7-6.62z"/><path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.9-2.26c-.8.54-1.83.86-3.06.86-2.35 0-4.34-1.58-5.05-3.71H.97v2.33A9 9 0 0 0 9 18z"/><path fill="#FBBC05" d="M3.95 10.71A5.41 5.41 0 0 1 3.66 9c0-.6.1-1.17.29-1.71V4.96H.97A9 9 0 0 0 0 9c0 1.45.35 2.83.97 4.04l2.98-2.33z"/><path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .97 4.96L3.95 7.3C4.66 5.16 6.65 3.58 9 3.58z"/></svg>'
            +   'Google'
            + '</span>'
          + '</div>'
        ) : '')
      + '</div>'

      + '</section>'/* end Akun */

      /* ════ PREFERENSI ════ */
      + '<section class="up-section" id="up-sec-pref">'
      +   '<div class="up-section__title">'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>'
      +     'Preferensi'
      +   '</div>'

      /* Server */
      + '<div class="up-field">'
      +   '<label class="up-label">Server Utama</label>'
      +   '<p class="up-field-desc">Pilihan ini juga berlaku saat menonton. Jika kamu mengganti server di pemutar, pengaturan ini otomatis ikut berubah.</p>'
      +   '<div class="up-radio-group" id="up-srv-group">'
      +     self._srvOption('av1', 'AV1', currentServer === 'av1', srvDescriptions.av1)
      +     self._srvOption('h264', 'H264', currentServer === 'h264', srvDescriptions.h264)
      +     self._srvOption('abyss', 'Abyss', currentServer === 'abyss' || currentServer === 'embed', srvDescriptions.abyss)
      +   '</div>'
      + '</div>'

      /* Kualitas */
      + '<div class="up-field">'
      +   '<label class="up-label">Kualitas Video</label>'
      +   '<p class="up-field-desc">Menentukan kualitas awal saat mulai menonton. Kamu tetap bisa ganti manual di pemutar.</p>'
      +   '<div class="up-radio-group" id="up-qual-group">'
      +     self._qualOption('auto', 'Otomatis', 'Menyesuaikan kecepatan internet secara otomatis', currentQuality === 'auto')
      +     self._qualOption('hemat', 'Hemat Data', 'Selalu mulai dari kualitas 480p', currentQuality === 'hemat')
      +     self._qualOption('tertinggi', 'Tertinggi', 'Selalu pilih kualitas paling tinggi yang tersedia', currentQuality === 'tertinggi')
      +   '</div>'
      + '</div>'

      /* NSFW */
      + '<div class="up-field">'
      +   '<label class="up-label">Konten Dewasa (NSFW)</label>'
      +   '<div class="up-switch-row">'
      +     '<span class="up-switch-label">Tampilkan konten bertanda dewasa</span>'
      +     '<label class="up-switch">'
      +       '<input type="checkbox" id="up-nsfw-toggle"' + (currentNsfw ? ' checked' : '') + ' />'
      +       '<span class="up-switch__track"></span>'
      +     '</label>'
      +   '</div>'
      +   '<span class="up-hint">Default: nonaktif. Konten NSFW disembunyikan dari daftar anime jika dimatikan.</span>'
      + '</div>'

      /* Experimental Mode (ADMIN-ONLY) */
      + (ANI.user.isAdmin() ? (
          '<div class="up-field up-field--experimental">'
          + '<label class="up-label">'
          +   '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="vertical-align:-1px;margin-right:4px"><path d="M10 2v7.31"/><path d="M14 9.3V1.99"/><path d="M8.5 2h7"/><path d="M14 9.3a6.5 6.5 0 1 1-4 0"/><path d="M5.52 16h12.96"/></svg>'
          +   'Mode Eksperimental <span class="up-badge-exp">ADMIN</span>'
          + '</label>'
          + '<div class="up-switch-row">'
          +   '<span class="up-switch-label">Tampilkan tipe eksperimental: Donghua, 3D Animation, Live Action</span>'
          +   '<label class="up-switch">'
          +     '<input type="checkbox" id="up-exp-toggle"' + (ANI.pref.getExperimental() ? ' checked' : '') + ' />'
          +     '<span class="up-switch__track"></span>'
          +   '</label>'
          + '</div>'
          + '<span class="up-hint">Konten dengan tipe eksperimental disembunyikan secara default. Kualitas sumber bisa bervariasi — fitur ini bukan prioritas.</span>'
          + '</div>'
        ) : '')

      + '</section>'/* end Preferensi */

      /* ════ PRIVASI ════ */
      + '<section class="up-section" id="up-sec-privasi">'
      +   '<div class="up-section__title">'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
      +     'Privasi'
      +   '</div>'
      +   '<p class="up-field-desc">Kontrol siapa yang bisa melihat aktivitasmu di Aneetaku. Default: semua privat.</p>'
      +   self._privacyRow('profile',   'Profil publik',          'Profil & avatar terlihat di halaman pengguna publik.', !!privacy.profile)
      +   self._privacyRow('watchlist', 'Watchlist publik',       'Daftar tontonanmu bisa dilihat pengguna lain.',         !!privacy.watchlist)
      +   self._privacyRow('history',   'Riwayat tonton publik',  'Riwayat episode yang sudah ditonton bisa dilihat.',     !!privacy.history)
      + '</section>'/* end Privasi */

      /* ════ DATA ════ */
      + '<section class="up-section" id="up-sec-data">'
      +   '<div class="up-section__title">'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
      +     'Data'
      +   '</div>'
      +   '<div class="up-field">'
      +     '<p class="up-field-desc">Unduh salinan data akunmu (profil, preferensi, watchlist, dan riwayat tonton) dalam format JSON.</p>'
      +     '<button class="up-btn-outline up-export-btn" id="up-export-btn">'
      +       '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
      +       '<span>Download data saya (JSON)</span>'
      +     '</button>'
      +   '</div>'
      + '</section>'/* end Data */

      /* ════ DANGER ZONE ════ */
      + '<section class="up-section up-section--danger" id="up-sec-danger">'
      +   '<div class="up-section__title up-section__title--danger">'
      +     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
      +     'Zona Berbahaya'
      +   '</div>'
      +   '<div class="up-field">'
      +     '<p class="up-field-desc" style="color:#f87171">Tindakan di bawah ini bersifat permanen dan tidak bisa dibatalkan.</p>'
      +     '<button class="up-btn-danger" id="up-delete-acct">Hapus Akun</button>'
      +   '</div>'
      + '</section>'

      + '<div id="up-toast-area"></div>'
      + '</div>'/* end up-main */
      + '</div>';/* end up-wrap */

    document.getElementById('app-content').innerHTML = html;
    self._bindEvents();
  },

  /* ═══ SERVER OPTION HTML ═══ */
  _srvOption: function(value, label, isActive, descHtml) {
    return '<label class="up-radio-card' + (isActive ? ' is-active' : '') + '" data-srv="' + value + '">'
      + '<div class="up-rc-header">'
      +   '<input type="radio" name="up-srv" value="' + value + '"' + (isActive ? ' checked' : '') + ' />'
      +   '<span class="up-rc-dot"></span>'
      +   '<span class="up-rc-label">' + label + '</span>'
      + '</div>'
      + '<div class="up-rc-desc">' + descHtml + '</div>'
      + '</label>';
  },

  /* ═══ PRIVACY ROW HTML ═══ */
  _privacyRow: function(key, label, desc, isOn) {
    return '<div class="up-field up-field--compact">'
      + '<div class="up-switch-row">'
      +   '<div class="up-switch-text">'
      +     '<span class="up-switch-label">' + label + '</span>'
      +     '<span class="up-switch-desc">' + desc + '</span>'
      +   '</div>'
      +   '<label class="up-switch">'
      +     '<input type="checkbox" data-privacy="' + key + '"' + (isOn ? ' checked' : '') + ' />'
      +     '<span class="up-switch__track"></span>'
      +   '</label>'
      + '</div>'
      + '</div>';
  },

  /* ═══ FORMAT TANGGAL ID ═══ */
  _formatTanggal: function(iso) {
    if (!iso) return '—';
    try {
      var s = iso.indexOf('Z') === -1 && iso.indexOf('T') !== -1 ? iso + 'Z' : iso;
      var d = new Date(s.indexOf('T') === -1 ? s.replace(' ', 'T') + 'Z' : s);
      if (isNaN(d.getTime())) return '—';
      var bulan = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];
      return d.getUTCDate() + ' ' + bulan[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
    } catch(e) { return '—'; }
  },

  /* ═══ QUALITY OPTION HTML ═══ */
  _qualOption: function(value, label, desc, isActive) {
    return '<label class="up-radio-option' + (isActive ? ' is-active' : '') + '">'
      + '<input type="radio" name="up-qual" value="' + value + '"' + (isActive ? ' checked' : '') + ' />'
      + '<span class="up-ro-dot"></span>'
      + '<div class="up-ro-text">'
      +   '<span class="up-ro-label">' + label + '</span>'
      +   '<span class="up-ro-desc">' + desc + '</span>'
      + '</div>'
      + '</label>';
  },

  /* ═══ BIND ALL EVENTS ═══ */
  _bindEvents: function() {
    var self = this;

    /* ── Avatar grid toggle ── */
    var avBtn = document.getElementById('up-av-change');
    var avGrid = document.getElementById('up-av-grid');
    if (avBtn && avGrid) {
      avBtn.addEventListener('click', function() {
        var open = avGrid.style.display === 'none';
        avGrid.style.display = open ? 'grid' : 'none';
        avBtn.textContent = open ? 'Batal' : 'Ganti Avatar';
      });
    }

    /* ── Avatar selection ── */
    if (avGrid) {
      avGrid.addEventListener('click', function(e) {
        var item = e.target.closest('.up-av-item');
        if (!item) return;
        var av = item.dataset.av;
        avGrid.querySelectorAll('.up-av-item').forEach(function(el) { el.classList.remove('is-active'); });
        item.classList.add('is-active');
        self._saveAvatar(av);
      });
    }

    /* ── Username save + realtime validation ── */
    var saveNameBtn = document.getElementById('up-save-name');
    var nameInput = document.getElementById('up-username');
    var nameCounter = document.getElementById('up-username-counter');
    if (saveNameBtn && nameInput) {
      var initialName = (ANI.user.data && ANI.user.data.username) || '';
      var nameRe = /^[a-zA-Z_][a-zA-Z0-9_]{2,19}$/;
      var validateName = function() {
        var val = nameInput.value.trim();
        if (nameCounter) nameCounter.textContent = val.length + '/20';
        nameInput.classList.remove('is-valid', 'is-invalid');
        if (nameInput.disabled) { saveNameBtn.disabled = true; return; }
        if (!val || val === initialName) { saveNameBtn.disabled = true; return; }
        if (val.length < 3 || val.length > 20 || !nameRe.test(val)) {
          nameInput.classList.add('is-invalid');
          saveNameBtn.disabled = true;
        } else {
          nameInput.classList.add('is-valid');
          saveNameBtn.disabled = false;
        }
      };
      nameInput.addEventListener('input', validateName);
      validateName();
      saveNameBtn.addEventListener('click', function() {
        var val = nameInput.value.trim();
        if (!val || saveNameBtn.disabled) return;
        self._saveUsername(val);
      });
    }

    /* ── Side nav (scroll-spy + smooth scroll) ── */
    self._bindSideNav();

    /* ── Privacy toggles ── */
    var privacyInputs = document.querySelectorAll('input[data-privacy]');
    privacyInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        self._savePrivacy(input.dataset.privacy, input.checked, input);
      });
    });

    /* ── Export data ── */
    var exportBtn = document.getElementById('up-export-btn');
    if (exportBtn) {
      exportBtn.addEventListener('click', function() { self._exportData(exportBtn); });
    }

    /* ── Server radio ── */
    var srvGroup = document.getElementById('up-srv-group');
    if (srvGroup) {
      srvGroup.addEventListener('change', function(e) {
        if (e.target.name !== 'up-srv') return;
        srvGroup.querySelectorAll('.up-radio-card').forEach(function(c) { c.classList.remove('is-active'); });
        e.target.closest('.up-radio-card').classList.add('is-active');
        ANI.pref.setServer(e.target.value.toUpperCase());
        self._showToast('Server diubah ke ' + e.target.value.toUpperCase());
      });
    }

    /* ── Quality radio ── */
    var qualGroup = document.getElementById('up-qual-group');
    if (qualGroup) {
      qualGroup.addEventListener('change', function(e) {
        if (e.target.name !== 'up-qual') return;
        qualGroup.querySelectorAll('.up-radio-option').forEach(function(c) { c.classList.remove('is-active'); });
        e.target.closest('.up-radio-option').classList.add('is-active');
        ANI.pref.setQuality(e.target.value);
        var labels = { auto: 'Otomatis', hemat: 'Hemat Data', tertinggi: 'Tertinggi' };
        self._showToast('Kualitas diubah ke ' + (labels[e.target.value] || e.target.value));
      });
    }

    /* ── NSFW toggle ── */
    var nsfwToggle = document.getElementById('up-nsfw-toggle');
    if (nsfwToggle) {
      nsfwToggle.addEventListener('change', function() {
        var wantOn = nsfwToggle.checked;
        if (wantOn) {
          /* Tampilkan modal peringatan */
          nsfwToggle.checked = false; /* revert dulu */
          self._showNsfwModal(function() {
            nsfwToggle.checked = true;
            ANI.pref.setNsfw(true);
            self._showToast('Konten NSFW diaktifkan');
          });
        } else {
          ANI.pref.setNsfw(false);
          self._showToast('Konten NSFW dinonaktifkan');
        }
      });
    }

    /* ── Experimental toggle (admin-only) ── */
    var expToggle = document.getElementById('up-exp-toggle');
    if (expToggle) {
      expToggle.addEventListener('change', function() {
        var on = expToggle.checked;
        ANI.pref.setExperimental(on);
        self._showToast(on ? 'Mode Eksperimental aktif — refresh halaman untuk efek penuh' : 'Mode Eksperimental dinonaktifkan');
      });
    }

    /* ── Delete account ── */
    var deleteBtn = document.getElementById('up-delete-acct');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', function() { self._showDeleteModal(); });
    }
  },

  /* ═══ SAVE AVATAR ═══ */
  _saveAvatar: function(av) {
    var self = this;
    ANI.userApi.updateProfile({ avatar: av }).then(function(res) {
      ANI.user.data = res.user;
      try { localStorage.setItem('aneetaku_user', JSON.stringify(res.user)); } catch(e){}
      ANI.authUI.updateHeaderUI();
      /* Update preview */
      var preview = document.getElementById('up-av-preview');
      if (preview) {
        var url = ANI.user.avatarUrl();
        preview.innerHTML = url ? '<img src="' + ANI.util.esc(url) + '" />' : ANI.user.initial();
      }
      document.getElementById('up-av-grid').style.display = 'none';
      document.getElementById('up-av-change').textContent = 'Ganti Avatar';
      self._showToast('Avatar berhasil diubah');
    }).catch(function(err) { self._showToast(err.message, true); });
  },

  /* ═══ SAVE USERNAME ═══ */
  _saveUsername: function(name) {
    var self = this;
    ANI.userApi.updateProfile({ username: name }).then(function(res) {
      ANI.user.data = res.user;
      try { localStorage.setItem('aneetaku_user', JSON.stringify(res.user)); } catch(e){}
      ANI.authUI.updateHeaderUI();
      self._showToast('Username berhasil diubah');
      /* Re-render so cooldown state & meta refresh */
      try { self.renderProfile(); } catch(e){}
    }).catch(function(err) { self._showToast(err.message, true); });
  },

  /* ═══ SAVE PRIVACY ═══ */
  _savePrivacy: function(key, val, inputEl) {
    var self = this;
    var payload = {};
    payload[key] = !!val;
    if (inputEl) inputEl.disabled = true;
    ANI.userApi.updatePrivacy(payload).then(function(res) {
      if (ANI.user.data) {
        ANI.user.data.privacy = res.privacy || ANI.user.data.privacy || {};
        try { localStorage.setItem('aneetaku_user', JSON.stringify(ANI.user.data)); } catch(e){}
      }
      var labels = { profile: 'Profil', watchlist: 'Watchlist', history: 'Riwayat tonton' };
      self._showToast((labels[key] || key) + (val ? ' dibuat publik' : ' dijadikan privat'));
    }).catch(function(err) {
      if (inputEl) inputEl.checked = !val; /* revert */
      self._showToast(err.message, true);
    }).then(function() {
      if (inputEl) inputEl.disabled = false;
    });
  },

  /* ═══ EXPORT DATA ═══ */
  _exportData: function(btn) {
    var self = this;
    if (!btn) btn = document.getElementById('up-export-btn');
    var label = btn ? btn.querySelector('span') : null;
    var origText = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Menyiapkan…';

    ANI.userApi.exportData().then(function(res) {
      var url = URL.createObjectURL(res.blob);
      var a = document.createElement('a');
      a.href = url; a.download = res.filename;
      document.body.appendChild(a); a.click();
      setTimeout(function() { URL.revokeObjectURL(url); a.remove(); }, 100);
      self._showToast('Data berhasil di-download');
    }).catch(function(err) {
      self._showToast(err.message, true);
    }).then(function() {
      if (btn) btn.disabled = false;
      if (label) label.textContent = origText;
    });
  },

  /* ═══ SIDE NAV (scroll-spy + click) ═══ */
  _bindSideNav: function() {
    var nav = document.getElementById('up-sidenav');
    if (!nav) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('.up-sidenav__item[data-target]'));
    if (!items.length) return;

    var setActive = function(id) {
      items.forEach(function(it) {
        it.classList.toggle('is-active', it.dataset.target === id);
      });
    };

    items.forEach(function(it) {
      it.addEventListener('click', function() {
        var id = it.dataset.target;
        var target = document.getElementById(id);
        if (!target) return;
        setActive(id);
        var top = target.getBoundingClientRect().top + window.pageYOffset - 76;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    /* ── Expand / collapse toggle ── */
    var toggleBtn = document.getElementById('up-sidenav-toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var nowExpanded = !nav.classList.contains('is-expanded');
        nav.classList.toggle('is-expanded', nowExpanded);
        try { localStorage.setItem('aneetaku_sidenav_expanded', nowExpanded ? '1' : '0'); } catch(err) {}
        toggleBtn.setAttribute('title', nowExpanded ? 'Kecilkan menu' : 'Lebarkan menu');
        var lbl = toggleBtn.querySelector('.up-sidenav__label');
        if (lbl) lbl.textContent = nowExpanded ? 'Kecilkan' : 'Lebarkan';
      });
    }

    /* Scroll-spy via IntersectionObserver */
    if (typeof IntersectionObserver === 'undefined') return;
    var sections = items.map(function(it) { return document.getElementById(it.dataset.target); }).filter(Boolean);
    var io = new IntersectionObserver(function(entries) {
      var visible = entries.filter(function(e) { return e.isIntersecting; });
      if (!visible.length) return;
      visible.sort(function(a, b) { return a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top; });
      setActive(visible[0].target.id);
    }, { rootMargin: '-80px 0px -55% 0px', threshold: 0 });
    sections.forEach(function(s) { io.observe(s); });
    this._sidenavObserver = io;
  },

  /* ═══ NSFW CONFIRMATION MODAL ═══ */
  _showNsfwModal: function(onConfirm) {
    var overlay = document.createElement('div');
    overlay.className = 'auth-overlay';
    overlay.innerHTML =
      '<div class="auth-modal" style="max-width:420px">'
      + '<div class="up-nsfw-warn-icon">18+</div>'
      + '<h2 class="auth-modal__title">Konten Dewasa (18+)</h2>'
      + '<p class="auth-modal__desc">Dengan mengaktifkan ini, kamu menyatakan berusia 18 tahun atau lebih dan bersedia melihat konten yang mungkin tidak sesuai untuk semua usia.</p>'
      + '<div style="display:flex;gap:var(--s3);justify-content:center;margin-top:var(--s4)">'
      +   '<button class="up-btn-outline" id="nsfw-cancel">Batal</button>'
      +   '<button class="up-btn-danger" id="nsfw-confirm">Saya Mengerti, Aktifkan</button>'
      + '</div>'
      + '</div>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function() { overlay.classList.add('is-open'); });

    var close = function() {
      overlay.classList.remove('is-open');
      setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
    };

    document.getElementById('nsfw-cancel').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
    document.getElementById('nsfw-confirm').addEventListener('click', function() { close(); onConfirm(); });
  },

  /* ═══ DELETE ACCOUNT MODAL ═══ */
  _showDeleteModal: function() {
    var overlay = document.createElement('div');
    overlay.className = 'auth-overlay';
    overlay.innerHTML =
      '<div class="auth-modal" style="max-width:440px">'
      + '<h2 class="auth-modal__title" style="color:#f87171">Hapus Akun</h2>'
      + '<div class="up-delete-points">'
      +   '<p>Jika kamu melanjutkan:</p>'
      +   '<ul>'
      +     '<li>Semua data watchlist dan riwayat tontonan akan <strong>dihapus permanen</strong></li>'
      +     '<li>Pesan di komunitas akan <strong>dianonimkan</strong> (bukan dihapus)</li>'
      +     '<li>Aksi ini <strong>tidak bisa dibatalkan</strong></li>'
      +   '</ul>'
      + '</div>'
      + '<p class="auth-modal__desc">Ketik <strong>HAPUS AKUN</strong> di bawah untuk konfirmasi:</p>'
      + '<input class="up-input" id="del-confirm-input" placeholder="Ketik disini..." style="text-align:center;margin-bottom:var(--s4)" />'
      + '<div style="display:flex;gap:var(--s3);justify-content:center">'
      +   '<button class="up-btn-outline" id="del-cancel">Batal</button>'
      +   '<button class="up-btn-danger" id="del-confirm" disabled>Hapus Akun Saya</button>'
      + '</div>'
      + '</div>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function() { overlay.classList.add('is-open'); });

    var close = function() {
      overlay.classList.remove('is-open');
      setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
    };

    var confirmBtn = document.getElementById('del-confirm');
    var confirmInput = document.getElementById('del-confirm-input');
    confirmInput.addEventListener('input', function() {
      confirmBtn.disabled = confirmInput.value.trim() !== 'HAPUS AKUN';
    });

    document.getElementById('del-cancel').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });

    confirmBtn.addEventListener('click', function() {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Menghapus...';
      ANI.userApi.deleteAccount('HAPUS AKUN').then(function() {
        close();
        ANI.user.clear();
        ANI.authUI.updateHeaderUI();
        window.location.href = '/';
      }).catch(function(err) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Hapus Akun Saya';
        alert('Gagal: ' + err.message);
      });
    });
  },

  /* ═══ INLINE TOAST ═══ */
  _showToast: function(msg, isError) {
    if (ANI.authUI && ANI.authUI._showToast) {
      ANI.authUI._showToast(msg);
    }
  },

/* ═══════════════════════════════════════════════
   PATCH 3 — Tambahan ke Module 13 (user-pages.js)
   
   INSTRUKSI: Tambahkan 2 method baru ini ke ANI.userPages object.
   Paste SEBELUM closing }; dari ANI.userPages.
   ═══════════════════════════════════════════════ */

  /* ═══ WATCHLIST PAGE ═══ */
  renderWatchlist: function() {
    var self = this;
    if (!ANI.user.isLoggedIn()) {
      document.getElementById('app-content').innerHTML =
        '<div class="static-page-wrap" style="text-align:center;padding-top:80px">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>'
        + '<h2 style="margin-top:var(--s4)">Kamu belum masuk</h2>'
        + '<p style="color:var(--c-muted);margin-top:var(--s2)">Masuk terlebih dahulu untuk melihat watchlist.</p>'
        + '</div>';
      return;
    }

    var STATUS_MAP = {
      '': { label: 'Semua', icon: '' },
      'watching': { label: 'Sedang Ditonton', icon: '▶' },
      'completed': { label: 'Selesai', icon: '✓' },
      'on_hold': { label: 'Ditunda', icon: '⏸' },
      'dropped': { label: 'Diberhentikan', icon: '✕' },
      'plan_to_watch': { label: 'Rencana', icon: '📋' }
    };

    var currentStatus = '';
    var currentPage = 1;

    var html =
      '<div class="wl-wrap">'
      + '<div class="up-header"><h1>Watchlist</h1></div>'
      + '<div class="wl-tabs" id="wl-tabs">'
      +   '<button class="wl-tab is-active" data-status="">Semua</button>'
      +   '<button class="wl-tab" data-status="watching">Ditonton</button>'
      +   '<button class="wl-tab" data-status="completed">Selesai</button>'
      +   '<button class="wl-tab" data-status="on_hold">Ditunda</button>'
      +   '<button class="wl-tab" data-status="dropped">Drop</button>'
      +   '<button class="wl-tab" data-status="plan_to_watch">Rencana</button>'
      + '</div>'
      + '<div id="wl-count" class="wl-count"></div>'
      + '<div id="wl-list" class="wl-list"></div>'
      + '<div id="wl-loadmore" style="text-align:center;padding:var(--s4) 0"></div>'
      + '</div>';

    document.getElementById('app-content').innerHTML = html;

    function loadData(status, page, append) {
      currentStatus = status;
      currentPage = page;
      var listEl = document.getElementById('wl-list');
      var countEl = document.getElementById('wl-count');
      var moreEl = document.getElementById('wl-loadmore');

      if (!append) {
        listEl.innerHTML = '<div class="wl-skeleton"><div class="wl-sk-item"></div><div class="wl-sk-item"></div><div class="wl-sk-item"></div></div>';
      }

      ANI.userApi.getWatchlist(status, page, 20).then(function(res) {
        var items = res.data || [];
        if (countEl) countEl.textContent = res.total + ' anime';

        if (!append) listEl.innerHTML = '';

        if (items.length === 0 && page === 1) {
          listEl.innerHTML = '<div class="wl-empty">'
            + '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--c-faint)" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>'
            + '<p>Belum ada anime di kategori ini.</p>'
            + '</div>';
          moreEl.innerHTML = '';
          return;
        }

        var newHtml = items.map(function(item) {
          var coverUrl = item.cover ? ANI.util.driveThumb(item.cover, 200) : '';
          var statusInfo = STATUS_MAP[item.status] || { label: item.status, icon: '' };
          return '<a href="/anime/' + ANI.util.esc(item.anime_slug) + '" class="wl-item">'
            + '<div class="wl-item__cover">' + (coverUrl ? '<img src="' + ANI.util.esc(coverUrl) + '" alt="" loading="lazy" />' : '') + '</div>'
            + '<div class="wl-item__info">'
            +   '<div class="wl-item__title">' + ANI.util.esc(item.title) + '</div>'
            +   '<div class="wl-item__meta">'
            +     (item.type ? '<span class="wl-item__type">' + ANI.util.esc(item.type) + '</span>' : '')
            +     '<span class="wl-item__status wl-status--' + item.status + '">' + statusInfo.icon + ' ' + statusInfo.label + '</span>'
            +   '</div>'
            + '</div>'
            + '<button class="wl-item__remove" data-slug="' + ANI.util.esc(item.anime_slug) + '" title="Hapus dari watchlist">'
            +   '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
            + '</button>'
            + '</a>';
        }).join('');

        if (append) {
          listEl.insertAdjacentHTML('beforeend', newHtml);
        } else {
          listEl.innerHTML = newHtml;
        }

        /* Load more button */
        var totalLoaded = page * 20;
        if (totalLoaded < res.total) {
          moreEl.innerHTML = '<button class="up-btn-outline" id="wl-more-btn">Muat lebih banyak</button>';
          document.getElementById('wl-more-btn').addEventListener('click', function() {
            loadData(currentStatus, currentPage + 1, true);
          });
        } else {
          moreEl.innerHTML = '';
        }
      }).catch(function(err) {
        listEl.innerHTML = '<p style="color:var(--c-muted);text-align:center;padding:var(--s8)">Gagal memuat: ' + ANI.util.esc(err.message) + '</p>';
      });
    }

    /* Tab click */
    var tabsEl = document.getElementById('wl-tabs');
    if (tabsEl) {
      tabsEl.addEventListener('click', function(e) {
        var btn = e.target.closest('.wl-tab');
        if (!btn) return;
        tabsEl.querySelectorAll('.wl-tab').forEach(function(t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        loadData(btn.dataset.status, 1, false);
      });
    }

    /* Remove item (event delegation) */
    document.getElementById('wl-list').addEventListener('click', function(e) {
      var removeBtn = e.target.closest('.wl-item__remove');
      if (!removeBtn) return;
      e.preventDefault();
      e.stopPropagation();
      var slug = removeBtn.dataset.slug;
      if (!slug) return;
      removeBtn.closest('.wl-item').style.opacity = '0.3';
      ANI.userApi.removeWatchlist(slug).then(function() {
        loadData(currentStatus, 1, false);
        if (ANI.authUI && ANI.authUI._showToast) ANI.authUI._showToast('Dihapus dari watchlist');
      }).catch(function() {
        removeBtn.closest('.wl-item').style.opacity = '1';
      });
    });

    loadData('', 1, false);
  },

  /* ═══ HISTORY PAGE ═══ */
  renderHistory: function() {
    var self = this;
    if (!ANI.user.isLoggedIn()) {
      document.getElementById('app-content').innerHTML =
        '<div class="static-page-wrap" style="text-align:center;padding-top:80px">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
        + '<h2 style="margin-top:var(--s4)">Kamu belum masuk</h2>'
        + '<p style="color:var(--c-muted);margin-top:var(--s2)">Masuk terlebih dahulu untuk melihat riwayat tonton.</p>'
        + '</div>';
      return;
    }

    document.getElementById('app-content').innerHTML =
      '<div class="wl-wrap">'
      + '<div class="up-header"><h1>Riwayat Tonton</h1></div>'
      + '<div id="hist-list" class="wl-list"></div>'
      + '<div id="hist-loadmore" style="text-align:center;padding:var(--s4) 0"></div>'
      + '</div>';

    var currentPage = 1;

    function loadHistory(page, append) {
      currentPage = page;
      var listEl = document.getElementById('hist-list');
      var moreEl = document.getElementById('hist-loadmore');

      if (!append) {
        listEl.innerHTML = '<div class="wl-skeleton"><div class="wl-sk-item"></div><div class="wl-sk-item"></div><div class="wl-sk-item"></div></div>';
      }

      ANI.userApi.getHistory(page, 30).then(function(res) {
        var items = res.data || [];

        if (!append) listEl.innerHTML = '';

        if (items.length === 0 && page === 1) {
          listEl.innerHTML = '<div class="wl-empty">'
            + '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--c-faint)" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
            + '<p>Belum ada riwayat tonton.</p>'
            + '</div>';
          moreEl.innerHTML = '';
          return;
        }

        var newHtml = items.map(function(item) {
          var coverUrl = item.cover ? ANI.util.driveThumb(item.cover, 200) : '';
          var pctText = item.total_episodes > 0
            ? item.episodes_completed + '/' + item.total_episodes + ' episode'
            : item.episodes_completed + ' episode ditonton';
          var timeAgo = self._timeAgo(item.last_watched);

          return '<div class="hist-item" data-slug="' + ANI.util.esc(item.anime_slug) + '">'
            + '<a href="/anime/' + ANI.util.esc(item.anime_slug) + '" class="hist-item__main">'
            +   '<div class="wl-item__cover">' + (coverUrl ? '<img src="' + ANI.util.esc(coverUrl) + '" alt="" loading="lazy" />' : '') + '</div>'
            +   '<div class="wl-item__info">'
            +     '<div class="wl-item__title">' + ANI.util.esc(item.title) + '</div>'
            +     '<div class="wl-item__meta">'
            +       '<span>' + pctText + '</span>'
            +       '<span class="hist-time">' + timeAgo + '</span>'
            +     '</div>'
            +   '</div>'
            + '</a>'
            + '<button class="hist-expand-btn" data-slug="' + ANI.util.esc(item.anime_slug) + '">'
            +   '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>'
            + '</button>'
            + '<div class="hist-episodes" id="hist-ep-' + ANI.util.esc(item.anime_slug) + '" style="display:none"></div>'
            + '</div>';
        }).join('');

        if (append) {
          listEl.insertAdjacentHTML('beforeend', newHtml);
        } else {
          listEl.innerHTML = newHtml;
        }

        /* Load more */
        var totalLoaded = page * 30;
        if (totalLoaded < res.total) {
          moreEl.innerHTML = '<button class="up-btn-outline" id="hist-more-btn">Muat lebih banyak</button>';
          document.getElementById('hist-more-btn').addEventListener('click', function() {
            loadHistory(currentPage + 1, true);
          });
        } else {
          moreEl.innerHTML = '';
        }
      }).catch(function(err) {
        listEl.innerHTML = '<p style="color:var(--c-muted);text-align:center;padding:var(--s8)">Gagal memuat: ' + ANI.util.esc(err.message) + '</p>';
      });
    }

    /* Expand/collapse episode detail */
    document.getElementById('hist-list').addEventListener('click', function(e) {
      var expandBtn = e.target.closest('.hist-expand-btn');
      if (!expandBtn) return;
      var slug = expandBtn.dataset.slug;
      var epPanel = document.getElementById('hist-ep-' + slug);
      if (!epPanel) return;

      var isOpen = epPanel.style.display !== 'none';
      if (isOpen) {
        epPanel.style.display = 'none';
        expandBtn.classList.remove('is-open');
        return;
      }

      expandBtn.classList.add('is-open');
      epPanel.style.display = 'block';
      epPanel.innerHTML = '<div style="padding:var(--s3);color:var(--c-muted);font-size:.75rem">Memuat...</div>';

      ANI.userApi.getHistoryBySlug(slug).then(function(res) {
        var eps = res.episodes || [];
        if (eps.length === 0) {
          epPanel.innerHTML = '<div style="padding:var(--s3);color:var(--c-faint);font-size:.75rem">Tidak ada data episode.</div>';
          return;
        }
        epPanel.innerHTML = eps.map(function(ep) {
          var pct = ep.duration > 0 ? Math.round(ep.position / ep.duration * 100) : 0;
          if (ep.completed) pct = 100;
          return '<a href="/anime/' + ANI.util.esc(slug) + '?ep=' + ep.episode_num + '" class="hist-ep-row">'
            + '<span class="hist-ep-num">Ep ' + ep.episode_num + '</span>'
            + '<div class="hist-ep-bar"><div class="hist-ep-bar__fill" style="width:' + pct + '%"></div></div>'
            + '<span class="hist-ep-pct">' + pct + '%</span>'
            + (ep.completed ? '<span class="hist-ep-done">✓</span>' : '')
            + '</a>';
        }).join('');
      }).catch(function() {
        epPanel.innerHTML = '<div style="padding:var(--s3);color:#f87171;font-size:.75rem">Gagal memuat episode.</div>';
      });
    });

    loadHistory(1, false);
  },

  /* ═══ TIME AGO HELPER ═══ */
  _timeAgo: function(dateStr) {
    if (!dateStr) return '';
    var now = Date.now();
    var then = new Date(dateStr + (dateStr.indexOf('Z') === -1 ? 'Z' : '')).getTime();
    var diff = Math.floor((now - then) / 1000);
    if (diff < 60) return 'Baru saja';
    if (diff < 3600) return Math.floor(diff / 60) + ' menit lalu';
    if (diff < 86400) return Math.floor(diff / 3600) + ' jam lalu';
    if (diff < 2592000) return Math.floor(diff / 86400) + ' hari lalu';
    return Math.floor(diff / 2592000) + ' bulan lalu';
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 14: Komunitas (Real-time Chat) — v2
   
   REPLACE TOTAL module 14 yang ada di app.js.
   
   Perubahan dari v1:
   - Own messages aligned right (chat app style)
   - Reply shows original content + click to jump
   - Slash command menu (/spoiler, /img)
   - Emoji reactions per message
   - Better placeholder hint
   - Color optimizations via CSS
   ═══════════════════════════════════════════════ */

ANI.komunitas = {
  _WS_BASE: 'wss://chat.aneetaku.cloud',
  _HTTP_BASE: 'https://chat.aneetaku.cloud',
  _ws: null,
  _room: 'chat',
  _reconnectDelay: 1000,
  _reconnectTimer: null,
  _typingTimer: null,
  _typingUsers: {},
  _replyTo: null,
  _replyData: null, /* { id, username, text } */
  _messages: [],
  _oldestMsgId: null,
  _loadingMore: false,
  _hasMore: true,
  _imgUploading: false,
  _cmdMenuOpen: false,

  REACTIONS: ['\ud83d\udc4d', '\u2764\ufe0f', '\ud83d\ude02', '\ud83d\ude2e', '\ud83d\ude22', '\ud83d\udd25', '\ud83d\udc4e', '\ud83d\udcaf'],
  COMMANDS: [
    { cmd: '/spoiler', desc: 'Kirim pesan tersembunyi (spoiler)', usage: '/spoiler [pesan]' },
    { cmd: '/img', desc: 'Upload gambar dari perangkat', usage: '/img' }
  ],

  /* ═══ INIT ═══ */
  init: function(room) {
    var self = this;
    self._room = room || 'chat';
    self._messages = [];
    self._oldestMsgId = null;
    self._hasMore = true;
    self._replyTo = null;
    self._replyData = null;

    if (!ANI.user.isLoggedIn()) {
      document.getElementById('app-content').innerHTML =
        '<div class="static-page-wrap" style="text-align:center;padding-top:80px">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5" style="margin:0 auto"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>'
        + '<h2 style="margin-top:var(--s4)">Masuk untuk bergabung</h2>'
        + '<p style="color:var(--c-muted);margin-top:var(--s2)">Masuk terlebih dahulu untuk mengakses komunitas.</p>'
        + '<button class="btn-primary" style="margin-top:var(--s4)" onclick="ANI.authUI.showLoginModal()">Masuk dengan Google</button>'
        + '</div>';
      return;
    }

    var roomTabs = [
      { id: 'chat', label: '#chat', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>' },
      { id: 'lapor-error', label: '#lapor-error', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' },
      { id: 'request-anime', label: '#request', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>' }
    ];

    var tabsHtml = roomTabs.map(function(t) {
      var active = t.id === self._room ? ' is-active' : '';
      var disabled = '';
      return '<button class="km-tab' + active + disabled + '" data-room="' + t.id + '">'
        + t.icon + '<span>' + t.label + '</span>'
        + ''
        + '</button>';
    }).join('');

    document.getElementById('app-content').innerHTML =
      '<div class="km-wrap">'
      + '<div class="km-header">'
      +   '<h1>Komunitas</h1>'
      +   '<div class="km-online" id="km-online"><span class="km-online-dot"></span><span id="km-online-count">0</span> online</div>'
      + '</div>'
      + '<div class="km-tabs">' + tabsHtml + '</div>'
      + '<div class="km-chat" id="km-chat">'
      +   '<div class="km-messages" id="km-messages">'
      +     '<div class="km-loading" id="km-init-loading"><div class="spinner"></div><span>Menghubungkan...</span></div>'
      +   '</div>'
      +   '<div class="km-reply-bar" id="km-reply-bar" style="display:none">'
      +     '<div class="km-reply-preview">'
      +       '<span class="km-reply-name" id="km-reply-name"></span>'
      +       '<span class="km-reply-snippet" id="km-reply-snippet"></span>'
      +     '</div>'
      +     '<button class="km-reply-close" id="km-reply-close"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>'
      +   '</div>'
      +   '<div class="km-cmd-menu" id="km-cmd-menu" style="display:none"></div>'
      +   '<button class="km-scroll-btn" id="km-scroll-btn" style="display:none" title="Ke pesan terbaru"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg></button>'
      +   '<div class="km-input-bar">'
      +     '<button class="km-clip-btn" id="km-clip-btn" title="Upload gambar">'
      +       '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>'
      +     '</button>'
      +     '<input type="file" id="km-file-input" accept="image/jpeg,image/png,image/gif,image/webp" style="display:none" />'
      +     '<input class="km-input" id="km-input" type="text" placeholder="Ketik pesan atau / untuk command..." maxlength="1000" autocomplete="off" />'
      +     '<button class="km-send-btn" id="km-send-btn" title="Kirim">'
      +       '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>'
      +     '</button>'
      +   '</div>'
      + '</div>'
      + '</div>';

    self._bindEvents();
    self._connect();
  },

  /* ═══ BIND UI ═══ */
  _bindEvents: function() {
    var self = this;

    /* Tab click */
    document.querySelector('.km-tabs').addEventListener('click', function(e) {
      var tab = e.target.closest('.km-tab');
      if (!tab) return;
      var room = tab.dataset.room;
      if (room === self._room) return;
      self._disconnect();
      self._switchRoom(room);
    });

    /* Send */
    var input = document.getElementById('km-input');
    var sendBtn = document.getElementById('km-send-btn');
    sendBtn.addEventListener('click', function() { self._sendText(); });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); self._sendText(); }
      if (e.key === 'Escape') { self._closeCmdMenu(); }
    });

    /* Slash command menu */
    input.addEventListener('input', function() {
      var val = input.value;
      if (val === '/') {
        self._showCmdMenu();
      } else if (val.charAt(0) === '/' && val.indexOf(' ') === -1) {
        self._filterCmdMenu(val);
      } else {
        self._closeCmdMenu();
      }
      /* Typing indicator */
      if (self._ws && self._ws.readyState === 1) {
        clearTimeout(self._typingTimer);
        self._ws.send(JSON.stringify({ type: 'typing' }));
      }
    });

    /* Reply close */
    document.getElementById('km-reply-close').addEventListener('click', function() {
      self._replyTo = null;
      self._replyData = null;
      document.getElementById('km-reply-bar').style.display = 'none';
    });

    /* Image upload */
    document.getElementById('km-clip-btn').addEventListener('click', function() {
      document.getElementById('km-file-input').click();
    });
    document.getElementById('km-file-input').addEventListener('change', function(e) {
      var file = e.target.files && e.target.files[0];
      if (file) self._uploadImage(file);
      e.target.value = '';
    });

   /* Scroll: load older + show/hide scroll-to-bottom */
    var msgContainer = document.getElementById('km-messages');
    var scrollBtn = document.getElementById('km-scroll-btn');
    msgContainer.addEventListener('scroll', function() {
      if (msgContainer.scrollTop < 100 && self._hasMore && !self._loadingMore) {
        self._loadOlder();
      }
      /* Show/hide scroll-to-bottom button */
      var distFromBottom = msgContainer.scrollHeight - msgContainer.scrollTop - msgContainer.clientHeight;
      if (scrollBtn) scrollBtn.style.display = distFromBottom > 300 ? 'flex' : 'none';
    });
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function() {
        self._scrollBottom();
        scrollBtn.style.display = 'none';
      });
    }
    msgContainer.addEventListener('scroll', function() {
      if (msgContainer.scrollTop < 100 && self._hasMore && !self._loadingMore) {
        self._loadOlder();
      }
    });

    /* Message interactions: reply, delete, reaction, spoiler, jump-to-reply */
    msgContainer.addEventListener('click', function(e) {
      /* Reply button */
      var replyBtn = e.target.closest('.km-msg-reply');
      if (replyBtn) {
        var msgEl = replyBtn.closest('.km-msg');
        var msgId = msgEl.dataset.id;
        var msgUser = msgEl.querySelector('.km-msg-name');
        var msgText = msgEl.querySelector('.km-msg-text');
        self._replyTo = msgId;
        self._replyData = {
          id: msgId,
          username: msgUser ? msgUser.textContent : '',
          text: msgText ? msgText.textContent.substring(0, 80) : '[gambar]'
        };
        document.getElementById('km-reply-name').textContent = self._replyData.username;
        document.getElementById('km-reply-snippet').textContent = self._replyData.text;
        document.getElementById('km-reply-bar').style.display = 'flex';
        document.getElementById('km-input').focus();
        return;
      }

      /* Delete button */
      var delBtn = e.target.closest('.km-msg-delete');
      if (delBtn) {
        var delId = delBtn.closest('.km-msg').dataset.id;
        if (confirm('Hapus pesan ini?')) {
          self._ws.send(JSON.stringify({ type: 'delete', message_id: delId }));
        }
        return;
      }

      /* Reaction button - toggle picker */
      var reactBtn = e.target.closest('.km-msg-react');
      if (reactBtn) {
        var reactMsgEl = reactBtn.closest('.km-msg');
        self._toggleReactionPicker(reactMsgEl);
        return;
      }

      /* Reaction pill click (toggle own reaction) */
      var pill = e.target.closest('.km-react-pill');
      if (pill) {
        var pillMsgId = pill.closest('.km-msg').dataset.id;
        var emoji = pill.dataset.emoji;
        if (self._ws && self._ws.readyState === 1) {
          self._ws.send(JSON.stringify({ type: 'react', message_id: pillMsgId, emoji: emoji }));
        }
        return;
      }

      /* Emoji in picker */
      var emojiBtn = e.target.closest('.km-picker-emoji');
      if (emojiBtn) {
        var pickerMsgId = emojiBtn.closest('.km-msg').dataset.id;
        var pickedEmoji = emojiBtn.dataset.emoji;
        if (self._ws && self._ws.readyState === 1) {
          self._ws.send(JSON.stringify({ type: 'react', message_id: pickerMsgId, emoji: pickedEmoji }));
        }
        self._closeReactionPickers();
        return;
      }

      /* Spoiler reveal */
      var spoiler = e.target.closest('.km-spoiler');
      if (spoiler && !spoiler.classList.contains('is-revealed')) {
        spoiler.classList.add('is-revealed');
        return;
      }

      /* Click reply indicator to jump */
      var replyInd = e.target.closest('.km-reply-ref');
      if (replyInd) {
        var targetId = replyInd.dataset.reply;
        var targetEl = document.querySelector('.km-msg[data-id="' + targetId + '"]');
        if (targetEl) {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          targetEl.classList.add('km-msg--flash');
          setTimeout(function() { targetEl.classList.remove('km-msg--flash'); }, 1500);
        }
        return;
      }

      /* Close reaction pickers on outside click */
      if (!e.target.closest('.km-reaction-picker') && !e.target.closest('.km-msg-react')) {
        self._closeReactionPickers();
      }
    });

    /* Command menu click */
    document.getElementById('km-cmd-menu').addEventListener('click', function(e) {
      var item = e.target.closest('.km-cmd-item');
      if (!item) return;
      var cmd = item.dataset.cmd;
      var input = document.getElementById('km-input');
      if (cmd === '/img') {
        document.getElementById('km-file-input').click();
        input.value = '';
      } else {
        input.value = cmd + ' ';
        input.focus();
      }
      self._closeCmdMenu();
    });

    /* Mobile keyboard fix: resize input bar to visual viewport */
    if (window.visualViewport) {
      var wrap = document.querySelector('.km-wrap');
      window.visualViewport.addEventListener('resize', function() {
        var vvh = window.visualViewport.height;
        var offset = window.innerHeight - vvh;
        if (offset > 50) {
          wrap.style.height = vvh + 'px';
          wrap.style.position = 'fixed';
          wrap.style.top = window.visualViewport.offsetTop + 'px';
          wrap.style.left = '0';
          wrap.style.right = '0';
          wrap.style.background = 'var(--c-bg)';
          wrap.style.zIndex = '100';
          self._scrollBottom();
        } else {
          wrap.style.height = '';
          wrap.style.position = '';
          wrap.style.top = '';
          wrap.style.left = '';
          wrap.style.right = '';
          wrap.style.background = '';
          wrap.style.zIndex = '';
        }
      });
      window.visualViewport.addEventListener('scroll', function() {
        var offset = window.innerHeight - window.visualViewport.height;
        if (offset > 50) {
          wrap.style.top = window.visualViewport.offsetTop + 'px';
        }
      });
    }
  },

  /* ═══ COMMAND MENU ═══ */
  _showCmdMenu: function() {
    var self = this;
    var menu = document.getElementById('km-cmd-menu');
    menu.innerHTML = self.COMMANDS.map(function(c) {
      return '<div class="km-cmd-item" data-cmd="' + c.cmd + '">'
        + '<span class="km-cmd-name">' + c.cmd + '</span>'
        + '<span class="km-cmd-desc">' + c.desc + '</span>'
        + '</div>';
    }).join('');
    menu.style.display = 'block';
    self._cmdMenuOpen = true;
  },

  _filterCmdMenu: function(partial) {
    var self = this;
    var menu = document.getElementById('km-cmd-menu');
    var filtered = self.COMMANDS.filter(function(c) { return c.cmd.indexOf(partial) === 0; });
    if (filtered.length === 0) { self._closeCmdMenu(); return; }
    menu.innerHTML = filtered.map(function(c) {
      return '<div class="km-cmd-item" data-cmd="' + c.cmd + '">'
        + '<span class="km-cmd-name">' + c.cmd + '</span>'
        + '<span class="km-cmd-desc">' + c.desc + '</span>'
        + '</div>';
    }).join('');
    menu.style.display = 'block';
    self._cmdMenuOpen = true;
  },

  _closeCmdMenu: function() {
    document.getElementById('km-cmd-menu').style.display = 'none';
    this._cmdMenuOpen = false;
  },

  /* ═══ REACTION PICKER ═══ */
  _toggleReactionPicker: function(msgEl) {
    var self = this;
    var existing = msgEl.querySelector('.km-reaction-picker');
    if (existing) { existing.remove(); return; }
    self._closeReactionPickers();
    var picker = document.createElement('div');
    picker.className = 'km-reaction-picker';
    picker.innerHTML = self.REACTIONS.map(function(e) {
      return '<button class="km-picker-emoji" data-emoji="' + e + '">' + e + '</button>';
    }).join('');
    msgEl.querySelector('.km-msg-body').appendChild(picker);
  },

  _closeReactionPickers: function() {
    document.querySelectorAll('.km-reaction-picker').forEach(function(p) { p.remove(); });
  },

  /* ═══ WEBSOCKET ═══ */
  _connect: function() {
    var self = this;
    if (self._ws) self._disconnect();
    var token = ANI.user.token;
    if (!token) return;
    var wsUrl = self._WS_BASE + '/ws/room/' + self._room + '?token=' + encodeURIComponent(token);
    var ws = new WebSocket(wsUrl);
    self._ws = ws;
    ws.onopen = function() { self._reconnectDelay = 1000; };
    ws.onmessage = function(e) {
      try { self._handleServerMessage(JSON.parse(e.data)); } catch (err) {}
    };
    ws.onclose = function() {
      self._ws = null;
      self._reconnectTimer = setTimeout(function() {
        if (document.querySelector('.km-wrap')) self._connect();
      }, self._reconnectDelay);
      self._reconnectDelay = Math.min(self._reconnectDelay * 2, 30000);
    };
    ws.onerror = function() {};
  },

  _disconnect: function() {
    clearTimeout(this._reconnectTimer);
    if (this._ws) { try { this._ws.close(); } catch (e) {} this._ws = null; }
  },

  /* ═══ SERVER MESSAGES ═══ */
  _handleServerMessage: function(data) {
    var self = this;
    switch (data.type) {
      case 'init':
        var initLoading = document.getElementById('km-init-loading');
        if (initLoading) initLoading.remove();
        self._messages = data.messages || [];
        if (self._messages.length > 0) self._oldestMsgId = self._messages[0].id;
        self._renderMessages(self._messages, false);
        self._scrollBottom();
        break;
      case 'message':
        self._messages.push(data.data);
        self._appendMessage(data.data);
        self._scrollBottomIfNear();
        break;
      case 'online':
        var countEl = document.getElementById('km-online-count');
        if (countEl) countEl.textContent = data.count || 0;
        break;
      case 'typing':
        self._showTyping(data.user);
        break;
      case 'delete':
        var msgEl = document.querySelector('.km-msg[data-id="' + data.message_id + '"]');
        if (msgEl) { msgEl.style.opacity = '0'; setTimeout(function() { if (msgEl.parentNode) msgEl.parentNode.removeChild(msgEl); }, 300); }
        break;
      case 'reactions':
        self._updateReactions(data.message_id, data.reactions);
        break;
      case 'error':
        self._showChatToast(data.message || 'Error');
        break;
    }
  },

  /* ═══ RENDER ═══ */
  _renderMessages: function(msgs, prepend) {
    var self = this;
    var container = document.getElementById('km-messages');
    if (!container) return;
    var html = msgs.map(function(m) { return self._msgHtml(m); }).join('');
    if (prepend) {
      var scrollBefore = container.scrollHeight;
      container.insertAdjacentHTML('afterbegin', html);
      container.scrollTop = container.scrollHeight - scrollBefore;
    } else {
      container.innerHTML = html;
    }
  },

  _appendMessage: function(msg) {
    var container = document.getElementById('km-messages');
    if (!container) return;
    container.insertAdjacentHTML('beforeend', this._msgHtml(msg));
  },

  _msgHtml: function(m) {
    var self = this;
    var u = m.user || {};
    var myId = ANI.user.data ? ANI.user.data.id : '';
    var isOwn = u.id === myId;
    var canDelete = isOwn || ANI.user.isAdmin() || ANI.user.isMod();

    /* Avatar */
    var avatarUrl = '';
    if (u.avatar === 'google' && u.google_avatar) avatarUrl = u.google_avatar;
    else if (u.avatar && u.avatar !== 'google') avatarUrl = '/assets/avatars/' + u.avatar + '.webp';
    var avatarHtml = avatarUrl
      ? '<img src="' + ANI.util.esc(avatarUrl) + '" alt="" onerror="this.style.display=\'none\'" />'
      : '<span>' + (u.username ? u.username.charAt(0).toUpperCase() : 'A') + '</span>';

    /* Role badge */
    var roleBadge = '';
    if (u.role === 'admin') roleBadge = '<span class="km-badge km-badge--admin">Admin</span>';
    else if (u.role === 'mod') roleBadge = '<span class="km-badge km-badge--mod">Mod</span>';

    /* Content */
    var content = m.content || {};
    var bodyHtml = '';
    if (content.type === 'text') {
      bodyHtml = '<div class="km-msg-text">' + self._formatText(content.text || '') + '</div>';
    } else if (content.type === 'spoiler') {
      bodyHtml = '<div class="km-spoiler" title="Klik untuk membuka spoiler"><div class="km-spoiler-label"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>Spoiler</div><div class="km-spoiler-text">' + ANI.util.esc(content.text || '') + '</div></div>';
    } else if (content.type === 'image') {
      bodyHtml = '<div class="km-msg-img"><img src="' + ANI.util.esc(content.url || '') + '" alt="Gambar" loading="lazy" onclick="window.open(this.src)" /></div>';
    }

    /* Reply reference (Discord-style) */
    var replyHtml = '';
    if (m.reply_to) {
      var replyMsg = self._findMessage(m.reply_to);
      if (replyMsg) {
        var ru = replyMsg.user || {};
        var rText = '';
        if (replyMsg.content) {
          if (replyMsg.content.type === 'image') rText = '[Gambar]';
          else rText = (replyMsg.content.text || '').substring(0, 60);
          if ((replyMsg.content.text || '').length > 60) rText += '...';
        }
        replyHtml = '<div class="km-reply-ref" data-reply="' + ANI.util.esc(m.reply_to) + '">'
          + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg>'
          + '<span class="km-reply-ref-name">' + ANI.util.esc(ru.username || 'Anonim') + '</span>'
          + '<span class="km-reply-ref-text">' + ANI.util.esc(rText) + '</span>'
          + '</div>';
      } else {
        replyHtml = '<div class="km-reply-ref" data-reply="' + ANI.util.esc(m.reply_to) + '">'
          + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg>'
          + '<span class="km-reply-ref-text" style="font-style:italic">Pesan tidak ditemukan</span>'
          + '</div>';
      }
    }

    /* Timestamp */
    var timeStr = '';
    if (m.created_at) {
      try {
        var d = new Date(m.created_at + (m.created_at.indexOf('Z') === -1 ? 'Z' : ''));
        timeStr = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
      } catch (e) {}
    }

    /* Actions */
    var actionsHtml = '<div class="km-msg-actions">'
      + '<button class="km-msg-react" title="Reaksi"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg></button>'
      + '<button class="km-msg-reply" title="Balas"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg></button>'
      + (canDelete ? '<button class="km-msg-delete" title="Hapus"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>' : '')
      + '</div>';

    /* Reactions */
    var reactionsHtml = '';
    if (m.reactions && m.reactions.length) {
      reactionsHtml = '<div class="km-reactions">' + m.reactions.map(function(r) {
        var isMine = r.users && r.users.indexOf(myId) !== -1;
        return '<button class="km-react-pill' + (isMine ? ' is-mine' : '') + '" data-emoji="' + r.emoji + '">'
          + r.emoji + '<span class="km-react-count">' + r.count + '</span>'
          + '</button>';
      }).join('') + '</div>';
    }

    return '<div class="km-msg' + (isOwn ? ' km-msg--own' : '') + '" data-id="' + ANI.util.esc(m.id) + '">'
      + '<div class="km-msg-avatar">' + avatarHtml + '</div>'
      + '<div class="km-msg-body">'
      +   '<div class="km-msg-header">'
      +     '<span class="km-msg-name' + (isOwn ? ' km-msg-name--own' : '') + '">' + ANI.util.esc(u.username || 'Anonim') + '</span>'
      +     roleBadge
      +     '<span class="km-msg-time">' + timeStr + '</span>'
      +     actionsHtml
      +   '</div>'
      +   replyHtml
      +   bodyHtml
      +   reactionsHtml
      + '</div>'
      + '</div>';
  },

  _formatText: function(text) {
    var safe = ANI.util.esc(text);
    safe = safe.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener" class="km-link">$1</a>');
    safe = safe.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    safe = safe.replace(/\*(.+?)\*/g, '<em>$1</em>');
    safe = safe.replace(/`(.+?)`/g, '<code class="km-code">$1</code>');
    return safe;
  },

  _findMessage: function(id) {
    for (var i = 0; i < this._messages.length; i++) {
      if (this._messages[i].id === id) return this._messages[i];
    }
    return null;
  },

  /* ═══ UPDATE REACTIONS IN-PLACE ═══ */
  _updateReactions: function(msgId, reactions) {
    var self = this;
    var myId = ANI.user.data ? ANI.user.data.id : '';
    /* Update in-memory */
    for (var i = 0; i < self._messages.length; i++) {
      if (self._messages[i].id === msgId) { self._messages[i].reactions = reactions; break; }
    }
    /* Update DOM */
    var msgEl = document.querySelector('.km-msg[data-id="' + msgId + '"]');
    if (!msgEl) return;
    var body = msgEl.querySelector('.km-msg-body');
    var oldReacts = msgEl.querySelector('.km-reactions');
    if (oldReacts) oldReacts.remove();
    if (reactions && reactions.length) {
      var html = '<div class="km-reactions">' + reactions.map(function(r) {
        var isMine = r.users && r.users.indexOf(myId) !== -1;
        return '<button class="km-react-pill' + (isMine ? ' is-mine' : '') + '" data-emoji="' + r.emoji + '">'
          + r.emoji + '<span class="km-react-count">' + r.count + '</span>'
          + '</button>';
      }).join('') + '</div>';
      body.insertAdjacentHTML('beforeend', html);
    }
  },

  /* ═══ SEND ═══ */
  _sendText: function() {
    var self = this;
    var input = document.getElementById('km-input');
    if (!input) return;
    var text = input.value.trim();
    if (!text || !self._ws || self._ws.readyState !== 1) return;

    /* /img command */
    if (text === '/img') {
      document.getElementById('km-file-input').click();
      input.value = '';
      return;
    }

    var contentType = 'text';
    if (text.indexOf('/spoiler ') === 0) { text = text.substring(9).trim(); contentType = 'spoiler'; }

    var msg = { type: 'message', content: { type: contentType, text: text } };
    if (self._replyTo) {
      msg.reply_to = self._replyTo;
      self._replyTo = null;
      self._replyData = null;
      document.getElementById('km-reply-bar').style.display = 'none';
    }
    self._ws.send(JSON.stringify(msg));
    input.value = '';
    input.focus();
  },

  /* ═══ UPLOAD IMAGE ═══ */
  _uploadImage: function(file) {
    var self = this;
    if (self._imgUploading) return;
    if (file.size > 32 * 1024 * 1024) { self._showChatToast('Gambar terlalu besar (max 32 MB)'); return; }
    self._imgUploading = true;
    var clipBtn = document.getElementById('km-clip-btn');
    if (clipBtn) clipBtn.classList.add('is-uploading');
    var form = new FormData();
    form.append('source', file);
    fetch(self._HTTP_BASE + '/upload', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + (ANI.user.token || '') },
      body: form
    }).then(function(r) { return r.json(); }).then(function(res) {
      self._imgUploading = false;
      if (clipBtn) clipBtn.classList.remove('is-uploading');
      if (res && res.url) {
        var msg = { type: 'message', content: { type: 'image', url: res.url } };
        if (self._replyTo) { msg.reply_to = self._replyTo; self._replyTo = null; self._replyData = null; document.getElementById('km-reply-bar').style.display = 'none'; }
        if (self._ws && self._ws.readyState === 1) self._ws.send(JSON.stringify(msg));
      } else { self._showChatToast(res.error || 'Upload gagal'); }
    }).catch(function() {
      self._imgUploading = false;
      if (clipBtn) clipBtn.classList.remove('is-uploading');
      self._showChatToast('Upload gagal, coba lagi');
    });
  },

  /* ═══ LOAD OLDER ═══ */
  _loadOlder: function() {
    var self = this;
    if (!self._oldestMsgId || self._loadingMore || !self._hasMore) return;
    self._loadingMore = true;
    var container = document.getElementById('km-messages');
    container.insertAdjacentHTML('afterbegin', '<div class="km-loading-more" id="km-loading-more"><div class="spinner" style="width:20px;height:20px"></div></div>');
    fetch(self._HTTP_BASE + '/rooms/' + self._room + '/messages?before=' + encodeURIComponent(self._oldestMsgId) + '&limit=50')
      .then(function(r) { return r.json(); })
      .then(function(res) {
        var msgs = res.data || [];
        var el = document.getElementById('km-loading-more');
        if (el) el.remove();
        self._loadingMore = false;
        if (msgs.length === 0) { self._hasMore = false; return; }
        if (msgs.length < 50) self._hasMore = false;
        self._oldestMsgId = msgs[0].id;
        self._messages = msgs.concat(self._messages);
        self._renderMessages(msgs, true);
      }).catch(function() {
        var el = document.getElementById('km-loading-more'); if (el) el.remove(); self._loadingMore = false;
      });
  },

  /* ═══ TYPING ═══ */
  _showTyping: function(username) {
    var self = this;
    self._typingUsers[username] = Date.now();
    var container = document.getElementById('km-messages');
    if (!container) return;
    var el = document.getElementById('km-typing');
    if (!el) { el = document.createElement('div'); el.id = 'km-typing'; el.className = 'km-typing'; container.appendChild(el); }
    var names = [];
    var now = Date.now();
    for (var key in self._typingUsers) { if (now - self._typingUsers[key] < 3000) names.push(key); else delete self._typingUsers[key]; }
    if (names.length === 0) { el.remove(); return; }
    el.innerHTML = '<span class="km-typing-dots"><span></span><span></span><span></span></span><span>' + ANI.util.esc(names.join(', ')) + ' sedang mengetik...</span>';
    setTimeout(function() {
      var now2 = Date.now(); var active = false;
      for (var k in self._typingUsers) { if (now2 - self._typingUsers[k] < 3000) { active = true; break; } }
      if (!active) { var te = document.getElementById('km-typing'); if (te) te.remove(); }
    }, 3200);
  },

  /* ═══ HELPERS ═══ */
  _scrollBottom: function() { var c = document.getElementById('km-messages'); if (c) c.scrollTop = c.scrollHeight; },
  _scrollBottomIfNear: function() { var c = document.getElementById('km-messages'); if (!c) return; if (c.scrollHeight - c.scrollTop - c.clientHeight < 150) c.scrollTop = c.scrollHeight; },
  _showChatToast: function(msg) { if (ANI.authUI && ANI.authUI._showToast) ANI.authUI._showToast(msg); },
  destroy: function() { this._disconnect(); this._messages = []; this._typingUsers = {}; this._replyTo = null; this._replyData = null; },
   // ═══════════════════════════════════════════════
// PATCH 4c — Tambahan ke ANI.komunitas (Module 14)
//
// Tambahkan methods ini SEBELUM closing }; dari ANI.komunitas
// Setelah method destroy yang sudah ada
//
// JUGA: edit init() dan _bindEvents() — lihat PATCH GUIDE
// ═══════════════════════════════════════════════

  /* ═══ LAPOR-ERROR ROOM ═══ */
  _renderLaporRoom: function() {
    var self = this;
    self._disconnect();
    var container = document.getElementById('km-chat');
    if (!container) return;

    container.innerHTML =
      '<div class="km-room-content" id="km-room-content">'
      + '<div class="km-room-toolbar">'
      +   '<div class="km-filter-pills">'
      +     '<button class="km-pill is-active" data-filter="">Semua</button>'
      +     '<button class="km-pill" data-filter="open">Open</button>'
      +     '<button class="km-pill" data-filter="handling">Ditangani</button>'
      +     '<button class="km-pill" data-filter="resolved">Selesai</button>'
      +   '</div>'
      +   '<button class="km-room-btn" id="km-lapor-btn"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>Buat Laporan</button>'
      + '</div>'
      + '<div class="km-room-form" id="km-lapor-form" style="display:none">'
      +   '<div class="km-form-title">Laporkan Error</div>'
      +   '<div class="km-form-row">'
      +     '<label>Cari Anime</label>'
      +     '<input type="text" id="km-lapor-search" placeholder="Ketik judul anime..." class="km-form-input" />'
      +     '<div id="km-lapor-results" class="km-search-results" style="display:none"></div>'
      +     '<div id="km-lapor-selected" class="km-selected-anime" style="display:none"></div>'
      +   '</div>'
      +   '<div class="km-form-row">'
      +     '<label>Episode</label>'
      +     '<input type="number" id="km-lapor-ep" placeholder="Nomor episode" class="km-form-input" min="0" />'
      +   '</div>'
      +   '<div class="km-form-row">'
      +     '<label>Jenis Error</label>'
      +     '<div class="km-radio-group" id="km-lapor-type">'
      +       '<label class="km-radio"><input type="radio" name="km-err-type" value="video" checked /><span>Video tidak bisa diputar</span></label>'
      +       '<label class="km-radio"><input type="radio" name="km-err-type" value="episode" /><span>Episode salah</span></label>'
      +       '<label class="km-radio"><input type="radio" name="km-err-type" value="link" /><span>Link rusak</span></label>'
      +       '<label class="km-radio"><input type="radio" name="km-err-type" value="other" /><span>Lainnya</span></label>'
      +     '</div>'
      +   '</div>'
      +   '<div class="km-form-row">'
      +     '<label>Deskripsi (opsional)</label>'
      +     '<textarea id="km-lapor-desc" class="km-form-input" placeholder="Jelaskan masalahnya..." maxlength="500" rows="3"></textarea>'
      +   '</div>'
      +   '<div class="km-form-actions">'
      +     '<button class="km-form-cancel" id="km-lapor-cancel">Batal</button>'
      +     '<button class="km-form-submit" id="km-lapor-submit">Kirim Laporan</button>'
      +   '</div>'
      + '</div>'
      + '<div class="km-room-list" id="km-lapor-list">'
      +   '<div class="km-loading"><div class="spinner"></div><span>Memuat laporan...</span></div>'
      + '</div>'
      + '</div>';

    self._laporFilter = '';
    self._laporPage = 1;
    self._laporSelectedSlug = '';
    self._loadReports();
    self._bindLaporEvents();
  },

  _bindLaporEvents: function() {
    var self = this;
    var content = document.getElementById('km-room-content');
    if (!content) return;

    /* Filter pills */
    content.querySelector('.km-filter-pills').addEventListener('click', function(e) {
      var pill = e.target.closest('.km-pill');
      if (!pill) return;
      content.querySelectorAll('.km-pill').forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      self._laporFilter = pill.dataset.filter || '';
      self._laporPage = 1;
      self._loadReports();
    });

    /* Toggle form */
    document.getElementById('km-lapor-btn').addEventListener('click', function() {
      var form = document.getElementById('km-lapor-form');
      form.style.display = form.style.display === 'none' ? 'block' : 'none';
    });
    document.getElementById('km-lapor-cancel').addEventListener('click', function() {
      document.getElementById('km-lapor-form').style.display = 'none';
    });

    /* Anime search */
    var searchTimer = null;
    document.getElementById('km-lapor-search').addEventListener('input', function() {
      clearTimeout(searchTimer);
      var q = this.value.trim();
      if (q.length < 2) { document.getElementById('km-lapor-results').style.display = 'none'; return; }
      searchTimer = setTimeout(function() {
        ANI.api.all({ q: q, limit: 5 }).then(function(res) {
          var results = res.data || [];
          var el = document.getElementById('km-lapor-results');
          if (results.length === 0) { el.style.display = 'none'; return; }
          el.innerHTML = results.map(function(a) {
            var info = {}; try { info = JSON.parse(a.info || '{}'); } catch(e) {}
            return '<div class="km-search-item" data-slug="' + ANI.util.esc(a.slug) + '" data-title="' + ANI.util.esc(a.title) + '" data-cover="' + ANI.util.esc(a.cover || '') + '">'
              + (a.cover ? '<img src="' + ANI.util.esc(a.cover) + '" alt="" />' : '')
              + '<div><div class="km-si-title">' + ANI.util.esc(a.title) + '</div>'
              + '<div class="km-si-meta">' + (info.type || 'TV') + ' · ' + (info.year || '-') + '</div></div>'
              + '</div>';
          }).join('');
          el.style.display = 'block';
        });
      }, 300);
    });

    /* Select anime from search results */
    document.getElementById('km-lapor-results').addEventListener('click', function(e) {
      var item = e.target.closest('.km-search-item');
      if (!item) return;
      self._laporSelectedSlug = item.dataset.slug;
      document.getElementById('km-lapor-selected').innerHTML =
        '<div class="km-selected-card">'
        + (item.dataset.cover ? '<img src="' + ANI.util.esc(item.dataset.cover) + '" alt="" />' : '')
        + '<span>' + ANI.util.esc(item.dataset.title) + '</span>'
        + '<button class="km-selected-clear">&times;</button>'
        + '</div>';
      document.getElementById('km-lapor-selected').style.display = 'block';
      document.getElementById('km-lapor-results').style.display = 'none';
      document.getElementById('km-lapor-search').value = '';
    });

    /* Clear selected */
    document.getElementById('km-lapor-selected').addEventListener('click', function(e) {
      if (e.target.closest('.km-selected-clear')) {
        self._laporSelectedSlug = '';
        this.style.display = 'none';
      }
    });

    /* Submit */
    document.getElementById('km-lapor-submit').addEventListener('click', function() {
      if (!self._laporSelectedSlug) { self._showChatToast('Pilih anime dulu'); return; }
      var epNum = parseInt(document.getElementById('km-lapor-ep').value) || 0;
      var errType = '';
      var radios = document.querySelectorAll('input[name="km-err-type"]');
      for (var i = 0; i < radios.length; i++) { if (radios[i].checked) { errType = radios[i].value; break; } }
      var desc = (document.getElementById('km-lapor-desc').value || '').trim();

      this.disabled = true;
      this.textContent = 'Mengirim...';
      var btn = this;

      ANI.userApi.createReport({
        anime_slug: self._laporSelectedSlug,
        episode_num: epNum,
        error_type: errType,
        description: desc
      }).then(function() {
        self._showChatToast('Laporan berhasil dikirim!');
        document.getElementById('km-lapor-form').style.display = 'none';
        self._laporSelectedSlug = '';
        self._laporPage = 1;
        self._loadReports();
      }).catch(function(err) {
        self._showChatToast(err.message || 'Gagal mengirim laporan');
      }).finally(function() {
        btn.disabled = false;
        btn.textContent = 'Kirim Laporan';
      });
    });

    /* Status change by admin */
    content.addEventListener('change', function(e) {
      var sel = e.target.closest('.km-report-status-sel');
      if (!sel) return;
      var reportId = sel.dataset.id;
      var newStatus = sel.value;
      ANI.userApi.updateReportStatus(reportId, newStatus).then(function() {
        self._showChatToast('Status diperbarui');
        self._loadReports();
      }).catch(function(err) { self._showChatToast(err.message); });
    });
  },

  _loadReports: function() {
    var self = this;
    var list = document.getElementById('km-lapor-list');
    if (!list) return;
    list.innerHTML = '<div class="km-loading"><div class="spinner"></div><span>Memuat...</span></div>';

    ANI.userApi.getReports(self._laporFilter, self._laporPage, 20).then(function(res) {
      var reports = res.data || [];
      if (reports.length === 0) {
        list.innerHTML = '<div class="km-room-empty"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg><p>Belum ada laporan' + (self._laporFilter ? ' dengan status ini' : '') + '</p></div>';
        return;
      }
      var isAdminMod = ANI.user.isAdmin() || ANI.user.isMod();
      list.innerHTML = reports.map(function(r) { return self._reportCardHtml(r, isAdminMod); }).join('');
    }).catch(function(err) {
      list.innerHTML = '<div class="km-room-empty"><p>Gagal memuat: ' + ANI.util.esc(err.message) + '</p></div>';
    });
  },

  _reportCardHtml: function(r, isAdmin) {
    var statusMap = { open: 'Open', handling: 'Ditangani', resolved: 'Selesai' };
    var errMap = { video: 'Video tidak bisa diputar', subtitle: 'Subtitle salah/hilang', episode: 'Episode salah', link: 'Link rusak', other: 'Lainnya' };
    var statusLabel = statusMap[r.status] || r.status;
    var errLabel = errMap[r.error_type] || r.error_type;

    var statusHtml = '';
    if (isAdmin) {
      statusHtml = '<select class="km-report-status-sel" data-id="' + ANI.util.esc(r.id) + '">'
        + '<option value="open"' + (r.status === 'open' ? ' selected' : '') + '>Open</option>'
        + '<option value="handling"' + (r.status === 'handling' ? ' selected' : '') + '>Ditangani</option>'
        + '<option value="resolved"' + (r.status === 'resolved' ? ' selected' : '') + '>Selesai</option>'
        + '</select>';
    } else {
      statusHtml = '<span class="km-status-badge km-status--' + r.status + '">' + statusLabel + '</span>';
    }

    var timeStr = '';
    try { var d = new Date(r.created_at + (r.created_at.indexOf('Z') === -1 ? 'Z' : '')); timeStr = d.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' }); } catch(e) {}

    return '<div class="km-report-card">'
      + '<div class="km-report-header">'
      +   statusHtml
      +   '<span class="km-report-time">' + timeStr + '</span>'
      + '</div>'
      + '<div class="km-report-body">'
      +   (r.anime_cover ? '<img class="km-report-cover" src="' + ANI.util.esc(r.anime_cover) + '" alt="" />' : '')
      +   '<div class="km-report-info">'
      +     '<div class="km-report-title">' + ANI.util.esc(r.anime_title) + (r.episode_num ? ' Ep. ' + r.episode_num : '') + '</div>'
      +     '<div class="km-report-type">' + ANI.util.esc(errLabel) + '</div>'
      +     (r.description ? '<div class="km-report-desc">' + ANI.util.esc(r.description) + '</div>' : '')
      +   '</div>'
      + '</div>'
      + '<div class="km-report-footer">Dilaporkan oleh <strong>' + ANI.util.esc(r.user.username) + '</strong></div>'
      + '</div>';
  },


  /* ═══ REQUEST-ANIME ROOM ═══ */
  _renderRequestRoom: function() {
    var self = this;
    self._disconnect();
    var container = document.getElementById('km-chat');
    if (!container) return;

    container.innerHTML =
      '<div class="km-room-content" id="km-room-content">'
      + '<div class="km-room-toolbar">'
      +   '<div class="km-filter-pills">'
      +     '<button class="km-pill is-active" data-sort="votes">Terpopuler</button>'
      +     '<button class="km-pill" data-sort="newest">Terbaru</button>'
      +   '</div>'
      +   '<button class="km-room-btn" id="km-req-btn"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>Request Anime</button>'
      + '</div>'
      + '<div class="km-room-form" id="km-req-form" style="display:none">'
      +   '<div class="km-form-title">Request Anime Baru</div>'
      +   '<div class="km-form-row">'
      +     '<label>Cari di AniList</label>'
      +     '<input type="text" id="km-req-search" placeholder="Ketik judul anime..." class="km-form-input" />'
      +     '<div id="km-req-results" class="km-search-results" style="display:none"></div>'
      +     '<div id="km-req-selected" class="km-selected-anime" style="display:none"></div>'
      +   '</div>'
      +   '<div class="km-form-actions">'
      +     '<button class="km-form-cancel" id="km-req-cancel">Batal</button>'
      +     '<button class="km-form-submit" id="km-req-submit">Kirim Request</button>'
      +   '</div>'
      + '</div>'
      + '<div class="km-room-list" id="km-req-list">'
      +   '<div class="km-loading"><div class="spinner"></div><span>Memuat request...</span></div>'
      + '</div>'
      + '</div>';

    self._reqSort = 'votes';
    self._reqPage = 1;
    self._reqSelectedData = null;
    self._loadRequests();
    self._bindRequestEvents();
  },

  _bindRequestEvents: function() {
    var self = this;
    var content = document.getElementById('km-room-content');
    if (!content) return;

    /* Sort pills */
    content.querySelector('.km-filter-pills').addEventListener('click', function(e) {
      var pill = e.target.closest('.km-pill');
      if (!pill) return;
      content.querySelectorAll('.km-pill').forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      self._reqSort = pill.dataset.sort || 'votes';
      self._reqPage = 1;
      self._loadRequests();
    });

    /* Toggle form */
    document.getElementById('km-req-btn').addEventListener('click', function() {
      var form = document.getElementById('km-req-form');
      form.style.display = form.style.display === 'none' ? 'block' : 'none';
    });
    document.getElementById('km-req-cancel').addEventListener('click', function() {
      document.getElementById('km-req-form').style.display = 'none';
    });

    /* AniList search */
    var searchTimer = null;
    document.getElementById('km-req-search').addEventListener('input', function() {
      clearTimeout(searchTimer);
      var q = this.value.trim();
      if (q.length < 2) { document.getElementById('km-req-results').style.display = 'none'; return; }
      searchTimer = setTimeout(function() {
        ANI.userApi.searchAniList(q).then(function(results) {
          var el = document.getElementById('km-req-results');
          if (!results || results.length === 0) { el.style.display = 'none'; return; }
          el.innerHTML = results.map(function(a) {
            var title = (a.title && a.title.romaji) || '';
            var cover = (a.coverImage && a.coverImage.large) || '';
            return '<div class="km-search-item" data-anilist=\'' + JSON.stringify({ id: a.id, title: title, cover: cover, format: a.format || '', year: a.seasonYear || 0, episodes: a.episodes || 0, genres: a.genres || [], status: a.status || '' }) + '\'>'
              + (cover ? '<img src="' + ANI.util.esc(cover) + '" alt="" />' : '')
              + '<div><div class="km-si-title">' + ANI.util.esc(title) + '</div>'
              + '<div class="km-si-meta">' + (a.format || '?') + ' · ' + (a.seasonYear || '?') + ' · ' + (a.episodes || '?') + ' eps</div></div>'
              + '</div>';
          }).join('');
          el.style.display = 'block';
        });
      }, 400);
    });

    /* Select from AniList results */
    document.getElementById('km-req-results').addEventListener('click', function(e) {
      var item = e.target.closest('.km-search-item');
      if (!item) return;
      try { self._reqSelectedData = JSON.parse(item.dataset.anilist); } catch(e) { return; }
      document.getElementById('km-req-selected').innerHTML =
        '<div class="km-selected-card">'
        + (self._reqSelectedData.cover ? '<img src="' + ANI.util.esc(self._reqSelectedData.cover) + '" alt="" />' : '')
        + '<span>' + ANI.util.esc(self._reqSelectedData.title) + ' (' + (self._reqSelectedData.year || '?') + ')</span>'
        + '<button class="km-selected-clear">&times;</button>'
        + '</div>';
      document.getElementById('km-req-selected').style.display = 'block';
      document.getElementById('km-req-results').style.display = 'none';
      document.getElementById('km-req-search').value = '';
    });

    /* Clear selected */
    document.getElementById('km-req-selected').addEventListener('click', function(e) {
      if (e.target.closest('.km-selected-clear')) { self._reqSelectedData = null; this.style.display = 'none'; }
    });

    /* Submit */
    document.getElementById('km-req-submit').addEventListener('click', function() {
      if (!self._reqSelectedData || !self._reqSelectedData.id) { self._showChatToast('Pilih anime dari AniList dulu'); return; }
      var d = self._reqSelectedData;
      var btn = this;
      btn.disabled = true; btn.textContent = 'Mengirim...';

      ANI.userApi.createRequest({
        anilist_id: d.id,
        title: d.title,
        cover: d.cover,
        info: { format: d.format, year: d.year, episodes: d.episodes, genres: d.genres, status: d.status }
      }).then(function(res) {
        self._showChatToast(res.existing ? res.message : 'Request berhasil dikirim!');
        document.getElementById('km-req-form').style.display = 'none';
        self._reqSelectedData = null;
        self._reqPage = 1;
        self._loadRequests();
      }).catch(function(err) {
        self._showChatToast(err.message || 'Gagal mengirim request');
      }).finally(function() { btn.disabled = false; btn.textContent = 'Kirim Request'; });
    });

    /* Vote toggle */
    content.addEventListener('click', function(e) {
      var voteBtn = e.target.closest('.km-vote-btn');
      if (!voteBtn) return;
      if (!ANI.user.isLoggedIn()) { ANI.authUI.showLoginModal(); return; }
      var reqId = voteBtn.dataset.id;
      voteBtn.disabled = true;
      ANI.userApi.toggleVote(reqId).then(function(res) {
        voteBtn.classList.toggle('is-voted', res.voted);
        var countEl = voteBtn.querySelector('.km-vote-count');
        if (countEl) countEl.textContent = res.vote_count;
      }).catch(function(err) { self._showChatToast(err.message); }).finally(function() { voteBtn.disabled = false; });
    });
  },

  _loadRequests: function() {
    var self = this;
    var list = document.getElementById('km-req-list');
    if (!list) return;
    list.innerHTML = '<div class="km-loading"><div class="spinner"></div><span>Memuat...</span></div>';

    ANI.userApi.getRequests(self._reqSort, self._reqPage, 20).then(function(res) {
      var requests = res.data || [];
      if (requests.length === 0) {
        list.innerHTML = '<div class="km-room-empty"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--c-muted)" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg><p>Belum ada request anime</p></div>';
        return;
      }
      list.innerHTML = requests.map(function(rq) { return self._requestCardHtml(rq); }).join('');
    }).catch(function(err) {
      list.innerHTML = '<div class="km-room-empty"><p>Gagal memuat: ' + ANI.util.esc(err.message) + '</p></div>';
    });
  },

  _requestCardHtml: function(rq) {
    var info = rq.info || {};
    var genres = (info.genres || []).slice(0, 3).join(', ');

    return '<div class="km-request-card">'
      + '<button class="km-vote-btn' + (rq.my_vote ? ' is-voted' : '') + '" data-id="' + ANI.util.esc(rq.id) + '">'
      +   '<svg width="14" height="14" viewBox="0 0 24 24" fill="' + (rq.my_vote ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="2"><path d="M12 4l3 5h5l-4 4 1.5 5.5L12 15l-5.5 3.5L8 13 4 9h5l3-5z"/></svg>'
      +   '<span class="km-vote-count">' + (rq.vote_count || 0) + '</span>'
      + '</button>'
      + '<div class="km-request-body">'
      +   (rq.cover ? '<img class="km-request-cover" src="' + ANI.util.esc(rq.cover) + '" alt="" />' : '')
      +   '<div class="km-request-info">'
      +     '<div class="km-request-title">' + ANI.util.esc(rq.title) + '</div>'
      +     '<div class="km-request-meta">'
      +       (info.format || '') + (info.year ? ' · ' + info.year : '') + (info.episodes ? ' · ' + info.episodes + ' eps' : '')
      +     '</div>'
      +     (genres ? '<div class="km-request-genres">' + ANI.util.esc(genres) + '</div>' : '')
      +     '<div class="km-request-by">Diminta oleh <strong>' + ANI.util.esc(rq.user.username) + '</strong></div>'
      +   '</div>'
      + '</div>'
      + '</div>';
  },

  /* ═══ ROOM SWITCH HELPER ═══ */
  _switchRoom: function(room) {
    var self = this;
    self._room = room;
    document.querySelectorAll('.km-tab').forEach(function(t) { t.classList.toggle('is-active', t.dataset.room === room); });

    if (room === 'chat') {
      /* Re-render chat UI */
      var chatContainer = document.getElementById('km-chat');
      if (chatContainer) {
        chatContainer.innerHTML =
          '<div class="km-messages" id="km-messages"><div class="km-loading" id="km-init-loading"><div class="spinner"></div><span>Menghubungkan...</span></div></div>'
          + '<div class="km-reply-bar" id="km-reply-bar" style="display:none"><div class="km-reply-preview"><span class="km-reply-name" id="km-reply-name"></span><span class="km-reply-snippet" id="km-reply-snippet"></span></div><button class="km-reply-close" id="km-reply-close"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>'
          + '<div class="km-cmd-menu" id="km-cmd-menu" style="display:none"></div>'
          + '<button class="km-scroll-btn" id="km-scroll-btn" style="display:none" title="Ke pesan terbaru"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg></button>'
          + '<div class="km-input-bar"><button class="km-clip-btn" id="km-clip-btn" title="Upload gambar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></button><input type="file" id="km-file-input" accept="image/jpeg,image/png,image/gif,image/webp" style="display:none" /><input class="km-input" id="km-input" type="text" placeholder="Ketik pesan atau / untuk command..." maxlength="1000" autocomplete="off" /><button class="km-send-btn" id="km-send-btn" title="Kirim"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button></div>';
      }
      self._messages = [];
      self._oldestMsgId = null;
      self._hasMore = true;
      self._replyTo = null;
      self._replyData = null;
      self._bindEvents();
      self._connect();
    } else if (room === 'lapor-error') {
      self._renderLaporRoom();
    } else if (room === 'request-anime') {
      self._renderRequestRoom();
    }
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 09b: Jadwal Tayang Page

   Halaman /jadwal — full schedule page.
   Mobile: day-picker (circular pills) + content per hari.
   Desktop: today hero (full-width) + 6-col week grid.
   Data dari /api/schedule, cache 5 menit di memory.
   ═══════════════════════════════════════════════ */

ANI.jadwal = {
  _cache: null,
  _cacheTs: 0,
  _CACHE_TTL: 300000,
  _DAY_KEY: {0:'minggu',1:'senin',2:'selasa',3:'rabu',4:'kamis',5:'jumat',6:'sabtu'},
  _DAY_ORDER: ['senin','selasa','rabu','kamis','jumat','sabtu','minggu'],
  _DAY_LABEL: {senin:'Senin',selasa:'Selasa',rabu:'Rabu',kamis:'Kamis',jumat:'Jumat',sabtu:'Sabtu',minggu:'Minggu'},
  _DAY_SHORT: {senin:'Sen',selasa:'Sel',rabu:'Rab',kamis:'Kam',jumat:'Jum',sabtu:'Sab',minggu:'Min'},

  _ordered: function(){
    var today = this._DAY_KEY[new Date().getDay()];
    var idx = this._DAY_ORDER.indexOf(today);
    return this._DAY_ORDER.slice(idx).concat(this._DAY_ORDER.slice(0, idx));
  },

  _todayKey: function(){ return this._DAY_KEY[new Date().getDay()]; },

  _fmtDate: function(dayKey){
    var DN = {minggu:0,senin:1,selasa:2,rabu:3,kamis:4,jumat:5,sabtu:6};
    var now = new Date();
    var diff = (DN[dayKey] - now.getDay() + 7) % 7;
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + diff);
    var M = ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'];
    return d.getDate() + ' ' + M[d.getMonth()];
  },

  init: function(){
    try { this._buildLayout(); this._loadData(); } catch(e){ console.error('[jadwal]', e); }
  },

  _buildLayout: function(){
    var _bc = (ANI.polish && ANI.polish.breadcrumb)
      ? ANI.polish.breadcrumb([{ label:'Beranda', href:'/' }, { label:'Jadwal Tayang' }])
      : '';
    document.getElementById('app-content').innerHTML = _bc +
      '<div class="jp-wrap">' +
        '<div class="jp-header"><h1 class="jp-title">Jadwal Tayang</h1>' +
        '<p class="jp-subtitle">Jadwal rilis episode baru anime ongoing &middot; WIB</p></div>' +
        '<div class="jp-picker" id="jp-picker"></div>' +
        '<div class="jp-today" id="jp-today"></div>' +
        '<div class="jp-day-content" id="jp-day-content"><div class="jp-loading"><div class="spinner"></div></div></div>' +
        '<div class="jp-week" id="jp-week"></div>' +
      '</div>';
  },

  _loadData: function(){
    var self = this;
    if(self._cache && (Date.now() - self._cacheTs < self._CACHE_TTL)){
      self._render(self._cache); return;
    }
    ANI.api.schedule().then(function(res){
      self._cache = res.data || {};
      self._cacheTs = Date.now();
      self._render(self._cache);
    }).catch(function(e){
      console.error('[jadwal]', e);
      var wrap = document.getElementById('jp-day-content');
      if(wrap) wrap.innerHTML = '<div class="jp-empty"><svg class="jp-empty-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg><div class="jp-empty-txt">Gagal memuat jadwal</div></div>';
    });
  },

  _render: function(data){
    var self = this;
    var ordered = self._ordered();
    var todayKey = self._todayKey();
    self._buildPicker(ordered, todayKey, data);
    self._renderDayContent(todayKey, data);
    self._renderTodayHero(todayKey, data);
    self._renderWeekGrid(ordered, todayKey, data);
  },

  /* ── Mobile: Day Picker ── */
  _buildPicker: function(ordered, todayKey, data){
    var self = this;
    var h = '';
    ordered.forEach(function(day, i){
      var isToday = (day === todayKey);
      var has = data[day] && data[day].length > 0;
      var cls = 'jp-pill' + (i === 0 ? ' active' : '') + (isToday ? ' is-today' : '') + (has ? ' has-anime' : '');
      h += '<button class="' + cls + '" data-day="' + day + '">' +
        '<span class="jp-pill-label">' + (isToday ? 'Hari ini' : self._DAY_SHORT[day]) + '</span>' +
        '<span class="jp-pill-num">' + self._fmtDate(day).split(' ')[0] + '</span>' +
        (has ? '<span class="jp-pill-dot"></span>' : '') +
        '</button>';
    });
    var el = document.getElementById('jp-picker');
    if(!el) return;
    el.innerHTML = h;
    el.querySelectorAll('.jp-pill').forEach(function(btn){
      btn.addEventListener('click', function(){
        el.querySelectorAll('.jp-pill').forEach(function(p){ p.classList.remove('active'); });
        this.classList.add('active');
        self._renderDayContent(this.dataset.day, self._cache || {});
      });
    });
  },

  /* ── Mobile: Day Content ── */
  _renderDayContent: function(dayKey, data){
    var self = this;
    var esc = ANI.util.esc;
    var isToday = (dayKey === self._todayKey());
    var items = data[dayKey] || [];
    var h = '<div class="jp-day-banner">' +
      '<span class="jp-day-name">' + self._DAY_LABEL[dayKey] + '</span>' +
      (isToday ? '<span class="jp-day-badge">Hari Ini</span>' : '') +
      '<span class="jp-day-date">' + self._fmtDate(dayKey) + '</span>' +
      (items.length ? '<span class="jp-day-count">' + items.length + ' anime</span>' : '') +
      '</div>';
    if(!items.length){
      h += '<div class="jp-empty"><svg class="jp-empty-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg><div class="jp-empty-txt">Tidak ada anime yang tayang</div></div>';
    } else {
      items.forEach(function(a){
        var ep = a.latest_ep ? 'Episode ' + a.latest_ep : (a.ep_count ? a.ep_count + ' ep' : '');
        var st = a.status || '';
        var cls = isToday ? 'jp-mcard jp-mcard--today' : 'jp-mcard';
        h += '<a href="/anime/' + esc(a.slug) + '" class="' + cls + '">' +
          (a.cover ? '<img class="jp-mcard-cover" src="' + esc(a.cover) + '" alt="" loading="lazy">' : '<div class="jp-mcard-cover jp-mcard-cover--empty"></div>') +
          '<div class="jp-mcard-body">' +
            '<div class="jp-mcard-title">' + esc(a.title) + '</div>' +
            '<div class="jp-mcard-sub">' + ep + (st ? ' &middot; ' + esc(st) : '') + '</div>' +
            (isToday ? '<div class="jp-mcard-trow"><span class="jp-mcard-dot"></span><span class="jp-mcard-time">' + esc(a.schedule_time || '') + '</span></div>' : '') +
          '</div>' +
          (!isToday ? '<span class="jp-mcard-tplain">' + esc(a.schedule_time || '') + '</span>' : '') +
          '</a>';
      });
    }
    var el = document.getElementById('jp-day-content');
    if(el) el.innerHTML = h;
  },

  /* ── Desktop: Today Hero ── */
  _renderTodayHero: function(todayKey, data){
    var self = this;
    var esc = ANI.util.esc;
    var items = data[todayKey] || [];
    var el = document.getElementById('jp-today');
    if(!el) return;
    var h = '<div class="jp-today-inner">' +
      '<div class="jp-today-head">' +
        '<span class="jp-today-badge">HARI INI</span>' +
        '<span class="jp-today-day">' + self._DAY_LABEL[todayKey] + ', ' + self._fmtDate(todayKey) + '</span>' +
        (items.length ? '<span class="jp-today-count">' + items.length + ' anime tayang</span>' : '') +
      '</div>';
    if(!items.length){
      h += '<div class="jp-empty" style="padding:24px 0"><svg class="jp-empty-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg><div class="jp-empty-txt">Tidak ada anime tayang hari ini</div></div>';
    } else {
      h += '<div class="jp-today-grid">';
      items.forEach(function(a){
        var ep = a.latest_ep ? 'Episode ' + a.latest_ep : (a.ep_count ? a.ep_count + ' ep' : '');
        var st = a.status || '';
        h += '<a href="/anime/' + esc(a.slug) + '" class="jp-tcard">' +
          (a.cover ? '<img class="jp-tcard-cover" src="' + esc(a.cover) + '" alt="" loading="lazy">' : '<div class="jp-tcard-cover jp-tcard-cover--empty"></div>') +
          '<div class="jp-tcard-info">' +
            '<div class="jp-tcard-title">' + esc(a.title) + '</div>' +
            '<div class="jp-tcard-sub">' + ep + (st ? ' &middot; ' + esc(st) : '') + '</div>' +
            '<div class="jp-tcard-trow"><span class="jp-tcard-dot"></span><span class="jp-tcard-time">' + esc(a.schedule_time || '') + ' WIB</span></div>' +
          '</div></a>';
      });
      h += '</div>';
    }
    h += '</div>';
    el.innerHTML = h;
  },

  /* ── Desktop: Week Grid (6 remaining days) ── */
  _renderWeekGrid: function(ordered, todayKey, data){
    var self = this;
    var esc = ANI.util.esc;
    var others = ordered.slice(1);
    var el = document.getElementById('jp-week');
    if(!el) return;
    var h = '';
    others.forEach(function(day){
      var items = data[day] || [];
      h += '<div class="jp-col">' +
        '<div class="jp-col-head"><div class="jp-col-bar"></div><span>' + self._DAY_LABEL[day] + '</span>' +
        (items.length > 3 ? '<span class="jp-col-count">' + items.length + '</span>' : '') +
        '</div>';
      if(!items.length){
        h += '<div class="jp-col-empty">Tidak ada jadwal</div>';
      } else {
        var pMax = Math.min(items.length, 3);
        for(var i = 0; i < pMax; i++){
          var a = items[i];
          var ep = a.latest_ep ? 'Ep ' + a.latest_ep : '';
          h += '<a href="/anime/' + esc(a.slug) + '" class="jp-poster">' +
            '<div class="jp-poster-img">' +
              (a.cover ? '<img src="' + esc(a.cover) + '" alt="" loading="lazy">' : '') +
              '<div class="jp-poster-ov"><span class="jp-poster-time">' + esc(a.schedule_time || '') + '</span></div>' +
            '</div>' +
            '<div class="jp-poster-title">' + esc(a.title) + '</div>' +
            (ep ? '<div class="jp-poster-ep">' + ep + '</div>' : '') +
          '</a>';
        }
        for(var j = 3; j < items.length; j++){
          var b = items[j];
          h += '<a href="/anime/' + esc(b.slug) + '" class="jp-crow">' +
            (b.cover ? '<img class="jp-crow-cover" src="' + esc(b.cover) + '" alt="" loading="lazy">' : '<div class="jp-crow-cover jp-crow-cover--empty"></div>') +
            '<span class="jp-crow-title">' + esc(b.title) + '</span>' +
            '<span class="jp-crow-time">' + esc(b.schedule_time || '') + '</span>' +
          '</a>';
        }
      }
      h += '</div>';
    });
    el.innerHTML = h;
  }
};

/* ═══════════════════════════════════════════════
   ANEETAKU — CF Pages app.js
   Module 10: Init (routing) + Base Behaviors
   
   PERUBAHAN dari v27:
   - Routing via URL pattern, bukan __pageType Blogger
   - Search form handler: SPA navigation, bukan form submit
   - Typeahead: ANI.api.search() bukan Blogger Feed
   ═══════════════════════════════════════════════ */

/* ─ BASE BEHAVIORS (wrapped in try/catch — MUST NOT crash) ─ */
try{
var hdr = document.getElementById('hdr');
var raf = null;
if(hdr){
  window.addEventListener('scroll', function(){
    if(!raf) raf = requestAnimationFrame(function(){
      hdr.classList.toggle('scrolled', window.scrollY > 80);
      raf = null;
    });
  }, {passive: true});
  hdr.classList.toggle('scrolled', window.scrollY > 80);
}

/* Active nav */
document.querySelectorAll('.hdr-nav__link,.mobile-nav__link').forEach(function(a){
  var href = a.getAttribute('href') || '';
  var path = window.location.pathname;
  a.classList.remove('is-active');
  if(href && href !== '/' && path.indexOf(href) === 0) a.classList.add('is-active');
  else if((href === '/' || href === window.location.origin + '/') && (path === '/' || path === '/index.html')) a.classList.add('is-active');
});

/* Mobile menu */
var btnMenu = document.getElementById('btn-menu');
var mobileNav = document.getElementById('mobile-nav');
var menuOpen = false;
if(btnMenu && mobileNav){
  window.toggleMenu = function(open){
    menuOpen = open;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', String(!open));
    btnMenu.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  };
  btnMenu.addEventListener('click', function(){ window.toggleMenu(!menuOpen); });
  mobileNav.addEventListener('click', function(e){ if(e.target.classList.contains('mobile-nav__link')) window.toggleMenu(false); });
}

/* Search overlay + Typeahead */
var sOverlay = document.getElementById('search-overlay');
var sModal = document.getElementById('search-modal');
var sInput = document.getElementById('search-input');
var sBtnOpen = document.getElementById('btn-search-open');
var sBtnClose = document.getElementById('btn-search-close');
var sDropdown = document.getElementById('search-dropdown');
var sOpen = false;
var _sDebounce = null;
var _sFocusIdx = -1;

function _sSkels(){
  var h = '';
  for(var i = 0; i < 3; i++){
    h += '<div class="search-dd-skel">' +
      '<div class="skel search-dd-skel-thumb"></div>' +
      '<div style="flex:1">' +
        '<div class="skel search-dd-skel-line" style="width:' + (60 + i * 12) + '%"></div>' +
        '<div class="skel search-dd-skel-line search-dd-skel-line--sm"></div>' +
      '</div>' +
    '</div>';
  }
  return h;
}

function _sRenderItem(item, q){
  var title = item.title || '';
  var url   = item.url   || '#';
  var thumb = item.thumb || '';
  var type  = item.type  || '';
  var year  = item.year  || '';
  var safeTitle = ANI.util.esc(title);
  if(q){
    var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    safeTitle = safeTitle.replace(re, '<mark style="background:rgba(108,99,255,.25);color:var(--c-accent);border-radius:2px;padding:0 1px">$1</mark>');
  }
  return '<a href="' + ANI.util.esc(url) + '" class="search-dd-item" role="option">' +
    '<div class="search-dd-thumb">' +
      (thumb ? '<img src="' + ANI.util.esc(thumb) + '" alt="" loading="lazy"/>' : '') + '</div>' +
    '<div class="search-dd-info">' +
      '<div class="search-dd-title">' + safeTitle + '</div>' +
      '<div class="search-dd-meta"><span>' + ANI.util.esc(type) + '</span><span class="dot"></span><span>' + ANI.util.esc(year) + '</span></div>' +
    '</div>' +
  '</a>';
}

function _sShowResults(items, q){
  _sFocusIdx = -1;
  if(!items.length){
    sDropdown.classList.remove('is-open');
    sDropdown.innerHTML = '';
    return;
  }
  var html = items.slice(0, 5).map(function(it){ return _sRenderItem(it, q); }).join('');
  html += '<div class="search-dd-divider"></div>' +
    '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-dd-all">' +
      'Lihat semua hasil untuk <strong style="margin:0 4px">"' + ANI.util.esc(q) + '"</strong>' +
      '<svg fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
    '</a>';
  sDropdown.innerHTML = html;
  sDropdown.classList.add('is-open');
}

/* Source 1: ANI.searchIndex (preloaded, includes alt_titles + abbreviations) */
function _sFromIndex(q){
  try{
    var results = ANI.searchIndex.search(q);
    return results; /* null = not ready, [] = no match, [...] = matches */
  }catch(e){ return null; }
}

/* Source 2: Worker API fallback (kalau index belum siap) */
function _sFromAPI(q){
  sDropdown.innerHTML = _sSkels();
  sDropdown.classList.add('is-open');
  ANI.api.search(q, 5).then(function(res){
    var rows = res.data || [];
    if(!rows.length){ sDropdown.classList.remove('is-open'); sDropdown.innerHTML = ''; return; }
    var items = rows.map(function(row){
      return ANI.parse.fromDBSlim(row);
    });
    _sShowResults(items, q);
  }).catch(function(){ sDropdown.classList.remove('is-open'); sDropdown.innerHTML = ''; });
}

function _sQuery(q){
  clearTimeout(_sDebounce);
  if(q.length < 2){ sDropdown.classList.remove('is-open'); sDropdown.innerHTML = ''; return; }

  /* Coba search index dulu (instant, supports alt titles + abbreviations) */
  var indexed = _sFromIndex(q);
  if(indexed !== null){
    _sShowResults(indexed, q);
    return;
  }

  /* Index belum siap → fallback ke API dengan debounce */
  _sDebounce = setTimeout(function(){ _sFromAPI(q); }, 400);
}

function _sNavKeys(e){
  if(!sOpen) return;
  var items = sDropdown.querySelectorAll('.search-dd-item, .search-dd-all');
  if(!items.length) return;
  if(e.key === 'ArrowDown'){
    e.preventDefault();
    _sFocusIdx = Math.min(_sFocusIdx + 1, items.length - 1);
  } else if(e.key === 'ArrowUp'){
    e.preventDefault();
    _sFocusIdx = Math.max(_sFocusIdx - 1, -1);
  } else { return; }
  items.forEach(function(it, i){ it.classList.toggle('is-focused', i === _sFocusIdx); });
  if(_sFocusIdx >= 0) items[_sFocusIdx].scrollIntoView({block: 'nearest'});
  if(_sFocusIdx === -1) sInput.focus();
}

if(sBtnOpen && sOverlay && sModal && sInput && sBtnClose && sDropdown){
  window.toggleSearch = function(open){
    sOpen = open;
    sOverlay.classList.toggle('is-open', open);
    sOverlay.setAttribute('aria-hidden', String(!open));
    sBtnOpen.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if(open){
      setTimeout(function(){ sInput.focus(); }, 50);
    } else {
      sInput.value = '';
      sDropdown.classList.remove('is-open');
      sDropdown.innerHTML = '';
      clearTimeout(_sDebounce);
      _sFocusIdx = -1;
    }
  };
  sBtnOpen.addEventListener('click', function(){ window.toggleSearch(true); });
  sBtnClose.addEventListener('click', function(){ window.toggleSearch(false); });
  sOverlay.addEventListener('click', function(e){ if(!sModal.contains(e.target)) window.toggleSearch(false); });
  sInput.addEventListener('input', function(){ _sQuery(this.value.trim()); });
  sInput.addEventListener('keydown', _sNavKeys);
  sDropdown.addEventListener('keydown', _sNavKeys);

  /* Search submit — SPA navigation instead of form submit */
  sInput.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){
      var q = sInput.value.trim();
      if(!q) return;
      /* Jika ada focused item, navigate ke sana */
      if(_sFocusIdx >= 0){
        var focused = sDropdown.querySelectorAll('.search-dd-item, .search-dd-all')[_sFocusIdx];
        if(focused && focused.href){ window.location.href = focused.href; window.toggleSearch(false); return; }
      }
      /* Else: navigate ke search results page */
      window.location.href = '/search?q=' + encodeURIComponent(q);
      window.toggleSearch(false);
    }
  });
}
document.addEventListener('keydown', function(e){
  var isCmdK = (navigator.platform.toUpperCase().indexOf('MAC') >= 0 ? e.metaKey : e.ctrlKey) && e.key === 'k';
  if(isCmdK){ e.preventDefault(); if(window.toggleSearch) window.toggleSearch(!sOpen); }
  if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){ if(sOpen) _sNavKeys(e); }
  if(e.key === 'Escape'){ if(sOpen && window.toggleSearch) window.toggleSearch(false); else if(menuOpen && window.toggleMenu) window.toggleMenu(false); }
});
}catch(baseBehaviorErr){
  console.warn('BASE BEHAVIORS error (non-fatal):', baseBehaviorErr);
}

/* ═══════════════════════════════════════════════
   INIT — URL-based routing (replaces __pageType)
   ═══════════════════════════════════════════════ */


/* ── Routing helpers ── */

function hideLoading(){
  var el = document.getElementById('app-loading');
  if(!el) return;
  el.style.cssText = 'opacity:0;transition:opacity .3s ease';
  setTimeout(function(){ el.style.display = 'none'; }, 320);
}

function setTitle(t){
  try { document.title = t ? t + ' | Aneetaku' : 'Aneetaku \u2014 Nonton Anime Sub Indo Gratis'; } catch(e){}
}

function render404(){
  setTitle('404');
  document.getElementById('app-content').innerHTML =
    '<div style="display:flex;align-items:center;justify-content:center;min-height:60vh;flex-direction:column;gap:16px;text-align:center;padding:0 var(--content-px)">' +
      '<div style="font-size:80px;font-weight:800;font-family:var(--font-display);background:var(--g-accent);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;line-height:1">404</div>' +
      '<h2 style="font-family:var(--font-display);font-size:var(--t-xl);color:var(--c-text)">Halaman Tidak Ditemukan</h2>' +
      '<p style="color:var(--c-muted);max-width:400px">Halaman yang kamu cari tidak ada atau sudah dipindahkan.</p>' +
      '<a href="/" class="btn-primary" style="margin-top:var(--s4)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>Kembali ke Beranda</a>' +
    '</div>';
}

function init(){
  try{
     /* Auth init HARUS pertama — sebelum routing, supaya isLoggedIn() akurat */
    try { ANI.user.init(); ANI.authUI.bind(); } catch(authErr) { console.warn('AUTH init error (non-fatal):', authErr); }

    /* Cleanup: hapus sessionStorage lama dari sistem catalog v1 */
    try { sessionStorage.removeItem('ani_cat_slim_v6'); sessionStorage.removeItem('ani_cat_slim_v6n'); } catch(e){}

    var rawPath = window.location.pathname;
    var path = rawPath.length > 1 ? rawPath.replace(/\/+$/, '') : rawPath;
    var params = new URLSearchParams(window.location.search);
    ANI.cfg.blogUrl = window.location.origin;
    var app = document.getElementById('app');

    /* Nuclear overflow fix — inject style to constrain genre-nav and home-grid */
    try {
      var fix = document.createElement('style');
      fix.textContent = '#app,#app-content{max-width:100vw!important;overflow:hidden!important}.genre-nav-wrap,.genre-nav-inner{max-width:100vw!important;overflow:hidden!important}.genre-nav{width:0!important;min-width:100%!important}@media(max-width:1024px){.home-grid{grid-template-columns:minmax(0,1fr)!important;max-width:100vw!important;overflow:hidden!important}}';
      document.head.appendChild(fix);
    } catch(e){}

    console.log('[ANI.init] path=' + path + ' raw=' + rawPath);

    /* ── URL-based routing ── */
    if(path.startsWith('/anime/')){
      ANI.cfg.pageType = 'item';
      if(app) app.setAttribute('data-page', 'item');
      ANI.series.init();

    } else if(path === '/daftar-anime' || path === '/p/daftar-anime'){
      setTitle('Daftar Anime');
      try { ANI.catalog.init(); } catch(e){ console.error('[ANI.catalog]', e); }

    } else if(path === '/admin' || path === '/p/admin'){
      setTitle('Admin');
      (function(){
        var VER = '20260509e';
        /* Inject CSS jika belum ada */
        if (!document.getElementById('ani-admin-css')) {
          var link = document.createElement('link');
          link.id   = 'ani-admin-css';
          link.rel  = 'stylesheet';
          link.href = '/assets/app.admin.7ce31de5.css';
          document.head.appendChild(link);
        }
        if (typeof ANI.admin !== 'undefined') {
          try { ANI.admin.init(); } catch(e){ console.error('[ANI.admin]', e); }
          return;
        }
        var s = document.createElement('script');
        s.src = '/assets/app.admin.76cd2a2b.js';
        s.onload = function(){
          try { ANI.admin.init(); } catch(e){ console.error('[ANI.admin]', e); }
        };
        s.onerror = function(){
          var root = document.getElementById('app-content');
          if(root) root.innerHTML = '<div style="padding:40px;text-align:center;color:#f87171">Gagal memuat modul admin.</div>';
        };
        document.head.appendChild(s);
      }());

    } else if(path.startsWith('/genre/')){
      var genre = decodeURIComponent(path.replace('/genre/', ''));
      var genreLabel = genre.replace(/_/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
      setTitle('Genre: ' + genreLabel);
      ANI.searchLabel.init('g:' + genre);

    } else if(path.startsWith('/status/')){
      var status = decodeURIComponent(path.replace('/status/', ''));
      setTitle('Status: ' + status.charAt(0).toUpperCase() + status.slice(1));
      ANI.searchLabel.init('status:' + status);

    } else if(path.startsWith('/search/label/')){
      var label = decodeURIComponent(path.replace('/search/label/', ''));
      ANI.searchLabel.init(label);

    } else if(path === '/search'){
      var q = params.get('q') || '';
      if(q){ setTitle('Cari: ' + q); ANI.searchResult.init(q); }
      else { setTitle(); ANI.home.init(); }

    } else if(path === '/tentang' || path === '/p/tentang'){ setTitle('Tentang Kami'); ANI.staticPage._tentang();
    } else if(path === '/faq' || path === '/p/faq'){ setTitle('FAQ'); ANI.staticPage._faq();
    } else if(path === '/dmca' || path === '/p/dmca'){ setTitle('DMCA'); ANI.staticPage._dmca();
    } else if(path === '/kebijakan-privasi' || path === '/p/kebijakan-privasi'){ setTitle('Kebijakan Privasi'); ANI.staticPage._privasi();
    } else if(path === '/jadwal' || path === '/p/jadwal'){
      setTitle('Jadwal Tayang');
      try { ANI.jadwal.init(); } catch(e) { console.error('[jadwal]', e); }

    } else if(path === '/pemeran'){
      setTitle('Pemeran');
      try { ANI.pemeran.initList(); } catch(e) { console.error('[pemeran]', e); }

    } else if(path.startsWith('/pemeran/')){
      var pmSlug = decodeURIComponent(path.replace('/pemeran/', '').replace(/\/+$/, ''));
      try { ANI.pemeran.initDetail(pmSlug); } catch(e) { console.error('[pemeran]', e); }
        } else if(path === '/komunitas' || path === '/p/komunitas'){
      setTitle('Komunitas');
      try { ANI.komunitas.init('chat'); } catch(e) { console.error('[komunitas]', e); }

        } else if(path === '/user'){
      setTitle('Pengaturan Akun');
      try { ANI.userPages.renderProfile(); } catch(e) { console.error('[userPages]', e); }

    } else if(path === '/user/watchlist'){
      setTitle('Watchlist');
      try { ANI.userPages.renderWatchlist(); } catch(e) { console.error('[userPages]', e); }

    } else if(path === '/user/histori'){
      setTitle('Histori Tonton');
      try { ANI.userPages.renderHistory(); } catch(e) { console.error('[userPages]', e); }

    } else if(path === '/' || path === '/index.html' || path === ''){
      setTitle();
      ANI.home.init();

    } else {
      console.log('[ANI.init] 404 for path=' + path);
      render404();
    }

    }catch(e){
    console.error('ANI init error:', e);
  }

  hideLoading();

  /* Preload search index untuk semua halaman (non-blocking) */
  setTimeout(function(){
    try { ANI.searchIndex.preload(); } catch(e){}
  }, 2000);
}

if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

window.addEventListener('beforeunload', function(){
  if(ANI.home.slideTimer){ clearInterval(ANI.home.slideTimer); ANI.home.slideTimer = null; }
  if(ANI.series.artInstance){ try{ ANI.series.artInstance.destroy(); }catch(e){} }
  try { ANI.historySync.flush(); } catch(e) {}
  try { ANI.komunitas.destroy(); } catch(e) {}
});

/* ═══════════════════════════════════════════════════════════════
   ANI.polish — frontend refinements (2026)
   - breadcrumb HTML helper
   - detail-page skeleton (anime detail)
   - page transition (anti-flicker fade between full reloads)
   - button ripple/pulse on click
   - BFCache restore handling
   ═══════════════════════════════════════════════════════════════ */
ANI.polish = (function(){
  var esc = ANI.util.esc;

  function breadcrumb(items, opts){
    if(!items || !items.length) return '';
    opts = opts || {};
    var cls = 'breadcrumb'
      + (opts.inset  ? ' breadcrumb--inset'  : '')
      + (opts.series ? ' breadcrumb--series' : '');
    /* Chevron SVG separator (lebih readable daripada "/") */
    var sep = '<span class="breadcrumb__sep" aria-hidden="true">'
      + '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
      + '</span>';
    var parts = [];
    for(var i = 0; i < items.length; i++){
      var it = items[i];
      var isLast = (i === items.length - 1);
      if(isLast || !it.href){
        parts.push('<span class="breadcrumb__current" aria-current="page">' + esc(it.label || '') + '</span>');
      } else {
        parts.push('<a href="' + esc(it.href) + '">' + esc(it.label || '') + '</a>');
      }
    }
    return '<nav class="' + cls + '" aria-label="Breadcrumb">' + parts.join(sep) + '</nav>';
  }

  function renderDetailSkeleton(slug){
    var content = document.getElementById('app-content');
    if(!content) return;
    var eps = '';
    for(var j = 0; j < 8; j++) eps += '<div class="detail-skel__ep"></div>';
    content.innerHTML =
      '<div class="detail-skel">' +
        '<div class="detail-skel__banner"></div>' +
        '<div class="detail-skel__main">' +
          '<div class="detail-skel__poster"></div>' +
          '<div class="detail-skel__info">' +
            '<div class="detail-skel__line detail-skel__line--title"></div>' +
            '<div class="detail-skel__line detail-skel__line--sub"></div>' +
            '<div class="detail-skel__genres">' +
              '<div class="detail-skel__pill"></div>' +
              '<div class="detail-skel__pill"></div>' +
              '<div class="detail-skel__pill"></div>' +
              '<div class="detail-skel__pill"></div>' +
            '</div>' +
            '<div class="detail-skel__epgrid">' + eps + '</div>' +
          '</div>' +
          '<div class="detail-skel__sidebar"></div>' +
        '</div>' +
      '</div>';
  }

  function renderPlayerSkeleton(){
    var content = document.getElementById('app-content');
    if(!content) return;
    content.innerHTML =
      '<div class="player-skel">' +
        '<div class="player-skel__unit">' +
          '<div class="player-skel__video"></div>' +
          '<div class="player-skel__bar"></div>' +
        '</div>' +
        '<div class="player-skel__strip">' +
          '<div class="player-skel__cover"></div>' +
          '<div class="player-skel__lines">' +
            '<div class="player-skel__line player-skel__line--lg"></div>' +
            '<div class="player-skel__line player-skel__line--sm"></div>' +
          '</div>' +
        '</div>' +
        '<div class="player-skel__eps"></div>' +
      '</div>';
  }

  function isInternalLink(a){
    if(!a || !a.href) return false;
    if(a.target && a.target !== '' && a.target !== '_self') return false;
    if(a.hasAttribute('download')) return false;
    var url;
    try { url = new URL(a.href, window.location.origin); }
    catch(_){ return false; }
    if(url.origin !== window.location.origin) return false;
    if(url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    return true;
  }

  /* Cleanup state: tutup semua dropdown/overlay supaya tidak nyangkut di header
     saat fade-out. .nav-dropdown dipicu CSS hover/focus-within → blur element
     aktif untuk dismiss focus-within state. */
  function cleanupOverlays(){
    try {
      var ae = document.activeElement;
      if (ae && ae !== document.body && typeof ae.blur === 'function') ae.blur();
    } catch(_){}
    try {
      var dds = document.querySelectorAll('.bm-dropdown.is-open');
      for (var i = 0; i < dds.length; i++) dds[i].classList.remove('is-open');
    } catch(_){}
    try {
      var mn = document.getElementById('mobile-nav');
      if (mn && mn.classList.contains('is-open')){
        mn.classList.remove('is-open');
        mn.setAttribute('aria-hidden', 'true');
      }
      var btnMenu = document.getElementById('btn-menu');
      if (btnMenu) btnMenu.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    } catch(_){}
  }

  function bindPageTransition(){
    document.addEventListener('click', function(e){
      if(e.defaultPrevented) return;
      if(e.button !== 0) return;
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if(!a) return;
      if(!isInternalLink(a)) return;
      var url = new URL(a.href, window.location.origin);
      /* Skip in-page hash on same path — no navigation occurs */
      if(url.pathname === window.location.pathname && url.hash && !url.search) return;
      /* Cleanup dropdowns/overlays first, then apply fade-out class */
      cleanupOverlays();
      document.body.classList.add('is-leaving');
    }, true);

    /* Programmatic navigation via location.href / replace — observe via beforeunload */
    window.addEventListener('beforeunload', function(){
      cleanupOverlays();
      document.body.classList.add('is-leaving');
    });

    /* BFCache restore: tab kembali aktif, pastikan fade-state bersih */
    window.addEventListener('pageshow', function(ev){
      document.body.classList.remove('is-leaving');
      if(ev.persisted){
        /* Browser restored from BFCache — pastikan body fade-in ulang */
        document.body.style.animation = 'none';
        // force reflow
        void document.body.offsetWidth;
        document.body.style.animation = '';
      }
    });

    /* Tab visibility: tidak perlu re-render, tapi pastikan fade-state bersih */
    document.addEventListener('visibilitychange', function(){
      if(document.visibilityState === 'visible'){
        document.body.classList.remove('is-leaving');
      }
    });
  }

  /* Ripple/denyut effect dihapus sepenuhnya per feedback user.
     Press-down feedback tetap via CSS .btn-*:active { scale .975 } — itu cukup
     dan tidak punya risiko nyangkut/noise visual. */

  /* ── Toast (singleton) ── */
  var _toastTimer = null;
  function toast(msg, ms){
    var el = document.getElementById('ani-polish-toast');
    if(!el){
      el = document.createElement('div');
      el.id = 'ani-polish-toast';
      el.className = 'ani-polish-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = String(msg || '');
    /* force reflow so transition triggers reliably */
    void el.offsetWidth;
    el.classList.add('is-show');
    if(_toastTimer) clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function(){
      el.classList.remove('is-show');
    }, Math.max(800, ms || 2400));
  }

  /* ── Clipboard fallback ── */
  function copyToClipboard(text){
    if(navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function(resolve, reject){
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch(_){ ok = false; }
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('exec copy failed'));
      } catch(e) { reject(e); }
    });
  }

  /* ── Share: Web Share API → fallback copy + toast ── */
  function share(opts){
    opts = opts || {};
    var url   = opts.url   || window.location.href;
    var title = opts.title || document.title;
    var text  = opts.text  || '';
    if(navigator.share){
      try {
        return navigator.share({ url: url, title: title, text: text })
          .catch(function(e){
            /* User dismiss = AbortError → tidak fallback */
            if(e && e.name === 'AbortError') return;
            copyToClipboard(url).then(function(){ toast('Link tersalin'); })
              .catch(function(){ toast('Gagal menyalin link'); });
          });
      } catch(_){ /* fall through */ }
    }
    copyToClipboard(url).then(function(){ toast('Link tersalin'); })
      .catch(function(){ toast('Gagal menyalin link'); });
  }

  function init(){
    try { bindPageTransition(); } catch(_){}
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    breadcrumb: breadcrumb,
    renderDetailSkeleton: renderDetailSkeleton,
    renderPlayerSkeleton: renderPlayerSkeleton,
    share: share,
    toast: toast
  };
})();

})();
